import { generateUUID } from 'utils';

export const IconImg = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 16 16"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path d="M13.583.5H2.417A1.92 1.92 0 0 0 .5 2.417v11.166A1.92 1.92 0 0 0 2.417 15.5h11.166a1.92 1.92 0 0 0 1.917-1.917V2.417A1.92 1.92 0 0 0 13.583.5zm1.034 13.083c0 .57-.464 1.034-1.034 1.034H2.417c-.57 0-1.033-.464-1.033-1.034v-1.611L4.29 9.498a.286.286 0 0 1 .368-.003l1.822 1.513a.442.442 0 0 0 .595-.028l4.328-4.334a.283.283 0 0 1 .217-.084c.047.002.137.02.207.105l2.789 3.434v3.482zm0-4.884L12.514 6.11a1.171 1.171 0 0 0-1.736-.089l-4.043 4.05-1.511-1.255a1.167 1.167 0 0 0-1.505.009l-2.335 1.987V2.417c0-.57.463-1.033 1.033-1.033h11.166c.57 0 1.034.463 1.034 1.033v6.282z" />
    <path d="M4.222 2.344c-1.175 0-2.13.955-2.13 2.13 0 1.175.955 2.13 2.13 2.13 1.175 0 2.13-.955 2.13-2.13 0-1.175-.955-2.13-2.13-2.13zm0 3.377c-.687 0-1.247-.56-1.247-1.247s.56-1.247 1.247-1.247c.688 0 1.247.56 1.247 1.247s-.56 1.247-1.247 1.247z" />
  </svg>
);

// ------------ Sidebar Icons -------------

export const DashboardIcon = (props) => (
  <svg
    width={props?.width || '20'}
    height={props?.height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5001 18.9583H7.50008C2.97508 18.9583 1.04175 17.025 1.04175 12.5V7.5C1.04175 2.975 2.97508 1.04166 7.50008 1.04166H12.5001C17.0251 1.04166 18.9584 2.975 18.9584 7.5V12.5C18.9584 17.025 17.0251 18.9583 12.5001 18.9583ZM7.50008 2.29166C3.65841 2.29166 2.29175 3.65833 2.29175 7.5V12.5C2.29175 16.3417 3.65841 17.7083 7.50008 17.7083H12.5001C16.3417 17.7083 17.7084 16.3417 17.7084 12.5V7.5C17.7084 3.65833 16.3417 2.29166 12.5001 2.29166H7.50008Z"
      fill="currentColor"
    />
    <path
      d="M8.33325 18.9583C7.99159 18.9583 7.70825 18.675 7.70825 18.3333V1.66666C7.70825 1.325 7.99159 1.04166 8.33325 1.04166C8.67492 1.04166 8.95825 1.325 8.95825 1.66666V18.3333C8.95825 18.675 8.67492 18.9583 8.33325 18.9583Z"
      fill="currentColor"
    />
    <path
      d="M18.3333 10.625H8.33325C7.99159 10.625 7.70825 10.3417 7.70825 10C7.70825 9.65833 7.99159 9.375 8.33325 9.375H18.3333C18.6749 9.375 18.9583 9.65833 18.9583 10C18.9583 10.3417 18.6749 10.625 18.3333 10.625Z"
      fill="currentColor"
    />
  </svg>
);

export const LeadsIcon = (props) => (
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.7998 6.39999H15.3998" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    <path d="M11.7998 9.55003H14.4998" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    <path
      d="M14.5 1H5.5C3.01472 1 1 3.01472 1 5.5V12.7C1 15.1853 3.01472 17.2 5.5 17.2H14.5C16.9853 17.2 19 15.1853 19 12.7V5.5C19 3.01472 16.9853 1 14.5 1Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path
      d="M3.7002 12.7C4.78767 10.377 8.84118 10.2242 10.0002 12.7"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.6498 6.40001C8.6498 7.39407 7.84392 8.20002 6.8498 8.20002C5.85569 8.20002 5.0498 7.39407 5.0498 6.40001C5.0498 5.40589 5.85569 4.60001 6.8498 4.60001C7.84392 4.60001 8.6498 5.40589 8.6498 6.40001Z"
      stroke="currentColor"
      strokeWidth="1.3"
    />
  </svg>
);

export const TokenIcon = (props) => (
  <svg
    width={props?.width || '20'}
    height={props?.height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99992 18.9584C6.66659 18.9584 3.95825 16.5667 3.95825 13.625V10.5417C3.95825 10.2 4.24159 9.91669 4.58325 9.91669C4.92492 9.91669 5.20825 10.2 5.20825 10.5417C5.20825 12.725 7.26659 14.375 9.99992 14.375C12.7333 14.375 14.7916 12.725 14.7916 10.5417C14.7916 10.2 15.0749 9.91669 15.4166 9.91669C15.7583 9.91669 16.0416 10.2 16.0416 10.5417V13.625C16.0416 16.5667 13.3333 18.9584 9.99992 18.9584ZM5.20825 13.7167C5.26659 15.925 7.39159 17.7084 9.99992 17.7084C12.6083 17.7084 14.7333 15.925 14.7916 13.7167C13.7083 14.8917 11.9916 15.625 9.99992 15.625C8.00825 15.625 6.29992 14.8917 5.20825 13.7167Z"
      fill="currentColor"
    />
    <path
      d="M9.99992 11.4584C7.69992 11.4584 5.63324 10.425 4.62491 8.75835C4.19158 8.05002 3.95825 7.22502 3.95825 6.37502C3.95825 4.94169 4.59992 3.59169 5.75826 2.57502C6.89159 1.58335 8.39992 1.04169 9.99992 1.04169C11.5999 1.04169 13.0999 1.58336 14.2416 2.56669C15.3999 3.59169 16.0416 4.94169 16.0416 6.37502C16.0416 7.22502 15.8083 8.04169 15.3749 8.75835C14.3666 10.425 12.2999 11.4584 9.99992 11.4584ZM9.99992 2.29169C8.69992 2.29169 7.48326 2.72502 6.57493 3.52502C5.6916 4.29169 5.20825 5.30836 5.20825 6.37502C5.20825 7.00002 5.37491 7.58335 5.69157 8.10835C6.48324 9.40835 8.13325 10.2084 9.99992 10.2084C11.8666 10.2084 13.5166 9.40002 14.3083 8.10835C14.6333 7.58335 14.7916 7.00002 14.7916 6.37502C14.7916 5.30836 14.3083 4.29169 13.4166 3.50835C12.5083 2.72502 11.2999 2.29169 9.99992 2.29169Z"
      fill="currentColor"
    />
    <path
      d="M9.99992 15.625C6.55825 15.625 3.95825 13.4417 3.95825 10.5417V6.37502C3.95825 3.43335 6.66659 1.04169 9.99992 1.04169C11.5999 1.04169 13.0999 1.58336 14.2416 2.56669C15.3999 3.59169 16.0416 4.94169 16.0416 6.37502V10.5417C16.0416 13.4417 13.4416 15.625 9.99992 15.625ZM9.99992 2.29169C7.35825 2.29169 5.20825 4.12502 5.20825 6.37502V10.5417C5.20825 12.725 7.26659 14.375 9.99992 14.375C12.7333 14.375 14.7916 12.725 14.7916 10.5417V6.37502C14.7916 5.30835 14.3083 4.29169 13.4166 3.50835C12.5083 2.72502 11.2999 2.29169 9.99992 2.29169Z"
      fill="currentColor"
    />
  </svg>
);

export const TrackingIcon = (props) => {
  return (
    <svg
      width={props.width || 20}
      height={props.height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.55838 8.95832C3.96671 8.95832 3.36671 8.74166 2.90838 8.29999C1.37505 6.84166 0.758381 5.24999 1.11671 3.69166C1.54171 1.85832 3.15005 1.04166 4.55838 1.04166C5.96671 1.04166 7.58338 1.86666 8.00005 3.69166C8.35838 5.24999 7.73338 6.84166 6.20838 8.29999C5.75005 8.74166 5.15838 8.95832 4.55838 8.95832ZM2.33338 3.97499C2.01671 5.36666 2.94171 6.59999 3.77505 7.39166C4.21671 7.81666 4.90838 7.80832 5.35005 7.39166C6.18338 6.59999 7.10838 5.36666 6.78338 3.96666C6.50005 2.73332 5.40838 2.29166 4.56671 2.29166C3.71671 2.29166 2.62505 2.73332 2.33338 3.97499Z"
        fill="currentColor"
      />
      <path
        d="M4.59163 5.16667C4.1333 5.16667 3.7583 4.79167 3.7583 4.33333C3.7583 3.875 4.12497 3.5 4.59163 3.5H4.59997C5.0583 3.5 5.4333 3.875 5.4333 4.33333C5.4333 4.79167 5.0583 5.16667 4.59163 5.16667Z"
        fill="currentColor"
      />
      <path
        d="M15.4084 18.9583C14.8167 18.9583 14.2167 18.7417 13.7501 18.3C12.2084 16.8417 11.5834 15.25 11.9501 13.6833C12.3751 11.8583 13.9917 11.0333 15.4084 11.0333C16.8251 11.0333 18.4417 11.8583 18.8667 13.6833C19.2251 15.2417 18.6001 16.8417 17.0584 18.2917C16.6001 18.7417 16.0084 18.9583 15.4084 18.9583ZM15.4084 12.2917C14.5584 12.2917 13.4584 12.7333 13.1667 13.975C12.8417 15.3667 13.7751 16.6083 14.6084 17.4C15.0501 17.825 15.7501 17.825 16.2001 17.4C17.0334 16.6083 17.9667 15.375 17.6417 13.9833C17.3667 12.7333 16.2667 12.2917 15.4084 12.2917Z"
        fill="currentColor"
      />
      <path
        d="M15.4417 15.1667C14.9834 15.1667 14.6084 14.7917 14.6084 14.3333C14.6084 13.875 14.9751 13.5 15.4417 13.5H15.4501C15.9084 13.5 16.2834 13.875 16.2834 14.3333C16.2834 14.7917 15.9001 15.1667 15.4417 15.1667Z"
        fill="currentColor"
      />
      <path
        d="M10 16.4583H7.7667C6.80003 16.4583 5.95837 15.875 5.62503 14.975C5.28337 14.075 5.53337 13.0833 6.25837 12.4417L12.9167 6.61666C13.3167 6.26666 13.325 5.79166 13.2084 5.46666C13.0834 5.14166 12.7667 4.79166 12.2334 4.79166H10C9.65836 4.79166 9.37503 4.50832 9.37503 4.16666C9.37503 3.82499 9.65836 3.54166 10 3.54166H12.2334C13.2 3.54166 14.0417 4.12499 14.375 5.02499C14.7167 5.92499 14.4667 6.91666 13.7417 7.55832L7.08337 13.3833C6.68337 13.7333 6.67503 14.2083 6.7917 14.5333C6.9167 14.8583 7.23336 15.2083 7.7667 15.2083H10C10.3417 15.2083 10.625 15.4917 10.625 15.8333C10.625 16.175 10.3417 16.4583 10 16.4583Z"
        fill="currentColor"
      />
      <path
        d="M10 16.4583H7.7667C6.80003 16.4583 5.95837 15.875 5.62503 14.975C5.28337 14.075 5.53337 13.0833 6.25837 12.4417L12.9167 6.61666C13.3167 6.26666 13.325 5.79166 13.2084 5.46666C13.0834 5.14166 12.7667 4.79166 12.2334 4.79166H10C9.65836 4.79166 9.37503 4.50832 9.37503 4.16666C9.37503 3.82499 9.65836 3.54166 10 3.54166H12.2334C13.2 3.54166 14.0417 4.12499 14.375 5.02499C14.7167 5.92499 14.4667 6.91666 13.7417 7.55832L7.08337 13.3833C6.68337 13.7333 6.67503 14.2083 6.7917 14.5333C6.9167 14.8583 7.23336 15.2083 7.7667 15.2083H10C10.3417 15.2083 10.625 15.4917 10.625 15.8333C10.625 16.175 10.3417 16.4583 10 16.4583Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PatientIcon = (props) => (
  <svg
    width={props?.width || '20'}
    height={props?.height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99992 10.625C7.35825 10.625 5.20825 8.47501 5.20825 5.83334C5.20825 3.19167 7.35825 1.04167 9.99992 1.04167C12.6416 1.04167 14.7916 3.19167 14.7916 5.83334C14.7916 8.47501 12.6416 10.625 9.99992 10.625ZM9.99992 2.29167C8.04992 2.29167 6.45825 3.88334 6.45825 5.83334C6.45825 7.78334 8.04992 9.375 9.99992 9.375C11.9499 9.375 13.5416 7.78334 13.5416 5.83334C13.5416 3.88334 11.9499 2.29167 9.99992 2.29167Z"
      fill="currentColor"
    />
    <path
      d="M2.8418 18.9583C2.50013 18.9583 2.2168 18.675 2.2168 18.3333C2.2168 14.775 5.70846 11.875 10.0001 11.875C10.8418 11.875 11.6668 11.9834 12.4668 12.2084C12.8001 12.3 12.9918 12.6417 12.9001 12.975C12.8085 13.3083 12.4668 13.5 12.1335 13.4084C11.4501 13.2167 10.7335 13.125 10.0001 13.125C6.40013 13.125 3.4668 15.4583 3.4668 18.3333C3.4668 18.675 3.18346 18.9583 2.8418 18.9583Z"
      fill="currentColor"
    />
    <path
      d="M15.0001 18.9583C14.0167 18.9583 13.0834 18.5917 12.3584 17.9334C12.0667 17.6834 11.8084 17.375 11.6084 17.0333C11.2417 16.4333 11.0417 15.725 11.0417 15C11.0417 13.9583 11.4417 12.9833 12.1584 12.2417C12.9084 11.4667 13.9167 11.0417 15.0001 11.0417C16.1334 11.0417 17.2084 11.525 17.9417 12.3584C18.5917 13.0834 18.9584 14.0167 18.9584 15C18.9584 15.3167 18.9168 15.6333 18.8334 15.9333C18.7501 16.3083 18.5917 16.7 18.3751 17.0417C17.6834 18.225 16.3834 18.9583 15.0001 18.9583ZM15.0001 12.2917C14.2584 12.2917 13.5751 12.5833 13.0584 13.1083C12.5668 13.6167 12.2917 14.2833 12.2917 15C12.2917 15.4917 12.4251 15.975 12.6834 16.3917C12.8167 16.625 12.9917 16.8333 13.1917 17.0083C13.6917 17.4666 14.3334 17.7167 15.0001 17.7167C15.9417 17.7167 16.8334 17.2167 17.3167 16.4083C17.4584 16.175 17.5667 15.9084 17.6251 15.65C17.6834 15.4334 17.7084 15.225 17.7084 15.0083C17.7084 14.3417 17.4584 13.7 17.0084 13.2C16.5084 12.6167 15.7751 12.2917 15.0001 12.2917Z"
      fill="currentColor"
    />
    <path
      d="M16.2497 15.6083H13.7581C13.4164 15.6083 13.1331 15.325 13.1331 14.9833C13.1331 14.6417 13.4164 14.3583 13.7581 14.3583H16.2497C16.5914 14.3583 16.8747 14.6417 16.8747 14.9833C16.8747 15.325 16.5914 15.6083 16.2497 15.6083Z"
      fill="currentColor"
    />
    <path
      d="M15 16.8833C14.6583 16.8833 14.375 16.6 14.375 16.2583V13.7667C14.375 13.425 14.6583 13.1417 15 13.1417C15.3417 13.1417 15.625 13.425 15.625 13.7667V16.2583C15.625 16.6083 15.3417 16.8833 15 16.8833Z"
      fill="currentColor"
    />
  </svg>
);

export const CasesIcon = (props) => (
  <svg
    width={props?.width || '20'}
    height={props?.height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6834 8.01666H10.3083C9.96668 8.01666 9.68335 7.73333 9.68335 7.39166C9.68335 7.05 9.96668 6.76666 10.3083 6.76666H14.6834C15.025 6.76666 15.3084 7.05 15.3084 7.39166C15.3084 7.73333 15.0334 8.01666 14.6834 8.01666Z"
      fill="currentColor"
    />
    <path
      d="M5.93322 8.64999C5.77489 8.64999 5.61655 8.59165 5.49155 8.46665L4.86655 7.84165C4.62489 7.59999 4.62489 7.19999 4.86655 6.95832C5.10822 6.71665 5.50822 6.71665 5.74989 6.95832L5.93322 7.14165L7.36655 5.70832C7.60822 5.46665 8.00822 5.46665 8.24989 5.70832C8.49155 5.94999 8.49155 6.34999 8.24989 6.59165L6.37489 8.46665C6.25822 8.58332 6.09989 8.64999 5.93322 8.64999Z"
      fill="currentColor"
    />
    <path
      d="M14.6834 13.85H10.3083C9.96668 13.85 9.68335 13.5667 9.68335 13.225C9.68335 12.8833 9.96668 12.6 10.3083 12.6H14.6834C15.025 12.6 15.3084 12.8833 15.3084 13.225C15.3084 13.5667 15.0334 13.85 14.6834 13.85Z"
      fill="currentColor"
    />
    <path
      d="M5.93322 14.4833C5.77489 14.4833 5.61655 14.425 5.49155 14.3L4.86655 13.675C4.62489 13.4333 4.62489 13.0333 4.86655 12.7917C5.10822 12.55 5.50822 12.55 5.74989 12.7917L5.93322 12.975L7.36655 11.5417C7.60822 11.3 8.00822 11.3 8.24989 11.5417C8.49155 11.7833 8.49155 12.1833 8.24989 12.425L6.37489 14.3C6.25822 14.4167 6.09989 14.4833 5.93322 14.4833Z"
      fill="currentColor"
    />
    <path
      d="M12.5001 18.9583H7.50008C2.97508 18.9583 1.04175 17.025 1.04175 12.5V7.49999C1.04175 2.97499 2.97508 1.04166 7.50008 1.04166H12.5001C17.0251 1.04166 18.9584 2.97499 18.9584 7.49999V12.5C18.9584 17.025 17.0251 18.9583 12.5001 18.9583ZM7.50008 2.29166C3.65841 2.29166 2.29175 3.65832 2.29175 7.49999V12.5C2.29175 16.3417 3.65841 17.7083 7.50008 17.7083H12.5001C16.3417 17.7083 17.7084 16.3417 17.7084 12.5V7.49999C17.7084 3.65832 16.3417 2.29166 12.5001 2.29166H7.50008Z"
      fill="currentColor"
    />
  </svg>
);

export const StatusesIcon = (props) => (
  <svg
    width={props?.width || '20'}
    height={props?.height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3334 10C18.3334 5.39765 14.6024 1.66669 10.0001 1.66669C5.39771 1.66669 1.66675 5.39765 1.66675 10C1.66675 14.6024 5.39771 18.3334 10.0001 18.3334"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 14.1666C7.41872 12.9426 9.18433 12.4201 10.8333 12.6617M12.0792 7.91665C12.0792 9.06723 11.1452 9.99998 9.99292 9.99998C8.84075 9.99998 7.90664 9.06723 7.90664 7.91665C7.90664 6.76605 8.84075 5.83331 9.99292 5.83331C11.1452 5.83331 12.0792 6.76605 12.0792 7.91665Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4167 18.3333C17.0275 18.3333 18.3333 17.0275 18.3333 15.4167C18.3333 13.8058 17.0275 12.5 15.4167 12.5C13.8058 12.5 12.5 13.8058 12.5 15.4167C12.5 17.0275 13.8058 18.3333 15.4167 18.3333Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProductsIcon = (props) => (
  <svg
    width={props?.width || '20'}
    height={props?.height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1240_1870)">
      <path
        d="M16.588 10.1232L17.609 9.10218C19.4636 7.24759 19.4638 4.24578 17.609 2.39101C15.7545 0.536453 12.7526 0.536207 10.8978 2.39101C10.502 2.7868 2.75007 10.5388 2.39102 10.8978C0.536431 12.7524 0.53622 15.7542 2.39102 17.609C4.24555 19.4635 7.24739 19.4638 9.10216 17.609L10.1232 16.588C10.9394 18.0263 12.4849 18.9989 14.2534 18.9989C16.8701 18.9989 18.9989 16.8701 18.9989 14.2534C18.9989 12.4848 18.0263 10.9393 16.588 10.1232ZM9.50787 14.2534C9.50761 14.6869 9.56689 15.1184 9.68403 15.5358L8.3565 16.8633C6.91408 18.3057 4.57932 18.3059 3.13672 16.8633C1.6943 15.4209 1.69409 13.0861 3.13672 11.6435L6.98509 7.79515L10.5187 11.3287C9.88573 12.1352 9.50787 13.151 9.50787 14.2534ZM13.7261 17.9065C11.9398 17.6499 10.5624 16.1096 10.5624 14.2534C10.5624 12.3972 11.9398 10.8569 13.7261 10.6002V17.9065ZM11.2574 10.5761L7.73076 7.04945L11.6435 3.13671C13.0859 1.69432 15.4207 1.69411 16.8633 3.13671C18.3057 4.5791 18.3059 6.91389 16.8633 8.35649L15.5357 9.68402C15.1184 9.56685 14.6869 9.50758 14.2534 9.50785C13.1182 9.50785 12.075 9.90873 11.2574 10.5761ZM14.7807 17.9065V10.6003C16.567 10.8569 17.9443 12.3972 17.9443 14.2534C17.9443 16.1096 16.567 17.6499 14.7807 17.9065Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
    </g>
    <defs>
      <clipPath id="clip0_1240_1870">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SubscriptionsIcon = (props) => (
  <svg
    width={props.width || 20}
    height={props.height || 20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3334 7.70834H1.66675C1.32508 7.70834 1.04175 7.42501 1.04175 7.08334C1.04175 6.74168 1.32508 6.45834 1.66675 6.45834H18.3334C18.6751 6.45834 18.9584 6.74168 18.9584 7.08334C18.9584 7.42501 18.6751 7.70834 18.3334 7.70834Z"
      fill="currentColor"
    />
    <path
      d="M6.66667 14.375H5C4.65833 14.375 4.375 14.0917 4.375 13.75C4.375 13.4083 4.65833 13.125 5 13.125H6.66667C7.00833 13.125 7.29167 13.4083 7.29167 13.75C7.29167 14.0917 7.00833 14.375 6.66667 14.375Z"
      fill="currentColor"
    />
    <path
      d="M12.0833 14.375H8.75C8.40833 14.375 8.125 14.0917 8.125 13.75C8.125 13.4083 8.40833 13.125 8.75 13.125H12.0833C12.425 13.125 12.7083 13.4083 12.7083 13.75C12.7083 14.0917 12.425 14.375 12.0833 14.375Z"
      fill="currentColor"
    />
    <path
      d="M14.6334 17.7083H5.36675C2.05008 17.7083 1.04175 16.7083 1.04175 13.425V6.57499C1.04175 3.29166 2.05008 2.29166 5.36675 2.29166H14.6251C17.9417 2.29166 18.9501 3.29166 18.9501 6.57499V13.4167C18.9584 16.7083 17.9501 17.7083 14.6334 17.7083ZM5.36675 3.54166C2.75008 3.54166 2.29175 3.99166 2.29175 6.57499V13.4167C2.29175 16 2.75008 16.45 5.36675 16.45H14.6251C17.2417 16.45 17.7001 16 17.7001 13.4167V6.57499C17.7001 3.99166 17.2417 3.54166 14.6251 3.54166H5.36675Z"
      fill="currentColor"
    />
  </svg>
);

export const TicketsIcon = (props) => (
  <svg
    width={props.width || 20}
    height={props.height || 20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1667 17.2917H5.83341C2.15841 17.2917 1.04175 16.175 1.04175 12.5V12.0833C1.04175 11.7417 1.32508 11.4583 1.66675 11.4583C2.46675 11.4583 3.12508 10.8 3.12508 10C3.12508 9.20001 2.46675 8.54168 1.66675 8.54168C1.32508 8.54168 1.04175 8.25834 1.04175 7.91668V7.50001C1.04175 3.82501 2.15841 2.70834 5.83341 2.70834H14.1667C17.8417 2.70834 18.9584 3.82501 18.9584 7.50001V8.33334C18.9584 8.67501 18.6751 8.95834 18.3334 8.95834C17.5334 8.95834 16.8751 9.61668 16.8751 10.4167C16.8751 11.2167 17.5334 11.875 18.3334 11.875C18.6751 11.875 18.9584 12.1583 18.9584 12.5C18.9584 16.175 17.8417 17.2917 14.1667 17.2917ZM2.29175 12.6333C2.30841 15.5 2.90008 16.0417 5.83341 16.0417H14.1667C16.9501 16.0417 17.6251 15.55 17.7001 13.05C16.5084 12.7667 15.6251 11.6917 15.6251 10.4167C15.6251 9.14168 16.5167 8.06668 17.7084 7.78334V7.50001C17.7084 4.52501 17.1501 3.95834 14.1667 3.95834H5.83341C2.90008 3.95834 2.30841 4.50001 2.29175 7.36668C3.48341 7.65001 4.37508 8.72501 4.37508 10C4.37508 11.275 3.48341 12.35 2.29175 12.6333Z"
      fill="currentColor"
    />
    <path
      d="M8.33325 6.04168C7.99159 6.04168 7.70825 5.75834 7.70825 5.41668V3.33334C7.70825 2.99168 7.99159 2.70834 8.33325 2.70834C8.67492 2.70834 8.95825 2.99168 8.95825 3.33334V5.41668C8.95825 5.75834 8.67492 6.04168 8.33325 6.04168Z"
      fill="currentColor"
    />
    <path
      d="M8.33325 12.15C7.99159 12.15 7.70825 11.8667 7.70825 11.525V8.46667C7.70825 8.12501 7.99159 7.84167 8.33325 7.84167C8.67492 7.84167 8.95825 8.12501 8.95825 8.46667V11.525C8.95825 11.875 8.67492 12.15 8.33325 12.15Z"
      fill="currentColor"
    />
    <path
      d="M8.33325 17.2917C7.99159 17.2917 7.70825 17.0083 7.70825 16.6667V14.5833C7.70825 14.2417 7.99159 13.9583 8.33325 13.9583C8.67492 13.9583 8.95825 14.2417 8.95825 14.5833V16.6667C8.95825 17.0083 8.67492 17.2917 8.33325 17.2917Z"
      fill="currentColor"
    />
  </svg>
);

export const VouchersIcon = (props) => (
  <svg
    width={props.width || 20}
    height={props.height || 20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1833 9.79166H13.3333C12.9916 9.79166 12.7083 9.50832 12.7083 9.16666V3.34166C12.7083 2.72499 12.9499 2.14999 13.3833 1.71666C13.8166 1.28332 14.3916 1.04166 15.0083 1.04166H15.0166C16.0583 1.04999 17.0416 1.45832 17.7916 2.19999C18.5416 2.95832 18.9499 3.95832 18.9499 4.99999V7.01665C18.9583 8.67499 17.8416 9.79166 16.1833 9.79166ZM13.9583 8.54166H16.1833C17.1499 8.54166 17.7083 7.98332 17.7083 7.01665V4.99999C17.7083 4.28332 17.4249 3.59999 16.9166 3.08332C16.4083 2.58332 15.7249 2.29999 15.0166 2.29166C15.0166 2.29166 15.0166 2.29166 15.0083 2.29166C14.7333 2.29166 14.4666 2.39999 14.2666 2.59999C14.0666 2.79999 13.9583 3.05832 13.9583 3.34166V8.54166Z"
      fill="currentColor"
    />
    <path
      d="M7.49981 19.4417C7.10814 19.4417 6.74147 19.2917 6.46647 19.0083L5.08314 17.6167C5.00814 17.5417 4.89147 17.5333 4.80814 17.6L3.38314 18.6667C2.94147 19 2.35814 19.0583 1.85814 18.8083C1.35814 18.5583 1.0498 18.0583 1.0498 17.5V4.99999C1.0498 2.48332 2.49147 1.04166 5.00814 1.04166H15.0081C15.3498 1.04166 15.6331 1.32499 15.6331 1.66666C15.6331 2.00832 15.3498 2.29166 15.0081 2.29166C14.4331 2.29166 13.9665 2.75832 13.9665 3.33332V17.5C13.9665 18.0583 13.6581 18.5583 13.1581 18.8083C12.6581 19.0583 12.0748 19.0083 11.6331 18.675L10.2081 17.6083C10.1248 17.5417 10.0081 17.5583 9.94147 17.625L8.54147 19.025C8.25814 19.2917 7.89147 19.4417 7.49981 19.4417ZM4.92481 16.3083C5.30814 16.3083 5.68314 16.45 5.96647 16.7417L7.34981 18.1333C7.39981 18.1833 7.46647 18.1917 7.49981 18.1917C7.53314 18.1917 7.59981 18.1833 7.64981 18.1333L9.04981 16.7333C9.56647 16.2167 10.3831 16.1667 10.9581 16.6083L12.3748 17.6667C12.4665 17.7333 12.5498 17.7083 12.5915 17.6833C12.6331 17.6583 12.7081 17.6083 12.7081 17.5V3.33332C12.7081 2.95832 12.7998 2.59999 12.9581 2.29166H4.99981C3.14981 2.29166 2.29147 3.14999 2.29147 4.99999V17.5C2.29147 17.6167 2.36647 17.6667 2.40814 17.6917C2.45814 17.7167 2.54147 17.7333 2.62481 17.6667L4.04981 16.6C4.30814 16.4083 4.61647 16.3083 4.92481 16.3083Z"
      fill="currentColor"
    />
    <path
      d="M9.52523 11.7333C9.05856 11.7333 8.69189 11.3583 8.69189 10.9C8.69189 10.4417 9.06689 10.0667 9.52523 10.0667C9.98356 10.0667 10.3586 10.4417 10.3586 10.9C10.3586 11.3583 9.98356 11.7333 9.52523 11.7333Z"
      fill="currentColor"
    />
    <path
      d="M5.47493 8.35835C5.00827 8.35835 4.6416 7.98335 4.6416 7.52501C4.6416 7.06668 5.0166 6.69168 5.47493 6.69168C5.93327 6.69168 6.30827 7.06668 6.30827 7.52501C6.30827 7.98335 5.93327 8.35835 5.47493 8.35835Z"
      fill="currentColor"
    />
    <path
      d="M5.22497 12.0666C5.06663 12.0666 4.9083 12.0083 4.7833 11.8833C4.54163 11.6416 4.54163 11.2416 4.7833 11L9.3333 6.44996C9.57497 6.20829 9.97497 6.20829 10.2166 6.44996C10.4583 6.69162 10.4583 7.09162 10.2166 7.33329L5.66663 11.8833C5.54997 12 5.3833 12.0666 5.22497 12.0666Z"
      fill="currentColor"
    />
  </svg>
);

export const PatientReferralIcon = (props) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 17C15.6193 17 14.5 15.8807 14.5 14.5C14.5 13.1193 15.6193 12 17 12C18.3807 12 19.5 13.1193 19.5 14.5C19.5 15.8807 18.3807 17 17 17ZM17 17C19.4853 17 21.5 19.0147 21.5 21.5M17 17C14.5147 17 12.5 19.0147 12.5 21.5"
      stroke={'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 7.5C5.61929 7.5 4.5 6.38071 4.5 5C4.5 3.61929 5.61929 2.5 7 2.5C8.38071 2.5 9.5 3.61929 9.5 5C9.5 6.38071 8.38071 7.5 7 7.5ZM7 7.5C9.48528 7.5 11.5 9.51472 11.5 12M7 7.5C4.51472 7.5 2.5 9.51472 2.5 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 15.5C3.5 18.2643 5.73571 20.5 8.5 20.5L8 18.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 8.5C18.5 5.73571 16.2643 3.5 13.5 3.5L14 5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const QuestionairesIcon = (props) => (
  <svg
    width={props.width || 20}
    height={props.height || 20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.32507 18.9833C7.82507 18.9833 7.35008 18.7333 7.02508 18.2917L6.02509 16.9583C6.02509 16.9667 5.98342 16.9417 5.96675 16.9417H5.65842C2.80842 16.9417 1.04175 16.1667 1.04175 12.325V8.99167C1.04175 5.48334 3.18342 4.56667 4.98342 4.40834C5.18342 4.38334 5.41676 4.375 5.65842 4.375H10.9918C14.0084 4.375 15.6084 5.97501 15.6084 8.99167V12.325C15.6084 12.5667 15.6001 12.8 15.5667 13.025C15.4167 14.8 14.5001 16.9417 10.9918 16.9417H10.6584L9.62507 18.2917C9.30007 18.7333 8.82507 18.9833 8.32507 18.9833ZM5.65842 5.625C5.46676 5.625 5.28342 5.63333 5.10842 5.65C3.17509 5.81667 2.29175 6.87501 2.29175 8.99167V12.325C2.29175 15.1833 3.17509 15.6917 5.65842 15.6917H5.99175C6.36675 15.6917 6.79174 15.9 7.02508 16.2L8.02509 17.5417C8.20842 17.7917 8.44175 17.7917 8.62509 17.5417L9.62507 16.2083C9.86674 15.8833 10.2501 15.6917 10.6584 15.6917H10.9918C13.1084 15.6917 14.1668 14.8 14.3251 12.9C14.3501 12.7 14.3584 12.5167 14.3584 12.325V8.99167C14.3584 6.66667 13.3168 5.625 10.9918 5.625H5.65842Z"
      fill="currentColor"
    />
    <path
      d="M8.32528 11.825C7.85861 11.825 7.49194 11.45 7.49194 10.9917C7.49194 10.5333 7.86694 10.1583 8.32528 10.1583C8.78361 10.1583 9.15861 10.5333 9.15861 10.9917C9.15861 11.45 8.79194 11.825 8.32528 11.825Z"
      fill="currentColor"
    />
    <path
      d="M10.9915 11.825C10.5249 11.825 10.1582 11.45 10.1582 10.9917C10.1582 10.5333 10.5332 10.1583 10.9915 10.1583C11.4499 10.1583 11.8249 10.5333 11.8249 10.9917C11.8249 11.45 11.4499 11.825 10.9915 11.825Z"
      fill="currentColor"
    />
    <path
      d="M5.66659 11.825C5.19992 11.825 4.83325 11.45 4.83325 10.9917C4.83325 10.5333 5.20825 10.1583 5.66659 10.1583C6.12492 10.1583 6.49992 10.5333 6.49992 10.9917C6.49992 11.45 6.12492 11.825 5.66659 11.825Z"
      fill="currentColor"
    />
    <path
      d="M14.9502 13.575C14.7835 13.575 14.6169 13.5084 14.5002 13.3834C14.3669 13.25 14.3085 13.0584 14.3335 12.875C14.3585 12.7 14.3669 12.5167 14.3669 12.325V8.99169C14.3669 6.66669 13.3252 5.62502 11.0002 5.62502H5.66685C5.47518 5.62502 5.29187 5.63335 5.11687 5.65002C4.93354 5.67502 4.74186 5.60834 4.60852 5.48334C4.47519 5.35001 4.40018 5.1667 4.41685 4.98336C4.56685 3.18336 5.49185 1.04169 9.00018 1.04169H14.3335C17.3502 1.04169 18.9502 2.64169 18.9502 5.65836V8.99169C18.9502 12.5 16.8085 13.4167 15.0085 13.575C14.9835 13.575 14.9669 13.575 14.9502 13.575ZM5.76687 4.37502H10.9919C14.0085 4.37502 15.6085 5.97503 15.6085 8.99169V12.2167C17.0252 11.8667 17.6919 10.825 17.6919 8.99169V5.65836C17.6919 3.33336 16.6502 2.29169 14.3252 2.29169H8.99187C7.15853 2.29169 6.1252 2.95835 5.76687 4.37502Z"
      fill="currentColor"
    />
  </svg>
);

export const UserIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 14}
    height={props.height || 16}
    fill={props.color || 'none'}
    viewBox="0 0 18 20"
    {...props}
  >
    <path
      stroke={props.stroke || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 19c0-1.396 0-2.093-.172-2.661a4 4 0 0 0-2.667-2.667c-.568-.172-1.265-.172-2.661-.172h-5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C1 16.907 1 17.604 1 19M13.5 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
    />
  </svg>
);

// ---------- Detail Page Icons ----------

export const ArrowDownIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" {...props}>
    <path
      stroke="#64748B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 2.917v8.166M11.083 7 7 11.083 2.917 7"
    />
  </svg>
);

export const ReSyncIcon = (props) => (
  <svg
    width={props?.size || '18'}
    height={props?.size || '18'}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.5 9C16.5 13.14 13.14 16.5 9 16.5C4.86 16.5 2.3325 12.33 2.3325 12.33M2.3325 12.33H5.7225M2.3325 12.33V16.08M1.5 9C1.5 4.86 4.83 1.5 9 1.5C14.0025 1.5 16.5 5.67 16.5 5.67M16.5 5.67V1.92M16.5 5.67H13.17"
      stroke={props?.stroke || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BackIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    width={props?.width || 16}
    height={props?.height || 16}
    fill="none"
    {...props}
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    className="size-6"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
  </svg>
);

export const MergeIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.3079 15.625C11.9163 15.625 10.5829 15.1083 9.55794 14.1833C9.42461 14.0667 9.34961 13.8917 9.34961 13.7167C9.34961 13.5417 9.42461 13.3667 9.55794 13.25C10.4829 12.4333 11.0163 11.25 11.0163 10C11.0163 8.75 10.4829 7.56667 9.55794 6.75C9.42461 6.63333 9.34961 6.46667 9.34961 6.28333C9.34961 6.10833 9.42461 5.93333 9.55794 5.81667C10.5913 4.88333 11.9163 4.375 13.3079 4.375C16.4079 4.375 18.9329 6.9 18.9329 10C18.9329 13.1 16.4163 15.625 13.3079 15.625ZM10.9163 13.6583C11.6246 14.125 12.4496 14.375 13.3163 14.375C15.7246 14.375 17.6913 12.4083 17.6913 10C17.6913 7.59167 15.7246 5.625 13.3163 5.625C12.4579 5.625 11.6246 5.875 10.9163 6.34167C11.7829 7.35 12.2746 8.64167 12.2746 10C12.2746 11.3583 11.7829 12.65 10.9163 13.6583Z"
      fill="currentColor"
    />
    <path
      d="M6.6416 15.625C3.5416 15.625 1.0166 13.1 1.0166 10C1.0166 6.9 3.5416 4.375 6.6416 4.375C8.03327 4.375 9.3666 4.89167 10.3916 5.81667C11.5749 6.86667 12.2666 8.39167 12.2666 10C12.2666 11.6083 11.5833 13.125 10.3916 14.1833C9.3666 15.1083 8.03327 15.625 6.6416 15.625ZM6.6416 5.625C4.23327 5.625 2.2666 7.59167 2.2666 10C2.2666 12.4083 4.23327 14.375 6.6416 14.375C7.72493 14.375 8.75827 13.975 9.55827 13.25C10.4916 12.425 11.0166 11.2417 11.0166 10C11.0166 8.75833 10.4833 7.56667 9.55827 6.75C8.75827 6.025 7.72493 5.625 6.6416 5.625Z"
      fill="currentColor"
    />
  </svg>
);

export const PersonIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 18}
    height={props?.height || 17}
    fill={props.color || 'none'}
    style={{ flexShrink: 0 }}
    {...props}
  >
    <path
      stroke={props.stroke || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props?.strokeWidth || 1.5}
      d="M1.5 15.667c1.946-2.065 4.59-3.334 7.5-3.334s5.553 1.27 7.5 3.334M12.75 5.25a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
    />
  </svg>
);

export const DetailIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 18}
    height={props?.height || 18}
    fill="none"
    {...props}
  >
    <path
      stroke="#334155"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.583 8.167H9.417m4.166 3.333H9.417m4.166-6.667H9.417M6.5 1.5v15m-1-15h7c1.4 0 2.1 0 2.635.272a2.5 2.5 0 0 1 1.092 1.093C16.5 3.4 16.5 4.1 16.5 5.5v7c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092c-.535.273-1.235.273-2.635.273h-7c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092C1.5 14.6 1.5 13.9 1.5 12.5v-7c0-1.4 0-2.1.272-2.635a2.5 2.5 0 0 1 1.093-1.093C3.4 1.5 4.1 1.5 5.5 1.5Z"
    />
  </svg>
);

export const ActivityIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={props.width || 16} height={props.height || 20} fill="none" {...props}>
    <path
      stroke="#334155"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.833 1.667-7.422 8.906c-.29.349-.436.523-.438.67a.417.417 0 0 0 .155.331c.114.093.341.093.795.093H8l-.833 6.666 7.422-8.906c.29-.349.436-.523.438-.67a.417.417 0 0 0-.155-.331c-.114-.093-.341-.093-.795-.093H8l.833-6.666Z"
    />
  </svg>
);

export const ChatIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={props.width || 18} height={props.height || 18} fill="none" {...props}>
    <path
      stroke="#334155"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.833 6.083H9M4.833 9H11.5m-6.667 5v1.946c0 .444 0 .666.091.78.08.1.2.157.326.157.146 0 .32-.139.666-.416l1.988-1.59c.406-.325.61-.488.836-.603a2.5 2.5 0 0 1 .634-.223c.25-.051.51-.051 1.03-.051H12.5c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.092-1.092C16.5 12.1 16.5 11.4 16.5 10V5.5c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 0 0-1.092-1.093C14.6 1.5 13.9 1.5 12.5 1.5h-7c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.093 1.093C1.5 3.4 1.5 4.1 1.5 5.5v5.167c0 .775 0 1.162.085 1.48a2.5 2.5 0 0 0 1.768 1.768c.318.085.705.085 1.48.085Z"
    />
  </svg>
);

export const SendIcon = (props) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 25}
    {...props}
  >
    <path
      d="M9.50929 4.72965L18.0693 9.00965C21.9093 10.9296 21.9093 14.0696 18.0693 15.9896L9.50929 20.2696C3.74929 23.1496 1.39929 20.7896 4.27929 15.0396L5.14929 13.3096C5.36929 12.8696 5.36929 12.1396 5.14929 11.6996L4.27929 9.95965C1.39929 4.20965 3.75929 1.84965 9.50929 4.72965Z"
      stroke={props?.stroke || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.43945 12.5H10.8395"
      stroke={props?.stroke || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SupportIcon = (props) => (
  <svg
    style={{ overflow: 'visible' }}
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 18}
    height={props.height || 18}
    fill="none"
    {...props}
  >
    <path
      stroke={props.stroke || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.5 14V9a7.5 7.5 0 0 0-15 0v5m2.083 2.5A2.083 2.083 0 0 1 1.5 14.417V12.75a2.083 2.083 0 1 1 4.167 0v1.667c0 1.15-.933 2.083-2.084 2.083Zm10.834 0a2.083 2.083 0 0 1-2.084-2.083V12.75a2.083 2.083 0 0 1 4.167 0v1.667c0 1.15-.933 2.083-2.083 2.083Z"
    />
  </svg>
);

export const SendArrowIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 16}
    height={props?.height || 16}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.875 8H2.75m-.063.219-1.751 5.23c-.138.412-.207.617-.157.744.043.11.135.193.248.225.131.036.329-.053.724-.23l12.533-5.64c.386-.174.579-.261.639-.382a.376.376 0 0 0 0-.332c-.06-.12-.253-.207-.639-.381L1.746 1.81c-.394-.177-.59-.266-.721-.23a.375.375 0 0 0-.249.225c-.05.126.019.331.155.741l1.756 5.292c.024.07.035.106.04.142a.375.375 0 0 1 0 .096.792.792 0 0 1-.04.142Z"
    />
  </svg>
);

export const TrashIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 20}
    height={props?.height || 20}
    fill={props.color || 'none'}
    {...props}
  >
    <path
      stroke={props.stroke || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 1h6M1 4h18m-2 0-.701 10.52c-.105 1.578-.158 2.367-.499 2.965a3 3 0 0 1-1.298 1.215c-.62.3-1.41.3-2.993.3H8.491c-1.582 0-2.373 0-2.993-.3A3 3 0 0 1 4.2 17.485c-.34-.598-.393-1.387-.499-2.966L3 4m5 4.5v5m4-5v5"
    />
  </svg>
);

export const ContactEditIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 20}
    height={props?.height || 18}
    fill={props.color || 'none'}
    viewBox="0 0 22 20"
    {...props}
  >
    <path
      stroke={props.stroke || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 13.5H6.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C1 16.907 1 17.604 1 19M13.5 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM10 19l3.101-.886c.149-.043.223-.064.292-.096a.998.998 0 0 0 .175-.102c.061-.045.116-.1.225-.21l6.457-6.456a1.768 1.768 0 1 0-2.5-2.5l-6.457 6.457c-.11.11-.164.164-.209.225a.998.998 0 0 0-.102.175 2.07 2.07 0 0 0-.096.292L10 19Z"
    />
  </svg>
);

export const CopyIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_20398_37554)">
      <path
        d="M7.5 12.5C7.5 10.143 7.5 8.9645 8.23223 8.23223C8.9645 7.5 10.143 7.5 12.5 7.5H13.3333C15.6903 7.5 16.8688 7.5 17.6011 8.23223C18.3333 8.9645 18.3333 10.143 18.3333 12.5V13.3333C18.3333 15.6903 18.3333 16.8688 17.6011 17.6011C16.8688 18.3333 15.6903 18.3333 13.3333 18.3333H12.5C10.143 18.3333 8.9645 18.3333 8.23223 17.6011C7.5 16.8688 7.5 15.6903 7.5 13.3333V12.5Z"
        stroke="#096DD9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.164 7.49935C14.162 5.03511 14.1247 3.75869 13.4074 2.88471C13.2689 2.71592 13.1141 2.56117 12.9454 2.42265C12.0234 1.66602 10.6536 1.66602 7.91406 1.66602C5.1745 1.66602 3.80471 1.66602 2.88275 2.42265C2.71397 2.56116 2.55921 2.71592 2.4207 2.88471C1.66406 3.80667 1.66406 5.17645 1.66406 7.91602C1.66406 10.6556 1.66406 12.0253 2.4207 12.9473C2.5592 13.1161 2.71397 13.2708 2.88275 13.4093C3.75674 14.1267 5.03315 14.1639 7.4974 14.1659"
        stroke="#096DD9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_20398_37554">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// ------------- Listings icons ----------

export const ActionsIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={props.width || 4} height={props.width || 14} fill="none" {...props}>
    <path
      stroke="#64748B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2 7.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM2 2.5A.75.75 0 1 0 2 1a.75.75 0 0 0 0 1.5ZM2 13a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
    />
  </svg>
);

// --------------- Arrow Icons -----------

export const ArrowRightIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 6}
    height={props?.height || 12}
    fill={props.color || 'none'}
    {...props}
  >
    <path
      stroke={props.stroke || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M.75 10.5 5.25 6 .75 1.5"
    />
  </svg>
);

export const BackArrowIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 12}
    height={props?.height || 12}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.25 6H.75m0 0L6 11.25M.75 6 6 .75"
    />
  </svg>
);

export const ReplyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props?.width || 12}
    height={props?.height || 12}
    {...props}
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="size-6"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
  </svg>
);

export const Envelope = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={props?.width || 12}
      height={props?.height || 12}
      {...props}
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
      />
    </svg>
  );
};

export const ClosedEnvelope = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={props?.width || 12}
      height={props?.height || 12}
      {...props}
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.981l7.5-4.039a2.25 2.25 0 0 1 2.134 0l7.5 4.039a2.25 2.25 0 0 1 1.183 1.98V19.5Z"
      />
    </svg>
  );
};

export const MissedCall = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={props?.width || 12}
      height={props?.height || 12}
      {...props}
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 3.75 18 6m0 0 2.25 2.25M18 6l2.25-2.25M18 6l-2.25 2.25m1.5 13.5c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z"
      />
    </svg>
  );
};

export const ExternalLink = (props) => {
  return (
    <svg
      width={props?.size || '20'}
      height={props?.size || '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.25076 2.50195C6.21001 2.50742 4.6177 2.58207 3.60011 3.59964C2.50195 4.69777 2.50195 6.46519 2.50195 9.99997C2.50195 13.5348 2.50195 15.3022 3.60011 16.4003C4.69826 17.4985 6.46573 17.4985 10.0007 17.4985C13.5355 17.4985 15.303 17.4985 16.4012 16.4003C17.4188 15.3828 17.4934 13.7906 17.4989 10.7499"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0678 2.93164L12.4434 7.5433M17.0678 2.93164C16.6561 2.51955 13.8831 2.55797 13.2969 2.5663M17.0678 2.93164C17.4794 3.34374 17.441 6.11979 17.4327 6.70667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CameraIcon = (props) => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.5 13.5C4.5 11.8431 5.84315 10.5 7.5 10.5H8.89445C9.89751 10.5 10.8342 9.9987 11.3906 9.1641L12.6094 7.3359C13.1658 6.5013 14.1025 6 15.1056 6H20.8944C21.8975 6 22.8342 6.5013 23.3906 7.3359L24.6094 9.1641C25.1658 9.9987 26.1025 10.5 27.1056 10.5H28.5C30.1569 10.5 31.5 11.8431 31.5 13.5V27C31.5 28.6569 30.1569 30 28.5 30H7.5C5.84315 30 4.5 28.6569 4.5 27V13.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5 19.5C22.5 21.9853 20.4853 24 18 24C15.5147 24 13.5 21.9853 13.5 19.5C13.5 17.0147 15.5147 15 18 15C20.4853 15 22.5 17.0147 22.5 19.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SettingsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-6"
      width={props?.width || 20}
      height={props?.height || 20}
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
    </svg>
  );
};

export const CoreIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-6"
      width={props?.width || 20}
      height={props?.height || 20}
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.429 9.75 2.25 12l4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0 4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0-5.571 3-5.571-3"
      />
    </svg>
  );
};

export const TemplateIcon = (props) => {
  return (
    <svg
      width={props?.width || 20}
      height={props?.height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5001 18.9584H7.50008C2.97508 18.9584 1.04175 17.025 1.04175 12.5V7.50002C1.04175 2.97502 2.97508 1.04169 7.50008 1.04169H11.6667C12.0084 1.04169 12.2917 1.32502 12.2917 1.66669C12.2917 2.00835 12.0084 2.29169 11.6667 2.29169H7.50008C3.65841 2.29169 2.29175 3.65835 2.29175 7.50002V12.5C2.29175 16.3417 3.65841 17.7084 7.50008 17.7084H12.5001C16.3417 17.7084 17.7084 16.3417 17.7084 12.5V8.33335C17.7084 7.99169 17.9917 7.70835 18.3334 7.70835C18.6751 7.70835 18.9584 7.99169 18.9584 8.33335V12.5C18.9584 17.025 17.0251 18.9584 12.5001 18.9584Z"
        fill="currentColor"
      />
      <path
        d="M18.3334 8.95834H15.0001C12.1501 8.95834 11.0417 7.85001 11.0417 5.00001V1.66668C11.0417 1.41668 11.1917 1.18334 11.4251 1.09168C11.6584 0.991678 11.9251 1.05001 12.1084 1.22501L18.7751 7.89168C18.9501 8.06668 19.0084 8.34168 18.9084 8.57501C18.8084 8.80834 18.5834 8.95834 18.3334 8.95834ZM12.2917 3.17501V5.00001C12.2917 7.15001 12.8501 7.70834 15.0001 7.70834H16.8251L12.2917 3.17501Z"
        fill="currentColor"
      />
      <path
        d="M10.8333 11.4583H5.83325C5.49159 11.4583 5.20825 11.175 5.20825 10.8333C5.20825 10.4916 5.49159 10.2083 5.83325 10.2083H10.8333C11.1749 10.2083 11.4583 10.4916 11.4583 10.8333C11.4583 11.175 11.1749 11.4583 10.8333 11.4583Z"
        fill="currentColor"
      />
      <path
        d="M9.16659 14.7917H5.83325C5.49159 14.7917 5.20825 14.5084 5.20825 14.1667C5.20825 13.825 5.49159 13.5417 5.83325 13.5417H9.16659C9.50825 13.5417 9.79159 13.825 9.79159 14.1667C9.79159 14.5084 9.50825 14.7917 9.16659 14.7917Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UploadIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-6"
      width={props?.width || 20}
      height={props?.height || 20}
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"
      />
    </svg>
  );
};

export const BellIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-6"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
      />
    </svg>
  );
};

export const LockIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.75 8.75V5.625C13.75 4.63044 13.3549 3.67661 12.6516 2.97335C11.9484 2.27009 10.9946 1.875 10 1.875C9.00544 1.875 8.05161 2.27009 7.34835 2.97335C6.64509 3.67661 6.25 4.63044 6.25 5.625V8.75M5.625 18.125H14.375C14.8723 18.125 15.3492 17.9275 15.7008 17.5758C16.0525 17.2242 16.25 16.7473 16.25 16.25V10.625C16.25 10.1277 16.0525 9.65081 15.7008 9.29917C15.3492 8.94754 14.8723 8.75 14.375 8.75H5.625C5.12772 8.75 4.65081 8.94754 4.29917 9.29917C3.94754 9.65081 3.75 10.1277 3.75 10.625V16.25C3.75 16.7473 3.94754 17.2242 4.29917 17.5758C4.65081 17.9275 5.12772 18.125 5.625 18.125Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TimerIcon = (props) => {
  return (
    <svg
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '21'}
      height={props.height || '20'}
      {...props}
    >
      <path
        d="M8.88514 2.29199C8.70806 2.29199 8.55966 2.23206 8.43993 2.1122C8.32007 1.99234 8.26014 1.84387 8.26014 1.66678C8.26014 1.48956 8.32007 1.34116 8.43993 1.22158C8.55966 1.10185 8.70806 1.04199 8.88514 1.04199H12.3147C12.4918 1.04199 12.6402 1.10192 12.7599 1.22178C12.8798 1.34165 12.9397 1.49012 12.9397 1.6672C12.9397 1.84442 12.8798 1.99283 12.7599 2.11241C12.6402 2.23213 12.4918 2.29199 12.3147 2.29199H8.88514ZM10.6001 11.5068C10.7774 11.5068 10.9258 11.4469 11.0454 11.327C11.1651 11.2073 11.2249 11.0589 11.2249 10.8818V7.4522C11.2249 7.27512 11.165 7.12671 11.0451 7.00699C10.9253 6.88713 10.7768 6.8272 10.5997 6.8272C10.4225 6.8272 10.2741 6.88713 10.1545 7.00699C10.0348 7.12671 9.97493 7.27512 9.97493 7.4522V10.8818C9.97493 11.0589 10.0349 11.2073 10.1547 11.327C10.2746 11.4469 10.4231 11.5068 10.6001 11.5068ZM10.5999 17.917C9.62813 17.917 8.71209 17.7311 7.85181 17.3593C6.99153 16.9875 6.23987 16.48 5.59681 15.8368C4.95362 15.1937 4.44612 14.4421 4.07431 13.5818C3.7025 12.7215 3.5166 11.8055 3.5166 10.8337C3.5166 9.86185 3.7025 8.94581 4.07431 8.08553C4.44612 7.22526 4.95362 6.47359 5.59681 5.83053C6.23987 5.18734 6.99153 4.67984 7.85181 4.30803C8.71209 3.93623 9.62813 3.75033 10.5999 3.75033C11.4344 3.75033 12.2381 3.89192 13.011 4.17512C13.7839 4.45817 14.5016 4.86359 15.1641 5.39137L15.7635 4.79199C15.8788 4.67658 16.0238 4.61755 16.1985 4.61491C16.3732 4.61227 16.5209 4.6713 16.6416 4.79199C16.7623 4.91269 16.8226 5.05908 16.8226 5.23116C16.8226 5.4031 16.7623 5.54942 16.6416 5.67012L16.0422 6.26949C16.57 6.93199 16.9754 7.6497 17.2585 8.42262C17.5417 9.19553 17.6833 9.99922 17.6833 10.8337C17.6833 11.8055 17.4974 12.7215 17.1256 13.5818C16.7538 14.4421 16.2463 15.1937 15.6031 15.8368C14.96 16.48 14.2083 16.9875 13.3481 17.3593C12.4878 17.7311 11.5717 17.917 10.5999 17.917ZM10.5999 16.667C12.211 16.667 13.586 16.0975 14.7249 14.9587C15.8638 13.8198 16.4333 12.4448 16.4333 10.8337C16.4333 9.22255 15.8638 7.84755 14.7249 6.70866C13.586 5.56977 12.211 5.00033 10.5999 5.00033C8.98882 5.00033 7.61382 5.56977 6.47493 6.70866C5.33605 7.84755 4.7666 9.22255 4.7666 10.8337C4.7666 12.4448 5.33605 13.8198 6.47493 14.9587C7.61382 16.0975 8.98882 16.667 10.5999 16.667Z"
        fill={props?.stroke || 'currentColor'}
      />
    </svg>
  );
};

export const CheckCaseIcon = (props) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '20'}
      height={props.height || '20'}
      {...props}
    >
      <g clipPath="url(#clip0_506_2513)">
        <path
          d="M15.2431 10.1048L14.7504 4.74473C14.7397 4.62832 14.6859 4.52011 14.5995 4.44132C14.5132 4.36254 14.4005 4.31886 14.2836 4.31887H11.4212V3.22984C11.4212 1.53504 10.0424 0.15625 8.34764 0.15625C6.65287 0.15625 5.27404 1.53504 5.27404 3.22984V4.31883H2.41162C2.29472 4.31882 2.18204 4.3625 2.09568 4.44129C2.00932 4.52007 1.95552 4.62828 1.94482 4.74469L0.926463 15.8243C0.887088 16.253 1.01963 16.6478 1.30974 16.9658C1.59994 17.2838 1.98084 17.452 2.41135 17.452H9.92435C10.7881 18.884 12.3588 19.8438 14.1496 19.8438C16.8684 19.8438 19.0803 17.6318 19.0803 14.913C19.0803 12.57 17.4374 10.6035 15.2431 10.1048ZM6.21154 3.22984C6.21154 2.05199 7.16978 1.09375 8.34764 1.09375C9.52549 1.09375 10.4838 2.05199 10.4838 3.22984V4.31883H6.21154V3.22984ZM2.41135 16.5145C2.24467 16.5145 2.11471 16.4571 2.00236 16.3339C1.89002 16.2108 1.84482 16.0761 1.86006 15.9101L2.83928 5.25637H5.27404V6.11102C5.27404 6.36988 5.48392 6.57977 5.74279 6.57977C6.00166 6.57977 6.21154 6.36988 6.21154 6.11102V5.25637H10.4838V6.11102C10.4838 6.36988 10.6937 6.57977 10.9525 6.57977C11.2114 6.57977 11.4213 6.36988 11.4213 6.11102V5.25637H13.856L14.2906 9.98453C14.2436 9.98315 14.1967 9.98243 14.1497 9.98238C11.4309 9.98238 9.21896 12.1943 9.21896 14.9131C9.21896 15.4734 9.3131 16.0121 9.48611 16.5145H2.41135ZM14.1496 18.9062C11.9478 18.9062 10.1564 17.1149 10.1564 14.913C10.1564 12.7112 11.9478 10.9198 14.1496 10.9198C16.3515 10.9198 18.1428 12.7112 18.1428 14.913C18.1428 17.1149 16.3515 18.9062 14.1496 18.9062ZM16.3525 13.443C16.5315 13.63 16.5251 13.9267 16.3381 14.1058L13.9445 16.3975C13.8573 16.4811 13.7411 16.5278 13.6203 16.5277C13.5028 16.5278 13.3897 16.4837 13.3033 16.4041L11.9683 15.1782C11.7777 15.0031 11.765 14.7066 11.9401 14.5159C12.1153 14.3252 12.4118 14.3126 12.6024 14.4877L13.6137 15.4163L15.6897 13.4286C15.8767 13.2496 16.1734 13.256 16.3525 13.443Z"
          fill={props?.stroke || 'currentColor'}
        />
      </g>
      <defs>
        <clipPath id="clip0_506_2513">
          <rect width={props.width || '20'} height={props.height || '20'} fill={props?.stroke || 'currentColor'} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TruckIcon = (props) => {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99994 1L10.9651 4.21723C11.1935 4.97859 11.8943 5.5 12.6892 5.5H17.6499"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1L12.7001 1.00034C13.2666 1.00036 13.8001 1.26708 14.14 1.72027L16.3 4.6L18.1985 5.86567C18.6992 6.19948 19 6.76153 19 7.36336V10.0004C19 10.4974 18.5971 10.9004 18.1 10.9004H16.3M1.9 1.00037L2.8 2.8C1.9 4.6 1 6.4 1 10L2.41944 10.71C2.6697 10.8352 2.94569 10.9004 3.22551 10.9002L3.7 10.9M7.3 10.9004H12.7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 12.7C15.4941 12.7 16.3 11.8941 16.3 10.9C16.3 9.90586 15.4941 9.09998 14.5 9.09998C13.5059 9.09998 12.7 9.90586 12.7 10.9C12.7 11.8941 13.5059 12.7 14.5 12.7Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.50001 12.7C6.49412 12.7 7.30001 11.8941 7.30001 10.9C7.30001 9.90586 6.49412 9.09998 5.50001 9.09998C4.5059 9.09998 3.70001 9.90586 3.70001 10.9C3.70001 11.8941 4.5059 12.7 5.50001 12.7Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TickIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.33594 9.33398L5.66927 11.6673L12.6693 4.33398"
        stroke={props?.stroke ?? '#24A147'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.33594 9.33398L5.66927 11.6673L12.6693 4.33398"
        stroke={'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CustomerSupportIcon = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      {...props}
    >
      <g clipPath="url(#clip0_323_2016)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.589 15.9768H3.49971C2.83674 15.9768 2.20093 15.7135 1.73215 15.2447C1.26336 14.7759 1 14.1401 1 13.4771V11.5349C1 10.8719 1.26336 10.2361 1.73215 9.7673C2.20093 9.29852 2.83674 9.03516 3.49971 9.03516H4.37305V9.01367C4.37305 4.8014 7.78777 1.38672 12 1.38672C16.2123 1.38672 19.627 4.8014 19.627 9.01367V9.03516H20.5003C21.1633 9.03516 21.7991 9.29852 22.2679 9.7673C22.7366 10.2361 23 10.8719 23 11.5349V13.4771C23 14.1401 22.7366 14.7759 22.2679 15.2447C21.7991 15.7135 21.1633 15.9768 20.5003 15.9768H19.2893C19.1738 15.9768 19.0629 15.9309 18.9812 15.8492C18.8994 15.7675 18.8535 15.6566 18.8535 15.541V9.01367C18.8535 5.2286 15.7851 2.16016 12 2.16016C8.21493 2.16016 5.14648 5.2286 5.14648 9.01367V15.541C5.14649 15.5982 5.13522 15.6549 5.11332 15.7078C5.09143 15.7607 5.05933 15.8087 5.01886 15.8492C4.97839 15.8897 4.93035 15.9218 4.87747 15.9437C4.8246 15.9656 4.76793 15.9768 4.7107 15.9768H4.36248C4.38229 18.4234 6.37152 20.4004 8.82246 20.4004H9.57072C9.65904 19.9927 9.8843 19.6275 10.209 19.3656C10.5337 19.1037 10.9383 18.9609 11.3555 18.9609H12.6445C13.6531 18.9609 14.4707 19.7785 14.4707 20.7871C14.4707 21.7957 13.6531 22.6133 12.6445 22.6133H11.3555C10.4796 22.6133 9.74779 21.9967 9.57033 21.1738H8.82246C5.94416 21.1738 3.60855 18.8503 3.589 15.9768ZM13.6973 20.7871C13.6973 20.2057 13.2259 19.7344 12.6445 19.7344H11.3555C11.2172 19.7344 11.0803 19.7616 10.9526 19.8145C10.8249 19.8674 10.7088 19.9449 10.6111 20.0427C10.5133 20.1405 10.4358 20.2565 10.3829 20.3842C10.33 20.512 10.3027 20.6489 10.3027 20.7871C10.3027 21.3685 10.7741 21.8398 11.3555 21.8398H12.6445C13.2259 21.8398 13.6973 21.3685 13.6973 20.7871ZM4.37305 9.80859H3.49971C3.04188 9.80861 2.6028 9.99048 2.27906 10.3142C1.95533 10.638 1.77345 11.077 1.77344 11.5349V13.4771C1.77345 13.935 1.95533 14.374 2.27906 14.6978C2.6028 15.0215 3.04188 15.2034 3.49971 15.2034H4.37305V9.80859ZM19.627 9.80859V15.2034H20.5003C20.9581 15.2034 21.3972 15.0215 21.7209 14.6978C22.0447 14.374 22.2266 13.935 22.2266 13.4771V11.5349C22.2266 11.3082 22.1819 11.0837 22.0952 10.8742C22.0084 10.6648 21.8813 10.4745 21.721 10.3142C21.5607 10.1539 21.3704 10.0267 21.1609 9.93996C20.9515 9.85322 20.727 9.80858 20.5003 9.80859H19.627Z"
          fill={props?.stroke || 'currentColor'}
          stroke={props?.stroke || 'currentColor'}
        />
      </g>
      <defs>
        <clipPath id="clip0_323_2016">
          <rect width={props.width || '24'} height={props.height || '24'} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MyLabsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.0833 8.74935V8.33268C17.0833 5.18998 17.0833 3.61864 16.1071 2.64232C15.1307 1.66602 13.5594 1.66602 10.4167 1.66602H9.58341C6.44077 1.66602 4.86944 1.66602 3.89313 2.64232C2.91682 3.61862 2.91681 5.18995 2.91678 8.33262L2.91675 12.0827C2.91672 14.8222 2.91671 16.192 3.67331 17.1139C3.81185 17.2828 3.96663 17.4375 4.13543 17.5761C5.05739 18.3327 6.42716 18.3327 9.16666 18.3327"
        stroke="#077882"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.25 5.83398H13.75" stroke="#077882" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.25 10H11.25" stroke="#077882" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M17.0833 16.666V14.166C17.0833 12.9748 15.964 11.666 14.5833 11.666C13.2025 11.666 12.0833 12.9748 12.0833 14.166V17.0827C12.0833 17.773 12.6429 18.3327 13.3333 18.3327C14.0236 18.3327 14.5833 17.773 14.5833 17.0827V14.166"
        stroke="#077882"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AidBoxIcon = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      {...props}
    >
      <g clipPath="url(#clip0_401_3119)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 4V5H4C3.20435 5 2.44129 5.31607 1.87868 5.87868C1.31607 6.44129 1 7.20435 1 8V20C1 20.7956 1.31607 21.5587 1.87868 22.1213C2.44129 22.6839 3.20435 23 4 23H20C20.7956 23 21.5587 22.6839 22.1213 22.1213C22.6839 21.5587 23 20.7956 23 20V8C23 7.20435 22.6839 6.44129 22.1213 5.87868C21.5587 5.31607 20.7956 5 20 5H17V4C17 3.20435 16.6839 2.44129 16.1213 1.87868C15.5587 1.31607 14.7956 1 14 1H10C9.20435 1 8.44129 1.31607 7.87868 1.87868C7.31607 2.44129 7 3.20435 7 4ZM10 2C9.46957 2 8.96086 2.21071 8.58579 2.58579C8.21071 2.96086 8 3.46957 8 4V5H16V4C16 3.46957 15.7893 2.96086 15.4142 2.58579C15.0391 2.21071 14.5304 2 14 2H10ZM2 8C2 7.46957 2.21071 6.96086 2.58579 6.58579C2.96086 6.21071 3.46957 6 4 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V8ZM8.5 13H11V10.5C11 10.3674 11.0527 10.2402 11.1464 10.1464C11.2402 10.0527 11.3674 10 11.5 10H12.5C12.6326 10 12.7598 10.0527 12.8536 10.1464C12.9473 10.2402 13 10.3674 13 10.5V13H15.5C15.6326 13 15.7598 13.0527 15.8536 13.1464C15.9473 13.2402 16 13.3674 16 13.5V14.5C16 14.6326 15.9473 14.7598 15.8536 14.8536C15.7598 14.9473 15.6326 15 15.5 15H13V17.5C13 17.6326 12.9473 17.7598 12.8536 17.8536C12.7598 17.9473 12.6326 18 12.5 18H11.5C11.3674 18 11.2402 17.9473 11.1464 17.8536C11.0527 17.7598 11 17.6326 11 17.5V15H8.5C8.36739 15 8.24021 14.9473 8.14645 14.8536C8.05268 14.7598 8 14.6326 8 14.5V13.5C8 13.3674 8.05268 13.2402 8.14645 13.1464C8.24021 13.0527 8.36739 13 8.5 13ZM14 10.5V12H15.5C15.8978 12 16.2794 12.158 16.5607 12.4393C16.842 12.7206 17 13.1022 17 13.5V14.5C17 14.8978 16.842 15.2794 16.5607 15.5607C16.2794 15.842 15.8978 16 15.5 16H14V17.5C14 17.8978 13.842 18.2794 13.5607 18.5607C13.2794 18.842 12.8978 19 12.5 19H11.5C11.1022 19 10.7206 18.842 10.4393 18.5607C10.158 18.2794 10 17.8978 10 17.5V16H8.5C8.10218 16 7.72064 15.842 7.43934 15.5607C7.15804 15.2794 7 14.8978 7 14.5V13.5C7 13.1022 7.15804 12.7206 7.43934 12.4393C7.72064 12.158 8.10218 12 8.5 12H10V10.5C10 10.1022 10.158 9.72064 10.4393 9.43934C10.7206 9.15804 11.1022 9 11.5 9H12.5C12.8978 9 13.2794 9.15804 13.5607 9.43934C13.842 9.72064 14 10.1022 14 10.5Z"
          fill={props?.stroke || 'currentColor'}
          stroke={props?.stroke || 'currentColor'}
          strokeWidth="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_401_3119">
          <rect width={props.width || '24'} height={props.height || '24'} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PaperClipIcon = (props) => {
  return (
    <svg
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '25'}
      {...props}
    >
      <path
        d="M15.1716 7.5L8.58579 14.0858C7.80474 14.8668 7.80474 16.1332 8.58579 16.9142C9.36684 17.6953 10.6332 17.6953 11.4142 16.9142L17.8284 10.3284C19.3905 8.76633 19.3905 6.23367 17.8284 4.67157C16.2663 3.10948 13.7337 3.10948 12.1716 4.67157L5.75736 11.2574C3.41421 13.6005 3.41421 17.3995 5.75736 19.7426C8.1005 22.0858 11.8995 22.0858 14.2426 19.7426L20.5 13.5"
        stroke={props?.stroke || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InBoundPolygon = (props) => {
  return (
    <svg viewBox={`0 0 11 16`} fill="none" xmlns="http://www.w3.org/2000/svg" width={'11'} height={'16'} {...props}>
      <path
        d="M0.865936 3.30937C-0.255817 2.01409 0.664279 7.34329e-05 2.37778 6.19888e-05L11.8564 0L11.8564 16L0.865936 3.30937Z"
        fill="var(--user-inner-card-bg)"
      />
    </svg>
  );
};

export const InBoundPolygonSmall = () => {
  return (
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.733635 3.28041C-0.351911 1.97776 0.574389 5.14984e-05 2.27006 3.91006e-05L8 0V12L0.733635 3.28041Z"
        fill="var('--user-inner-card-bg)"
      />
    </svg>
  );
};

export const OutBoundPolygon = (props) => {
  return (
    <svg viewBox={`0 0 12 16`} fill="none" xmlns="http://www.w3.org/2000/svg" width={'12'} height={'16'} {...props}>
      <path
        d="M11.1341 3.30937C12.2558 2.01409 11.3357 7.43866e-05 9.62222 6.29425e-05L0.143595 0L0.143595 16L11.1341 3.30937Z"
        fill="var(--user-primary-light)"
      />
    </svg>
  );
};

export const OutBoundPolygonSmall = () => {
  return (
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.26637 3.28041C8.35191 1.97776 7.42561 5.05447e-05 5.72994 3.91006e-05L0 0V12L7.26637 3.28041Z"
        fill="var(--user-primary-light)"
      />
    </svg>
  );
};

export const CopyBtnIcon = (props) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '1.2em'}
      height={props.height || '1.2em'}
      {...props}
    >
      <path
        d="M9.24996 18.9587H5.74996C2.49163 18.9587 1.04163 17.5087 1.04163 14.2503V10.7503C1.04163 7.49199 2.49163 6.04199 5.74996 6.04199H9.24996C12.5083 6.04199 13.9583 7.49199 13.9583 10.7503V14.2503C13.9583 17.5087 12.5083 18.9587 9.24996 18.9587ZM5.74996 7.29199C3.16663 7.29199 2.29163 8.16699 2.29163 10.7503V14.2503C2.29163 16.8337 3.16663 17.7087 5.74996 17.7087H9.24996C11.8333 17.7087 12.7083 16.8337 12.7083 14.2503V10.7503C12.7083 8.16699 11.8333 7.29199 9.24996 7.29199H5.74996Z"
        fill={props.fill || 'currentColor'}
      />
      <path
        d="M14.25 13.9587H13.3333C12.9916 13.9587 12.7083 13.6753 12.7083 13.3337V10.7503C12.7083 8.16699 11.8333 7.29199 9.24996 7.29199H6.66663C6.32496 7.29199 6.04163 7.00866 6.04163 6.66699V5.75033C6.04163 2.49199 7.49163 1.04199 10.75 1.04199H14.25C17.5083 1.04199 18.9583 2.49199 18.9583 5.75033V9.25033C18.9583 12.5087 17.5083 13.9587 14.25 13.9587ZM13.9583 12.7087H14.25C16.8333 12.7087 17.7083 11.8337 17.7083 9.25033V5.75033C17.7083 3.16699 16.8333 2.29199 14.25 2.29199H10.75C8.16663 2.29199 7.29163 3.16699 7.29163 5.75033V6.04199H9.24996C12.5083 6.04199 13.9583 7.49199 13.9583 10.7503V12.7087Z"
        fill={props.fill || 'currentColor'}
      />
    </svg>
  );
};

export const CalenderIcon = (props) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      style={{ flexShrink: 0 }}
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '20'}
      height={props.height || '20'}
      {...props}
    >
      <path
        d="M6.66675 4.79199C6.32508 4.79199 6.04175 4.50866 6.04175 4.16699V1.66699C6.04175 1.32533 6.32508 1.04199 6.66675 1.04199C7.00841 1.04199 7.29175 1.32533 7.29175 1.66699V4.16699C7.29175 4.50866 7.00841 4.79199 6.66675 4.79199Z"
        fill={props?.fill || 'var(--user-main-text)'}
      />
      <path
        d="M13.3333 4.79199C12.9916 4.79199 12.7083 4.50866 12.7083 4.16699V1.66699C12.7083 1.32533 12.9916 1.04199 13.3333 1.04199C13.6749 1.04199 13.9583 1.32533 13.9583 1.66699V4.16699C13.9583 4.50866 13.6749 4.79199 13.3333 4.79199Z"
        fill={props?.fill || 'var(--user-main-text)'}
      />
      <path
        d="M7.08333 12.0829C6.975 12.0829 6.86667 12.058 6.76667 12.0163C6.65833 11.9746 6.575 11.9163 6.49167 11.8413C6.34167 11.6829 6.25 11.4746 6.25 11.2496C6.25 11.1413 6.275 11.0329 6.31667 10.9329C6.35833 10.8329 6.41667 10.7413 6.49167 10.6579C6.575 10.5829 6.65833 10.5246 6.76667 10.4829C7.06667 10.3579 7.44167 10.4246 7.675 10.6579C7.825 10.8163 7.91667 11.0329 7.91667 11.2496C7.91667 11.2996 7.90833 11.358 7.9 11.4163C7.89167 11.4663 7.875 11.5163 7.85 11.5663C7.83333 11.6163 7.80833 11.6663 7.775 11.7163C7.75 11.7579 7.70833 11.7996 7.675 11.8413C7.51667 11.9913 7.3 12.0829 7.08333 12.0829Z"
        fill={props?.fill || 'var(--user-main-text)'}
      />
      <path
        d="M10.0001 12.0837C9.89175 12.0837 9.78341 12.0587 9.68341 12.0171C9.57508 11.9754 9.49175 11.917 9.40842 11.842C9.25842 11.6837 9.16675 11.4754 9.16675 11.2504C9.16675 11.142 9.19175 11.0337 9.23342 10.9337C9.27508 10.8337 9.33342 10.7421 9.40842 10.6587C9.49175 10.5837 9.57508 10.5254 9.68341 10.4837C9.98341 10.3504 10.3584 10.4254 10.5917 10.6587C10.7417 10.8171 10.8334 11.0337 10.8334 11.2504C10.8334 11.3004 10.8251 11.3587 10.8167 11.4171C10.8084 11.4671 10.7917 11.5171 10.7667 11.5671C10.7501 11.6171 10.7251 11.667 10.6917 11.717C10.6667 11.7587 10.6251 11.8004 10.5917 11.842C10.4334 11.992 10.2167 12.0837 10.0001 12.0837Z"
        fill={props?.fill || 'var(--user-main-text)'}
      />
      <path
        d="M12.9166 12.0837C12.8083 12.0837 12.6999 12.0587 12.5999 12.0171C12.4916 11.9754 12.4083 11.917 12.3249 11.842C12.2916 11.8004 12.2583 11.7587 12.2249 11.717C12.1916 11.667 12.1666 11.6171 12.1499 11.5671C12.1249 11.5171 12.1083 11.4671 12.0999 11.4171C12.0916 11.3587 12.0833 11.3004 12.0833 11.2504C12.0833 11.0337 12.1749 10.8171 12.3249 10.6587C12.4083 10.5837 12.4916 10.5254 12.5999 10.4837C12.9083 10.3504 13.2749 10.4254 13.5083 10.6587C13.6583 10.8171 13.7499 11.0337 13.7499 11.2504C13.7499 11.3004 13.7416 11.3587 13.7333 11.4171C13.7249 11.4671 13.7083 11.5171 13.6833 11.5671C13.6666 11.6171 13.6416 11.667 13.6083 11.717C13.5833 11.7587 13.5416 11.8004 13.5083 11.842C13.3499 11.992 13.1333 12.0837 12.9166 12.0837Z"
        fill={props?.fill || 'var(--user-main-text)'}
      />
      <path
        d="M7.08333 15C6.975 15 6.86667 14.975 6.76667 14.9333C6.66667 14.8917 6.575 14.8333 6.49167 14.7583C6.34167 14.6 6.25 14.3833 6.25 14.1667C6.25 14.0583 6.275 13.95 6.31667 13.85C6.35833 13.7417 6.41667 13.65 6.49167 13.575C6.8 13.2667 7.36667 13.2667 7.675 13.575C7.825 13.7333 7.91667 13.95 7.91667 14.1667C7.91667 14.3833 7.825 14.6 7.675 14.7583C7.51667 14.9083 7.3 15 7.08333 15Z"
        fill={props?.fill || 'var(--user-main-text)'}
      />
      <path
        d="M10.0001 15C9.78341 15 9.56675 14.9083 9.40842 14.7583C9.25842 14.6 9.16675 14.3833 9.16675 14.1667C9.16675 14.0583 9.19175 13.95 9.23342 13.85C9.27508 13.7417 9.33342 13.65 9.40842 13.575C9.71675 13.2667 10.2834 13.2667 10.5917 13.575C10.6667 13.65 10.7251 13.7417 10.7667 13.85C10.8084 13.95 10.8334 14.0583 10.8334 14.1667C10.8334 14.3833 10.7417 14.6 10.5917 14.7583C10.4334 14.9083 10.2167 15 10.0001 15Z"
        fill={props?.fill || 'var(--user-main-text)'}
      />
      <path
        d="M12.9166 15.0004C12.6999 15.0004 12.4833 14.9087 12.3249 14.7587C12.2499 14.6837 12.1916 14.5921 12.1499 14.4838C12.1083 14.3838 12.0833 14.2754 12.0833 14.1671C12.0833 14.0587 12.1083 13.9504 12.1499 13.8504C12.1916 13.7421 12.2499 13.6504 12.3249 13.5754C12.5166 13.3838 12.8083 13.2921 13.0749 13.3504C13.1333 13.3587 13.1833 13.3754 13.2333 13.4004C13.2833 13.4171 13.3333 13.4421 13.3833 13.4754C13.4249 13.5004 13.4666 13.5421 13.5083 13.5754C13.6583 13.7338 13.7499 13.9504 13.7499 14.1671C13.7499 14.3837 13.6583 14.6004 13.5083 14.7587C13.3499 14.9087 13.1333 15.0004 12.9166 15.0004Z"
        fill={props?.fill || 'var(--user-main-text)'}
      />
      <path
        d="M17.0834 8.20019H2.91675C2.57508 8.20019 2.29175 7.91686 2.29175 7.5752C2.29175 7.23353 2.57508 6.9502 2.91675 6.9502H17.0834C17.4251 6.9502 17.7084 7.23353 17.7084 7.5752C17.7084 7.91686 17.4251 8.20019 17.0834 8.20019Z"
        fill={props?.fill || 'var(--user-main-text)'}
      />
      <path
        d="M13.3333 18.9587H6.66667C3.625 18.9587 1.875 17.2087 1.875 14.167V7.08366C1.875 4.04199 3.625 2.29199 6.66667 2.29199H13.3333C16.375 2.29199 18.125 4.04199 18.125 7.08366V14.167C18.125 17.2087 16.375 18.9587 13.3333 18.9587ZM6.66667 3.54199C4.28333 3.54199 3.125 4.70033 3.125 7.08366V14.167C3.125 16.5503 4.28333 17.7087 6.66667 17.7087H13.3333C15.7167 17.7087 16.875 16.5503 16.875 14.167V7.08366C16.875 4.70033 15.7167 3.54199 13.3333 3.54199H6.66667Z"
        fill={props?.fill || 'var(--user-main-text)'}
      />
    </svg>
  );
};

export const ProfileIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.1329 9.68268C10.1079 9.68268 10.0912 9.68268 10.0662 9.68268C10.0246 9.67435 9.96623 9.67435 9.91623 9.68268C7.49956 9.60768 5.67456 7.70768 5.67456 5.36602C5.67456 2.98268 7.61623 1.04102 9.99956 1.04102C12.3829 1.04102 14.3246 2.98268 14.3246 5.36602C14.3162 7.70768 12.4829 9.60768 10.1579 9.68268C10.1496 9.68268 10.1412 9.68268 10.1329 9.68268ZM9.99956 2.29102C8.30789 2.29102 6.92456 3.67435 6.92456 5.36602C6.92456 7.03268 8.22456 8.37435 9.88289 8.43268C9.92456 8.42435 10.0412 8.42435 10.1496 8.43268C11.7829 8.35768 13.0662 7.01602 13.0746 5.36602C13.0746 3.67435 11.6912 2.29102 9.99956 2.29102Z"
        fill="currentColor"
      />
      <path
        d="M10.1413 18.7923C8.50801 18.7923 6.86634 18.3756 5.62467 17.5423C4.46634 16.7756 3.83301 15.7257 3.83301 14.584C3.83301 13.4423 4.46634 12.384 5.62467 11.609C8.12467 9.95065 12.1747 9.95065 14.658 11.609C15.808 12.3757 16.4497 13.4256 16.4497 14.5673C16.4497 15.709 15.8163 16.7673 14.658 17.5423C13.408 18.3756 11.7747 18.7923 10.1413 18.7923ZM6.31634 12.659C5.51634 13.1923 5.08301 13.8757 5.08301 14.5923C5.08301 15.3007 5.52467 15.984 6.31634 16.509C8.39134 17.9006 11.8913 17.9006 13.9663 16.509C14.7663 15.9756 15.1997 15.2923 15.1997 14.5757C15.1997 13.8673 14.758 13.184 13.9663 12.659C11.8913 11.2757 8.39134 11.2757 6.31634 12.659Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SaleStatsIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      stroke="#077882"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.336 11.666h1.996c.245 0 .487.056.706.162l1.701.823c.22.106.461.161.707.161h.868c.84 0 1.522.66 1.522 1.473a.074.074 0 0 1-.055.07l-2.118.586c-.38.105-.786.068-1.14-.103l-1.819-.88"
    />
    <path
      stroke="#077882"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10.836 13.75 3.827-1.176a1.655 1.655 0 0 1 1.837.628.896.896 0 0 1-.265 1.293L9.972 18.11c-.399.23-.869.286-1.307.156l-5.33-1.582M12.5 10h-1.667c-1.571 0-2.357 0-2.845-.488C7.5 9.023 7.5 8.238 7.5 6.666V5c0-1.572 0-2.357.488-2.845s1.274-.488 2.845-.488H12.5c1.571 0 2.357 0 2.845.488s.488 1.273.488 2.845v1.667c0 1.57 0 2.357-.488 2.845S14.071 10 12.5 10ZM10.836 4.167h1.667"
    />
  </svg>
);

export const ProfileSettingIcon = (props) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '20'}
      height={props.height || '20'}
      {...props}
    >
      <path
        d="M10 18.8577C9.4417 18.8577 8.87503 18.7327 8.43337 18.4743L3.85003 15.8327C1.98337 14.5744 1.8667 14.3827 1.8667 12.4077V7.59102C1.8667 5.61602 1.97503 5.42435 3.80837 4.18268L8.42503 1.51602C9.30003 1.00768 10.675 1.00768 11.55 1.51602L16.15 4.16602C18.0167 5.42435 18.1334 5.61602 18.1334 7.59102V12.3993C18.1334 14.3743 18.025 14.566 16.1917 15.8077L11.575 18.4743C11.125 18.7327 10.5584 18.8577 10 18.8577ZM10 2.39102C9.65003 2.39102 9.30837 2.45768 9.0667 2.59935L4.48337 5.24935C3.12503 6.16602 3.12503 6.16602 3.12503 7.59102V12.3993C3.12503 13.8243 3.12503 13.8243 4.5167 14.766L9.0667 17.391C9.55837 17.6744 10.45 17.6744 10.9417 17.391L15.525 14.741C16.875 13.8244 16.875 13.8243 16.875 12.3993V7.59102C16.875 6.16602 16.875 6.16602 15.4834 5.22435L10.9334 2.59935C10.6917 2.45768 10.35 2.39102 10 2.39102Z"
        fill={props.fill || 'currentColor'}
      />
      <path
        d="M10 13.125C8.275 13.125 6.875 11.725 6.875 10C6.875 8.275 8.275 6.875 10 6.875C11.725 6.875 13.125 8.275 13.125 10C13.125 11.725 11.725 13.125 10 13.125ZM10 8.125C8.96667 8.125 8.125 8.96667 8.125 10C8.125 11.0333 8.96667 11.875 10 11.875C11.0333 11.875 11.875 11.0333 11.875 10C11.875 8.96667 11.0333 8.125 10 8.125Z"
        fill={props.fill || 'currentColor'}
      />
    </svg>
  );
};

export const LogoutIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.7001 18.5581H12.5918C8.89176 18.5581 7.10843 17.0997 6.80009 13.8331C6.76676 13.4914 7.01676 13.1831 7.36676 13.1497C7.70009 13.1164 8.01676 13.3747 8.05009 13.7164C8.29176 16.3331 9.52509 17.3081 12.6001 17.3081H12.7084C16.1001 17.3081 17.3001 16.1081 17.3001 12.7164V7.28307C17.3001 3.89141 16.1001 2.69141 12.7084 2.69141H12.6001C9.50843 2.69141 8.27509 3.68307 8.05009 6.34974C8.00843 6.69141 7.71676 6.94974 7.36676 6.91641C7.01676 6.89141 6.76676 6.58307 6.79176 6.24141C7.07509 2.92474 8.86676 1.44141 12.5918 1.44141H12.7001C16.7918 1.44141 18.5418 3.19141 18.5418 7.28307V12.7164C18.5418 16.8081 16.7918 18.5581 12.7001 18.5581Z"
        fill="var(--user-main-red)"
      />
      <path
        d="M12.4999 10.625H3.0166C2.67493 10.625 2.3916 10.3417 2.3916 10C2.3916 9.65833 2.67493 9.375 3.0166 9.375H12.4999C12.8416 9.375 13.1249 9.65833 13.1249 10C13.1249 10.3417 12.8416 10.625 12.4999 10.625Z"
        fill="var(--user-main-red)"
      />
      <path
        d="M4.87503 13.4172C4.7167 13.4172 4.55837 13.3589 4.43337 13.2339L1.6417 10.4422C1.40003 10.2005 1.40003 9.80052 1.6417 9.55885L4.43337 6.76719C4.67503 6.52552 5.07503 6.52552 5.3167 6.76719C5.55837 7.00885 5.55837 7.40885 5.3167 7.65052L2.9667 10.0005L5.3167 12.3505C5.55837 12.5922 5.55837 12.9922 5.3167 13.2339C5.20003 13.3589 5.03337 13.4172 4.87503 13.4172Z"
        fill="var(--user-main-red)"
      />
    </svg>
  );
};

export const NotificationIcon = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      {...props}
    >
      <path
        d="M12.0201 2.91016C8.71009 2.91016 6.02009 5.60016 6.02009 8.91016V11.8002C6.02009 12.4102 5.76009 13.3402 5.45009 13.8602L4.30009 15.7702C3.59009 16.9502 4.08009 18.2602 5.38009 18.7002C9.69009 20.1402 14.3401 20.1402 18.6501 18.7002C19.8601 18.3002 20.3901 16.8702 19.7301 15.7702L18.5801 13.8602C18.2801 13.3402 18.0201 12.4102 18.0201 11.8002V8.91016C18.0201 5.61016 15.3201 2.91016 12.0201 2.91016Z"
        stroke={props.stroke || 'currentColor'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.8699 3.19994C13.5599 3.10994 13.2399 3.03994 12.9099 2.99994C11.9499 2.87994 11.0299 2.94994 10.1699 3.19994C10.4599 2.45994 11.1799 1.93994 12.0199 1.93994C12.8599 1.93994 13.5799 2.45994 13.8699 3.19994Z"
        stroke={props.stroke || 'currentColor'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.02 19.0601C15.02 20.7101 13.67 22.0601 12.02 22.0601C11.2 22.0601 10.44 21.7201 9.90002 21.1801C9.36002 20.6401 9.02002 19.8801 9.02002 19.0601"
        stroke={props.stroke || 'currentColor'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export const SearchIcon = (props) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.625 15.75C12.56 15.75 15.75 12.56 15.75 8.625C15.75 4.68997 12.56 1.5 8.625 1.5C4.68997 1.5 1.5 4.68997 1.5 8.625C1.5 12.56 4.68997 15.75 8.625 15.75Z"
        stroke="#ABABAB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16.5 16.5L15 15" stroke="#ABABAB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const RefreshIcon = (props) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.9125 16.815C10.665 16.815 10.4325 16.65 10.365 16.395C10.2825 16.095 10.4625 15.7875 10.77 15.705C13.815 14.9025 15.9375 12.1425 15.9375 8.9925C15.9375 5.1675 12.825 2.055 9 2.055C5.7525 2.055 3.6225 3.9525 2.625 5.1H4.83C5.1375 5.1 5.3925 5.355 5.3925 5.6625C5.3925 5.97 5.145 6.2325 4.83 6.2325H1.5075C1.47 6.2325 1.4025 6.225 1.35 6.21C1.2825 6.1875 1.2225 6.1575 1.17 6.12C1.1025 6.075 1.05 6.015 1.0125 5.9475C0.975 5.88 0.945 5.7975 0.9375 5.715C0.9375 5.6925 0.9375 5.6775 0.9375 5.655V2.25C0.9375 1.9425 1.1925 1.6875 1.5 1.6875C1.8075 1.6875 2.0625 1.9425 2.0625 2.25V4.0425C3.285 2.73 5.5875 0.9375 9 0.9375C13.4475 0.9375 17.0625 4.5525 17.0625 9C17.0625 12.66 14.595 15.87 11.055 16.8C11.01 16.8075 10.9575 16.815 10.9125 16.815Z"
        fill="#077882"
      />
      <path
        d="M8.4675 17.0475C8.4525 17.0475 8.4375 17.04 8.43 17.04C7.62 16.9875 6.825 16.8075 6.075 16.515C5.8575 16.4325 5.7075 16.215 5.715 15.9825C5.715 15.915 5.73 15.8475 5.7525 15.7875C5.865 15.5025 6.2025 15.36 6.48 15.465C7.1325 15.72 7.815 15.87 8.505 15.9225C8.7975 15.9375 9.03 16.1925 9.03 16.4925L9.0225 16.5225C9.0075 16.815 8.76 17.0475 8.4675 17.0475ZM4.335 15.435C4.2075 15.435 4.0875 15.39 3.9825 15.315C3.3525 14.805 2.7975 14.2125 2.3475 13.5525C2.28 13.455 2.2425 13.35 2.2425 13.2375C2.2425 13.05 2.3325 12.8775 2.49 12.7725C2.7375 12.6 3.0975 12.6675 3.27 12.9075C3.27 12.915 3.27 12.915 3.27 12.915C3.2775 12.9225 3.285 12.9375 3.2925 12.945C3.6825 13.5075 4.155 14.01 4.6875 14.43C4.815 14.535 4.8975 14.6925 4.8975 14.865C4.8975 14.9925 4.86 15.12 4.7775 15.225C4.665 15.36 4.5075 15.435 4.335 15.435ZM1.83 11.775C1.5825 11.775 1.365 11.6175 1.2975 11.385C1.0575 10.6125 0.9375 9.81 0.9375 9V8.9925C0.945 8.685 1.1925 8.4375 1.5 8.4375C1.8075 8.4375 2.0625 8.6925 2.0625 9C2.0625 9.705 2.1675 10.395 2.37 11.0475C2.385 11.1075 2.3925 11.16 2.3925 11.22C2.3925 11.46 2.235 11.6775 1.995 11.7525C1.9425 11.7675 1.89 11.775 1.83 11.775Z"
        fill="#077882"
      />
    </svg>
  );
};

export const PencilIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.6935 4.36019L15.6398 7.30647M13.9435 3.11019C14.7571 2.2966 16.0762 2.2966 16.8898 3.11019C17.7034 3.92379 17.7034 5.24288 16.8898 6.05647L5.41667 17.5296H2.5V14.5537L13.9435 3.11019Z"
        stroke="var(--ant-color-primary)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProcessingIcon = (props) => {
  return (
    <svg
      width={props.width || '15'}
      height={props.height || '18'}
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.50001 9L4.08169 6.15141C3.57381 5.72818 3.31988 5.51656 3.13732 5.25715C2.97556 5.0273 2.85544 4.77083 2.78241 4.49942C2.70001 4.19311 2.70001 3.86255 2.70001 3.20144V1M7.50001 9L10.9183 6.15141C11.4262 5.72818 11.6802 5.51656 11.8627 5.25715C12.0245 5.0273 12.1446 4.77083 12.2176 4.49942C12.3 4.19311 12.3 3.86255 12.3 3.20144V1M7.50001 9L4.08169 11.8486C3.57381 12.2718 3.31988 12.4834 3.13732 12.7429C2.97556 12.9727 2.85544 13.2292 2.78241 13.5006C2.70001 13.8069 2.70001 14.1374 2.70001 14.7986V17M7.50001 9L10.9183 11.8486C11.4262 12.2718 11.6802 12.4834 11.8627 12.7429C12.0245 12.9727 12.1446 13.2292 12.2176 13.5006C12.3 13.8069 12.3 14.1374 12.3 14.7986V17M1.10001 1H13.9M1.10001 17H13.9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ActiveProcessingIcon = (props) => {
  return (
    <svg
      width={props.width || '20'}
      height={props.height || '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1055_3801)">
        <path
          d="M10 19.1667C4.91668 19.1667 0.833344 15.0834 0.833344 10C0.833344 9.50004 1.16668 9.16671 1.66668 9.16671C2.16668 9.16671 2.50001 9.50004 2.50001 10C2.50001 14.1667 5.83334 17.5 10 17.5C14.1667 17.5 17.5 14.1667 17.5 10C17.5 5.83337 14.1667 2.50004 10 2.50004C9.50001 2.50004 9.16668 2.16671 9.16668 1.66671C9.16668 1.16671 9.50001 0.833374 10 0.833374C15.0833 0.833374 19.1667 4.91671 19.1667 10C19.1667 15.0834 15.0833 19.1667 10 19.1667Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1055_3801">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CrossIcon = (props) => {
  return (
    <svg
      width={props?.size || '28'}
      height={props?.size || '28'}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 21L21 7M7 7L21 21"
        stroke={'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
      />
    </svg>
  );
};

export const TickFillIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="24" height="24" rx="12" fill={'currentColor'} />
      <path
        d="M7.33301 12.6665L9.99967 15.3332L16.6663 8.6665"
        stroke={props?.stroke || 'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RefundIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.9795 12.0071C22.9795 14.9422 21.8342 17.7034 19.7582 19.7794C17.6822 21.8554 14.7983 22.9905 11.9859 22.9905C9.17362 22.9905 6.35107 21.9167 4.21371 19.7794C-0.0712378 15.4944 -0.0712378 8.51986 4.21371 4.23491C8.02824 0.410161 13.9801 0.0215498 18.2651 3.00772L18.1424 1.86234C18.1015 1.44305 18.398 1.06466 18.8275 1.01353C19.2468 0.972625 19.6252 1.2692 19.6764 1.69871L20.0036 4.69511C20.0445 5.1144 19.7479 5.49279 19.3184 5.54392L16.2709 5.87117H16.1891C15.8005 5.87117 15.4732 5.58483 15.4221 5.18599C15.3812 4.7667 15.6777 4.38831 16.1073 4.33718L17.3345 4.20423C13.6529 1.67826 8.58048 2.03619 5.31819 5.30871C1.62638 9.00051 1.62638 15.0035 5.31819 18.6851C9.00999 22.3769 15.013 22.3769 18.6946 18.6851C19.5761 17.8091 20.275 16.7669 20.7507 15.6188C21.2264 14.4707 21.4696 13.2396 21.466 11.9969C21.466 11.5776 21.8137 11.2299 22.233 11.2299C22.6523 11.2299 23 11.5776 23 11.9969L22.9795 12.0071ZM11.8632 11.0458C11.945 11.0867 12.0371 11.0867 12.1189 11.0458L16.4038 8.571C16.4038 8.571 16.3322 8.50964 16.2913 8.48918L12.8859 6.52567C12.3336 6.20865 11.6485 6.20865 11.0962 6.52567L7.69076 8.48918C7.69076 8.48918 7.61917 8.55054 7.57827 8.571L11.8632 11.0458ZM11.2496 12.4367C11.2496 12.4367 11.1474 12.406 11.0962 12.3753L6.81127 9.90046C6.81127 9.90046 6.79082 9.9925 6.79082 10.0334V13.9706C6.79082 14.6047 7.1283 15.1978 7.69076 15.5251L11.0962 17.4886L11.2496 17.55V12.4367ZM12.8859 12.3753C12.8859 12.3753 12.8143 12.406 12.7836 12.4162V17.5295C12.7836 17.5295 12.8552 17.5091 12.8859 17.4886L16.2913 15.5251C16.8436 15.2081 17.1913 14.6149 17.1913 13.9706V10.0334C17.1913 10.0334 17.1811 9.94136 17.1708 9.90046L12.8859 12.3753Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CancelFillIcon = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="32" height="32" rx="16" fill="currentColor" />
      <path
        d="M18.9167 18.9167L13.084 13.0834M13.0846 18.9167L18.9173 13.0834"
        stroke={props?.stroke || 'white'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3333 16C24.3333 11.3976 20.6023 7.66663 16 7.66663C11.3976 7.66663 7.66666 11.3976 7.66666 16C7.66666 20.6023 11.3976 24.3333 16 24.3333C20.6023 24.3333 24.3333 20.6023 24.3333 16Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PictureIcon = () => {
  return (
    <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.48145 18.375L9.50028 12.3562C9.74403 12.1124 10.0334 11.9191 10.3519 11.7871C10.6704 11.6552 11.0117 11.5873 11.3564 11.5873C11.7012 11.5873 12.0425 11.6552 12.361 11.7871C12.6795 11.9191 12.9689 12.1124 13.2126 12.3562L19.2314 18.375M17.4814 16.625L19.1253 14.9812C19.369 14.7374 19.6584 14.5441 19.9769 14.4121C20.2954 14.2802 20.6367 14.2123 20.9814 14.2123C21.3262 14.2123 21.6675 14.2802 21.986 14.4121C22.3045 14.5441 22.5939 14.7374 22.8376 14.9812L26.2314 18.375M5.23145 22.75H24.4814C24.9456 22.75 25.3907 22.5656 25.7189 22.2374C26.0471 21.9092 26.2314 21.4641 26.2314 21V7C26.2314 6.53587 26.0471 6.09075 25.7189 5.76256C25.3907 5.43437 24.9456 5.25 24.4814 5.25H5.23145C4.76732 5.25 4.3222 5.43437 3.99401 5.76256C3.66582 6.09075 3.48145 6.53587 3.48145 7V21C3.48145 21.4641 3.66582 21.9092 3.99401 22.2374C4.3222 22.5656 4.76732 22.75 5.23145 22.75ZM17.4814 9.625H17.4908V9.63433H17.4814V9.625ZM17.9189 9.625C17.9189 9.74103 17.8729 9.85231 17.7908 9.93436C17.7088 10.0164 17.5975 10.0625 17.4814 10.0625C17.3654 10.0625 17.2541 10.0164 17.1721 9.93436C17.09 9.85231 17.0439 9.74103 17.0439 9.625C17.0439 9.50897 17.09 9.39769 17.1721 9.31564C17.2541 9.23359 17.3654 9.1875 17.4814 9.1875C17.5975 9.1875 17.7088 9.23359 17.7908 9.31564C17.8729 9.39769 17.9189 9.50897 17.9189 9.625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VideoIcon = () => {
  return (
    <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.2314 12.25L24.7381 6.74333C24.8605 6.62112 25.0163 6.53791 25.186 6.50421C25.3556 6.47051 25.5314 6.48784 25.6912 6.554C25.851 6.62016 25.9876 6.73219 26.0837 6.87595C26.1799 7.0197 26.2313 7.18872 26.2314 7.36167V20.6383C26.2313 20.8113 26.1799 20.9803 26.0837 21.1241C25.9876 21.2678 25.851 21.3798 25.6912 21.446C25.5314 21.5122 25.3556 21.5295 25.186 21.4958C25.0163 21.4621 24.8605 21.3789 24.7381 21.2567L19.2314 15.75M6.10645 21.875H16.6064C17.3026 21.875 17.9703 21.5984 18.4626 21.1062C18.9549 20.6139 19.2314 19.9462 19.2314 19.25V8.75C19.2314 8.05381 18.9549 7.38613 18.4626 6.89384C17.9703 6.40156 17.3026 6.125 16.6064 6.125H6.10645C5.41025 6.125 4.74257 6.40156 4.25029 6.89384C3.75801 7.38613 3.48145 8.05381 3.48145 8.75V19.25C3.48145 19.9462 3.75801 20.6139 4.25029 21.1062C4.74257 21.5984 5.41025 21.875 6.10645 21.875Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EyeIcon = (props) => {
  return (
    <svg
      width={props?.size || '21'}
      height={props?.size || '21'}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5529 10.2683C2.49539 10.0955 2.49539 9.90867 2.5529 9.73583C3.70873 6.25833 6.98956 3.75 10.8562 3.75C14.7212 3.75 18.0004 6.25583 19.1587 9.73167C19.2171 9.90417 19.2171 10.0908 19.1587 10.2642C18.0037 13.7417 14.7229 16.25 10.8562 16.25C6.99123 16.25 3.71123 13.7442 2.5529 10.2683Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3564 10C13.3564 10.663 13.0931 11.2989 12.6242 11.7678C12.1554 12.2366 11.5195 12.5 10.8564 12.5C10.1934 12.5 9.55752 12.2366 9.08868 11.7678C8.61984 11.2989 8.35645 10.663 8.35645 10C8.35645 9.33696 8.61984 8.70107 9.08868 8.23223C9.55752 7.76339 10.1934 7.5 10.8564 7.5C11.5195 7.5 12.1554 7.76339 12.6242 8.23223C13.0931 8.70107 13.3564 9.33696 13.3564 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadIcon = (props) => {
  return (
    <svg
      width={props?.width ?? '21'}
      height={props?.height ?? '20'}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.35645 13.75V15.625C3.35645 16.1223 3.55399 16.5992 3.90562 16.9508C4.25725 17.3025 4.73416 17.5 5.23145 17.5H16.4814C16.9787 17.5 17.4556 17.3025 17.8073 16.9508C18.1589 16.5992 18.3564 16.1223 18.3564 15.625V13.75M14.6064 10L10.8564 13.75M10.8564 13.75L7.10645 10M10.8564 13.75V2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PdfIcon = () => {
  return (
    <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.1855 6.00425L19.3522 0.170898C19.2428 0.0615234 19.0947 0 18.9397 0H6.68974C5.40289 0 4.35645 1.04645 4.35645 2.33335V25.6667C4.35645 26.9536 5.40289 28 6.6898 28H23.0231C24.31 28 25.3564 26.9536 25.3564 25.6666V6.41665C25.3564 6.26172 25.2949 6.11363 25.1855 6.00425ZM19.5231 1.99155L23.3649 5.83335H20.6897C20.0466 5.83335 19.5231 5.30983 19.5231 4.6667V1.99155ZM24.1898 25.6666C24.1898 26.3098 23.6663 26.8333 23.0231 26.8333H6.6898C6.04667 26.8333 5.52315 26.3098 5.52315 25.6666V2.33335C5.52315 1.69023 6.04667 1.1667 6.6898 1.1667H18.3564V4.6667C18.3564 5.95355 19.4029 7 20.6898 7H24.1898V25.6666Z"
        fill="currentColor"
      />
      <path
        d="M17.8306 17.1243C17.2906 16.6993 16.7773 16.2624 16.4355 15.9206C15.9912 15.4763 15.5953 15.0456 15.2512 14.6355C15.7879 12.9772 16.0231 12.1221 16.0231 11.6664C16.0231 9.73009 15.3236 9.33301 14.2731 9.33301C13.475 9.33301 12.5231 9.7477 12.5231 11.7222C12.5231 12.5927 13 13.6494 13.945 14.8776C13.7137 15.5834 13.442 16.3974 13.1367 17.3151C12.9897 17.7555 12.8302 18.1633 12.6616 18.5405C12.527 18.5999 12.3939 18.6624 12.2622 18.7279C11.7985 18.9598 11.3582 19.1682 10.9497 19.3619C9.08691 20.2438 7.85645 20.8271 7.85645 21.9789C7.85645 22.8152 8.76508 23.333 9.60645 23.333C10.6911 23.333 12.3288 21.8843 13.5251 19.4439C14.767 18.954 16.3108 18.5911 17.5293 18.3638C18.5057 19.1146 19.5841 19.833 20.1064 19.833C21.5528 19.833 21.8564 18.9967 21.8564 18.2955C21.8564 16.9163 20.2807 16.9163 19.5231 16.9163C19.2878 16.9164 18.6567 16.9859 17.8306 17.1243ZM9.60645 22.1664C9.27318 22.1664 9.04759 22.0091 9.02309 21.9789C9.02309 21.5653 10.2564 20.9809 11.4493 20.4158C11.525 20.3799 11.602 20.344 11.68 20.307C10.8039 21.5774 9.93741 22.1664 9.60645 22.1664ZM13.6898 11.7222C13.6898 10.4997 14.0692 10.4997 14.2731 10.4997C14.6856 10.4997 14.8565 10.4997 14.8565 11.6664C14.8565 11.9125 14.6924 12.5277 14.3922 13.4882C13.9341 12.7829 13.6898 12.1785 13.6898 11.7222ZM14.137 17.9919C14.1737 17.8898 14.209 17.7873 14.243 17.6843C14.4594 17.0349 14.6543 16.4515 14.828 15.9263C15.0701 16.1929 15.331 16.4658 15.6108 16.7455C15.7201 16.8548 15.9913 17.1009 16.3525 17.4091C15.6334 17.5658 14.8684 17.76 14.137 17.9919ZM20.6898 18.2955C20.6898 18.5576 20.6898 18.6664 20.1486 18.6698C19.9897 18.6356 19.6222 18.4192 19.1688 18.1104C19.3334 18.0922 19.4547 18.0831 19.5231 18.0831C20.385 18.0831 20.6294 18.1673 20.6898 18.2955Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PdfDocumentIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width ?? 49}
    height={props?.height ?? 49}
    fill="none"
    {...props}
  >
    <path
      stroke="#BFBFBF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M40.666 26.666V21.98c0-1.635 0-2.453-.304-3.188-.305-.735-.883-1.313-2.04-2.47L28.85 6.85c-.998-.998-1.497-1.497-2.115-1.792a3.996 3.996 0 0 0-.395-.164c-.646-.228-1.351-.228-2.762-.228-6.49 0-9.735 0-11.933 1.772a7.996 7.996 0 0 0-1.207 1.207c-1.772 2.198-1.772 5.443-1.772 11.933v7.088m18-21v1c0 5.657 0 8.485 1.757 10.243 1.758 1.757 4.586 1.757 10.243 1.757h1M40.166 32.666h-5a2 2 0 0 0-2 2v4m0 0v6m0-6h6m-30 6v-5m0 0v-7h3.5a3.5 3.5 0 1 1 0 7h-3.5Zm12-7h3a4 4 0 0 1 4 4v4a4 4 0 0 1-4 4h-3v-12Z"
    />
  </svg>
);

export const HomeIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.8251 18.9577H5.17508C2.89175 18.9577 1.04175 17.0993 1.04175 14.816V8.64099C1.04175 7.50766 1.74175 6.08266 2.64175 5.38266L7.13341 1.88266C8.48341 0.832661 10.6417 0.782661 12.0417 1.76599L17.1917 5.37433C18.1834 6.06599 18.9584 7.54933 18.9584 8.75766V14.8243C18.9584 17.0993 17.1084 18.9577 14.8251 18.9577ZM7.90008 2.86599L3.40841 6.36599C2.81675 6.83266 2.29175 7.89099 2.29175 8.64099V14.816C2.29175 16.4077 3.58341 17.7077 5.17508 17.7077H14.8251C16.4167 17.7077 17.7084 16.416 17.7084 14.8243V8.75766C17.7084 7.95766 17.1334 6.84933 16.4751 6.39933L11.3251 2.79099C10.3751 2.12433 8.80841 2.15766 7.90008 2.86599Z"
        fill="currentColor"
      />
      <path
        d="M10 15.625C9.65833 15.625 9.375 15.3417 9.375 15V12.5C9.375 12.1583 9.65833 11.875 10 11.875C10.3417 11.875 10.625 12.1583 10.625 12.5V15C10.625 15.3417 10.3417 15.625 10 15.625Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TipIcon = () => {
  return (
    <svg width="29" height="15" viewBox="0 0 29 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.8 2.1868e-06L17.2588 11.793C15.69 13.396 13.11 13.396 11.5412 11.793L0 0L28.8 2.1868e-06Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const OrderIcon = (props) => {
  return (
    <svg
      width={props?.width || '20'}
      height={props?.height || '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1173_1822)">
        <path
          d="M9.99992 10.2077C9.63325 10.2077 9.26659 10.116 8.93325 9.94102L3.50825 7.01602C3.01659 6.74935 2.70825 6.22435 2.70825 5.64102C2.70825 5.05768 3.01659 4.53268 3.50825 4.26602L8.93325 1.34102C9.59992 0.982682 10.3999 0.982682 11.0583 1.34102L16.4833 4.26602C16.9749 4.53268 17.2833 5.05768 17.2833 5.64102C17.2833 6.22435 16.9749 6.74935 16.4833 7.01602L11.0583 9.94102C10.7333 10.1243 10.3666 10.2077 9.99992 10.2077ZM9.99992 2.31602C9.84159 2.31602 9.67492 2.35768 9.52492 2.44102L4.10825 5.35768C3.96659 5.43268 3.95825 5.59102 3.95825 5.64102C3.95825 5.69102 3.96659 5.84935 4.10825 5.91602L9.53325 8.84101C9.83325 8.99935 10.1749 8.99935 10.4749 8.84101L15.8999 5.91602C16.0333 5.84102 16.0499 5.68268 16.0499 5.64102C16.0499 5.59102 16.0416 5.43268 15.8999 5.36602L10.4749 2.44102C10.3249 2.35768 10.1583 2.31602 9.99992 2.31602Z"
          fill="currentColor"
        />
        <path
          d="M8.15008 18.9338C7.91675 18.9338 7.67508 18.8755 7.45842 18.7671L2.40841 16.2505C1.56675 15.8255 1.04175 14.9755 1.04175 14.0338V9.26712C1.04175 8.72546 1.31675 8.23379 1.77508 7.95046C2.24175 7.66712 2.80008 7.64212 3.28341 7.88379L8.33342 10.4005C9.17508 10.8255 9.70008 11.6671 9.70008 12.6171V17.3838C9.70008 17.9255 9.42508 18.4171 8.96675 18.7005C8.71675 18.8588 8.43341 18.9338 8.15008 18.9338ZM2.59175 8.96712C2.52508 8.96712 2.46675 8.99213 2.43341 9.00879C2.38341 9.04213 2.29175 9.11712 2.29175 9.26712V14.0338C2.29175 14.5005 2.55008 14.9255 2.96675 15.1338L8.00841 17.6588C8.14175 17.7255 8.25008 17.6755 8.30008 17.6505C8.35008 17.6171 8.44175 17.5421 8.44175 17.3921V12.6255C8.44175 12.1588 8.18341 11.7338 7.76675 11.5255L2.72508 9.00046C2.67508 8.97546 2.63341 8.96712 2.59175 8.96712Z"
          fill="currentColor"
        />
        <path
          d="M11.85 18.9324C11.5667 18.9324 11.2834 18.8574 11.0334 18.699C10.575 18.4157 10.3 17.924 10.3 17.3824V12.6157C10.3 11.674 10.825 10.824 11.6667 10.399L16.7084 7.87403C17.1917 7.63236 17.7584 7.65736 18.2167 7.94069C18.6751 8.22403 18.9501 8.71569 18.9501 9.25736V14.024C18.9501 14.9657 18.4251 15.8157 17.5834 16.2407L12.5417 18.7657C12.325 18.8824 12.0834 18.9324 11.85 18.9324ZM17.4084 8.96569C17.3667 8.96569 17.325 8.97403 17.2751 8.99903L12.2334 11.524C11.8167 11.7324 11.5584 12.149 11.5584 12.624V17.3907C11.5584 17.5407 11.65 17.6157 11.7 17.649C11.75 17.6824 11.8584 17.724 11.9917 17.6574L17.0334 15.1324C17.4501 14.924 17.7084 14.499 17.7084 14.0324V9.26569C17.7084 9.11569 17.6167 9.04069 17.5667 9.00736C17.5334 8.99069 17.475 8.96569 17.4084 8.96569Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1173_1822">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SelectArrow = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.6673 10L8.00065 5.33333L3.33398 10"
        stroke={props?.stroke || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SelectTick = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.16602 10.8335L7.49935 14.1668L15.8327 5.8335"
        stroke={props?.stroke || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InfoIcon = ({ width = 20, height = 20, stroke = 'currentColor', strokeWidth = 2, ...props }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11 14H10V10H9M10 6H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WarningIcon = (props) => {
  return (
    <svg
      width={props?.width ?? '20'}
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 7V9M10 13H10.01M3.07183 17H16.9282C18.4678 17 19.4301 15.3333 18.6603 14L11.7321 2C10.9623 0.666667 9.03778 0.666667 8.26798 2L1.33978 14C0.56998 15.3333 1.53223 17 3.07183 17Z"
        stroke={props?.stroke || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UsersIcon = (props) => {
  return (
    <svg
      width={props?.width || '20'}
      height={props?.height || '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9999 6.59166C14.9749 6.59166 14.9583 6.59166 14.9333 6.59166H14.8916C13.3166 6.54166 12.1416 5.32499 12.1416 3.82499C12.1416 2.29166 13.3916 1.04999 14.9166 1.04999C16.4416 1.04999 17.6916 2.29999 17.6916 3.82499C17.6833 5.33332 16.5083 6.54999 15.0083 6.59999C15.0083 6.59166 15.0083 6.59166 14.9999 6.59166ZM14.9166 2.29166C14.0749 2.29166 13.3916 2.97499 13.3916 3.81666C13.3916 4.64166 14.0333 5.30833 14.8583 5.34166C14.8666 5.33333 14.9333 5.33333 15.0083 5.34166C15.8166 5.3 16.4416 4.63333 16.4499 3.81666C16.4499 2.97499 15.7666 2.29166 14.9166 2.29166Z"
        fill="currentColor"
      />
      <path
        d="M15.0083 12.7334C14.6833 12.7334 14.3583 12.7084 14.0333 12.65C13.6916 12.5917 13.4666 12.2667 13.5249 11.925C13.5833 11.5834 13.9083 11.3584 14.2499 11.4167C15.2749 11.5917 16.3583 11.4 17.0833 10.9167C17.4749 10.6584 17.6833 10.3334 17.6833 10.0084C17.6833 9.68337 17.4666 9.3667 17.0833 9.10837C16.3583 8.62504 15.2583 8.43337 14.2249 8.61671C13.8833 8.68337 13.5583 8.45004 13.4999 8.10837C13.4416 7.76671 13.6666 7.44171 14.0083 7.38338C15.3666 7.14171 16.7749 7.40004 17.7749 8.0667C18.5083 8.55837 18.9333 9.25837 18.9333 10.0084C18.9333 10.75 18.5166 11.4584 17.7749 11.9584C17.0166 12.4584 16.0333 12.7334 15.0083 12.7334Z"
        fill="currentColor"
      />
      <path
        d="M4.9749 6.59169C4.96657 6.59169 4.95824 6.59169 4.95824 6.59169C3.45824 6.54169 2.28324 5.32502 2.2749 3.82502C2.2749 2.29168 3.5249 1.04169 5.0499 1.04169C6.5749 1.04169 7.8249 2.29169 7.8249 3.81669C7.8249 5.32502 6.6499 6.54169 5.1499 6.59169L4.9749 5.96669L5.03324 6.59169C5.01657 6.59169 4.99157 6.59169 4.9749 6.59169ZM5.05824 5.34169C5.10824 5.34169 5.1499 5.34169 5.1999 5.35002C5.94157 5.31669 6.59157 4.65002 6.59157 3.82502C6.59157 2.98335 5.90824 2.30002 5.06657 2.30002C4.2249 2.30002 3.54157 2.98335 3.54157 3.82502C3.54157 4.64168 4.1749 5.30002 4.98324 5.35002C4.99157 5.34169 5.0249 5.34169 5.05824 5.34169Z"
        fill="currentColor"
      />
      <path
        d="M4.96675 12.7334C3.94175 12.7334 2.95841 12.4584 2.20008 11.9584C1.46675 11.4667 1.04175 10.7584 1.04175 10.0084C1.04175 9.26671 1.46675 8.55837 2.20008 8.0667C3.20008 7.40004 4.60841 7.14171 5.96675 7.38338C6.30841 7.44171 6.53342 7.76671 6.47508 8.10837C6.41675 8.45004 6.09175 8.68337 5.75008 8.61671C4.71675 8.43337 3.62508 8.62504 2.89175 9.10837C2.50008 9.3667 2.29175 9.68337 2.29175 10.0084C2.29175 10.3334 2.50842 10.6584 2.89175 10.9167C3.61675 11.4 4.70008 11.5917 5.72508 11.4167C6.06675 11.3584 6.39175 11.5917 6.45008 11.925C6.50842 12.2667 6.28342 12.5917 5.94175 12.65C5.61675 12.7084 5.29175 12.7334 4.96675 12.7334Z"
        fill="currentColor"
      />
      <path
        d="M9.99994 12.8166C9.97494 12.8166 9.95827 12.8166 9.93327 12.8166H9.8916C8.3166 12.7666 7.1416 11.55 7.1416 10.05C7.1416 8.51663 8.3916 7.27496 9.9166 7.27496C11.4416 7.27496 12.6916 8.52496 12.6916 10.05C12.6833 11.5583 11.5083 12.775 10.0083 12.825C10.0083 12.8166 10.0083 12.8166 9.99994 12.8166ZM9.9166 8.51663C9.07494 8.51663 8.3916 9.19997 8.3916 10.0416C8.3916 10.8666 9.03327 11.5333 9.85827 11.5666C9.8666 11.5583 9.93327 11.5583 10.0083 11.5666C10.8166 11.525 11.4416 10.8583 11.4499 10.0416C11.4499 9.2083 10.7666 8.51663 9.9166 8.51663Z"
        fill="currentColor"
      />
      <path
        d="M9.99974 18.9667C8.99974 18.9667 7.99974 18.7083 7.22474 18.1833C6.49141 17.6917 6.06641 16.9917 6.06641 16.2417C6.06641 15.5 6.48307 14.7833 7.22474 14.2917C8.78307 13.2583 11.2247 13.2583 12.7747 14.2917C13.5081 14.7833 13.9331 15.4833 13.9331 16.2333C13.9331 16.975 13.5164 17.6917 12.7747 18.1833C11.9997 18.7 10.9997 18.9667 9.99974 18.9667ZM7.91641 15.3417C7.52474 15.6 7.31641 15.925 7.31641 16.25C7.31641 16.575 7.53307 16.8917 7.91641 17.15C9.04141 17.9083 10.9497 17.9083 12.0747 17.15C12.4664 16.8917 12.6747 16.5667 12.6747 16.2417C12.6747 15.9167 12.4581 15.6 12.0747 15.3417C10.9581 14.5833 9.04974 14.5917 7.91641 15.3417Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TeamsIcon = (props) => {
  return (
    <svg
      width={props?.width || '20'}
      height={props?.height || '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.54992 12.0666C7.91658 12.0666 6.58325 10.7333 6.58325 9.09997C6.58325 7.46663 7.91658 6.1333 9.54992 6.1333C11.1832 6.1333 12.5166 7.46663 12.5166 9.09997C12.5166 10.7333 11.1832 12.0666 9.54992 12.0666ZM9.54992 7.39164C8.60825 7.39164 7.83325 8.15831 7.83325 9.10831C7.83325 10.0583 8.59992 10.825 9.54992 10.825C10.4999 10.825 11.2666 10.0583 11.2666 9.10831C11.2666 8.15831 10.4999 7.39164 9.54992 7.39164Z"
        fill="currentColor"
      />
      <path
        d="M13.8751 17.4583C13.5334 17.4583 13.2501 17.175 13.2501 16.8333C13.2501 15.2333 11.5918 13.9333 9.5501 13.9333C7.50843 13.9333 5.8501 15.2333 5.8501 16.8333C5.8501 17.175 5.56676 17.4583 5.2251 17.4583C4.88343 17.4583 4.6001 17.175 4.6001 16.8333C4.6001 14.55 6.81676 12.6833 9.5501 12.6833C12.2834 12.6833 14.5001 14.5417 14.5001 16.8333C14.5001 17.175 14.2168 17.4583 13.8751 17.4583Z"
        fill="currentColor"
      />
      <path
        d="M9.58342 18.9583C4.87508 18.9583 1.04175 15.125 1.04175 10.4167C1.04175 5.70833 4.87508 1.875 9.58342 1.875C10.7417 1.875 11.8584 2.09999 12.9084 2.54166C13.2084 2.66666 13.3584 2.99998 13.2584 3.30831C13.1667 3.58331 13.1251 3.875 13.1251 4.16667C13.1251 4.65833 13.2584 5.14165 13.5167 5.55832C13.6501 5.79165 13.8251 5.99998 14.0251 6.17498C14.7501 6.83331 15.8251 7.04169 16.6667 6.74169C16.9751 6.62502 17.3251 6.78334 17.4501 7.09168C17.9001 8.15001 18.1251 9.27501 18.1251 10.425C18.1251 15.125 14.2917 18.9583 9.58342 18.9583ZM9.58342 3.125C5.56675 3.125 2.29175 6.39167 2.29175 10.4167C2.29175 14.4417 5.56675 17.7083 9.58342 17.7083C13.6001 17.7083 16.8751 14.4417 16.8751 10.4167C16.8751 9.61667 16.7417 8.82499 16.4917 8.06666C15.3417 8.26666 14.0834 7.90835 13.2001 7.10002C12.9084 6.85002 12.6501 6.54167 12.4501 6.2C12.0834 5.6 11.8834 4.89167 11.8834 4.16667C11.8834 3.94167 11.9001 3.72502 11.9418 3.50835C11.1834 3.25002 10.3917 3.125 9.58342 3.125Z"
        fill="currentColor"
      />
      <path
        d="M15.8333 8.12498C14.85 8.12498 13.9167 7.75833 13.1917 7.1C12.9 6.85 12.6417 6.54165 12.4417 6.19998C12.075 5.59998 11.875 4.89165 11.875 4.16665C11.875 3.74165 11.9417 3.32499 12.075 2.92499C12.2583 2.35832 12.575 1.83332 13 1.40831C13.75 0.641648 14.7583 0.208313 15.8417 0.208313C16.975 0.208313 18.05 0.691661 18.7833 1.52499C19.4333 2.24999 19.8 3.18331 19.8 4.16665C19.8 4.48331 19.7583 4.79998 19.675 5.09998C19.5917 5.47498 19.4333 5.86666 19.2167 6.20832C18.7333 7.02499 17.9667 7.63331 17.0667 7.91665C16.6917 8.05831 16.275 8.12498 15.8333 8.12498ZM15.8333 1.45831C15.0917 1.45831 14.4 1.74996 13.8917 2.27496C13.6 2.57496 13.3917 2.91662 13.2667 3.30829C13.175 3.58329 13.1333 3.87498 13.1333 4.16665C13.1333 4.65831 13.2667 5.14163 13.525 5.5583C13.6583 5.79163 13.8333 5.99996 14.0333 6.17496C14.7583 6.83329 15.8333 7.04167 16.675 6.74167C17.3083 6.54167 17.825 6.12497 18.1583 5.56664C18.3083 5.32497 18.4083 5.06666 18.4667 4.80833C18.525 4.59166 18.55 4.38331 18.55 4.16665C18.55 3.49998 18.3 2.85833 17.85 2.35833C17.3417 1.78333 16.6083 1.45831 15.8333 1.45831Z"
        fill="currentColor"
      />
      <path
        d="M17.0749 4.77496H14.5833C14.2416 4.77496 13.9583 4.49163 13.9583 4.14996C13.9583 3.8083 14.2416 3.52496 14.5833 3.52496H17.0749C17.4166 3.52496 17.6999 3.8083 17.6999 4.14996C17.6999 4.49163 17.4249 4.77496 17.0749 4.77496Z"
        fill="currentColor"
      />
      <path
        d="M15.8333 6.05001C15.4916 6.05001 15.2083 5.76667 15.2083 5.42501V2.93335C15.2083 2.59168 15.4916 2.30835 15.8333 2.30835C16.1749 2.30835 16.4583 2.59168 16.4583 2.93335V5.42501C16.4583 5.77501 16.1749 6.05001 15.8333 6.05001Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ProtectIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9999 22.7595C10.9099 22.7595 9.8299 22.4395 8.9799 21.8095L4.6799 18.5995C3.5399 17.7495 2.6499 15.9795 2.6499 14.5595V7.11945C2.6499 5.57945 3.7799 3.93945 5.2299 3.39945L10.2199 1.52945C11.2099 1.15945 12.7699 1.15945 13.7599 1.52945L18.7599 3.39945C20.2099 3.93945 21.3399 5.57945 21.3399 7.11945V14.5495C21.3399 15.9695 20.4499 17.7395 19.3099 18.5895L15.0099 21.7995C14.1699 22.4395 13.0899 22.7595 11.9999 22.7595ZM10.7499 2.93945L5.7599 4.80945C4.8999 5.12945 4.1499 6.20945 4.1499 7.12945V14.5595C4.1499 15.5095 4.8199 16.8395 5.5699 17.3995L9.8699 20.6095C11.0199 21.4695 12.9699 21.4695 14.1199 20.6095L18.4199 17.3995C19.1799 16.8295 19.8399 15.4995 19.8399 14.5595V7.11945C19.8399 6.20945 19.0899 5.12945 18.2299 4.79945L13.2399 2.92945C12.5799 2.68945 11.4199 2.68945 10.7499 2.93945Z"
        fill="currentColor"
      />
      <path
        d="M12 13.25C10.48 13.25 9.25 12.02 9.25 10.5C9.25 8.98 10.48 7.75 12 7.75C13.52 7.75 14.75 8.98 14.75 10.5C14.75 12.02 13.52 13.25 12 13.25ZM12 9.25C11.31 9.25 10.75 9.81 10.75 10.5C10.75 11.19 11.31 11.75 12 11.75C12.69 11.75 13.25 11.19 13.25 10.5C13.25 9.81 12.69 9.25 12 9.25Z"
        fill="currentColor"
      />
      <path
        d="M12 16.25C11.59 16.25 11.25 15.91 11.25 15.5V12.5C11.25 12.09 11.59 11.75 12 11.75C12.41 11.75 12.75 12.09 12.75 12.5V15.5C12.75 15.91 12.41 16.25 12 16.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AddButton = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99935 2.66667V13.3333M13.3327 8L2.66602 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GiftIcon = (props) => {
  return (
    <svg
      width={props?.size || '24'}
      height={props?.size || '24'}
      viewBox={`0 0 24 24`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 11V15C4 18.2998 4 19.9497 5.02513 20.9749C6.05025 22 7.70017 22 11 22H13C16.2998 22 17.9497 22 18.9749 20.9749C20 19.9497 20 18.2998 20 15V11"
        stroke="currentColor"
        strokeWidth={props?.strokeWidth || '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 9C3 8.25231 3 7.87846 3.20096 7.6C3.33261 7.41758 3.52197 7.26609 3.75 7.16077C4.09808 7 4.56538 7 5.5 7H18.5C19.4346 7 19.9019 7 20.25 7.16077C20.478 7.26609 20.6674 7.41758 20.799 7.6C21 7.87846 21 8.25231 21 9C21 9.74769 21 10.1215 20.799 10.4C20.6674 10.5824 20.478 10.7339 20.25 10.8392C19.9019 11 19.4346 11 18.5 11H5.5C4.56538 11 4.09808 11 3.75 10.8392C3.52197 10.7339 3.33261 10.5824 3.20096 10.4C3 10.1215 3 9.74769 3 9Z"
        stroke="currentColor"
        strokeWidth={props?.strokeWidth || '1.5'}
        strokeLinejoin="round"
      />
      <path
        d="M6 3.78571C6 2.79949 6.79949 2 7.78571 2H8.14286C10.2731 2 12 3.7269 12 5.85714V7H9.21429C7.43908 7 6 5.56091 6 3.78571Z"
        stroke="currentColor"
        strokeWidth={props?.strokeWidth || '1.5'}
        strokeLinejoin="round"
      />
      <path
        d="M18 3.78571C18 2.79949 17.2005 2 16.2143 2H15.8571C13.7269 2 12 3.7269 12 5.85714V7H14.7857C16.5609 7 18 5.56091 18 3.78571Z"
        stroke="currentColor"
        strokeWidth={props?.strokeWidth || '1.5'}
        strokeLinejoin="round"
      />
      <path
        d="M12 11V22"
        stroke="currentColor"
        strokeWidth={props?.strokeWidth || '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BinIcon = (props) => {
  return (
    <svg
      width={props?.size || '16'}
      height={props?.size || '16'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.0004 4.48666C13.9871 4.48666 13.9671 4.48666 13.9471 4.48666C10.4204 4.13333 6.90043 3.99999 3.41377 4.35333L2.05377 4.48666C1.77377 4.51333 1.5271 4.31333 1.50043 4.03333C1.47377 3.75333 1.67377 3.51333 1.9471 3.48666L3.3071 3.35333C6.85377 2.99333 10.4471 3.13333 14.0471 3.48666C14.3204 3.51333 14.5204 3.75999 14.4938 4.03333C14.4738 4.29333 14.2538 4.48666 14.0004 4.48666Z"
        fill="#F5222D"
      />
      <path
        d="M5.66651 3.81333C5.63984 3.81333 5.61318 3.81333 5.57984 3.80666C5.31318 3.75999 5.12651 3.49999 5.17318 3.23333L5.31984 2.35999C5.42651 1.71999 5.57318 0.833328 7.12651 0.833328H8.87318C10.4332 0.833328 10.5798 1.75333 10.6798 2.36666L10.8265 3.23333C10.8732 3.50666 10.6865 3.76666 10.4198 3.80666C10.1465 3.85333 9.88651 3.66666 9.84651 3.39999L9.69984 2.53333C9.60651 1.95333 9.58651 1.83999 8.87984 1.83999H7.13318C6.42651 1.83999 6.41318 1.93333 6.31318 2.52666L6.15984 3.39333C6.11984 3.64 5.90651 3.81333 5.66651 3.81333Z"
        fill="#F5222D"
      />
      <path
        d="M10.1396 15.1667H5.85961C3.53294 15.1667 3.43961 13.88 3.36627 12.84L2.93294 6.12667C2.91294 5.85334 3.12627 5.61334 3.39961 5.59334C3.67961 5.58 3.91294 5.78667 3.93294 6.06L4.36627 12.7733C4.43961 13.7867 4.46627 14.1667 5.85961 14.1667H10.1396C11.5396 14.1667 11.5663 13.7867 11.6329 12.7733L12.0663 6.06C12.0863 5.78667 12.3263 5.58 12.5996 5.59334C12.8729 5.61334 13.0863 5.84667 13.0663 6.12667L12.6329 12.84C12.5596 13.88 12.4663 15.1667 10.1396 15.1667Z"
        fill="#F5222D"
      />
      <path
        d="M9.10672 11.5H6.88672C6.61339 11.5 6.38672 11.2733 6.38672 11C6.38672 10.7267 6.61339 10.5 6.88672 10.5H9.10672C9.38005 10.5 9.60672 10.7267 9.60672 11C9.60672 11.2733 9.38005 11.5 9.10672 11.5Z"
        fill="#F5222D"
      />
      <path
        d="M9.66732 8.83333H6.33398C6.06065 8.83333 5.83398 8.60666 5.83398 8.33333C5.83398 8.05999 6.06065 7.83333 6.33398 7.83333H9.66732C9.94065 7.83333 10.1673 8.05999 10.1673 8.33333C10.1673 8.60666 9.94065 8.83333 9.66732 8.83333Z"
        fill="#F5222D"
      />
    </svg>
  );
};

export const DragIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.33301 7.08334H16.6663"
        stroke={props?.stroke || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33301 12.9167H16.6663"
        stroke={props?.stroke || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FilterIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.5 6.45834H2.5C2.15833 6.45834 1.875 6.175 1.875 5.83334C1.875 5.49167 2.15833 5.20834 2.5 5.20834H17.5C17.8417 5.20834 18.125 5.49167 18.125 5.83334C18.125 6.175 17.8417 6.45834 17.5 6.45834Z"
        fill="#077882"
      />
      <path
        d="M15 10.625H5C4.65833 10.625 4.375 10.3417 4.375 10C4.375 9.65833 4.65833 9.375 5 9.375H15C15.3417 9.375 15.625 9.65833 15.625 10C15.625 10.3417 15.3417 10.625 15 10.625Z"
        fill="#077882"
      />
      <path
        d="M11.6663 14.7917H8.33301C7.99134 14.7917 7.70801 14.5083 7.70801 14.1667C7.70801 13.825 7.99134 13.5417 8.33301 13.5417H11.6663C12.008 13.5417 12.2913 13.825 12.2913 14.1667C12.2913 14.5083 12.008 14.7917 11.6663 14.7917Z"
        fill="#077882"
      />
    </svg>
  );
};

export const HorizontalDotsIcon = (props) => {
  return (
    <svg width={'18'} height={'4'} viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2 2H2.01M9 2H9.01M16 2H16.01M3 2C3 2.55228 2.55228 3 2 3C1.44772 3 1 2.55228 1 2C1 1.44772 1.44772 1 2 1C2.55228 1 3 1.44772 3 2ZM10 2C10 2.55228 9.55228 3 9 3C8.44772 3 8 2.55228 8 2C8 1.44772 8.44772 1 9 1C9.55228 1 10 1.44772 10 2ZM17 2C17 2.55228 16.5523 3 16 3C15.4477 3 15 2.55228 15 2C15 1.44772 15.4477 1 16 1C16.5523 1 17 1.44772 17 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ColumnIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.7575 3.24269C17.9168 4.40207 17.9168 6.26804 17.9168 9.99999C17.9168 13.7319 17.9168 15.5979 16.7575 16.7573C15.5981 17.9167 13.7321 17.9167 10.0002 17.9167C6.26821 17.9167 4.40224 17.9167 3.24286 16.7573C2.0835 15.5979 2.0835 13.7319 2.0835 9.99999C2.0835 6.26804 2.0835 4.40207 3.24286 3.24269C4.40224 2.08333 6.26821 2.08333 10.0002 2.08333C13.7321 2.08333 15.5981 2.08333 16.7575 3.24269Z"
        stroke={props?.stroke || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7.0835 2.08333V17.9167" stroke={props?.stroke || 'currentColor'} strokeWidth="1.5" />
      <path d="M12.9165 2.08333V17.9167" stroke={props?.stroke || 'currentColor'} strokeWidth="1.5" />
    </svg>
  );
};

export const ReferralIcon = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.334 17C15.9533 17 14.834 15.8807 14.834 14.5C14.834 13.1193 15.9533 12 17.334 12C18.7147 12 19.834 13.1193 19.834 14.5C19.834 15.8807 18.7147 17 17.334 17ZM17.334 17C19.8193 17 21.834 19.0147 21.834 21.5M17.334 17C14.8487 17 12.834 19.0147 12.834 21.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33398 7.5C5.95327 7.5 4.83398 6.38071 4.83398 5C4.83398 3.61929 5.95327 2.5 7.33398 2.5C8.71469 2.5 9.83398 3.61929 9.83398 5C9.83398 6.38071 8.71469 7.5 7.33398 7.5ZM7.33398 7.5C9.81926 7.5 11.834 9.51472 11.834 12M7.33398 7.5C4.8487 7.5 2.83398 9.51472 2.83398 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.83398 15.5C3.83398 18.2643 6.06969 20.5 8.83398 20.5L8.33398 18.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.834 8.5C18.834 5.73571 16.5983 3.5 13.834 3.5L14.334 5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AffiliateIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3036 3.75447C18.3036 3.75447 18.4503 2.2672 18.0912 1.90808M18.0912 1.90808C17.7299 1.54684 16.245 1.69693 16.245 1.69693M18.0912 1.90808L15.8333 4.16599"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3036 16.2455C18.3036 16.2455 18.4503 17.7327 18.0912 18.0919M18.0912 18.0919C17.7299 18.4532 16.245 18.3031 16.245 18.3031M18.0912 18.0919L15.8333 15.834"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.90881 1.90807L4.16675 4.16599M1.90881 1.90807C2.27005 1.54684 3.75502 1.69693 3.75502 1.69693M1.90881 1.90807C1.54969 2.2672 1.69642 3.75446 1.69642 3.75446"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.90881 18.0919L4.16675 15.834M1.90881 18.0919C2.27005 18.4532 3.75502 18.3031 3.75502 18.3031M1.90881 18.0919C1.54969 17.7328 1.69642 16.2456 1.69642 16.2456"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8334 9.99935C15.8334 13.221 13.2217 15.8327 10.0001 15.8327C6.77842 15.8327 4.16675 13.221 4.16675 9.99935C4.16675 6.77769 6.77842 4.16602 10.0001 4.16602C13.2217 4.16602 15.8334 6.77769 15.8334 9.99935Z"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <path
        d="M9.92825 7.75041C9.00775 7.75041 8.33325 8.28553 8.33325 8.9066C8.33325 9.5276 8.76817 9.91593 9.99992 9.91593C11.3568 9.91593 11.6666 10.5346 11.6666 11.1556C11.6666 11.7767 11.0735 12.2672 9.92825 12.2672M9.92825 7.75041C10.6539 7.75041 11.0375 8.00446 11.3404 8.34643M9.92825 7.75041V7.04688M9.92825 12.2672C9.20258 12.2672 8.92042 12.1238 8.52075 11.7622M9.92825 12.2672V12.9233"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const UserTickIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 8C15 5.23858 12.7614 3 10 3C7.23858 3 5 5.23858 5 8C5 10.7614 7.23858 13 10 13C12.7614 13 15 10.7614 15 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 20C3 16.134 6.13401 13 10 13C11.9587 13 13.7295 13.8045 15 15.101"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 18.5C13 18.5 14.3485 19.0067 15 21C15 21 18.1765 16 21 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserHeartIcon = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 7.5C15 4.73858 12.7614 2.5 10 2.5C7.23858 2.5 5 4.73858 5 7.5C5 10.2614 7.23858 12.5 10 12.5C12.7614 12.5 15 10.2614 15 7.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 19.5C3 15.634 6.13401 12.5 10 12.5C11.0736 12.5 12.0907 12.7417 13 13.1736"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 21.5C18 21.5 22 19.6471 22 16.6389C22 15.4576 21.1579 14.5 20 14.5C19.0526 14.5 18.4211 14.9118 18 15.7353C17.5789 14.9118 16.9474 14.5 16 14.5C14.8421 14.5 14 15.4576 14 16.6389C14 19.6471 18 21.5 18 21.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserLockIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10 13.7507V12.084" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M3.55716 15.7039C3.74456 17.0958 4.89743 18.1862 6.30037 18.2507C7.48088 18.305 8.68008 18.3333 10.0007 18.3333C11.3212 18.3333 12.5204 18.305 13.7009 18.2507C15.1039 18.1862 16.2567 17.0958 16.4442 15.7039C16.5664 14.7956 16.6673 13.8647 16.6673 12.9167C16.6673 11.9687 16.5664 11.0377 16.4442 10.1294C16.2567 8.7375 15.1039 7.64707 13.7009 7.58257C12.5204 7.52831 11.3212 7.5 10.0007 7.5C8.68008 7.5 7.48088 7.52831 6.30037 7.58257C4.89743 7.64707 3.74456 8.7375 3.55716 10.1294C3.43486 11.0377 3.33398 11.9687 3.33398 12.9167C3.33398 13.8647 3.43486 14.7956 3.55716 15.7039Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M6.25 7.49935V5.41602C6.25 3.34495 7.92893 1.66602 10 1.66602C12.0711 1.66602 13.75 3.34495 13.75 5.41602V7.49935"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LinkIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.91602 12.0827L12.0827 7.91602" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M14.0386 12.1746L16.2132 10C17.9289 8.28427 17.9289 5.50252 16.2132 3.78679C14.4975 2.07107 11.7158 2.07107 10 3.78679L7.82538 5.96142M12.1746 14.0386L10 16.2132C8.28428 17.929 5.50253 17.929 3.7868 16.2132C2.07107 14.4975 2.07107 11.7157 3.7868 10L5.96142 7.82538"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const FacebookIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1969_2077)">
        <path
          d="M24 12C24 5.3719 18.6281 0 12 0C5.3719 0 0 5.3719 0 12C0 17.9907 4.3875 22.9547 10.125 23.8547V15.4688H7.0781V12H10.125V9.35625C10.125 6.3492 11.9156 4.6875 14.6578 4.6875C15.9703 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8297C14.3391 7.875 13.875 8.8008 13.875 9.75V12H17.2031L16.6711 15.4688H13.875V23.8547C19.6125 22.9547 24 17.9907 24 12Z"
          fill="#1877F2"
        />
        <path
          d="M16.6711 15.4688L17.2031 12H13.875V9.75C13.875 8.8008 14.3391 7.875 15.8297 7.875H17.3438V4.92188C17.3438 4.92188 15.9703 4.6875 14.6578 4.6875C11.9157 4.6875 10.125 6.3492 10.125 9.35625V12H7.07812V15.4688H10.125V23.8547C10.7367 23.9508 11.3625 24 12 24C12.6375 24 13.2633 23.9508 13.875 23.8547V15.4688H16.6711Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1969_2077">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ManageDevicesIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_1829_10086)">
        <path
          d="M13.3332 10V9M2.6665 10V4.66667C2.6665 3.40959 2.6665 2.78105 3.05703 2.39053C3.44755 2 4.07609 2 5.33317 2H7.33317"
          stroke="#077882"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0002 6.47611V7.33325M12.0002 6.47611C11.229 6.47611 10.5496 6.09731 10.151 5.52213M12.0002 6.47611C12.7714 6.47611 13.4508 6.09731 13.8493 5.52213M10.151 5.52213L9.33376 6.04754M10.151 5.52213C9.91536 5.18195 9.77796 4.77307 9.77796 4.33325C9.77796 3.89349 9.9153 3.48466 10.151 3.14451M13.8493 5.52213L14.6666 6.04754M13.8493 5.52213C14.085 5.18195 14.2224 4.77307 14.2224 4.33325C14.2224 3.89349 14.085 3.48466 13.8494 3.14451M12.0002 2.19039C12.7714 2.19039 13.4509 2.56925 13.8494 3.14451M12.0002 2.19039C11.2289 2.19039 10.5494 2.56925 10.151 3.14451M12.0002 2.19039V1.33325M13.8494 3.14451L14.6668 2.61897M10.151 3.14451L9.3335 2.61897"
          stroke="#077882"
          strokeLinecap="round"
        />
        <path
          d="M2.33191 10.6769L2.67985 10H13.3014L13.6684 10.6769C14.6303 12.4513 14.8699 13.3385 14.5042 14.0026C14.1386 14.6667 13.1692 14.6667 11.2304 14.6667H4.76991C2.83111 14.6667 1.8617 14.6667 1.49608 14.0026C1.13045 13.3385 1.36999 12.4513 2.33191 10.6769Z"
          stroke="#077882"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1829_10086">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EditIcon = (props) => {
  return (
    <svg
      width={props?.size || '16'}
      height={props?.size || '16'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.1548 3.48816L12.5118 5.84518M11.1548 2.48816C11.8057 1.83728 12.8609 1.83728 13.5118 2.48816C14.1627 3.13903 14.1627 4.1943 13.5118 4.84518L4.33333 14.0237H2V11.6429L11.1548 2.48816Z"
        stroke="#077882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GmailIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 7.5L9.94202 9.23943C11.6572 10.2535 12.3428 10.2535 14.058 9.23943L17 7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.996 10C21.9933 9.63328 21.9894 9.77017 21.9842 9.5265C21.9189 6.46005 21.8862 4.92682 20.7551 3.79105C19.6239 2.65528 18.0497 2.61571 14.9012 2.53658C12.9607 2.48781 11.0393 2.48781 9.09882 2.53657C5.95033 2.6157 4.37608 2.65526 3.24495 3.79103C2.11382 4.92681 2.08114 6.46003 2.01576 9.52648C1.99474 10.5125 1.99475 11.4926 2.01577 12.4786C2.08114 15.5451 2.11383 17.0783 3.24496 18.2141C4.37608 19.3498 5.95033 19.3894 9.09883 19.4685C9.7068 19.4838 10.4957 19.4943 11 19.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5861 18.6482C14.9573 19.0167 13.3087 19.7693 14.3128 20.711C14.8033 21.171 15.3496 21.5 16.0365 21.5H19.9557C20.6425 21.5 21.1888 21.171 21.6793 20.711C22.6835 19.7693 21.0348 19.0167 20.406 18.6482C18.9315 17.7839 17.0606 17.7839 15.5861 18.6482Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M19.9961 14C19.9961 15.1046 19.1006 16 17.9961 16C16.8915 16 15.9961 15.1046 15.9961 14C15.9961 12.8954 16.8915 12 17.9961 12C19.1006 12 19.9961 12.8954 19.9961 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const InboxIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.08301 10.0007C2.08301 6.2687 2.08301 4.40273 3.24237 3.24335C4.40175 2.08398 6.26772 2.08398 9.99968 2.08398C13.7316 2.08398 15.5976 2.08398 16.757 3.24335C17.9163 4.40273 17.9163 6.2687 17.9163 10.0007C17.9163 13.7326 17.9163 15.5986 16.757 16.758C15.5976 17.9173 13.7316 17.9173 9.99968 17.9173C6.26772 17.9173 4.40175 17.9173 3.24237 16.758C2.08301 15.5986 2.08301 13.7326 2.08301 10.0007Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9163 11.25H13.8116C13.1098 11.25 12.5585 11.8363 12.2493 12.456C11.9133 13.1292 11.2404 13.75 9.99968 13.75C8.75893 13.75 8.08612 13.1292 7.75013 12.456C7.44086 11.8363 6.88948 11.25 6.18773 11.25H2.08301"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ComposeEmailIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.83496 6.45898L8.28664 7.90851C9.716 8.75357 10.2873 8.75357 11.7166 7.90851L14.1683 6.45898"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3317 8.95768V8.14805C18.2772 5.59197 18.25 4.31392 17.3069 3.36719C16.3637 2.42045 15.0512 2.38747 12.4259 2.32151C10.808 2.28086 9.20591 2.28085 7.58791 2.3215C4.96271 2.38746 3.65011 2.42043 2.70698 3.36717C1.76386 4.31392 1.7366 5.59196 1.68209 8.14804C1.66456 8.96993 1.66456 9.78693 1.68209 10.6088C1.73661 13.1649 1.76386 14.4429 2.70699 15.3897C3.65011 16.3364 4.96271 16.3694 7.58792 16.4353C7.97813 16.4452 8.78016 16.4526 9.16899 16.4577"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3788 11.4071L17.9558 11.9841C18.4439 12.4722 18.4439 13.2637 17.9558 13.7518L14.933 16.8316C14.6952 17.0693 14.391 17.2297 14.0604 17.2914L12.187 17.6981C11.8912 17.7623 11.6277 17.4997 11.6912 17.2037L12.0899 15.3409C12.1517 15.0103 12.3119 14.7062 12.5497 14.4684L15.6111 11.4071C16.0992 10.919 16.8907 10.919 17.3788 11.4071Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReloadIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2781_15875)">
        <path
          d="M16.6747 1.66602V4.27617C16.6747 4.52106 16.3685 4.63192 16.2117 4.44379C14.6858 2.73893 12.4684 1.66602 10.0003 1.66602C5.39795 1.66602 1.66699 5.39697 1.66699 9.99935C1.66699 14.6017 5.39795 18.3327 10.0003 18.3327C14.6027 18.3327 18.3337 14.6017 18.3337 9.99935"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2781_15875">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ImageIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.667 2.91602H8.33366C5.19096 2.91602 3.61962 2.91602 2.6433 3.89232C1.66699 4.86864 1.66699 6.43998 1.66699 9.58268V11.2493C1.66699 14.392 1.66699 15.9634 2.6433 16.9397C3.61962 17.916 5.19096 17.916 8.33366 17.916H11.667C14.8097 17.916 16.3811 17.916 17.3573 16.9397C18.3337 15.9634 18.3337 14.392 18.3337 11.2493V9.58268C18.3337 6.43998 18.3337 4.86864 17.3573 3.89232C16.3811 2.91602 14.8097 2.91602 11.667 2.91602Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08301 8.75C7.77336 8.75 8.33301 8.19036 8.33301 7.5C8.33301 6.80964 7.77336 6.25 7.08301 6.25C6.39265 6.25 5.83301 6.80964 5.83301 7.5C5.83301 8.19036 6.39265 8.75 7.08301 8.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9163 14.584L13.623 9.9004C13.4383 9.69873 13.1773 9.58398 12.9038 9.58398C12.645 9.58398 12.3968 9.68682 12.2139 9.86973L8.33301 13.7507L6.53241 11.9501C6.35138 11.769 6.10585 11.6673 5.84983 11.6673C5.5741 11.6673 5.31153 11.7852 5.12835 11.9913L2.08301 15.4173"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReplyEmailIcon = (props) => {
  return (
    <svg
      width={props?.size || '24'}
      height={props?.size || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.37283 11.7498L9.69608 15.0728C9.84474 15.2216 9.91808 15.3957 9.91608 15.595C9.91424 15.7943 9.83574 15.9716 9.68058 16.1268C9.52541 16.2716 9.34974 16.3466 9.15358 16.3518C8.95758 16.3568 8.78199 16.2818 8.62683 16.1268L4.13258 11.6325C3.95174 11.4517 3.86133 11.2408 3.86133 10.9998C3.86133 10.7588 3.95174 10.5478 4.13258 10.367L8.62683 5.87276C8.76533 5.73442 8.93674 5.66359 9.14108 5.66026C9.34558 5.65709 9.52541 5.72792 9.68058 5.87276C9.83574 6.02792 9.91333 6.20617 9.91333 6.40751C9.91333 6.60867 9.83574 6.78684 9.68058 6.94201L6.37283 10.2498H15.7498C17.0627 10.2498 18.1825 10.7133 19.1093 11.6403C20.0363 12.5671 20.4998 13.6869 20.4998 14.9998V17.7498C20.4998 17.9626 20.428 18.1408 20.2843 18.2843C20.1408 18.4279 19.9627 18.4998 19.7498 18.4998C19.537 18.4998 19.3588 18.4279 19.2153 18.2843C19.0717 18.1408 18.9998 17.9626 18.9998 17.7498V14.9998C18.9998 14.1023 18.6825 13.3363 18.0478 12.7018C17.4133 12.0671 16.6473 11.7498 15.7498 11.7498H6.37283Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EmailArrowDownIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.8337 7.5L10.0003 13.3333L4.16699 7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReplyAllIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.85246 9.16647L7.24684 12.5606C7.37072 12.6847 7.43184 12.8297 7.43017 12.9958C7.42864 13.162 7.36322 13.3097 7.23392 13.439C7.10461 13.5597 6.95822 13.6222 6.79475 13.6265C6.63142 13.6306 6.4851 13.5681 6.35579 13.439L2.61059 9.69376C2.53253 9.6157 2.47753 9.53341 2.44559 9.44688C2.4135 9.36035 2.39746 9.26688 2.39746 9.16647C2.39746 9.06605 2.4135 8.97258 2.44559 8.88605C2.47753 8.79952 2.53253 8.71723 2.61059 8.63917L6.35579 4.89396C6.47121 4.77869 6.61406 4.71966 6.78434 4.71688C6.95475 4.71424 7.10461 4.77327 7.23392 4.89396C7.36322 5.02327 7.42788 5.17181 7.42788 5.33959C7.42788 5.50723 7.36322 5.6557 7.23392 5.78501L3.85246 9.16647ZM8.27559 9.79147L11.0448 12.5606C11.1688 12.6847 11.23 12.8297 11.2283 12.9958C11.2266 13.162 11.1612 13.3097 11.032 13.439C10.9027 13.5597 10.7563 13.6222 10.5929 13.6265C10.4294 13.6306 10.283 13.5681 10.1537 13.439L6.40871 9.69376C6.33066 9.6157 6.27559 9.53341 6.2435 9.44688C6.21142 9.36035 6.19538 9.26688 6.19538 9.16647C6.19538 9.06605 6.21142 8.97258 6.2435 8.88605C6.27559 8.79952 6.33066 8.71723 6.40871 8.63917L10.1537 4.89396C10.2691 4.77869 10.412 4.71966 10.5825 4.71688C10.7529 4.71424 10.9027 4.77327 11.032 4.89396C11.1612 5.02327 11.2258 5.17181 11.2258 5.33959C11.2258 5.50723 11.1612 5.6557 11.032 5.78501L8.27559 8.54147H13.9583C15.0523 8.54147 15.9855 8.92772 16.7579 9.70022C17.5304 10.4726 17.9166 11.4058 17.9166 12.4998V14.7915C17.9166 14.9688 17.8568 15.1173 17.737 15.2369C17.6175 15.3566 17.469 15.4165 17.2916 15.4165C17.1143 15.4165 16.9658 15.3566 16.8462 15.2369C16.7265 15.1173 16.6666 14.9688 16.6666 14.7915V12.4998C16.6666 11.7519 16.4022 11.1135 15.8733 10.5848C15.3445 10.0559 14.7062 9.79147 13.9583 9.79147H8.27559Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ReadIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.66675 15.834L7.4276 11.9094C9.53233 10.4755 10.4678 10.4755 12.5726 11.9094L18.3334 15.834"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M1.68001 12.1265C1.73496 14.6542 1.76245 15.9181 2.70517 16.8541C3.6479 17.7901 4.95994 17.8225 7.58401 17.8874C9.19949 17.9273 10.8007 17.9273 12.4162 17.8874C15.0402 17.8225 16.3522 17.7901 17.295 16.8541C18.2377 15.9181 18.2652 14.6542 18.3202 12.1265C18.3471 10.8881 18.333 9.66182 18.2779 8.41073C18.2437 7.63368 18.2267 7.24516 18.0296 6.90052C17.8325 6.55588 17.4928 6.33344 16.8134 5.88857L13.6794 3.83637C11.8952 2.66812 11.0032 2.08398 10.0001 2.08398C8.99691 2.08398 8.10489 2.66811 6.32077 3.83637L3.18672 5.88857C2.50732 6.33344 2.16763 6.55588 1.97057 6.90052C1.77351 7.24516 1.75641 7.63369 1.72221 8.41073C1.66715 9.66182 1.65309 10.8881 1.68001 12.1265Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M18.3334 7.91602L14.7789 10.5053C13.9171 11.1332 13.2087 11.666 12.0834 11.666M1.66675 7.91602L5.22123 10.5053C6.08304 11.1332 6.79142 11.666 7.91675 11.666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UnreadIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.66675 15.834L7.4276 11.9094C9.53233 10.4755 10.4678 10.4755 12.5726 11.9094L18.3334 15.834"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M18.3334 7.91602L14.7789 10.5053C13.9171 11.1332 13.2087 11.666 12.0834 11.666M1.66675 7.91602L5.22123 10.5053C6.08304 11.1332 6.79142 11.666 7.91675 11.666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M10.0002 1.33398C10.6625 1.33404 11.2571 1.53158 11.8889 1.85449C12.1047 1.96481 12.3306 2.09573 12.5725 2.24121C12.2766 2.64896 12.0793 3.13276 12.0198 3.65918C11.7151 3.4699 11.45 3.31402 11.2063 3.18945C10.6955 2.92836 10.341 2.83404 10.0002 2.83398C9.65962 2.83404 9.30573 2.92855 8.79517 3.18945C8.53167 3.32413 8.24198 3.49453 7.90552 3.70508L6.73169 4.46387L3.5979 6.51562C2.94858 6.9408 2.7549 7.08564 2.65845 7.2168L2.62231 7.27246C2.55739 7.38601 2.52646 7.51172 2.49927 7.9248L2.47192 8.44336C2.41758 9.67829 2.40337 10.8886 2.42993 12.1104L2.45142 13.002C2.47476 13.8245 2.50937 14.4474 2.59888 14.957C2.71185 15.6 2.90173 15.9927 3.23364 16.3223C3.56325 16.6495 3.96762 16.8419 4.64185 16.958C5.34903 17.0797 6.26887 17.1047 7.60278 17.1377L8.80298 17.1602C10.0011 17.175 11.1955 17.1674 12.3977 17.1377L13.3245 17.1133C14.1789 17.0867 14.8293 17.0493 15.3596 16.958C16.0334 16.842 16.4373 16.6493 16.7668 16.3223C17.0987 15.9927 17.2896 15.5999 17.4026 14.957C17.5219 14.2776 17.5426 13.3968 17.5706 12.1104L17.5833 11.1953C17.5864 10.5865 17.5798 9.97832 17.5627 9.36621L17.5295 8.44336C17.497 7.70253 17.4719 7.47796 17.4084 7.33203L17.3792 7.27246C17.3141 7.15873 17.2144 7.06346 16.8567 6.81836L16.511 6.58789C16.9592 6.32566 17.3321 5.95198 17.593 5.50293L17.6692 5.55371C18.0935 5.84092 18.4504 6.12528 18.6809 6.52832L18.7834 6.7334C18.9913 7.21907 19.0004 7.75961 19.0276 8.37793L19.0618 9.32422C19.0793 9.9528 19.0865 10.5776 19.0833 11.2031L19.0706 12.1426C19.0436 13.3833 19.0239 14.3985 18.8801 15.2168C18.73 16.0716 18.4342 16.7803 17.8235 17.3867C17.2106 17.9951 16.4866 18.2862 15.6135 18.4365C14.9833 18.545 14.2359 18.5853 13.3577 18.6123L12.4348 18.6367C11.2141 18.6669 10.0011 18.6752 8.78442 18.6602L7.56567 18.6367C6.27611 18.6048 5.2273 18.5812 4.38696 18.4365C3.51385 18.2862 2.78995 17.9952 2.177 17.3867C1.56622 16.7803 1.27153 16.0716 1.12134 15.2168C1.01351 14.603 0.97517 13.8786 0.951416 13.0312L0.930908 12.1426C0.903627 10.8876 0.918116 9.64504 0.973877 8.37793L0.997314 7.86621C1.02707 7.37279 1.08902 6.93169 1.31958 6.52832L1.44556 6.33594C1.76174 5.90815 2.23703 5.61407 2.77661 5.26074L5.9104 3.20898L7.10962 2.43359C7.47334 2.20618 7.80475 2.01181 8.11255 1.85449C8.74423 1.53165 9.33811 1.33405 10.0002 1.33398Z"
        fill="currentColor"
      />
      <circle cx="15" cy="4" r="2" fill="currentColor" />
    </svg>
  );
};

export const TypesIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_3171_11203)">
        <path
          d="M6.01735 6.05684L8.76686 1.40062C8.85671 1.25148 8.96409 1.14738 9.089 1.08832C9.2139 1.02944 9.34576 1 9.48458 1C9.6234 1 9.75526 1.02944 9.88017 1.08832C10.0051 1.14738 10.1124 1.25148 10.2023 1.40062L12.9518 6.05684C13.0417 6.19928 13.0866 6.34878 13.0866 6.50533C13.0866 6.66205 13.0503 6.80617 12.9776 6.93768C12.9049 7.0692 12.8071 7.17321 12.684 7.24972C12.5612 7.32641 12.4178 7.36475 12.2539 7.36475H6.71523C6.54978 7.36475 6.40503 7.32561 6.28099 7.24734C6.15695 7.16906 6.06048 7.06585 5.99158 6.93768C5.91891 6.8104 5.88257 6.6691 5.88257 6.51379C5.88257 6.3583 5.9275 6.20598 6.01735 6.05684ZM15.1542 19C14.0771 19 13.1669 18.6186 12.4235 17.8558C11.6801 17.093 11.3084 16.159 11.3084 15.0538C11.3084 13.9486 11.6801 13.0146 12.4235 12.2518C13.1669 11.489 14.0771 11.1076 15.1542 11.1076C16.2313 11.1076 17.1415 11.489 17.8849 12.2518C18.6283 13.0146 19 13.9486 19 15.0538C19 16.159 18.6283 17.093 17.8849 17.8558C17.1415 18.6186 16.2313 19 15.1542 19ZM1 17.6162V12.4861C1 12.2437 1.0798 12.0415 1.23941 11.8795C1.39919 11.7175 1.59711 11.6365 1.83318 11.6365H6.83275C7.06898 11.6365 7.26604 11.7184 7.42393 11.8821C7.58182 12.0461 7.66077 12.2492 7.66077 12.4914V17.6215C7.66077 17.8639 7.58096 18.0661 7.42136 18.2281C7.26158 18.3901 7.06365 18.4711 6.82759 18.4711H1.82802C1.59179 18.4711 1.39473 18.3892 1.23684 18.2255C1.07895 18.0615 1 17.8584 1 17.6162ZM15.1537 17.9422C15.9418 17.9422 16.608 17.6631 17.1525 17.1048C17.6969 16.5465 17.9692 15.863 17.9692 15.0543C17.9692 14.2457 17.6971 13.562 17.153 13.0034C16.6089 12.4447 15.9428 12.1653 15.1547 12.1653C14.3666 12.1653 13.7004 12.4445 13.1559 13.0028C12.6115 13.5611 12.3392 14.2446 12.3392 15.0533C12.3392 15.8619 12.6113 16.5456 13.1554 17.1042C13.6995 17.6629 14.3656 17.9422 15.1537 17.9422ZM2.03084 17.4134H6.62993V12.6942H2.03084V17.4134ZM7.0384 6.307H11.9308L9.48458 2.28358L7.0384 6.307Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.3"
        />
      </g>
      <defs>
        <clipPath id="clip0_3171_11203">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RedCrossIcon = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="32" height="32" rx="16" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9998 30.3327C8.08376 30.3327 1.6665 23.9155 1.6665 15.9994C1.6665 8.08327 8.08376 1.66602 15.9998 1.66602C23.916 1.66602 30.3332 8.08327 30.3332 15.9994C30.3332 23.9155 23.916 30.3327 15.9998 30.3327ZM20.9426 12.9422C21.4633 12.4215 21.4633 11.5773 20.9426 11.0566C20.422 10.5359 19.5778 10.5358 19.057 11.0565L15.9996 14.1138L12.9426 11.057C12.4219 10.5363 11.5777 10.5364 11.057 11.0571C10.5363 11.5778 10.5363 12.422 11.0571 12.9427L14.1138 15.9994L11.0571 19.056C10.5363 19.5767 10.5363 20.421 11.057 20.9416C11.5777 21.4623 12.4219 21.4623 12.9426 20.9416L15.9996 17.885L19.057 20.9422C19.5778 21.4628 20.422 21.4628 20.9426 20.9422C21.4633 20.4214 21.4633 19.5772 20.9426 19.0566L17.8853 15.9994L20.9426 12.9422Z"
        fill="#F5222D"
      />
    </svg>
  );
};

export const GetStartedArrowIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.8333 5.83398L15 10.0007M15 10.0007L10.8333 14.1673M15 10.0007L5 10.0007"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RatingsIcon = () => {
  return (
    <svg width="118" height="22" viewBox="0 0 118 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3350_23091)">
        <path d="M22.125 0H0V22H22.125V0Z" fill="#00B67A" />
        <path d="M46.0938 0H23.9688V22H46.0938V0Z" fill="#00B67A" />
        <path d="M70.0625 0H47.9375V22H70.0625V0Z" fill="#00B67A" />
        <path d="M94.0312 0H71.9062V22H94.0312V0Z" fill="#00B67A" />
        <path d="M117.999 0H106.938V22H117.999V0Z" fill="#DCDCE6" />
        <path d="M114 0H96V22H114V0Z" fill="#00B67A" />
        <path
          d="M11.0621 14.8275L14.4269 13.9796L15.8328 18.2879L11.0621 14.8275ZM18.8058 9.25873H12.8828L11.0621 3.71289L9.2414 9.25873H3.31836L8.11211 12.6962L6.2914 18.2421L11.0851 14.8046L14.0351 12.6962L18.8058 9.25873Z"
          fill="white"
        />
        <path
          d="M35.0308 14.8275L38.3957 13.9796L39.8015 18.2879L35.0308 14.8275ZM42.7746 9.25873H36.8515L35.0308 3.71289L33.2101 9.25873H27.2871L32.0808 12.6962L30.2601 18.2421L35.0539 14.8046L38.0039 12.6962L42.7746 9.25873Z"
          fill="white"
        />
        <path
          d="M58.9997 14.8275L62.3645 13.9796L63.7704 18.2879L58.9997 14.8275ZM66.7434 9.25873H60.8204L58.9997 3.71289L57.179 9.25873H51.2559L56.0497 12.6962L54.229 18.2421L59.0227 14.8046L61.9727 12.6962L66.7434 9.25873Z"
          fill="white"
        />
        <path
          d="M82.9683 14.8275L86.3332 13.9796L87.739 18.2879L82.9683 14.8275ZM90.7121 9.25873H84.789L82.9683 3.71289L81.1476 9.25873H75.2246L80.0183 12.6962L78.1976 18.2421L82.9914 14.8046L85.9414 12.6962L90.7121 9.25873Z"
          fill="white"
        />
        <path
          d="M106.937 14.8275L110.302 13.9796L111.708 18.2879L106.937 14.8275ZM114.681 9.25873H108.758L106.937 3.71289L105.117 9.25873H99.1934L103.987 12.6962L102.167 18.2421L106.961 14.8046L109.911 12.6962L114.681 9.25873Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3350_23091">
          <rect width="118" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DuplicateIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: 'pointer' }}
      {...props}
    >
      <path
        d="M9 15C9 12.1716 9 10.7574 9.87868 9.87868C10.7574 9 12.1716 9 15 9H16C18.8284 9 20.2426 9 21.1213 9.87868C22 10.7574 22 12.1716 22 15V16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H15C12.1716 22 10.7574 22 9.87868 21.1213C9 20.2426 9 18.8284 9 16V15Z"
        stroke="#096DD9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9999 9C16.9975 6.04291 16.9528 4.51121 16.092 3.46243C15.9258 3.25989 15.7401 3.07418 15.5376 2.90796C14.4312 2 12.7875 2 9.5 2C6.21252 2 4.56878 2 3.46243 2.90796C3.25989 3.07417 3.07418 3.25989 2.90796 3.46243C2 4.56878 2 6.21252 2 9.5C2 12.7875 2 14.4312 2.90796 15.5376C3.07417 15.7401 3.25989 15.9258 3.46243 16.092C4.51121 16.9528 6.04291 16.9975 9 16.9999"
        stroke="#096DD9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LandingBackgroundArrow = (props) => {
  return (
    <svg width="151" height="144" viewBox="0 0 151 144" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M27.8179 35.1694C32.5516 28.9782 39.4343 25.6475 46.3081 24.934C49.7653 24.5662 53.3263 24.8679 56.8036 25.835C60.9217 26.9961 65.0587 29.0969 68.4779 32.6286C74.1139 38.4695 76.8678 47.6257 76.9005 56.3949C76.9427 65.634 73.4011 73.7261 67.9387 78.9396C65.169 81.5871 61.9281 83.5001 58.5218 84.5792C55.1684 85.6164 51.4425 86.156 47.9318 84.8904C44.5109 83.6553 40.9501 80.53 40.7934 75.5354C40.6363 70.409 43.6916 66.3271 46.4443 63.3986C52.1894 57.2403 59.9466 54.5181 67.5171 53.5988C74.6758 52.731 82.1374 53.6651 89.3099 56.2597C96.5231 58.8323 103.464 63.0829 109.703 68.782C116.253 74.8141 122.094 82.6153 125.725 91.8903C126.169 93.0223 126.543 94.1785 126.999 95.2907C127.459 96.4401 127.841 97.5393 128.122 98.7594C127.221 98.6802 126.319 98.601 125.418 98.5218C125.971 96.5203 126.316 94.5918 126.473 92.3958C126.537 91.8073 126.56 91.2408 126.57 90.694C126.589 90.2219 126.576 89.7148 126.583 89.3942C126.565 88.8497 126.564 88.3228 126.505 87.8003C126.505 87.6686 126.488 87.5193 126.471 87.3701C126.504 87.5369 126.5 87.4996 126.446 87.2779C126.182 86.0753 126.472 87.5018 126.937 87.5403C127.165 87.5222 127.393 87.5042 127.622 87.4861C127.369 87.5437 127.906 87.2 127.906 87.2C127.991 87.0615 128.015 86.8902 128.011 86.7211C128.015 86.6267 127.956 86.1043 128.023 86.5696C128.06 86.7737 128.097 86.9778 128.077 87.1865C127.831 86.6601 127.585 86.1337 127.351 85.5875L127.412 85.6203C127.221 85.579 127.041 85.5179 126.849 85.4766C126.792 85.4811 126.723 85.5055 126.723 85.5055C128.059 84.9667 128.944 87.7203 127.595 88.2788C127.225 88.4399 126.931 88.3878 126.551 88.2108C126.828 88.2453 127.106 88.2798 127.395 88.2946L127.367 88.2968C127.029 88.493 126.494 88.3471 126.196 87.9942C124.96 86.4732 125.67 83.6876 127.408 84.0395C128.367 84.2459 129.157 85.2563 129.421 86.4589C129.636 87.4772 129.623 88.5136 129.638 89.5477C129.677 93.234 129.144 96.8338 128.151 100.169C127.953 100.843 127.383 101.284 126.812 101.197C126.273 101.146 125.615 100.671 125.446 99.9313C125.186 98.766 124.926 97.6007 124.666 96.4354C124.405 95.2701 124.023 94.171 123.584 93.0763C122.754 90.9396 121.778 88.9087 120.724 86.9591C118.535 82.9724 115.939 79.3378 113.088 76.1188C107.63 69.9437 101.353 65.1888 94.6883 61.8575C88.1623 58.6094 81.2367 56.8046 74.4502 56.6265C67.4027 56.4314 60.2412 57.7889 54.0039 61.4826C50.8445 63.3515 47.9236 65.9356 45.6941 69.2933C45.1377 70.1091 44.6303 70.9775 44.2006 71.8962C43.9251 72.5204 43.5448 73.6234 43.4451 74.4031C43.3293 75.297 43.3524 76.274 43.5502 77.0113C43.7728 77.8407 44.0927 78.5119 44.5512 79.1344C45.4846 80.397 46.9104 81.3006 48.278 81.8135C49.8537 82.3853 51.4162 82.5816 52.9901 82.4947C56.3214 82.2875 59.5484 81.2791 62.5042 79.5204C68.1513 76.2122 72.8805 69.852 74.2648 61.78C75.5852 54.1649 74.1784 45.4668 70.1879 38.8933C65.6894 31.5128 57.977 28.3398 51.1897 27.8982C44.6921 27.4713 38.1562 29.4004 32.7107 33.3515C31.3799 34.3227 30.0452 35.3884 28.7882 36.5043C28.1983 37.0216 27.2775 35.871 27.8179 35.1694Z"
        fill="#24A147"
      />
      <path
        d="M130.501 103.379C128.658 103.379 126.714 103.122 124.824 102.459C123.862 102.11 122.917 101.687 121.99 101.19C121.046 100.675 119.899 100.105 119.08 99.2592C118.528 98.689 118.333 97.751 118.62 97.1256C118.954 96.4267 119.59 96.3163 120.256 96.6658C120.707 96.8865 121.111 97.2727 121.533 97.5854C121.948 97.8613 122.382 98.1556 122.827 98.4315C123.635 98.9281 124.449 99.3695 125.275 99.7925C126.956 100.639 128.667 101.301 130.397 101.705C131.199 101.889 131.256 103.361 130.501 103.379Z"
        fill="#24A147"
      />
    </svg>
  );
};

export const ClockIcon = (props) => {
  return (
    <svg
      width={props?.size || '40'}
      height={props?.size || '40'}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.9997 36.6673C29.2044 36.6673 36.6663 29.2054 36.6663 20.0007C36.6663 10.7959 29.2044 3.33398 19.9997 3.33398C10.7949 3.33398 3.33301 10.7959 3.33301 20.0007C3.33301 29.2054 10.7949 36.6673 19.9997 36.6673Z"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '2'}
      />
      <path
        d="M20 13.334V20.0007L23.3333 23.334"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '2'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MedicalCareIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.3352 2.66602C18.8071 2.66602 20.0004 3.9077 20.0004 5.43939C20.0004 6.70488 20.0483 7.83102 19.0256 8.76196C15.6783 11.8091 14.0045 13.3327 12.0004 13.3327C9.99618 13.3327 8.32249 11.8091 4.9751 8.76196C3.95234 7.83094 4.00035 6.70468 4.00035 5.4391C4.00035 3.90756 5.19346 2.66602 6.66523 2.66602"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18.666V23.3324C12 26.6463 14.6865 29.3328 18.0004 29.3328C21.3144 29.3328 24.0009 26.6463 24.0009 23.3324V21.3327"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6673 9.33398L16.931 13.6748C16.4694 14.8287 16.2386 15.4056 15.8522 15.8796C15.4657 16.3537 14.9471 16.696 13.9099 17.3805L11.9601 18.6673L10.0444 17.377C9.03026 16.6941 8.52317 16.3525 8.14493 15.8841C7.76668 15.4157 7.53962 14.8481 7.08552 13.7128L5.33398 9.33398"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 17.334C28 19.5432 26.2092 21.334 24 21.334C21.7908 21.334 20 19.5432 20 17.334C20 15.1248 21.7908 13.334 24 13.334C26.2092 13.334 28 15.1248 28 17.334Z"
        stroke="#077882"
        strokeWidth="2"
      />
      <path
        d="M24.0115 17.334H23.998"
        stroke="#077882"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TrackLandingIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.9574 14.2861C24.7004 14.5299 24.357 14.666 23.9995 14.666C23.642 14.666 23.2986 14.5299 23.0416 14.2861C20.6883 12.0416 17.5347 9.53416 19.0727 5.89382C19.9042 3.92551 21.9003 2.66602 23.9995 2.66602C26.0987 2.66602 28.0947 3.92551 28.9263 5.89382C30.4623 9.52958 27.3164 12.0493 24.9574 14.2861Z"
        stroke="#077882"
        strokeWidth="2"
      />
      <path d="M24 8H24.012" stroke="#077882" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6.66602 29.334C8.87515 29.334 10.666 27.5431 10.666 25.334C10.666 23.1248 8.87515 21.334 6.66602 21.334C4.45688 21.334 2.66602 23.1248 2.66602 25.334C2.66602 27.5431 4.45688 29.334 6.66602 29.334Z"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 9.33398H12.6667C10.0893 9.33398 8 11.1249 8 13.334C8 15.5432 10.0893 17.334 12.6667 17.334H16.6667C19.244 17.334 21.3333 19.1248 21.3333 21.334C21.3333 23.5432 19.244 25.334 16.6667 25.334H14.6667"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ConnectedIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3368_2139)">
        <path
          d="M26.1343 6.53398C26.001 6.53398 25.8676 6.53398 25.7343 6.40065C23.0676 4.00065 19.601 2.66732 16.001 2.66732C12.5343 2.66732 9.06762 3.86732 6.40096 6.26732C6.13429 6.40065 5.73429 6.40065 5.46762 6.13398C5.20095 5.86732 5.33429 5.46732 5.60095 5.20065C8.40095 2.66732 12.1343 1.33398 16.001 1.33398C19.8676 1.33398 23.7343 2.80065 26.6676 5.33398C26.9343 5.60065 26.9343 6.00065 26.6676 6.26732C26.5343 6.40065 26.401 6.53398 26.1343 6.53398Z"
          fill="#077882"
          stroke="#077882"
          strokeWidth="0.5"
        />
        <path
          d="M10.0007 6.66732H6.00065C5.60065 6.66732 5.33398 6.40065 5.33398 6.00065V2.00065C5.33398 1.60065 5.60065 1.33398 6.00065 1.33398C6.40065 1.33398 6.66732 1.60065 6.66732 2.00065V5.33398H10.0007C10.4007 5.33398 10.6673 5.60065 10.6673 6.00065C10.6673 6.40065 10.4007 6.66732 10.0007 6.66732Z"
          fill="#077882"
          stroke="#077882"
          strokeWidth="0.5"
        />
        <path
          d="M16.1342 30.6665C12.2676 30.6665 8.40091 29.1999 5.46758 26.6665C5.20091 26.3999 5.20091 25.9999 5.46758 25.7332C5.73424 25.4665 6.13425 25.4665 6.40091 25.7332C9.06758 28.1332 12.5342 29.4665 16.1342 29.4665C19.6009 29.4665 23.0676 28.2665 25.7342 25.8665C26.0009 25.5999 26.4009 25.5999 26.6676 25.9999C26.9342 26.2665 26.9342 26.6665 26.5342 26.9332C23.7342 29.3332 20.0009 30.6665 16.1342 30.6665Z"
          fill="#077882"
          stroke="#077882"
          strokeWidth="0.5"
        />
        <path
          d="M26.1335 30.6673C25.7335 30.6673 25.4668 30.4007 25.4668 30.0007V26.6673H22.1335C21.7335 26.6673 21.4668 26.4007 21.4668 26.0007C21.4668 25.6007 21.7335 25.334 22.1335 25.334H26.1335C26.5335 25.334 26.8001 25.6007 26.8001 26.0007V30.0007C26.8001 30.4007 26.5335 30.6673 26.1335 30.6673Z"
          fill="#077882"
          stroke="#077882"
          strokeWidth="0.5"
        />
        <path
          d="M6.66732 16.0007C4.80065 16.0007 3.33398 14.534 3.33398 12.6673C3.33398 10.8007 4.80065 9.33398 6.66732 9.33398C8.53398 9.33398 10.0007 10.8007 10.0007 12.6673C10.0007 14.534 8.53398 16.0007 6.66732 16.0007ZM6.66732 10.6673C5.60065 10.6673 4.66732 11.6007 4.66732 12.6673C4.66732 13.734 5.60065 14.6673 6.66732 14.6673C7.73398 14.6673 8.66732 13.734 8.66732 12.6673C8.66732 11.6007 7.73398 10.6673 6.66732 10.6673Z"
          fill="#077882"
          stroke="#077882"
          strokeWidth="0.5"
        />
        <path
          d="M12.6667 22.6673C12.2667 22.6673 12 22.4007 12 22.0007V20.6673C12 19.6007 11.0667 18.6673 10 18.6673H3.33333C2.26667 18.6673 1.33333 19.6007 1.33333 20.6673V22.0007C1.33333 22.4007 1.06667 22.6673 0.666667 22.6673C0.266667 22.6673 0 22.4007 0 22.0007V20.6673C0 18.8007 1.46667 17.334 3.33333 17.334H10C11.8667 17.334 13.3333 18.8007 13.3333 20.6673V22.0007C13.3333 22.4007 13.0667 22.6673 12.6667 22.6673Z"
          fill="#077882"
          stroke="#077882"
          strokeWidth="0.5"
        />
        <path
          d="M25.3333 16.0007C23.4667 16.0007 22 14.534 22 12.6673C22 10.8007 23.4667 9.33398 25.3333 9.33398C27.2 9.33398 28.6667 10.8007 28.6667 12.6673C28.6667 14.534 27.2 16.0007 25.3333 16.0007ZM25.3333 10.6673C24.2667 10.6673 23.3333 11.6007 23.3333 12.6673C23.3333 13.734 24.2667 14.6673 25.3333 14.6673C26.4 14.6673 27.3333 13.734 27.3333 12.6673C27.3333 11.6007 26.4 10.6673 25.3333 10.6673Z"
          fill="#077882"
          stroke="#077882"
          strokeWidth="0.5"
        />
        <path
          d="M31.3327 22.6673C30.9327 22.6673 30.666 22.4007 30.666 22.0007V20.6673C30.666 19.6007 29.7327 18.6673 28.666 18.6673H21.9993C20.9327 18.6673 19.9993 19.6007 19.9993 20.6673V22.0007C19.9993 22.4007 19.7327 22.6673 19.3327 22.6673C18.9327 22.6673 18.666 22.4007 18.666 22.0007V20.6673C18.666 18.8007 20.1327 17.334 21.9993 17.334H28.666C30.5327 17.334 31.9993 18.8007 31.9993 20.6673V22.0007C31.9993 22.4007 31.7327 22.6673 31.3327 22.6673Z"
          fill="#077882"
          stroke="#077882"
          strokeWidth="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_3368_2139">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CareIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.33398 18.666H8.52708C8.91928 18.666 9.30609 18.7544 9.65688 18.9241L12.3795 20.2415C12.7303 20.4112 13.1171 20.4995 13.5093 20.4995H14.8995C16.244 20.4995 17.334 21.5543 17.334 22.8553C17.334 22.9079 17.298 22.9541 17.2457 22.9685L13.8579 23.9053C13.2501 24.0733 12.5993 24.0148 12.034 23.7412L9.12346 22.3331"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.334 22L23.4577 20.1186C24.5433 19.7803 25.7168 20.1814 26.3968 21.1231C26.8885 21.8039 26.6883 22.779 25.972 23.1923L15.9512 28.974C15.3139 29.3418 14.5619 29.4315 13.8609 29.2235L5.33398 26.6932"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 15.9993H17.3333C14.8192 15.9993 13.5621 15.9993 12.7811 15.2183C12 14.4372 12 13.1802 12 10.666V7.99935C12 5.48519 12 4.22811 12.7811 3.44707C13.5621 2.66602 14.8192 2.66602 17.3333 2.66602H20C22.5141 2.66602 23.7712 2.66602 24.5523 3.44707C25.3333 4.22811 25.3333 5.48519 25.3333 7.99935V10.666C25.3333 13.1802 25.3333 14.4372 24.5523 15.2183C23.7712 15.9993 22.5141 15.9993 20 15.9993Z"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M17.334 6.66602H20.0007" stroke="#077882" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const CrossFillIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0527 1.75C14.2453 1.74999 15.9673 1.74998 17.3115 1.93066C18.6882 2.11575 19.7805 2.50313 20.6387 3.36133C21.4969 4.21953 21.8842 5.31182 22.0693 6.68848C22.25 8.03274 22.25 9.75468 22.25 11.9473V12.0527C22.25 14.2453 22.25 15.9673 22.0693 17.3115C21.8842 18.6882 21.4969 19.7805 20.6387 20.6387C19.7805 21.4969 18.6882 21.8842 17.3115 22.0693C15.9673 22.25 14.2453 22.25 12.0527 22.25H11.9473C9.75468 22.25 8.03274 22.25 6.68848 22.0693C5.31182 21.8842 4.21953 21.4969 3.36133 20.6387C2.50313 19.7805 2.11575 18.6882 1.93066 17.3115C1.74998 15.9673 1.74999 14.2453 1.75 12.0527V11.9473C1.74999 9.75468 1.74998 8.03274 1.93066 6.68848C2.11575 5.31182 2.50313 4.21953 3.36133 3.36133C4.21953 2.50313 5.31182 2.11575 6.68848 1.93066C8.03274 1.74998 9.75468 1.74999 11.9473 1.75H12.0527ZM15.707 8.29297C15.3165 7.90246 14.6835 7.90247 14.293 8.29297L11.999 10.585L9.70703 8.29297L9.63086 8.22461C9.23816 7.90448 8.65903 7.9271 8.29297 8.29297C7.9268 8.6592 7.90398 9.23908 8.22461 9.63184L8.29297 9.70801L10.585 12L8.29297 14.292C7.90247 14.6825 7.90247 15.3165 8.29297 15.707C8.65902 16.0728 9.23818 16.0955 9.63086 15.7754L9.70703 15.707L11.999 13.4141L14.293 15.707L14.3691 15.7754C14.7619 16.0957 15.3409 16.0731 15.707 15.707C16.0731 15.3409 16.0957 14.7619 15.7754 14.3691L15.707 14.293L13.4141 12L15.707 9.70703C16.0975 9.31654 16.0975 8.6835 15.707 8.29297Z"
        fill="#077882"
      />
    </svg>
  );
};

export const TrustPilotIcon = () => {
  return (
    <svg width="318" height="112" viewBox="0 0 318 112" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3429_2191)">
        <path
          d="M125.451 11.9698H139.624V14.5668H134.052V29.1688H130.986V14.5668H125.438V11.9688H125.45L125.451 11.9698ZM139.019 16.7148H141.639V19.1187H141.688C141.774 18.7787 141.935 18.4508 142.17 18.1348C142.672 17.4575 143.352 16.9324 144.135 16.6178C144.532 16.4603 144.955 16.3779 145.382 16.3748C145.702 16.3748 145.938 16.3867 146.062 16.3997C146.185 16.4117 146.309 16.4358 146.444 16.4478V19.0938C146.244 19.0586 146.042 19.0303 145.84 19.0088C145.638 18.985 145.436 18.9729 145.234 18.9727C144.764 18.9727 144.32 19.0698 143.9 19.2528C143.48 19.4338 143.121 19.7127 142.812 20.0658C142.484 20.4604 142.232 20.9133 142.07 21.4007C141.885 21.9347 141.799 22.5407 141.799 23.2337V29.1567H139.007V16.7148H139.019ZM159.283 29.1698H156.541V27.4338H156.49C156.144 28.0658 155.639 28.5638 154.958 28.9398C154.278 29.3158 153.587 29.5098 152.883 29.5098C151.215 29.5098 150.003 29.1097 149.263 28.2957C148.521 27.4827 148.15 26.2568 148.15 24.6178V16.7157H150.943V24.3507C150.943 25.4438 151.152 26.2207 151.585 26.6698C152.005 27.1188 152.61 27.3498 153.376 27.3498C153.969 27.3498 154.451 27.2648 154.847 27.0818C155.243 26.8998 155.564 26.6697 155.799 26.3657C156.046 26.0747 156.219 25.7108 156.331 25.2978C156.441 24.8848 156.49 24.4358 156.49 23.9508V16.7278H159.283V29.1698ZM164.041 25.1768C164.128 25.9768 164.436 26.5368 164.968 26.8638C165.511 27.1798 166.153 27.3498 166.907 27.3498C167.167 27.3498 167.464 27.3247 167.798 27.2887C168.131 27.2517 168.451 27.1667 168.736 27.0588C169.033 26.9488 169.267 26.7788 169.465 26.5608C169.651 26.3408 169.736 26.0628 169.724 25.7108C169.723 25.5474 169.687 25.3862 169.619 25.2377C169.551 25.0891 169.452 24.9566 169.33 24.8488C169.082 24.6188 168.773 24.4487 168.389 24.3027C167.962 24.1545 167.524 24.0369 167.08 23.9508C166.586 23.8538 166.091 23.7438 165.585 23.6348C165.076 23.5245 164.572 23.3866 164.078 23.2218C163.613 23.073 163.176 22.852 162.78 22.5667C162.395 22.298 162.081 21.9397 161.865 21.5228C161.631 21.0978 161.519 20.5757 161.519 19.9447C161.519 19.2648 161.693 18.7068 162.027 18.2448C162.363 17.7866 162.798 17.4094 163.3 17.1408C163.838 16.856 164.417 16.6554 165.016 16.5457C165.646 16.4367 166.252 16.3757 166.82 16.3757C167.475 16.3757 168.105 16.4488 168.699 16.5828C169.275 16.7059 169.823 16.9318 170.318 17.2498C170.799 17.5538 171.194 17.9538 171.516 18.4398C171.837 18.9248 172.036 19.5198 172.122 20.2118H169.206C169.069 19.5568 168.772 19.1077 168.292 18.8888C167.81 18.6588 167.254 18.5487 166.636 18.5487C166.438 18.5487 166.202 18.5607 165.931 18.5977C165.67 18.6325 165.413 18.6935 165.165 18.7798C164.937 18.8635 164.731 18.9959 164.559 19.1677C164.476 19.2574 164.412 19.3625 164.37 19.4772C164.327 19.5918 164.308 19.7136 164.313 19.8358C164.313 20.1758 164.435 20.4427 164.67 20.6488C164.905 20.8548 165.215 21.0247 165.597 21.1707C165.98 21.3047 166.413 21.4258 166.907 21.5228C167.401 21.6198 167.908 21.7288 168.428 21.8388C168.934 21.9478 169.428 22.0938 169.923 22.2507C170.417 22.4087 170.849 22.6277 171.233 22.9067C171.616 23.1858 171.924 23.5257 172.158 23.9387C172.393 24.3507 172.517 24.8727 172.517 25.4797C172.517 26.2197 172.345 26.8397 171.998 27.3617C171.653 27.8717 171.208 28.2957 170.664 28.6117C170.094 28.9398 169.477 29.1773 168.834 29.3158C168.181 29.4595 167.514 29.5326 166.845 29.5338C166.095 29.5422 165.348 29.4524 164.622 29.2668C163.942 29.0848 163.349 28.8177 162.855 28.4667C162.366 28.112 161.965 27.6511 161.681 27.1187C161.396 26.5847 161.247 25.9408 161.223 25.2008H164.041V25.1768ZM173.259 16.7167H175.372V12.9768H178.165V16.7167H180.684V18.7668H178.166V25.4198C178.166 25.7098 178.178 25.9538 178.203 26.1718C178.227 26.3788 178.288 26.5607 178.375 26.7057C178.47 26.8581 178.614 26.9738 178.782 27.0338C178.968 27.1068 179.203 27.1437 179.525 27.1437C179.722 27.1437 179.92 27.1438 180.118 27.1308C180.316 27.1188 180.512 27.0947 180.71 27.0457V29.1698C180.402 29.2068 180.092 29.2308 179.808 29.2668C179.509 29.3015 179.208 29.3179 178.906 29.3158C178.165 29.3158 177.572 29.2428 177.126 29.1098C176.682 28.9757 176.324 28.7698 176.077 28.5028C175.817 28.2358 175.656 27.9078 175.557 27.5068C175.461 27.0558 175.408 26.5968 175.398 26.1357V18.7898H173.285V16.7138H173.26L173.259 16.7167ZM182.662 16.7167H185.306V18.4028H185.357C185.751 17.6747 186.295 17.1648 186.999 16.8498C187.718 16.5298 188.498 16.3682 189.286 16.3757C190.286 16.3757 191.151 16.5458 191.893 16.8978C192.633 17.2378 193.251 17.7118 193.745 18.3178C194.24 18.9248 194.599 19.6287 194.846 20.4307C195.097 21.265 195.222 22.1324 195.217 23.0037C195.217 23.8407 195.106 24.6537 194.883 25.4317C194.678 26.1822 194.339 26.8893 193.882 27.5187C193.432 28.1256 192.849 28.6202 192.176 28.9638C191.484 29.3278 190.682 29.5098 189.743 29.5098C189.332 29.5093 188.922 29.4725 188.518 29.3997C188.116 29.3271 187.722 29.2094 187.346 29.0487C186.971 28.8926 186.622 28.6839 186.306 28.4288C185.996 28.1807 185.725 27.8863 185.503 27.5557H185.454V33.7708H182.662V16.7148V16.7167ZM192.424 22.9548C192.424 22.4012 192.349 21.8502 192.202 21.3167C192.065 20.8113 191.838 20.3345 191.533 19.9088C191.244 19.5037 190.869 19.1677 190.434 18.9247C189.968 18.6726 189.445 18.5432 188.915 18.5487C187.741 18.5487 186.851 18.9487 186.258 19.7507C185.665 20.5517 185.368 21.6208 185.368 22.9548C185.368 23.5857 185.442 24.1687 185.602 24.7027C185.762 25.2367 185.986 25.6987 186.306 26.0868C186.617 26.4757 186.986 26.7787 187.419 26.9967C187.851 27.2277 188.359 27.3368 188.927 27.3368C189.57 27.3368 190.101 27.2037 190.546 26.9487C190.976 26.7008 191.348 26.3611 191.633 25.9538C191.917 25.5408 192.128 25.0788 192.251 24.5578C192.364 24.031 192.422 23.4937 192.424 22.9548ZM197.354 11.9698H200.146V14.5677H197.354V11.9698ZM197.354 16.7157H200.146V29.1698H197.354V16.7157ZM202.643 11.9698H205.436V29.1698H202.643V11.9698ZM213.999 29.5098C212.985 29.5098 212.082 29.3398 211.292 29.0128C210.535 28.7021 209.85 28.2392 209.279 27.6528C208.723 27.0545 208.298 26.3476 208.029 25.5767C207.736 24.7259 207.589 23.8309 207.598 22.9307C207.598 21.9837 207.745 21.1108 208.029 20.3088C208.298 19.5383 208.723 18.8318 209.279 18.2337C209.822 17.6507 210.501 17.2018 211.292 16.8738C212.082 16.5458 212.985 16.3757 213.999 16.3757C215.012 16.3757 215.913 16.5458 216.704 16.8738C217.495 17.2018 218.162 17.6637 218.718 18.2337C219.274 18.8316 219.699 19.5382 219.966 20.3088C220.25 21.1097 220.398 21.9837 220.398 22.9307C220.398 23.8907 220.25 24.7758 219.966 25.5767C219.699 26.3477 219.274 27.0547 218.718 27.6528C218.174 28.2358 217.495 28.6848 216.704 29.0128C215.913 29.3398 215.012 29.5098 213.999 29.5098ZM213.999 27.3368C214.617 27.3368 215.16 27.2037 215.617 26.9487C216.062 26.7008 216.446 26.3564 216.742 25.9408C217.037 25.5288 217.247 25.0548 217.396 24.5328C217.533 24.0108 217.606 23.4767 217.606 22.9307C217.606 22.3967 217.533 21.8748 217.396 21.3407C217.269 20.8342 217.047 20.3564 216.742 19.9328C216.446 19.5211 216.061 19.181 215.617 18.9377C215.16 18.6827 214.617 18.5487 213.999 18.5487C213.381 18.5487 212.837 18.6827 212.38 18.9377C211.938 19.1847 211.554 19.5241 211.255 19.9328C210.954 20.359 210.733 20.8359 210.6 21.3407C210.464 21.8598 210.393 22.394 210.389 22.9307C210.389 23.4767 210.464 24.0108 210.6 24.5328C210.736 25.0548 210.958 25.5288 211.255 25.9408C211.551 26.3538 211.923 26.6937 212.38 26.9487C212.837 27.2157 213.381 27.3368 213.999 27.3368ZM221.214 16.7167H223.327V12.9768H226.12V16.7167H228.641V18.7668H226.12V25.4198C226.12 25.7098 226.132 25.9538 226.156 26.1718C226.181 26.3788 226.243 26.5607 226.33 26.7057C226.425 26.8583 226.568 26.974 226.738 27.0338C226.924 27.1068 227.157 27.1437 227.479 27.1437C227.676 27.1437 227.874 27.1438 228.072 27.1308C228.27 27.1188 228.467 27.0947 228.665 27.0457V29.1698C228.356 29.2068 228.048 29.2308 227.764 29.2668C227.464 29.3015 227.163 29.3179 226.861 29.3158C226.12 29.3158 225.526 29.2428 225.081 29.1098C224.637 28.9757 224.278 28.7698 224.031 28.5028C223.772 28.2358 223.611 27.9078 223.512 27.5068C223.416 27.0558 223.363 26.5967 223.352 26.1357V18.7898H221.24V16.7138H221.214V16.7167Z"
          fill="black"
        />
        <path
          d="M122.189 11.969H109.388L105.434 0L101.466 11.97L88.666 11.957L99.033 19.361L95.067 31.317L105.434 23.925L115.789 31.317L111.835 19.361L122.189 11.969Z"
          fill="#04DA8D"
        />
        <path d="M112.724 22.0683L111.834 19.3613L105.434 23.9253L112.724 22.0683Z" fill="#126849" />
      </g>
      <g clipPath="url(#clip1_3429_2191)">
        <path d="M96.166 44H58.666V81.2881H96.166V44Z" fill="#00B67A" />
        <path d="M136.791 44H99.291V81.2881H136.791V44Z" fill="#00B67A" />
        <path d="M177.416 44H139.916V81.2881H177.416V44Z" fill="#00B67A" />
        <path d="M218.041 44H180.541V81.2881H218.041V44Z" fill="#00B67A" />
        <path d="M258.665 44H239.916V81.2881H258.665V44Z" fill="#DCDCE6" />
        <path d="M251.885 44H221.377V81.2881H251.885V44Z" fill="#00B67A" />
        <path
          d="M77.416 69.1313L83.1191 67.6942L85.502 74.9964L77.416 69.1313ZM90.541 59.6927H80.502L77.416 50.293L74.3301 59.6927H64.291L72.416 65.5189L69.3301 74.9187L77.455 69.0925L82.455 65.5189L90.541 59.6927Z"
          fill="white"
        />
        <path
          d="M118.041 69.1313L123.744 67.6942L126.127 74.9964L118.041 69.1313ZM131.166 59.6927H121.127L118.041 50.293L114.955 59.6927H104.916L113.041 65.5189L109.955 74.9187L118.08 69.0925L123.08 65.5189L131.166 59.6927Z"
          fill="white"
        />
        <path
          d="M158.666 69.1313L164.369 67.6942L166.752 74.9964L158.666 69.1313ZM171.791 59.6927H161.752L158.666 50.293L155.58 59.6927H145.541L153.666 65.5189L150.58 74.9187L158.705 69.0925L163.705 65.5189L171.791 59.6927Z"
          fill="white"
        />
        <path
          d="M199.291 69.1313L204.994 67.6942L207.377 74.9964L199.291 69.1313ZM212.416 59.6927H202.377L199.291 50.293L196.205 59.6927H186.166L194.291 65.5189L191.205 74.9187L199.33 69.0925L204.33 65.5189L212.416 59.6927Z"
          fill="white"
        />
        <path
          d="M239.915 69.1313L245.619 67.6942L248.002 74.9964L239.915 69.1313ZM253.041 59.6927H243.002L239.915 50.293L236.83 59.6927H226.791L234.915 65.5189L231.831 74.9187L239.956 69.0925L244.956 65.5189L253.041 59.6927Z"
          fill="white"
        />
      </g>
      <path
        d="M77.2384 95.4891V96.6651H73.9764V105.289H72.8004V96.6651H69.5454V95.4891H77.2384ZM77.5226 105.289V98.2891H78.6986V99.1641C78.946 98.8374 79.2586 98.5784 79.6366 98.3871C80.0146 98.1911 80.4253 98.0931 80.8686 98.0931C81.1393 98.0931 81.4006 98.1281 81.6526 98.1981L81.1766 99.3741C80.9853 99.3134 80.7986 99.2831 80.6166 99.2831C80.2666 99.2831 79.9446 99.3694 79.6506 99.5421C79.3613 99.7101 79.1303 99.9387 78.9576 100.228C78.785 100.517 78.6986 100.839 78.6986 101.194V105.289H77.5226ZM82.2192 102.629V98.2891H83.3952V102.37C83.3952 102.725 83.4815 103.047 83.6542 103.336C83.8268 103.625 84.0578 103.856 84.3472 104.029C84.6412 104.197 84.9632 104.281 85.3132 104.281C85.6678 104.281 85.9875 104.197 86.2722 104.029C86.5615 103.856 86.7925 103.625 86.9652 103.336C87.1378 103.047 87.2242 102.725 87.2242 102.37V98.2891H88.4002L88.4072 105.289H87.2312L87.2242 104.4C86.9768 104.727 86.6642 104.988 86.2862 105.184C85.9082 105.375 85.4998 105.471 85.0612 105.471C84.5385 105.471 84.0602 105.345 83.6262 105.093C83.1968 104.836 82.8538 104.493 82.5972 104.064C82.3452 103.635 82.2192 103.156 82.2192 102.629ZM91.9486 105.422C91.5706 105.408 91.202 105.338 90.8426 105.212C90.488 105.081 90.1753 104.906 89.9046 104.687C89.6386 104.463 89.445 104.206 89.3236 103.917L90.3316 103.483C90.4016 103.642 90.5276 103.791 90.7096 103.931C90.8916 104.071 91.1016 104.183 91.3396 104.267C91.5776 104.351 91.818 104.393 92.0606 104.393C92.3173 104.393 92.5576 104.353 92.7816 104.274C93.0056 104.195 93.1876 104.078 93.3276 103.924C93.4723 103.765 93.5446 103.576 93.5446 103.357C93.5446 103.124 93.4653 102.942 93.3066 102.811C93.1526 102.676 92.9566 102.571 92.7186 102.496C92.4853 102.417 92.2473 102.342 92.0046 102.272C91.524 102.151 91.0946 102.006 90.7166 101.838C90.3386 101.665 90.04 101.448 89.8206 101.187C89.606 100.921 89.4986 100.583 89.4986 100.172C89.4986 99.7381 89.6176 99.3624 89.8556 99.0451C90.0983 98.7277 90.4156 98.4827 90.8076 98.3101C91.1996 98.1374 91.6196 98.0511 92.0676 98.0511C92.6323 98.0511 93.148 98.1724 93.6146 98.4151C94.0813 98.6577 94.429 98.9867 94.6576 99.4021L93.7126 99.9551C93.6333 99.7871 93.512 99.6401 93.3486 99.5141C93.1853 99.3834 92.9986 99.2807 92.7886 99.2061C92.5786 99.1314 92.364 99.0917 92.1446 99.0871C91.874 99.0777 91.6196 99.1127 91.3816 99.1921C91.1483 99.2714 90.9593 99.3927 90.8146 99.5561C90.6746 99.7147 90.6046 99.9131 90.6046 100.151C90.6046 100.384 90.6793 100.562 90.8286 100.683C90.9826 100.804 91.181 100.902 91.4236 100.977C91.671 101.047 91.9393 101.129 92.2286 101.222C92.6533 101.357 93.05 101.514 93.4186 101.691C93.7873 101.868 94.0836 102.09 94.3076 102.356C94.5363 102.622 94.6483 102.951 94.6436 103.343C94.6436 103.772 94.5153 104.148 94.2586 104.47C94.002 104.787 93.6683 105.03 93.2576 105.198C92.8516 105.366 92.4153 105.441 91.9486 105.422ZM99.4689 99.4651H97.8799L97.8729 105.289H96.6969L96.7039 99.4651H95.4999V98.2891H96.7039L96.6969 96.0911H97.8729L97.8799 98.2891H99.4689V99.4651ZM104.175 105.471C103.647 105.471 103.139 105.389 102.649 105.226C102.159 105.058 101.729 104.82 101.361 104.512C100.997 104.204 100.738 103.838 100.584 103.413L101.683 103C101.776 103.261 101.949 103.49 102.201 103.686C102.457 103.877 102.758 104.027 103.104 104.134C103.449 104.241 103.806 104.295 104.175 104.295C104.595 104.295 104.984 104.227 105.344 104.092C105.708 103.952 106.002 103.758 106.226 103.511C106.45 103.264 106.562 102.974 106.562 102.643C106.562 102.302 106.445 102.025 106.212 101.81C105.978 101.591 105.68 101.418 105.316 101.292C104.952 101.161 104.571 101.061 104.175 100.991C103.498 100.879 102.891 100.72 102.355 100.515C101.823 100.305 101.4 100.013 101.088 99.6401C100.78 99.2667 100.626 98.7744 100.626 98.1631C100.626 97.5937 100.789 97.0967 101.116 96.6721C101.447 96.2474 101.883 95.9184 102.425 95.6851C102.966 95.4517 103.549 95.3351 104.175 95.3351C104.693 95.3351 105.194 95.4167 105.68 95.5801C106.17 95.7387 106.601 95.9721 106.975 96.2801C107.348 96.5881 107.616 96.9637 107.78 97.4071L106.667 97.8131C106.573 97.5471 106.398 97.3184 106.142 97.1271C105.89 96.9311 105.591 96.7817 105.246 96.6791C104.905 96.5717 104.548 96.5181 104.175 96.5181C103.759 96.5134 103.372 96.5811 103.013 96.7211C102.653 96.8611 102.362 97.0547 102.138 97.3021C101.914 97.5494 101.802 97.8364 101.802 98.1631C101.802 98.5551 101.904 98.8561 102.11 99.0661C102.32 99.2714 102.604 99.4254 102.964 99.5281C103.323 99.6307 103.727 99.7217 104.175 99.8011C104.809 99.9084 105.397 100.079 105.939 100.312C106.48 100.541 106.914 100.846 107.241 101.229C107.572 101.612 107.738 102.083 107.738 102.643C107.738 103.212 107.572 103.709 107.241 104.134C106.914 104.559 106.48 104.888 105.939 105.121C105.397 105.354 104.809 105.471 104.175 105.471ZM114.023 103.441L115.073 104.008C114.756 104.451 114.352 104.806 113.862 105.072C113.377 105.338 112.85 105.471 112.28 105.471C111.636 105.471 111.048 105.305 110.516 104.974C109.989 104.643 109.567 104.199 109.249 103.644C108.937 103.084 108.78 102.466 108.78 101.789C108.78 101.276 108.871 100.797 109.053 100.354C109.235 99.9061 109.485 99.5141 109.802 99.1781C110.124 98.8374 110.498 98.5714 110.922 98.3801C111.347 98.1887 111.8 98.0931 112.28 98.0931C112.85 98.0931 113.377 98.2261 113.862 98.4921C114.352 98.7581 114.756 99.1151 115.073 99.5631L114.023 100.13C113.799 99.8547 113.533 99.6424 113.225 99.4931C112.917 99.3437 112.602 99.2691 112.28 99.2691C111.846 99.2691 111.452 99.3857 111.097 99.6191C110.747 99.8477 110.47 100.153 110.264 100.536C110.059 100.919 109.956 101.336 109.956 101.789C109.956 102.242 110.059 102.659 110.264 103.042C110.474 103.42 110.754 103.723 111.104 103.952C111.459 104.181 111.851 104.295 112.28 104.295C112.626 104.295 112.95 104.216 113.253 104.057C113.557 103.898 113.813 103.693 114.023 103.441ZM119.294 105.471C118.65 105.471 118.062 105.305 117.53 104.974C117.003 104.643 116.58 104.199 116.263 103.644C115.95 103.084 115.794 102.466 115.794 101.789C115.794 101.276 115.885 100.797 116.067 100.354C116.249 99.9061 116.499 99.5141 116.816 99.1781C117.138 98.8374 117.511 98.5714 117.936 98.3801C118.361 98.1887 118.813 98.0931 119.294 98.0931C119.938 98.0931 120.524 98.2587 121.051 98.5901C121.583 98.9214 122.005 99.3671 122.318 99.9271C122.635 100.487 122.794 101.108 122.794 101.789C122.794 102.298 122.703 102.774 122.521 103.217C122.339 103.66 122.087 104.052 121.765 104.393C121.448 104.729 121.077 104.993 120.652 105.184C120.232 105.375 119.779 105.471 119.294 105.471ZM119.294 104.295C119.733 104.295 120.127 104.181 120.477 103.952C120.832 103.719 121.109 103.413 121.31 103.035C121.515 102.652 121.618 102.237 121.618 101.789C121.618 101.332 121.513 100.912 121.303 100.529C121.098 100.146 120.82 99.8407 120.47 99.6121C120.12 99.3834 119.728 99.2691 119.294 99.2691C118.855 99.2691 118.461 99.3857 118.111 99.6191C117.761 99.8477 117.483 100.153 117.278 100.536C117.073 100.919 116.97 101.336 116.97 101.789C116.97 102.256 117.075 102.68 117.285 103.063C117.495 103.441 117.777 103.742 118.132 103.966C118.487 104.185 118.874 104.295 119.294 104.295ZM123.952 105.289V98.2891H125.128V99.1641C125.376 98.8374 125.688 98.5784 126.066 98.3871C126.444 98.1911 126.855 98.0931 127.298 98.0931C127.569 98.0931 127.83 98.1281 128.082 98.1981L127.606 99.3741C127.415 99.3134 127.228 99.2831 127.046 99.2831C126.696 99.2831 126.374 99.3694 126.08 99.5421C125.791 99.7101 125.56 99.9387 125.387 100.228C125.215 100.517 125.128 100.839 125.128 101.194V105.289H123.952ZM131.667 105.471C131.023 105.471 130.435 105.305 129.903 104.974C129.376 104.643 128.953 104.199 128.636 103.644C128.323 103.084 128.167 102.466 128.167 101.789C128.167 101.276 128.258 100.797 128.44 100.354C128.622 99.9061 128.872 99.5141 129.189 99.1781C129.511 98.8374 129.884 98.5714 130.309 98.3801C130.734 98.1887 131.186 98.0931 131.667 98.0931C132.194 98.0931 132.677 98.2004 133.116 98.4151C133.559 98.6251 133.937 98.9191 134.25 99.2971C134.567 99.6751 134.803 100.114 134.957 100.613C135.116 101.112 135.174 101.647 135.132 102.216H129.42C129.476 102.613 129.607 102.967 129.812 103.28C130.017 103.588 130.279 103.833 130.596 104.015C130.918 104.197 131.275 104.29 131.667 104.295C132.087 104.295 132.467 104.188 132.808 103.973C133.149 103.754 133.424 103.455 133.634 103.077L134.831 103.357C134.551 103.978 134.129 104.486 133.564 104.883C132.999 105.275 132.367 105.471 131.667 105.471ZM129.385 101.292H133.949C133.912 100.9 133.786 100.543 133.571 100.221C133.356 99.8944 133.083 99.6331 132.752 99.4371C132.421 99.2411 132.059 99.1431 131.667 99.1431C131.275 99.1431 130.916 99.2387 130.589 99.4301C130.262 99.6214 129.992 99.8804 129.777 100.207C129.567 100.529 129.436 100.891 129.385 101.292Z"
        fill="#434343"
      />
      <path
        d="M143.684 105.289V102.783H139.491V101.32L143.334 95.4891H145.14V101.327H146.036V102.783H145.14V105.289H143.684ZM141.185 101.32L143.684 101.327L143.67 97.4981L141.185 101.32ZM148.197 105.471C147.982 105.471 147.8 105.396 147.651 105.247C147.506 105.098 147.434 104.916 147.434 104.701C147.434 104.491 147.506 104.311 147.651 104.162C147.8 104.013 147.982 103.938 148.197 103.938C148.412 103.938 148.594 104.013 148.743 104.162C148.892 104.311 148.967 104.491 148.967 104.701C148.967 104.916 148.892 105.098 148.743 105.247C148.594 105.396 148.412 105.471 148.197 105.471ZM153.579 105.471C152.987 105.471 152.448 105.336 151.962 105.065C151.477 104.794 151.09 104.433 150.8 103.98C150.516 103.523 150.373 103.014 150.373 102.454C150.373 101.983 150.49 101.544 150.723 101.138C150.957 100.732 151.267 100.396 151.654 100.13C151.342 99.8967 151.087 99.6027 150.891 99.2481C150.695 98.8934 150.597 98.5107 150.597 98.1001C150.597 97.5867 150.73 97.1201 150.996 96.7001C151.267 96.2754 151.629 95.9371 152.081 95.6851C152.534 95.4331 153.033 95.3071 153.579 95.3071C154.125 95.3071 154.625 95.4331 155.077 95.6851C155.53 95.9371 155.889 96.2754 156.155 96.7001C156.426 97.1201 156.561 97.5867 156.561 98.1001C156.561 98.5107 156.463 98.8934 156.267 99.2481C156.076 99.6027 155.822 99.8967 155.504 100.13C155.901 100.396 156.214 100.732 156.442 101.138C156.676 101.544 156.792 101.983 156.792 102.454C156.792 103.009 156.648 103.516 156.358 103.973C156.069 104.43 155.682 104.794 155.196 105.065C154.711 105.336 154.172 105.471 153.579 105.471ZM153.579 104.015C153.887 104.015 154.167 103.945 154.419 103.805C154.671 103.665 154.872 103.478 155.021 103.245C155.175 103.007 155.252 102.743 155.252 102.454C155.252 102.169 155.175 101.91 155.021 101.677C154.872 101.439 154.671 101.25 154.419 101.11C154.167 100.97 153.887 100.9 153.579 100.9C153.276 100.9 152.996 100.97 152.739 101.11C152.487 101.25 152.284 101.439 152.13 101.677C151.981 101.91 151.906 102.169 151.906 102.454C151.906 102.743 151.981 103.007 152.13 103.245C152.284 103.478 152.487 103.665 152.739 103.805C152.996 103.945 153.276 104.015 153.579 104.015ZM153.579 99.4441C153.845 99.4441 154.086 99.3834 154.3 99.2621C154.52 99.1407 154.695 98.9797 154.825 98.7791C154.956 98.5737 155.021 98.3474 155.021 98.1001C155.021 97.8527 154.956 97.6287 154.825 97.4281C154.695 97.2274 154.52 97.0664 154.3 96.9451C154.086 96.8237 153.845 96.7631 153.579 96.7631C153.313 96.7631 153.071 96.8237 152.851 96.9451C152.637 97.0664 152.464 97.2274 152.333 97.4281C152.203 97.6287 152.137 97.8527 152.137 98.1001C152.137 98.3474 152.203 98.5737 152.333 98.7791C152.464 98.9797 152.637 99.1407 152.851 99.2621C153.071 99.3834 153.313 99.4441 153.579 99.4441Z"
        fill="black"
      />
      <line x1="166.166" y1="91.2891" x2="166.166" y2="109.289" stroke="#077882" />
      <path
        d="M174.607 105.289V103.994C174.938 103.719 175.319 103.399 175.748 103.035C176.177 102.666 176.614 102.277 177.057 101.866C177.5 101.451 177.909 101.038 178.282 100.627C178.655 100.212 178.956 99.8197 179.185 99.4511C179.418 99.0777 179.535 98.7534 179.535 98.4781C179.535 98.1654 179.458 97.8807 179.304 97.6241C179.155 97.3627 178.952 97.1551 178.695 97.0011C178.438 96.8424 178.154 96.7631 177.841 96.7631C177.528 96.7631 177.241 96.8424 176.98 97.0011C176.723 97.1551 176.516 97.3627 176.357 97.6241C176.203 97.8807 176.126 98.1654 176.126 98.4781H174.67C174.67 97.8854 174.815 97.3511 175.104 96.8751C175.398 96.3944 175.783 96.0141 176.259 95.7341C176.74 95.4494 177.267 95.3071 177.841 95.3071C178.42 95.3071 178.947 95.4494 179.423 95.7341C179.899 96.0187 180.279 96.4014 180.564 96.8821C180.849 97.3581 180.991 97.8901 180.991 98.4781C180.991 98.8047 180.923 99.1407 180.788 99.4861C180.653 99.8314 180.464 100.184 180.221 100.543C179.983 100.902 179.705 101.266 179.388 101.635C179.071 102.004 178.73 102.372 178.366 102.741C178.002 103.11 177.631 103.474 177.253 103.833H181.075V105.289H174.607ZM185.681 105.471C185.056 105.471 184.484 105.317 183.966 105.009C183.448 104.696 183.033 104.281 182.72 103.763C182.412 103.24 182.258 102.664 182.258 102.034C182.258 101.698 182.298 101.395 182.377 101.124C182.457 100.853 182.578 100.569 182.741 100.27L185.499 95.4891H187.193L185.282 98.7931C185.67 98.7184 186.048 98.7161 186.416 98.7861C186.79 98.8514 187.14 98.9797 187.466 99.1711C187.793 99.3577 188.08 99.5957 188.327 99.8851C188.579 100.17 188.775 100.494 188.915 100.858C189.055 101.222 189.125 101.614 189.125 102.034C189.125 102.505 189.034 102.949 188.852 103.364C188.675 103.779 188.428 104.146 188.11 104.463C187.798 104.776 187.431 105.023 187.011 105.205C186.596 105.382 186.153 105.471 185.681 105.471ZM185.681 104.015C186.064 104.015 186.405 103.922 186.703 103.735C187.002 103.548 187.238 103.303 187.41 103C187.583 102.697 187.669 102.375 187.669 102.034C187.669 101.675 187.581 101.346 187.403 101.047C187.231 100.748 186.995 100.51 186.696 100.333C186.398 100.151 186.064 100.06 185.695 100.06C185.313 100.06 184.972 100.153 184.673 100.34C184.375 100.527 184.139 100.769 183.966 101.068C183.798 101.367 183.714 101.689 183.714 102.034C183.714 102.412 183.805 102.75 183.987 103.049C184.174 103.348 184.417 103.583 184.715 103.756C185.014 103.929 185.336 104.015 185.681 104.015ZM193.772 105.471C193.193 105.471 192.67 105.34 192.204 105.079C191.742 104.813 191.343 104.447 191.007 103.98C190.671 103.513 190.414 102.974 190.237 102.363C190.059 101.747 189.971 101.089 189.971 100.389C189.971 99.6891 190.059 99.0311 190.237 98.4151C190.414 97.7991 190.671 97.2601 191.007 96.7981C191.343 96.3314 191.742 95.9674 192.204 95.7061C192.67 95.4401 193.193 95.3071 193.772 95.3071C194.341 95.3071 194.859 95.4401 195.326 95.7061C195.792 95.9674 196.189 96.3314 196.516 96.7981C196.847 97.2601 197.101 97.7991 197.279 98.4151C197.456 99.0311 197.545 99.6891 197.545 100.389C197.545 101.089 197.456 101.747 197.279 102.363C197.101 102.974 196.847 103.513 196.516 103.98C196.189 104.447 195.792 104.813 195.326 105.079C194.859 105.34 194.341 105.471 193.772 105.471ZM193.772 104.015C194.308 104.015 194.754 103.847 195.109 103.511C195.468 103.17 195.736 102.725 195.914 102.174C196.091 101.623 196.18 101.028 196.18 100.389C196.18 99.7171 196.086 99.1081 195.9 98.5621C195.718 98.0114 195.447 97.5751 195.088 97.2531C194.733 96.9264 194.294 96.7631 193.772 96.7631C193.356 96.7631 192.995 96.8611 192.687 97.0571C192.383 97.2531 192.131 97.5214 191.931 97.8621C191.735 98.2027 191.585 98.5901 191.483 99.0241C191.385 99.4581 191.336 99.9131 191.336 100.389C191.336 101.028 191.427 101.623 191.609 102.174C191.791 102.725 192.061 103.17 192.421 103.511C192.785 103.847 193.235 104.015 193.772 104.015Z"
        fill="black"
      />
      <path
        d="M202.162 105.289V98.2891H203.338V99.1641C203.586 98.8374 203.898 98.5784 204.276 98.3871C204.654 98.1911 205.065 98.0931 205.508 98.0931C205.779 98.0931 206.04 98.1281 206.292 98.1981L205.816 99.3741C205.625 99.3134 205.438 99.2831 205.256 99.2831C204.906 99.2831 204.584 99.3694 204.29 99.5421C204.001 99.7101 203.77 99.9387 203.597 100.228C203.425 100.517 203.338 100.839 203.338 101.194V105.289H202.162ZM209.877 105.471C209.233 105.471 208.645 105.305 208.113 104.974C207.586 104.643 207.163 104.199 206.846 103.644C206.533 103.084 206.377 102.466 206.377 101.789C206.377 101.276 206.468 100.797 206.65 100.354C206.832 99.9061 207.082 99.5141 207.399 99.1781C207.721 98.8374 208.094 98.5714 208.519 98.3801C208.944 98.1887 209.396 98.0931 209.877 98.0931C210.404 98.0931 210.887 98.2004 211.326 98.4151C211.769 98.6251 212.147 98.9191 212.46 99.2971C212.777 99.6751 213.013 100.114 213.167 100.613C213.326 101.112 213.384 101.647 213.342 102.216H207.63C207.686 102.613 207.817 102.967 208.022 103.28C208.227 103.588 208.489 103.833 208.806 104.015C209.128 104.197 209.485 104.29 209.877 104.295C210.297 104.295 210.677 104.188 211.018 103.973C211.359 103.754 211.634 103.455 211.844 103.077L213.041 103.357C212.761 103.978 212.339 104.486 211.774 104.883C211.209 105.275 210.577 105.471 209.877 105.471ZM207.595 101.292H212.159C212.122 100.9 211.996 100.543 211.781 100.221C211.566 99.8944 211.293 99.6331 210.962 99.4371C210.631 99.2411 210.269 99.1431 209.877 99.1431C209.485 99.1431 209.126 99.2387 208.799 99.4301C208.472 99.6214 208.202 99.8804 207.987 100.207C207.777 100.529 207.646 100.891 207.595 101.292ZM217.861 105.289H216.356L213.801 98.2751H215.054L217.105 103.924L219.156 98.2751H220.409L217.861 105.289ZM221.549 98.2891H222.725V105.289H221.549V98.2891ZM222.151 97.1481C221.964 97.1481 221.808 97.0874 221.682 96.9661C221.556 96.8447 221.493 96.6931 221.493 96.5111C221.493 96.3291 221.556 96.1774 221.682 96.0561C221.808 95.9347 221.962 95.8741 222.144 95.8741C222.326 95.8741 222.48 95.9347 222.606 96.0561C222.732 96.1774 222.795 96.3291 222.795 96.5111C222.795 96.6931 222.732 96.8447 222.606 96.9661C222.485 97.0874 222.333 97.1481 222.151 97.1481ZM227.391 105.471C226.747 105.471 226.159 105.305 225.627 104.974C225.099 104.643 224.677 104.199 224.36 103.644C224.047 103.084 223.891 102.466 223.891 101.789C223.891 101.276 223.982 100.797 224.164 100.354C224.346 99.9061 224.595 99.5141 224.913 99.1781C225.235 98.8374 225.608 98.5714 226.033 98.3801C226.457 98.1887 226.91 98.0931 227.391 98.0931C227.918 98.0931 228.401 98.2004 228.84 98.4151C229.283 98.6251 229.661 98.9191 229.974 99.2971C230.291 99.6751 230.527 100.114 230.681 100.613C230.839 101.112 230.898 101.647 230.856 102.216H225.144C225.2 102.613 225.33 102.967 225.536 103.28C225.741 103.588 226.002 103.833 226.32 104.015C226.642 104.197 226.999 104.29 227.391 104.295C227.811 104.295 228.191 104.188 228.532 103.973C228.872 103.754 229.148 103.455 229.358 103.077L230.555 103.357C230.275 103.978 229.852 104.486 229.288 104.883C228.723 105.275 228.091 105.471 227.391 105.471ZM225.109 101.292H229.673C229.635 100.9 229.509 100.543 229.295 100.221C229.08 99.8944 228.807 99.6331 228.476 99.4371C228.144 99.2411 227.783 99.1431 227.391 99.1431C226.999 99.1431 226.639 99.2387 226.313 99.4301C225.986 99.6214 225.715 99.8804 225.501 100.207C225.291 100.529 225.16 100.891 225.109 101.292ZM234.85 105.289H233.66L231.315 98.2891H232.463L234.269 103.63L236.054 98.2891H237.265L239.057 103.63L240.842 98.2891H242.004L239.659 105.289H238.462L236.649 99.8991L234.85 105.289ZM245.231 105.422C244.853 105.408 244.484 105.338 244.125 105.212C243.77 105.081 243.458 104.906 243.187 104.687C242.921 104.463 242.727 104.206 242.606 103.917L243.614 103.483C243.684 103.642 243.81 103.791 243.992 103.931C244.174 104.071 244.384 104.183 244.622 104.267C244.86 104.351 245.1 104.393 245.343 104.393C245.6 104.393 245.84 104.353 246.064 104.274C246.288 104.195 246.47 104.078 246.61 103.924C246.755 103.765 246.827 103.576 246.827 103.357C246.827 103.124 246.748 102.942 246.589 102.811C246.435 102.676 246.239 102.571 246.001 102.496C245.768 102.417 245.53 102.342 245.287 102.272C244.806 102.151 244.377 102.006 243.999 101.838C243.621 101.665 243.322 101.448 243.103 101.187C242.888 100.921 242.781 100.583 242.781 100.172C242.781 99.7381 242.9 99.3624 243.138 99.0451C243.381 98.7277 243.698 98.4827 244.09 98.3101C244.482 98.1374 244.902 98.0511 245.35 98.0511C245.915 98.0511 246.43 98.1724 246.897 98.4151C247.364 98.6577 247.711 98.9867 247.94 99.4021L246.995 99.9551C246.916 99.7871 246.794 99.6401 246.631 99.5141C246.468 99.3834 246.281 99.2807 246.071 99.2061C245.861 99.1314 245.646 99.0917 245.427 99.0871C245.156 99.0777 244.902 99.1127 244.664 99.1921C244.431 99.2714 244.242 99.3927 244.097 99.5561C243.957 99.7147 243.887 99.9131 243.887 100.151C243.887 100.384 243.962 100.562 244.111 100.683C244.265 100.804 244.463 100.902 244.706 100.977C244.953 101.047 245.222 101.129 245.511 101.222C245.936 101.357 246.332 101.514 246.701 101.691C247.07 101.868 247.366 102.09 247.59 102.356C247.819 102.622 247.931 102.951 247.926 103.343C247.926 103.772 247.798 104.148 247.541 104.47C247.284 104.787 246.951 105.03 246.54 105.198C246.134 105.366 245.698 105.441 245.231 105.422Z"
        fill="#434343"
      />
      <defs>
        <clipPath id="clip0_3429_2191">
          <rect width="140" height="34" fill="white" transform="translate(88.666)" />
        </clipPath>
        <clipPath id="clip1_3429_2191">
          <rect width="200" height="37.2881" fill="white" transform="translate(58.666 44)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FilledCareIcon = () => {
  return (
    <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.644531" width="80" height="80" rx="40" fill="#077882" fillOpacity="0.1" />
      <path
        d="M25.334 44.3105H29.7245C30.2638 44.3105 30.7956 44.4321 31.278 44.6655L35.0216 46.4768C35.5039 46.7102 36.0358 46.8316 36.5751 46.8316H38.4865C40.3352 46.8316 41.834 48.2819 41.834 50.0709C41.834 50.1431 41.7845 50.2067 41.7126 50.2265L37.0543 51.5146C36.2186 51.7456 35.3238 51.6651 34.5465 51.2889L30.5445 49.3528"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.834 48.8946L50.2541 46.3076C51.7468 45.8424 53.3603 46.3939 54.2953 47.6888C54.9715 48.6249 54.6961 49.9656 53.7112 50.5339L39.9326 58.4838C39.0563 58.9895 38.0223 59.1129 37.0585 58.8269L25.334 55.3477"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.5 40.6439H41.8333C38.3764 40.6439 36.6479 40.6439 35.5739 39.5699C34.5 38.4959 34.5 36.7675 34.5 33.3105V29.6439C34.5 26.1869 34.5 24.4584 35.5739 23.3845C36.6479 22.3105 38.3764 22.3105 41.8333 22.3105H45.5C48.9569 22.3105 50.6854 22.3105 51.7594 23.3845C52.8333 24.4584 52.8333 26.1869 52.8333 29.6439V33.3105C52.8333 36.7675 52.8333 38.4959 51.7594 39.5699C50.6854 40.6439 48.9569 40.6439 45.5 40.6439Z"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M41.834 27.8105H45.5007" stroke="#077882" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const ResultsIcon = () => {
  return (
    <svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.332031" y="0.644531" width="80" height="80" rx="40" fill="#077882" fillOpacity="0.1" />
      <path
        d="M45.8314 33.3112C45.8314 28.2486 41.7273 24.1445 36.6647 24.1445C31.6021 24.1445 27.498 28.2486 27.498 33.3112C27.498 38.3738 31.6021 42.4779 36.6647 42.4779C41.7273 42.4779 45.8314 38.3738 45.8314 33.3112Z"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.832 55.3118C23.832 48.2242 29.5777 42.4785 36.6654 42.4785C39.0029 42.4785 41.1944 43.1035 43.082 44.1954"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.5234 45.2373L52.6525 47.5143C52.8065 47.8313 53.2172 48.1352 53.5635 48.1935L55.6102 48.5364C56.9191 48.7564 57.2271 49.7137 56.284 50.6583L54.6928 52.2624C54.4233 52.5341 54.2758 53.0583 54.3592 53.4334L54.8148 55.4194C55.1741 56.9913 54.3463 57.5995 52.9669 56.7779L51.0485 55.6328C50.702 55.4259 50.1311 55.4259 49.7782 55.6328L47.8598 56.7779C46.4868 57.5995 45.6527 56.9849 46.012 55.4194L46.4676 53.4334C46.551 53.0583 46.4034 52.5341 46.1339 52.2624L44.5428 50.6583C43.6059 49.7137 43.9075 48.7564 45.2165 48.5364L47.2631 48.1935C47.6032 48.1352 48.0138 47.8313 48.1678 47.5143L49.297 45.2373C49.913 44.0016 50.9138 44.0016 51.5234 45.2373Z"
        stroke="#077882"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VerifiedIcon = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.666 1.53906C12.1048 1.53906 11.6476 1.77517 11.2316 2.09264C10.8419 2.38995 10.4121 2.81981 9.90921 3.32273L9.87384 3.3581C9.35918 3.87276 8.91051 4.07532 8.2181 4.07532C8.13132 4.07532 8.02181 4.07224 7.89814 4.06876C7.58111 4.05984 7.17099 4.0483 6.81217 4.07933C6.2873 4.12472 5.63134 4.26835 5.13347 4.7704C4.63942 5.26861 4.49929 5.92188 4.45525 6.44345C4.42524 6.79901 4.43677 7.20607 4.44568 7.52084C4.44919 7.64484 4.4523 7.75455 4.4523 7.84112C4.4523 8.53354 4.24973 8.98221 3.73504 9.4969L3.69969 9.53225C3.19677 10.0351 2.76691 10.465 2.4696 10.8546C2.15214 11.2707 1.91603 11.7279 1.91602 12.2891C1.91603 12.8502 2.15215 13.3074 2.4696 13.7235C2.76697 14.1133 3.19693 14.5432 3.69997 15.0462L3.73508 15.0813C4.06874 15.4149 4.22613 15.6313 4.31534 15.8355C4.40221 16.0344 4.4523 16.2862 4.4523 16.737C4.4523 16.8238 4.44922 16.9333 4.44574 17.057C4.43682 17.374 4.42528 17.7841 4.45631 18.143C4.50171 18.6678 4.64535 19.3238 5.14741 19.8217C5.64563 20.3157 6.29889 20.4558 6.82045 20.4998C7.17599 20.5299 7.58305 20.5183 7.89781 20.5094C8.02183 20.5059 8.13152 20.5028 8.21808 20.5028C8.6593 20.5028 8.90728 20.5472 9.10247 20.6277C9.29749 20.7082 9.50608 20.8523 9.82026 21.1665C9.88731 21.2335 9.97565 21.3282 10.0775 21.4374C10.3075 21.6839 10.6067 22.0046 10.886 22.2487C11.3097 22.6191 11.9176 23.0391 12.666 23.0391C13.4145 23.0391 14.0223 22.6191 14.4461 22.2487C14.7253 22.0046 15.0243 21.6842 15.2542 21.4377C15.3562 21.3283 15.4447 21.2336 15.5118 21.1664C15.8259 20.8523 16.0345 20.7082 16.2295 20.6277C16.4247 20.5472 16.6727 20.5028 17.1139 20.5028C17.2005 20.5028 17.3102 20.5059 17.4342 20.5094C17.749 20.5183 18.156 20.5299 18.5116 20.4998C19.0331 20.4558 19.6864 20.3157 20.1846 19.8217C20.6867 19.3238 20.8303 18.6678 20.8757 18.143C20.9067 17.7841 20.8952 17.374 20.8863 17.057C20.8828 16.9334 20.8797 16.8237 20.8797 16.737C20.8797 16.2862 20.9298 16.0344 21.0167 15.8355C21.1059 15.6313 21.2633 15.4149 21.5969 15.0813L21.6321 15.0462C22.1351 14.5432 22.5651 14.1133 22.8624 13.7235C23.1799 13.3074 23.416 12.8502 23.416 12.2891C23.416 11.7279 23.1799 11.2707 22.8624 10.8546C22.5651 10.465 22.1353 10.0351 21.6324 9.53228L21.597 9.4969C21.2633 9.16322 21.1059 8.94685 21.0167 8.7426C20.9298 8.54374 20.8797 8.29194 20.8797 7.84112C20.8797 7.7544 20.8828 7.64499 20.8863 7.52142C20.8952 7.20439 20.9067 6.79402 20.8757 6.43521C20.8303 5.91035 20.6867 5.25439 20.1847 4.75653C19.6865 4.26245 19.0332 4.12231 18.5116 4.07827C18.156 4.04825 17.749 4.05978 17.4342 4.0687C17.3102 4.07221 17.2005 4.07532 17.1139 4.07532C16.4213 4.07532 15.9727 3.87267 15.4582 3.3581L15.4228 3.32274C14.9199 2.81981 14.4901 2.38995 14.1004 2.09264C13.6844 1.77517 13.2272 1.53906 12.666 1.53906ZM16.4317 10.4323C16.7869 10.0094 16.7321 9.3786 16.3092 9.02338C15.8863 8.66815 15.2555 8.723 14.9003 9.14589L11.3632 13.3567L10.332 12.436C9.92008 12.0682 9.28792 12.104 8.92009 12.516C8.55226 12.9279 8.58804 13.5601 9.00001 13.9279L10.8 15.5351C11.0017 15.7152 11.2678 15.8059 11.5376 15.7866C11.8073 15.7672 12.0578 15.6394 12.2317 15.4323L16.4317 10.4323Z"
        fill="#096DD9"
      />
    </svg>
  );
};

export const FiveStarIcon = () => {
  return (
    <svg width="137" height="25" viewBox="0 0 137 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6621 1.53906C13.7114 1.53906 14.5379 2.33159 15.0655 3.40097L16.8276 6.95422C16.881 7.06419 17.0077 7.21904 17.1981 7.3607C17.3883 7.50221 17.5746 7.58027 17.6971 7.60086L20.8867 8.13519C22.0389 8.32879 23.0046 8.89355 23.3181 9.87696C23.6313 10.8596 23.1724 11.8807 22.3438 12.7107L22.343 12.7116L19.8651 15.21C19.7669 15.309 19.6569 15.4955 19.5879 15.7385C19.5194 15.9799 19.5133 16.1998 19.5444 16.3418L19.5448 16.3438L20.2537 19.4345C20.5478 20.7208 20.4503 21.9964 19.5431 22.6633C18.6327 23.3324 17.3887 23.0358 16.2585 22.3627L13.2686 20.5781C13.143 20.5031 12.9274 20.4423 12.6671 20.4423C12.4087 20.4423 12.1886 20.5023 12.0548 20.5801L12.0529 20.5812L9.06889 22.3623C7.94006 23.0378 6.69755 23.3291 5.78712 22.6593C4.8805 21.9923 4.77815 20.7191 5.07312 19.4338L5.78191 16.3438L5.78234 16.3418C5.81342 16.1998 5.80734 15.9799 5.73881 15.7385C5.66981 15.4955 5.5598 15.309 5.46159 15.21L2.98186 12.7097C2.15866 11.8797 1.70122 10.8595 2.01196 9.87831C2.3236 8.89431 3.28744 8.32886 4.44034 8.13512L7.62733 7.60125L7.62834 7.60108C7.74518 7.58081 7.92871 7.50362 8.11849 7.36174C8.30862 7.2196 8.4356 7.06441 8.48913 6.95422L8.49183 6.94873L10.2516 3.40003L10.2523 3.39863C10.785 2.33014 11.614 1.53906 12.6621 1.53906Z"
        fill="#24A147"
      />
      <path
        d="M40.6621 1.53906C41.7114 1.53906 42.5379 2.33159 43.0655 3.40097L44.8276 6.95422C44.881 7.06419 45.0077 7.21904 45.1981 7.3607C45.3883 7.50221 45.5746 7.58027 45.6971 7.60086L48.8867 8.13519C50.0389 8.32879 51.0046 8.89355 51.3181 9.87696C51.6313 10.8596 51.1724 11.8807 50.3438 12.7107L50.343 12.7116L47.8651 15.21C47.7669 15.309 47.6569 15.4955 47.5879 15.7385C47.5194 15.9799 47.5133 16.1998 47.5444 16.3418L47.5448 16.3438L48.2537 19.4345C48.5478 20.7208 48.4503 21.9964 47.5431 22.6633C46.6327 23.3324 45.3887 23.0358 44.2585 22.3627L41.2686 20.5781C41.143 20.5031 40.9274 20.4423 40.6671 20.4423C40.4087 20.4423 40.1886 20.5023 40.0548 20.5801L40.0529 20.5812L37.0689 22.3623C35.9401 23.0378 34.6976 23.3291 33.7871 22.6593C32.8805 21.9923 32.7782 20.7191 33.0731 19.4338L33.7819 16.3438L33.7823 16.3418C33.8134 16.1998 33.8073 15.9799 33.7388 15.7385C33.6698 15.4955 33.5598 15.309 33.4616 15.21L30.9819 12.7097C30.1587 11.8797 29.7012 10.8595 30.012 9.87831C30.3236 8.89431 31.2874 8.32886 32.4403 8.13512L35.6273 7.60125L35.6283 7.60108C35.7452 7.58081 35.9287 7.50362 36.1185 7.36174C36.3086 7.2196 36.4356 7.06441 36.4891 6.95422L36.4918 6.94873L38.2516 3.40003L38.2523 3.39863C38.785 2.33014 39.614 1.53906 40.6621 1.53906Z"
        fill="#24A147"
      />
      <path
        d="M68.6621 1.53906C69.7114 1.53906 70.5379 2.33159 71.0655 3.40097L72.8276 6.95422C72.881 7.06419 73.0077 7.21904 73.1981 7.3607C73.3883 7.50221 73.5746 7.58027 73.6971 7.60086L76.8867 8.13519C78.0389 8.32879 79.0046 8.89355 79.3181 9.87696C79.6313 10.8596 79.1724 11.8807 78.3438 12.7107L78.343 12.7116L75.8651 15.21C75.7669 15.309 75.6569 15.4955 75.5879 15.7385C75.5194 15.9799 75.5133 16.1998 75.5444 16.3418L75.5448 16.3438L76.2537 19.4345C76.5478 20.7208 76.4503 21.9964 75.5431 22.6633C74.6327 23.3324 73.3887 23.0358 72.2585 22.3627L69.2686 20.5781C69.143 20.5031 68.9274 20.4423 68.6671 20.4423C68.4087 20.4423 68.1886 20.5023 68.0548 20.5801L68.0529 20.5812L65.0689 22.3623C63.9401 23.0378 62.6976 23.3291 61.7871 22.6593C60.8805 21.9923 60.7782 20.7191 61.0731 19.4338L61.7819 16.3438L61.7823 16.3418C61.8134 16.1998 61.8073 15.9799 61.7388 15.7385C61.6698 15.4955 61.5598 15.309 61.4616 15.21L58.9819 12.7097C58.1587 11.8797 57.7012 10.8595 58.012 9.87831C58.3236 8.89431 59.2874 8.32886 60.4403 8.13512L63.6273 7.60125L63.6283 7.60108C63.7452 7.58081 63.9287 7.50362 64.1185 7.36174C64.3086 7.2196 64.4356 7.06441 64.4891 6.95422L64.4918 6.94873L66.2516 3.40003L66.2523 3.39863C66.785 2.33014 67.614 1.53906 68.6621 1.53906Z"
        fill="#24A147"
      />
      <path
        d="M96.6621 1.53906C97.7114 1.53906 98.5379 2.33159 99.0655 3.40097L100.828 6.95422C100.881 7.06419 101.008 7.21904 101.198 7.3607C101.388 7.50221 101.575 7.58027 101.697 7.60086L104.887 8.13519C106.039 8.32879 107.005 8.89355 107.318 9.87696C107.631 10.8596 107.172 11.8807 106.344 12.7107L106.343 12.7116L103.865 15.21C103.767 15.309 103.657 15.4955 103.588 15.7385C103.519 15.9799 103.513 16.1998 103.544 16.3418L103.545 16.3438L104.254 19.4345C104.548 20.7208 104.45 21.9964 103.543 22.6633C102.633 23.3324 101.389 23.0358 100.259 22.3627L97.2686 20.5781C97.143 20.5031 96.9274 20.4423 96.6671 20.4423C96.4087 20.4423 96.1886 20.5023 96.0548 20.5801L96.0529 20.5812L93.0689 22.3623C91.9401 23.0378 90.6976 23.3291 89.7871 22.6593C88.8805 21.9923 88.7782 20.7191 89.0731 19.4338L89.7819 16.3438L89.7823 16.3418C89.8134 16.1998 89.8073 15.9799 89.7388 15.7385C89.6698 15.4955 89.5598 15.309 89.4616 15.21L86.9819 12.7097C86.1587 11.8797 85.7012 10.8595 86.012 9.87831C86.3236 8.89431 87.2874 8.32886 88.4403 8.13512L91.6273 7.60125L91.6283 7.60108C91.7452 7.58081 91.9287 7.50362 92.1185 7.36174C92.3086 7.2196 92.4356 7.06441 92.4891 6.95422L92.4918 6.94873L94.2516 3.40003L94.2523 3.39863C94.785 2.33014 95.614 1.53906 96.6621 1.53906Z"
        fill="#24A147"
      />
      <path
        d="M124.662 1.53906C125.711 1.53906 126.538 2.33159 127.066 3.40097L128.828 6.95422C128.881 7.06419 129.008 7.21904 129.198 7.3607C129.388 7.50221 129.575 7.58027 129.697 7.60086L132.887 8.13519C134.039 8.32879 135.005 8.89355 135.318 9.87696C135.631 10.8596 135.172 11.8807 134.344 12.7107L134.343 12.7116L131.865 15.21C131.767 15.309 131.657 15.4955 131.588 15.7385C131.519 15.9799 131.513 16.1998 131.544 16.3418L131.545 16.3438L132.254 19.4345C132.548 20.7208 132.45 21.9964 131.543 22.6633C130.633 23.3324 129.389 23.0358 128.259 22.3627L125.269 20.5781C125.143 20.5031 124.927 20.4423 124.667 20.4423C124.409 20.4423 124.189 20.5023 124.055 20.5801L124.053 20.5812L121.069 22.3623C119.94 23.0378 118.698 23.3291 117.787 22.6593C116.881 21.9923 116.778 20.7191 117.073 19.4338L117.782 16.3438L117.782 16.3418C117.813 16.1998 117.807 15.9799 117.739 15.7385C117.67 15.4955 117.56 15.309 117.462 15.21L114.982 12.7097C114.159 11.8797 113.701 10.8595 114.012 9.87831C114.324 8.89431 115.287 8.32886 116.44 8.13512L119.627 7.60125L119.628 7.60108C119.745 7.58081 119.929 7.50362 120.118 7.36174C120.309 7.2196 120.436 7.06441 120.489 6.95422L120.492 6.94873L122.252 3.40003L122.252 3.39863C122.785 2.33014 123.614 1.53906 124.662 1.53906Z"
        fill="#24A147"
      />
    </svg>
  );
};

export const PartialRefundIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3626_20847)">
        <mask id="mask0_3626_20847" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
          <path d="M20 0H0V20H20V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_3626_20847)">
          <path
            d="M12.0834 7.70825H1.66675C1.32508 7.70825 1.04175 7.42492 1.04175 7.08325C1.04175 6.74159 1.32508 6.45825 1.66675 6.45825H12.0834C12.4251 6.45825 12.7084 6.74159 12.7084 7.08325C12.7084 7.42492 12.4251 7.70825 12.0834 7.70825Z"
            fill="white"
          />
          <path
            d="M6.66667 14.375H5C4.65833 14.375 4.375 14.0917 4.375 13.75C4.375 13.4083 4.65833 13.125 5 13.125H6.66667C7.00833 13.125 7.29167 13.4083 7.29167 13.75C7.29167 14.0917 7.00833 14.375 6.66667 14.375Z"
            fill="white"
          />
          <path
            d="M12.0833 14.375H8.75C8.40833 14.375 8.125 14.0917 8.125 13.75C8.125 13.4083 8.40833 13.125 8.75 13.125H12.0833C12.425 13.125 12.7083 13.4083 12.7083 13.75C12.7083 14.0917 12.425 14.375 12.0833 14.375Z"
            fill="white"
          />
          <path
            d="M14.6334 17.7083H5.36675C2.05008 17.7083 1.04175 16.7083 1.04175 13.425V6.57496C1.04175 3.29163 2.05008 2.29163 5.36675 2.29163H12.0834C12.4251 2.29163 12.7084 2.57496 12.7084 2.91663C12.7084 3.25829 12.4251 3.54163 12.0834 3.54163H5.36675C2.75008 3.54163 2.29175 3.99163 2.29175 6.57496V13.4166C2.29175 16 2.75008 16.45 5.36675 16.45H14.6251C17.2417 16.45 17.7001 16 17.7001 13.4166V11.6833C17.7001 11.3416 17.9834 11.0583 18.3251 11.0583C18.6667 11.0583 18.9501 11.3416 18.9501 11.6833V13.4166C18.9584 16.7083 17.9501 17.7083 14.6334 17.7083Z"
            fill="white"
          />
          <path
            d="M16.6667 8.54163C16.5834 8.54163 16.5084 8.52496 16.4251 8.49163C16.1917 8.39163 16.0417 8.16663 16.0417 7.91663V2.91663C16.0417 2.57496 16.3251 2.29163 16.6667 2.29163C17.0084 2.29163 17.2917 2.57496 17.2917 2.91663V6.40829L17.8917 5.80829C18.1334 5.56663 18.5334 5.56663 18.7751 5.80829C19.0167 6.04996 19.0167 6.44996 18.7751 6.69163L17.1084 8.35829C16.9917 8.47496 16.8334 8.54163 16.6667 8.54163Z"
            fill="white"
          />
          <path
            d="M16.6668 8.542C16.5084 8.542 16.3501 8.48367 16.2251 8.35867L14.5584 6.69202C14.3168 6.45036 14.3168 6.05036 14.5584 5.80869C14.8001 5.56702 15.2001 5.56702 15.4418 5.80869L17.1084 7.47536C17.3501 7.71703 17.3501 8.11703 17.1084 8.35867C16.9834 8.48367 16.8251 8.542 16.6668 8.542Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3626_20847">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CommunicationIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.25 10H11.25M6.25 6.66667H8.75"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08337 16.6667C7.95869 17.3914 9.01212 17.8532 10.2196 17.9323C11.171 17.9948 12.1643 17.9947 13.1138 17.9323C13.4407 17.9109 13.7971 17.8339 14.104 17.7092C14.4455 17.5704 14.6163 17.501 14.7031 17.5115C14.7899 17.522 14.9158 17.6137 15.1676 17.7969C15.6116 18.12 16.171 18.3521 17.0005 18.3322C17.4199 18.3221 17.6296 18.317 17.7235 18.1591C17.8174 18.0011 17.7005 17.7824 17.4665 17.3451C17.1422 16.7385 16.9367 16.0441 17.2481 15.4877C17.7845 14.6929 18.24 13.7518 18.3065 12.7353C18.3423 12.1891 18.3423 11.6234 18.3065 11.0773C18.2622 10.3999 18.0978 9.75609 17.8344 9.16667"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2875 14.5723C13.2505 14.3772 15.6106 12.0058 15.8048 9.02867C15.8428 8.44609 15.8428 7.84276 15.8048 7.26016C15.6106 4.28308 13.2505 1.91168 10.2875 1.71655C9.27663 1.64998 8.22123 1.65011 7.21245 1.71655C4.24948 1.91168 1.88933 4.28308 1.69513 7.26016C1.65713 7.84276 1.65713 8.44609 1.69513 9.02867C1.76586 10.113 2.24989 11.1169 2.81973 11.9647C3.15059 12.5581 2.93223 13.2988 2.58761 13.9458C2.33913 14.4123 2.21488 14.6456 2.31464 14.8141C2.41439 14.9826 2.63723 14.988 3.08288 14.9988C3.96423 15.02 4.55853 14.7724 5.03028 14.4278C5.29783 14.2323 5.43161 14.1346 5.52381 14.1234C5.61601 14.1122 5.79746 14.1862 6.1603 14.3343C6.48641 14.4673 6.86506 14.5494 7.21245 14.5723C8.22123 14.6388 9.27663 14.6388 10.2875 14.5723Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SubscriptionIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22 14.0057C22 17.3206 19.3171 20.0017 16 20.0017L16.8571 18.2886"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 10.0086C2 6.69363 4.68286 4.01257 8 4.01257L7.14286 5.72571"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9648 5.52406H21.7713M13.4648 10.9943H19.4989C20.8796 10.9943 21.9989 9.87573 21.9989 8.49595V4.49674C21.9989 3.11695 20.8796 1.99841 19.4989 1.99841H13.4648C12.0841 1.99841 10.9648 3.11695 10.9648 4.49674V8.49595C10.9648 9.87573 12.0841 10.9943 13.4648 10.9943Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 16.5314H12.8065M4.5 22.0016H10.5341C11.9148 22.0016 13.0341 20.8831 13.0341 19.5033V15.5041C13.0341 14.1243 11.9148 13.0057 10.5341 13.0057H4.5C3.11929 13.0057 2 14.1243 2 15.5041V19.5033C2 20.8831 3.11929 22.0016 4.5 22.0016Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MoneyCoinIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3900_26203)">
        <path
          d="M18.3327 10C18.3327 14.6023 14.6017 18.3333 9.99935 18.3333C5.39697 18.3333 1.66602 14.6023 1.66602 10C1.66602 5.39763 5.39697 1.66667 9.99935 1.66667C14.6017 1.66667 18.3327 5.39763 18.3327 10Z"
          stroke="#24A147"
          strokeWidth="1.5"
        />
        <path
          d="M12.2578 8.38425C12.1753 7.7487 11.4455 6.72185 10.1333 6.72182C8.60868 6.7218 7.96715 7.56622 7.83697 7.98842C7.63389 8.55317 7.6745 9.71425 9.4616 9.84083C11.6955 9.99917 12.5904 10.2628 12.4766 11.63C12.3627 12.9971 11.1174 13.2925 10.1333 13.2607C9.14918 13.2292 7.53905 12.7771 7.47656 11.5611M9.97718 5.83171V6.72485M9.97718 13.2526V14.165"
          stroke="#24A147"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3900_26203">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AuthorizedMoneyCoinIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_19028_33041)">
      <path
        d="M10.8525 18.2901C10.5714 18.3187 10.2861 18.3334 9.9974 18.3334C5.39502 18.3334 1.66406 14.6024 1.66406 10.0001C1.66406 5.39771 5.39502 1.66675 9.9974 1.66675C14.5997 1.66675 18.3307 5.39771 18.3307 10.0001C18.3307 10.5708 18.2733 11.1282 18.1641 11.6667"
        stroke="#24A147"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12.1916 8.45045C12.1123 7.84032 11.4118 6.85454 10.1521 6.85452C8.6884 6.85449 8.07253 7.66514 7.94756 8.07046C7.7526 8.61261 7.79159 9.72726 9.5072 9.84878C11.6518 10.0008 12.5109 10.2539 12.4016 11.5664C12.2923 12.8788 11.0968 13.1624 10.1521 13.1319C9.20728 13.1016 7.66155 12.6676 7.60156 11.5002M10.0022 6V6.85742M10.0022 13.1241V14"
        stroke="#24A147"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.5357 16.8428L15.75 16.45V15.2714M18.5 16.45C18.5 17.9687 17.2688 19.2 15.75 19.2C14.2312 19.2 13 17.9687 13 16.45C13 14.9312 14.2312 13.7 15.75 13.7C17.2688 13.7 18.5 14.9312 18.5 16.45Z"
        stroke="#24A147"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_19028_33041">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RefundOrderIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_3900_26208" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <path d="M20 0H0V20H20V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_3900_26208)">
        <path
          d="M12.0827 7.70834H1.66602C1.32435 7.70834 1.04102 7.425 1.04102 7.08334C1.04102 6.74167 1.32435 6.45834 1.66602 6.45834H12.0827C12.4244 6.45834 12.7077 6.74167 12.7077 7.08334C12.7077 7.425 12.4244 7.70834 12.0827 7.70834Z"
          fill="#F5222D"
        />
        <path
          d="M6.66667 14.375H5C4.65833 14.375 4.375 14.0917 4.375 13.75C4.375 13.4083 4.65833 13.125 5 13.125H6.66667C7.00833 13.125 7.29167 13.4083 7.29167 13.75C7.29167 14.0917 7.00833 14.375 6.66667 14.375Z"
          fill="#F5222D"
        />
        <path
          d="M12.0833 14.375H8.75C8.40833 14.375 8.125 14.0917 8.125 13.75C8.125 13.4083 8.40833 13.125 8.75 13.125H12.0833C12.425 13.125 12.7083 13.4083 12.7083 13.75C12.7083 14.0917 12.425 14.375 12.0833 14.375Z"
          fill="#F5222D"
        />
        <path
          d="M14.6327 17.7083H5.36602C2.04935 17.7083 1.04102 16.7083 1.04102 13.425V6.575C1.04102 3.29167 2.04935 2.29167 5.36602 2.29167H12.0827C12.4243 2.29167 12.7077 2.575 12.7077 2.91667C12.7077 3.25833 12.4243 3.54167 12.0827 3.54167H5.36602C2.74935 3.54167 2.29102 3.99167 2.29102 6.575V13.4167C2.29102 16 2.74935 16.45 5.36602 16.45H14.6243C17.241 16.45 17.6993 16 17.6993 13.4167V11.6833C17.6993 11.3417 17.9827 11.0583 18.3243 11.0583C18.666 11.0583 18.9493 11.3417 18.9493 11.6833V13.4167C18.9577 16.7083 17.9493 17.7083 14.6327 17.7083Z"
          fill="#F5222D"
        />
        <path
          d="M16.666 8.54167C16.5827 8.54167 16.5077 8.525 16.4243 8.49167C16.191 8.39167 16.041 8.16667 16.041 7.91667V2.91667C16.041 2.575 16.3243 2.29167 16.666 2.29167C17.0077 2.29167 17.291 2.575 17.291 2.91667V6.40833L17.891 5.80833C18.1327 5.56667 18.5327 5.56667 18.7743 5.80833C19.016 6.05 19.016 6.45 18.7743 6.69167L17.1077 8.35833C16.991 8.475 16.8327 8.54167 16.666 8.54167Z"
          fill="#F5222D"
        />
        <path
          d="M16.6665 8.542C16.5082 8.542 16.3499 8.48367 16.2249 8.35867L14.5582 6.69202C14.3165 6.45036 14.3165 6.05036 14.5582 5.80869C14.7999 5.56702 15.1999 5.56702 15.4415 5.80869L17.1082 7.47536C17.3499 7.71703 17.3499 8.11703 17.1082 8.35867C16.9832 8.48367 16.8249 8.542 16.6665 8.542Z"
          fill="#F5222D"
        />
      </g>
    </svg>
  );
};

export const AuthorizedRefundOrderIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.3379 6.31429L15.5094 5.9V4.65714M18.4094 5.9C18.4094 7.50163 17.111 8.8 15.5094 8.8C13.9077 8.8 12.6094 7.50163 12.6094 5.9C12.6094 4.29837 13.9077 3 15.5094 3C17.111 3 18.4094 4.29837 18.4094 5.9Z"
      stroke="#F5222D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0885 7.7085H1.67188C1.33021 7.7085 1.04688 7.42516 1.04688 7.0835C1.04688 6.74183 1.33021 6.4585 1.67188 6.4585H11.0885C11.4302 6.4585 11.7135 6.74183 11.7135 7.0835C11.7135 7.42516 11.4302 7.7085 11.0885 7.7085Z"
      fill="#F5222D"
    />
    <path
      d="M6.67448 14.375H5.00781C4.66615 14.375 4.38281 14.0917 4.38281 13.75C4.38281 13.4083 4.66615 13.125 5.00781 13.125H6.67448C7.01615 13.125 7.29948 13.4083 7.29948 13.75C7.29948 14.0917 7.01615 14.375 6.67448 14.375Z"
      fill="#F5222D"
    />
    <path
      d="M12.0911 14.375H8.75781C8.41615 14.375 8.13281 14.0917 8.13281 13.75C8.13281 13.4083 8.41615 13.125 8.75781 13.125H12.0911C12.4328 13.125 12.7161 13.4083 12.7161 13.75C12.7161 14.0917 12.4328 14.375 12.0911 14.375Z"
      fill="#F5222D"
    />
    <path
      d="M14.6385 17.7084H5.37187C2.05521 17.7084 1.04688 16.7084 1.04688 13.4251V6.57508C1.04688 3.29175 2.05521 2.29175 5.37187 2.29175C5.37187 2.29175 10.7469 2.29175 11.0885 2.29175C11.4302 2.29175 11.7135 2.57508 11.7135 2.91675C11.7135 3.25841 11.4302 3.54175 11.0885 3.54175H5.37187C2.75521 3.54175 2.29687 3.99175 2.29687 6.57508V13.4167C2.29687 16.0001 2.75521 16.4501 5.37187 16.4501H14.6302C17.2469 16.4501 17.7052 16.0001 17.7052 13.4167V9.68341C17.7052 9.34175 17.9885 9.05841 18.3302 9.05841C18.6719 9.05841 18.9552 9.34175 18.9552 9.68341V13.4167C18.9635 16.7084 17.9552 17.7084 14.6385 17.7084Z"
      fill="#F5222D"
    />
  </svg>
);

export const SamcartIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.47316 2.97999L4.92239 4.33002C4.82405 4.35685 4.82405 4.49097 4.92239 4.51779L9.47316 5.87677C9.53574 5.89466 9.59831 5.84996 9.59831 5.77844V3.06939C9.59831 3.00681 9.53574 2.9621 9.47316 2.97999Z"
        fill="#0086FA"
      />
      <path
        d="M10.5805 16.3643C9.74011 16.3643 9.08746 17.1332 9.26627 18.0005C9.37355 18.5101 9.78482 18.9214 10.2944 19.0287C11.1617 19.2075 11.9306 18.5548 11.9306 17.7144C11.9216 16.9723 11.3226 16.3643 10.5805 16.3643Z"
        fill="#0086FA"
      />
      <path
        d="M18.655 14.1202C17.8146 14.1202 17.1619 14.8891 17.3407 15.7564C17.448 16.275 17.8772 16.6862 18.3957 16.7846C19.406 16.9723 20.2643 16.0336 19.9246 15.0054C19.7457 14.4689 19.2272 14.1202 18.655 14.1202Z"
        fill="#0086FA"
      />
      <path
        d="M2.50779 14.1202C1.66737 14.1202 1.0147 14.8891 1.19351 15.7564C1.3008 16.275 1.72995 16.6862 2.24851 16.7846C3.25879 16.9723 4.11709 16.0336 3.77735 15.0054C3.59853 14.4689 3.07104 14.1202 2.50779 14.1202Z"
        fill="#0086FA"
      />
      <path
        d="M1.15784 11.1429C1.15784 11.7688 1.56911 12.3141 2.15918 12.4929L10.17 14.898C10.4382 14.9785 10.7153 14.9785 10.9835 14.898L18.9943 12.4929C19.5933 12.3141 19.9957 11.7688 19.9957 11.1429V4.75921C19.9957 4.58934 19.8347 4.47311 19.6738 4.51782L10.9299 7.12851C10.6974 7.20003 10.4471 7.20003 10.2236 7.12851L2.31117 4.76816L1.75686 4.60722C1.57805 4.55358 1.57805 4.30324 1.75686 4.24959L10.3398 1.70149C10.4561 1.66572 10.5812 1.75513 10.5812 1.8803V5.84998C10.5812 5.97515 10.6975 6.06455 10.8226 6.02879L18.1271 3.85621L18.6814 3.69527C18.8602 3.64163 18.8602 3.39129 18.6814 3.33764L10.7869 0.968351C10.6527 0.932588 10.5097 0.932588 10.3756 0.968351L0.66611 3.89196C0.147556 4.04396 -0.138549 4.61616 0.0670843 5.13472C0.174371 5.41188 0.433653 5.60858 0.719752 5.69799L1.16678 5.8321"
        fill="#0086FA"
      />
    </svg>
  );
};

export const ShopifyIcon = () => {
  return (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.4579 3.85618C15.446 3.74974 15.3514 3.70243 15.2804 3.69061C15.2095 3.67878 13.7903 3.66695 13.7903 3.66695C13.7903 3.66695 12.5957 2.50791 12.4775 2.38964C12.3592 2.27137 12.1345 2.30685 12.0399 2.3305C12.0399 2.3305 11.8151 2.40147 11.4367 2.51974C11.3775 2.31868 11.2829 2.07031 11.1528 1.82194C10.7271 1.00588 10.1121 0.580112 9.35514 0.580112C9.30783 0.580112 9.24869 0.580112 9.20139 0.591939C9.17773 0.568285 9.15408 0.544632 9.13042 0.509151C8.79927 0.154341 8.38532 -0.0112361 7.88859 0.000590911C6.91878 0.0242449 5.96079 0.722036 5.16839 1.97569C4.61252 2.85089 4.19858 3.9508 4.08031 4.80234C2.96857 5.14532 2.18799 5.38186 2.17616 5.39369C1.6203 5.57109 1.59664 5.58292 1.52568 6.11513C1.46654 6.50542 0 17.8711 0 17.8711L12.3119 20L17.6458 18.6754C17.6458 18.6754 15.4697 3.9508 15.4579 3.85618ZM10.8217 2.70897C10.5378 2.79176 10.2185 2.8982 9.8637 3.00464C9.85187 2.51974 9.79273 1.83377 9.56802 1.24242C10.3131 1.38435 10.6679 2.21223 10.8217 2.70897ZM9.22504 3.2057C8.57456 3.40676 7.87676 3.61964 7.16715 3.84436C7.3682 3.08743 7.74667 2.3305 8.20792 1.83377C8.38532 1.64454 8.62186 1.44348 8.90571 1.32521C9.17773 1.88108 9.22504 2.67349 9.22504 3.2057ZM7.90042 0.651074C8.12513 0.651074 8.31436 0.698382 8.47994 0.804825C8.21975 0.934922 7.95955 1.13598 7.72301 1.39617C7.10801 2.05848 6.63493 3.0756 6.4457 4.06907C5.85435 4.24647 5.28666 4.42388 4.75444 4.58946C5.10925 3.0283 6.41022 0.698382 7.90042 0.651074Z"
        fill="#95BF47"
      />
      <path
        d="M15.2798 3.69047C15.2089 3.67864 13.7897 3.66682 13.7897 3.66682C13.7897 3.66682 12.5951 2.50777 12.4769 2.3895C12.4295 2.3422 12.3704 2.31854 12.3113 2.31854V19.9999L17.6452 18.6752C17.6452 18.6752 15.4691 3.96249 15.4573 3.85605C15.4336 3.74961 15.3508 3.7023 15.2798 3.69047Z"
        fill="#5E8E3E"
      />
      <path
        d="M9.35543 6.43439L8.74043 8.75248C8.74043 8.75248 8.05446 8.43315 7.22658 8.49228C6.02022 8.56325 6.0084 9.32017 6.02023 9.52123C6.09119 10.562 8.81139 10.7867 8.96514 13.2112C9.08341 15.1272 7.94802 16.4282 6.3159 16.5346C4.35262 16.6529 3.27637 15.5057 3.27637 15.5057L3.69031 13.7435C3.69031 13.7435 4.77839 14.5595 5.64176 14.5122C6.20946 14.4767 6.41052 14.0155 6.38686 13.6843C6.30407 12.336 4.0806 12.407 3.93868 10.1954C3.82041 8.32671 5.05041 6.43439 7.75879 6.25699C8.82322 6.16237 9.35543 6.43439 9.35543 6.43439Z"
        fill="white"
      />
    </svg>
  );
};

export const StripeIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3900_26692)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.675 5.9469C8.675 5.09065 9.3875 4.7594 10.5387 4.7594C12.4441 4.80057 14.3138 5.28436 16 6.17253V1.00378C14.2613 0.320475 12.4068 -0.0201527 10.5387 0.000654704C6.10125 0.000654704 3.125 2.32503 3.125 6.20628C3.125 12.2788 11.4637 11.2925 11.4637 13.91C11.4637 14.9338 10.5887 15.2513 9.3575 15.2513C7.54187 15.2513 5.19688 14.5 3.3575 13.5V18.7363C5.25126 19.5603 7.29289 19.9902 9.35812 20C13.9187 20 17.0625 17.7469 17.0625 13.7982C17.0625 7.2444 8.675 8.41503 8.675 5.94815V5.9469Z"
          fill="#635BFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3900_26692">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AttachIcon = (props) => {
  return (
    <svg
      width={props?.size || '20'}
      height={props?.size || '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.91699 12.0833L12.0837 7.91663"
        stroke={props?.stroke || 'var(--user-main-pink)'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.0386 12.1746L16.2132 10C17.9289 8.28427 17.9289 5.50252 16.2132 3.78679C14.4975 2.07107 11.7157 2.07107 10 3.78679L7.82537 5.96142M12.1746 14.0386L10 16.2132C8.28427 17.929 5.50253 17.929 3.7868 16.2132C2.07107 14.4975 2.07107 11.7157 3.7868 10L5.96142 7.82538"
        stroke={props?.stroke || 'var(--user-main-pink)'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const SendSmallIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.50862 18.125C3.57528 18.125 2.98362 17.8083 2.60862 17.4333C1.87528 16.7 1.35862 15.1417 3.00862 11.8333L3.73362 10.3917C3.82528 10.2 3.82528 9.79999 3.73362 9.60832L3.00862 8.16665C1.35028 4.85832 1.87528 3.29165 2.60862 2.56665C3.33362 1.83332 4.90028 1.30832 8.20028 2.96665L15.3336 6.53332C17.1086 7.41665 18.0836 8.64999 18.0836 9.99999C18.0836 11.35 17.1086 12.5833 15.3419 13.4667L8.20862 17.0333C6.59195 17.8417 5.39195 18.125 4.50862 18.125ZM4.50862 3.12499C4.05862 3.12499 3.70862 3.23332 3.49195 3.44999C2.88362 4.04999 3.12528 5.60832 4.12528 7.59999L4.85028 9.04999C5.11695 9.59165 5.11695 10.4083 4.85028 10.95L4.12528 12.3917C3.12528 14.3917 2.88362 15.9417 3.49195 16.5417C4.09195 17.15 5.65028 16.9083 7.65028 15.9083L14.7836 12.3417C16.0919 11.6917 16.8336 10.8333 16.8336 9.99165C16.8336 9.14999 16.0836 8.29165 14.7753 7.64165L7.64195 4.08332C6.37528 3.44999 5.28362 3.12499 4.50862 3.12499Z"
        fill="currentColor"
      />
      <path
        d="M9.0332 10.625H4.5332C4.19154 10.625 3.9082 10.3417 3.9082 10C3.9082 9.65833 4.19154 9.375 4.5332 9.375H9.0332C9.37487 9.375 9.6582 9.65833 9.6582 10C9.6582 10.3417 9.37487 10.625 9.0332 10.625Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CheckFillIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="20" height="20" rx="10" fill="currentColor" />
      <path
        d="M5.91797 10.5834L8.2513 12.9167L14.0846 7.08337"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19 7L18.1327 19.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224C6.81296 21 5.94208 20.1891 5.86732 19.1425L5 7M10 11V17M14 11V17M15 7V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V7M4 7H20"
        stroke="#F5222D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotesIcon = (props) => {
  return (
    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.0278 8.68566L20.5962 10.1693M13.8342 13.1153L16.6183 13.8571M13.9727 21.4605L15.0864 21.7573C18.2362 22.5965 19.8113 23.0161 21.052 22.3039C22.2928 21.5915 22.7148 20.0254 23.5588 16.8932L24.7524 12.4636C25.5965 9.3314 26.0185 7.7653 25.3022 6.53153C24.5858 5.29775 23.0108 4.87812 19.8608 4.03885L18.7471 3.74212C15.5972 2.90284 14.0222 2.48322 12.7815 3.19554C11.5407 3.90786 11.1187 5.47396 10.2747 8.60615L9.08102 13.0357C8.23698 16.1679 7.81497 17.734 8.53133 18.9678C9.24769 20.2016 10.8227 20.6213 13.9727 21.4605Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M13.9999 24.9377L12.8889 25.2402C9.74629 26.096 8.17501 26.5238 6.93714 25.7975C5.69929 25.0713 5.27826 23.4745 4.43621 20.2808L3.24538 15.7643C2.40332 12.5707 1.9823 10.9738 2.69699 9.71585C3.3152 8.62767 4.66659 8.66729 6.41659 8.66715"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const BulbIcon = (props) => {
  return (
    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.10436 17.9993C6.66288 17.007 6.41675 15.903 6.41675 14.7396C6.41675 10.4187 9.81192 6.91602 14.0001 6.91602C18.1883 6.91602 21.5834 10.4187 21.5834 14.7396C21.5834 15.903 21.3372 17.007 20.8958 17.9993"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14 2.83203V3.9987"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.6667 14.499H24.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.49992 14.499H2.33325"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2488 6.24902L21.4238 7.07399"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.57618 7.07496L5.75122 6.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9366 23.0233C18.1154 22.6421 18.5881 21.5631 18.7211 20.4779C18.7608 20.1537 18.4941 19.8848 18.1674 19.8848L9.88975 19.885C9.55188 19.885 9.28054 20.1718 9.32088 20.5072C9.45114 21.5903 9.77991 22.3815 11.0291 23.0233M16.9366 23.0233C16.9366 23.0233 11.2348 23.0233 11.0291 23.0233M16.9366 23.0233C16.7948 25.2925 16.1395 26.1912 14.008 26.166C11.7281 26.2081 11.2036 25.0973 11.0291 23.0233"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PrescriptionIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.5794 14.1258L12.5769 13.1155L10.9589 11.4977L9.94873 12.495C9.71618 12.7276 9.5999 12.9994 9.5999 13.3105C9.5999 13.6216 9.71618 13.8934 9.94873 14.1258C10.1812 14.3583 10.453 14.4745 10.7641 14.4745C11.0752 14.4745 11.347 14.3583 11.5794 14.1258ZM13.0359 12.6565L14.0461 11.6592C14.2786 11.4267 14.3927 11.1549 14.3884 10.8438C14.3842 10.5327 14.2658 10.2609 14.0332 10.0283C13.8008 9.80444 13.5312 9.69033 13.2244 9.686C12.9175 9.68177 12.6478 9.79589 12.4154 10.0283L11.4179 11.0387L13.0359 12.6565ZM12.0422 14.6015C11.6825 14.9613 11.2543 15.1391 10.7577 15.1348C10.2611 15.1305 9.83284 14.9527 9.47306 14.6015C9.12173 14.2416 8.94395 13.8134 8.93973 13.3168C8.9354 12.8203 9.11317 12.3921 9.47306 12.0322L11.9526 9.55266C12.3038 9.20144 12.732 9.02583 13.2371 9.02583C13.7423 9.02583 14.1705 9.20144 14.5217 9.55266C14.8816 9.91255 15.0616 10.3408 15.0616 10.8373C15.0616 11.3339 14.8816 11.7621 14.5217 12.122L12.0422 14.6015ZM3.74106 13.3335C3.44273 13.3335 3.18862 13.2286 2.97873 13.0188C2.76895 12.8089 2.66406 12.5548 2.66406 12.2565V3.74383C2.66406 3.4455 2.76895 3.19139 2.97873 2.9815C3.18862 2.77172 3.44273 2.66683 3.74106 2.66683H6.8744C6.81362 2.32661 6.89501 2.01933 7.11856 1.745C7.34201 1.47066 7.63495 1.3335 7.9974 1.3335C8.36829 1.3335 8.66551 1.47066 8.88906 1.745C9.11262 2.01933 9.18973 2.32661 9.1204 2.66683H12.2537C12.5521 2.66683 12.8062 2.77172 13.0161 2.9815C13.2258 3.19139 13.3307 3.4455 13.3307 3.74383V7.19883C13.2196 7.18605 13.1085 7.18394 12.9974 7.1925C12.8863 7.20105 12.7752 7.21344 12.6641 7.22966V3.74383C12.6641 3.62416 12.6256 3.52583 12.5487 3.44883C12.4717 3.37194 12.3734 3.3335 12.2537 3.3335H3.74106C3.6214 3.3335 3.52306 3.37194 3.44606 3.44883C3.36917 3.52583 3.33073 3.62416 3.33073 3.74383V12.2565C3.33073 12.3762 3.36917 12.4745 3.44606 12.5515C3.52306 12.6284 3.6214 12.6668 3.74106 12.6668H7.16273C7.13795 12.7779 7.12129 12.8891 7.11273 13.0002C7.10417 13.1113 7.10634 13.2224 7.11923 13.3335H3.74106ZM7.9974 2.96166C8.14184 2.96166 8.26129 2.91444 8.35573 2.82C8.45017 2.72555 8.4974 2.60611 8.4974 2.46166C8.4974 2.31722 8.45017 2.19777 8.35573 2.10333C8.26129 2.00889 8.14184 1.96166 7.9974 1.96166C7.85295 1.96166 7.73351 2.00889 7.63906 2.10333C7.54462 2.19777 7.4974 2.31722 7.4974 2.46166C7.4974 2.60611 7.54462 2.72555 7.63906 2.82C7.73351 2.91444 7.85295 2.96166 7.9974 2.96166ZM4.9974 5.82066V5.154H10.9974V5.82066H4.9974ZM4.9974 8.3335V7.66683H10.9974V7.93866C10.9342 7.98566 10.8758 8.03244 10.8224 8.079C10.769 8.12555 10.7106 8.1805 10.6474 8.24383L10.5577 8.3335H4.9974ZM4.9974 10.8463V10.1797H8.71156L8.52306 10.3682C8.44273 10.4485 8.36429 10.5282 8.28773 10.6072C8.21129 10.6863 8.13673 10.766 8.06406 10.8463H4.9974Z"
        fill="currentColor"
      />
      <path
        d="M3.33073 12.6668V3.3335M11.5794 14.1258L12.5769 13.1155L10.9589 11.4977L9.94873 12.495C9.71618 12.7276 9.5999 12.9994 9.5999 13.3105C9.5999 13.6216 9.71618 13.8934 9.94873 14.1258C10.1812 14.3583 10.453 14.4745 10.7641 14.4745C11.0752 14.4745 11.347 14.3583 11.5794 14.1258ZM13.0359 12.6565L14.0461 11.6592C14.2786 11.4267 14.3927 11.1549 14.3884 10.8438C14.3842 10.5327 14.2658 10.2609 14.0332 10.0283C13.8008 9.80444 13.5312 9.69033 13.2244 9.686C12.9175 9.68177 12.6478 9.79589 12.4154 10.0283L11.4179 11.0387L13.0359 12.6565ZM12.0422 14.6015C11.6825 14.9613 11.2543 15.1391 10.7577 15.1348C10.2611 15.1305 9.83284 14.9527 9.47306 14.6015C9.12173 14.2416 8.94395 13.8134 8.93973 13.3168C8.9354 12.8203 9.11317 12.3921 9.47306 12.0322L11.9526 9.55266C12.3038 9.20144 12.732 9.02583 13.2371 9.02583C13.7423 9.02583 14.1705 9.20144 14.5217 9.55266C14.8816 9.91255 15.0616 10.3408 15.0616 10.8373C15.0616 11.3339 14.8816 11.7621 14.5217 12.122L12.0422 14.6015ZM3.74106 13.3335C3.44273 13.3335 3.18862 13.2286 2.97873 13.0188C2.76895 12.8089 2.66406 12.5548 2.66406 12.2565V3.74383C2.66406 3.4455 2.76895 3.19139 2.97873 2.9815C3.18862 2.77172 3.44273 2.66683 3.74106 2.66683H6.8744C6.81362 2.32661 6.89501 2.01933 7.11856 1.745C7.34201 1.47066 7.63495 1.3335 7.9974 1.3335C8.36829 1.3335 8.66551 1.47066 8.88906 1.745C9.11262 2.01933 9.18973 2.32661 9.1204 2.66683H12.2537C12.5521 2.66683 12.8062 2.77172 13.0161 2.9815C13.2258 3.19139 13.3307 3.4455 13.3307 3.74383V7.19883C13.2196 7.18605 13.1085 7.18394 12.9974 7.1925C12.8863 7.20105 12.7752 7.21344 12.6641 7.22966V3.74383C12.6641 3.62416 12.6256 3.52583 12.5487 3.44883C12.4717 3.37194 12.3734 3.3335 12.2537 3.3335H3.74106C3.6214 3.3335 3.52306 3.37194 3.44606 3.44883C3.36917 3.52583 3.33073 3.62416 3.33073 3.74383V12.2565C3.33073 12.3762 3.36917 12.4745 3.44606 12.5515C3.52306 12.6284 3.6214 12.6668 3.74106 12.6668H7.16273C7.13795 12.7779 7.12129 12.8891 7.11273 13.0002C7.10417 13.1113 7.10634 13.2224 7.11923 13.3335H3.74106ZM7.9974 2.96166C8.14184 2.96166 8.26129 2.91444 8.35573 2.82C8.45017 2.72555 8.4974 2.60611 8.4974 2.46166C8.4974 2.31722 8.45017 2.19777 8.35573 2.10333C8.26129 2.00889 8.14184 1.96166 7.9974 1.96166C7.85295 1.96166 7.73351 2.00889 7.63906 2.10333C7.54462 2.19777 7.4974 2.31722 7.4974 2.46166C7.4974 2.60611 7.54462 2.72555 7.63906 2.82C7.73351 2.91444 7.85295 2.96166 7.9974 2.96166ZM4.9974 5.82066V5.154H10.9974V5.82066H4.9974ZM4.9974 8.3335V7.66683H10.9974V7.93866C10.9342 7.98566 10.8758 8.03244 10.8224 8.079C10.769 8.12555 10.7106 8.1805 10.6474 8.24383L10.5577 8.3335H4.9974ZM4.9974 10.8463V10.1797H8.71156L8.52306 10.3682C8.44273 10.4485 8.36429 10.5282 8.28773 10.6072C8.21129 10.6863 8.13673 10.766 8.06406 10.8463H4.9974Z"
        stroke="currentColor"
        strokeWidth="0.3"
      />
    </svg>
  );
};

export const ExportFileIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.6693 11.6665V8.88059C16.6693 8.1993 16.6693 7.85867 16.5424 7.55239C16.4155 7.2461 16.1747 7.00525 15.6929 6.52353L11.7459 2.5764C11.3301 2.16067 11.1223 1.9528 10.8647 1.82963C10.8111 1.804 10.7563 1.78127 10.7003 1.76151C10.431 1.6665 10.1371 1.6665 9.5491 1.6665C6.84495 1.6665 5.49286 1.6665 4.57705 2.4049C4.39203 2.55407 4.2235 2.7226 4.07433 2.90761C3.33594 3.82343 3.33594 5.17552 3.33594 7.8797V11.6665C3.33594 14.8092 3.33594 16.3806 4.31225 17.3568C5.28856 18.3332 6.8599 18.3332 10.0026 18.3332M10.8359 2.08317V2.49984C10.8359 4.85686 10.8359 6.03537 11.5682 6.7676C12.3004 7.49984 13.4789 7.49984 15.8359 7.49984H16.2526"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1667 18.3335C14.6723 17.842 16.6667 16.5337 16.6667 15.8335C16.6667 15.1332 14.6723 13.825 14.1667 13.3335M15.8333 15.8335H10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MeasurementIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.56885 4.16602C4.43177 4.21741 3.72921 4.37735 3.23223 4.87518C2.5 5.60867 2.5 6.78921 2.5 9.15027V13.3241C2.5 15.6852 2.5 16.8657 3.23223 17.5992C3.96447 18.3327 5.14297 18.3327 7.5 18.3327H12.5C14.857 18.3327 16.0355 18.3327 16.7677 17.5992C17.5 16.8657 17.5 15.6852 17.5 13.3241V9.15027C17.5 6.78921 17.5 5.60867 16.7677 4.87518C16.2707 4.37735 15.5682 4.21741 14.4312 4.16602"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M5.85427 5.44957C5.45379 3.88297 5.25355 3.09967 5.57901 2.52509C5.66566 2.37212 5.77637 2.23345 5.9071 2.11415C6.39816 1.66602 7.22378 1.66602 8.875 1.66602H11.1247C12.7759 1.66602 13.6015 1.66602 14.0926 2.11415C14.2233 2.23345 14.334 2.37212 14.4207 2.52509C14.7461 3.09967 14.5459 3.88297 14.1454 5.44957C13.8261 6.6985 13.6665 7.32297 13.2396 7.73396C13.1234 7.84582 12.9945 7.94427 12.8553 8.02737C12.3441 8.33268 11.6859 8.33268 10.3695 8.33268H9.63017C8.31379 8.33268 7.65558 8.33268 7.14434 8.02737C7.00519 7.94427 6.87625 7.84582 6.76007 7.73396C6.33319 7.32297 6.17355 6.6985 5.85427 5.44957Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M8.3335 15H11.6668"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5835 8.33398L10.4168 5.83398"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ShareIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.5 5.4165C17.5 6.79721 16.3807 7.9165 15 7.9165C13.6192 7.9165 12.5 6.79721 12.5 5.4165C12.5 4.0358 13.6192 2.9165 15 2.9165C16.3807 2.9165 17.5 4.0358 17.5 5.4165Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M7.5 10C7.5 11.3807 6.38071 12.5 5 12.5C3.61929 12.5 2.5 11.3807 2.5 10C2.5 8.61925 3.61929 7.5 5 7.5C6.38071 7.5 7.5 8.61925 7.5 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M17.5 14.5835C17.5 15.9642 16.3807 17.0835 15 17.0835C13.6192 17.0835 12.5 15.9642 12.5 14.5835C12.5 13.2027 13.6192 12.0835 15 12.0835C16.3807 12.0835 17.5 13.2027 17.5 14.5835Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M7.27344 8.95808L12.6901 6.4585M7.27344 11.0418L12.6901 13.5414"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const QuelloIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.1119 8.46262L11.6857 4.8115L14.1425 3.41531V1.5L10.0002 3.85389L5.85784 1.5V3.4151L8.31506 4.81128L1.88816 8.46241C1.45887 8.70584 1.08254 9.02999 0.780694 9.41637C0.478846 9.80276 0.257388 10.2438 0.128942 10.7143C0.000495188 11.1848 -0.0323991 11.6756 0.0321109 12.1586C0.0966209 12.6416 0.257261 13.1075 0.504906 13.5294C0.752551 13.9514 1.08235 14.3213 1.47543 14.618C1.8685 14.9147 2.31718 15.1324 2.79585 15.2587C3.27452 15.385 3.77381 15.4173 4.2652 15.3539C4.75658 15.2905 5.23044 15.1326 5.65973 14.8891C5.74748 14.839 5.83209 14.7854 5.91442 14.7291C5.92111 14.8913 5.9279 15.0463 5.93547 15.1895C5.95969 15.6239 6.08978 16.0462 6.3148 16.4209C6.53982 16.7955 6.85317 17.1115 7.22842 17.3421C7.47038 17.4911 8.4557 18.0513 8.70252 18.1805C9.10174 18.3903 9.54742 18.5 10.0001 18.5C10.4528 18.5 10.8984 18.3903 11.2977 18.1805C11.5451 18.0513 12.5302 17.4912 12.7718 17.3421C13.1471 17.1116 13.4605 16.7957 13.6855 16.421C13.9105 16.0463 14.0404 15.624 14.0643 15.1895C14.0723 15.0463 14.0794 14.8914 14.0858 14.7291C14.1687 14.7854 14.2531 14.839 14.34 14.8891C15.207 15.3808 16.2372 15.5138 17.2039 15.2588C18.1707 15.0039 18.9948 14.3818 19.495 13.5296C19.9952 12.6774 20.1305 11.6647 19.8711 10.7144C19.6117 9.76416 18.9789 8.95408 18.1119 8.46241L18.1119 8.46262ZM5.8566 11.7754C5.8566 12.4355 5.44812 13.0945 4.81551 13.4537C4.57848 13.5883 4.31677 13.6757 4.04536 13.7108C3.77396 13.7459 3.49819 13.728 3.23381 13.6582C2.96943 13.5885 2.72163 13.4681 2.5046 13.3041C2.28757 13.1402 2.10556 12.9357 1.96899 12.7025C1.69293 12.2309 1.61825 11.671 1.7613 11.1454C1.90436 10.6199 2.25349 10.1714 2.73223 9.89835L5.85766 8.1223L5.8566 11.7754ZM7.62001 7.68719C7.62986 7.51868 7.68067 7.35493 7.76815 7.20968C7.85564 7.06444 7.97726 6.94192 8.12283 6.85239C8.34816 6.714 9.26527 6.19286 9.49524 6.07256C9.6504 5.99096 9.82364 5.94821 9.9996 5.94811C10.1756 5.94801 10.3488 5.99055 10.5041 6.07196C10.7342 6.19292 11.6525 6.71454 11.8766 6.85239C12.0224 6.94168 12.1442 7.06415 12.2317 7.20944C12.3192 7.35474 12.3699 7.5186 12.3794 7.68719C12.4199 8.43569 12.4438 9.47189 12.4522 10.5658H7.54762C7.55646 9.47194 7.57991 8.43574 7.6203 7.68725L7.62001 7.68719ZM11.8768 15.937C11.6519 16.0753 10.7343 16.5964 10.5043 16.7173C10.349 16.7987 10.1758 16.8413 9.99985 16.8413C9.8239 16.8413 9.65066 16.7987 9.49543 16.7173C9.26579 16.5971 8.34832 16.0753 8.12299 15.937C7.9154 15.8088 7.75856 15.6148 7.67836 15.387H12.3214C12.2413 15.6148 12.0844 15.8088 11.8768 15.937ZM12.4293 13.729H7.57018C7.55962 13.2574 7.55151 12.7474 7.54808 12.2242H12.4526C12.4484 12.7474 12.4409 13.2574 12.4294 13.7293L12.4293 13.729ZM18.0307 12.7025C17.8941 12.9357 17.7121 13.1401 17.495 13.3041C17.278 13.4681 17.0302 13.5884 16.7658 13.6582C16.5014 13.728 16.2256 13.7458 15.9542 13.7107C15.6828 13.6756 15.4211 13.5883 15.1841 13.4537C14.5519 13.0944 14.1431 12.4354 14.1431 11.7754L14.1422 8.12246L17.2676 9.89851C17.7463 10.1716 18.0954 10.6201 18.2384 11.1457C18.3815 11.6713 18.3068 12.2311 18.0308 12.7027L18.0307 12.7025Z"
        fill="#00524C"
      />
    </svg>
  );
};

export const TelegraIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_4254_29364)">
        <path
          d="M6.58545 16.5854C6.58545 14.6995 8.11423 13.1707 10.0001 13.1707H13.4147V16.5854C13.4147 18.4712 11.8859 20 10.0001 20C8.11423 20 6.58545 18.4712 6.58545 16.5854Z"
          fill="#D8B8F3"
        />
        <path
          d="M12.927 10.2439C12.927 8.35807 14.4558 6.82928 16.3416 6.82928C18.2275 6.82928 19.7563 8.35807 19.7563 10.2439C19.7563 12.1298 18.2275 13.6586 16.3416 13.6586H12.927V10.2439Z"
          fill="#D8B8F3"
        />
        <path
          d="M0.243652 9.75607C0.243652 7.87022 1.77244 6.34143 3.65829 6.34143H7.07291V9.75607C7.07291 11.6419 5.54413 13.1707 3.65828 13.1707C1.77243 13.1707 0.243652 11.6419 0.243652 9.75607Z"
          fill="#5456AD"
        />
        <path
          d="M6.58521 3.41463C6.58521 1.52878 8.11399 0 9.99984 0C11.8857 0 13.4145 1.52878 13.4145 3.41463C13.4145 5.30048 11.8857 6.82927 9.99983 6.82927H6.58521V3.41463Z"
          fill="#5456AD"
        />
      </g>
      <defs>
        <clipPath id="clip0_4254_29364">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MdiIcon = (props) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.6457 20C5.12848 20 0.645752 15.5232 0.645752 10.0132C0.645752 4.50331 5.12848 0 10.6457 0C16.1629 0 20.6456 4.47682 20.6456 9.98676C20.6722 15.5232 16.1629 20 10.6457 20ZM10.6457 0.741724C5.52636 0.741724 1.36193 4.90066 1.36193 10.0132C1.36193 15.1258 5.52636 19.2848 10.6457 19.2848C15.765 19.2848 19.9295 15.1258 19.9295 10.0132C19.9295 4.90066 15.765 0.741724 10.6457 0.741724Z"
        fill="#252F3A"
      />
      <path
        d="M17.6482 6.17227C17.6482 5.96035 17.5156 5.69545 17.383 5.51002C17.1442 5.16565 16.7463 5.11267 16.3485 5.11267C15.3936 5.11267 14.4387 5.11267 13.4838 5.11267L12.9002 5.90737C14.1469 5.90737 15.3936 5.90737 16.6403 5.90737C16.9055 5.90737 16.9585 5.98684 16.9585 6.22526C16.9585 8.47693 16.9585 10.7551 16.9585 13.0067C16.9585 13.2716 16.8524 13.3511 16.6137 13.3511C14.6243 13.3511 12.6084 13.3511 10.619 13.3511C8.62965 13.3511 6.61377 13.3511 4.62439 13.3511C4.35914 13.3511 4.27957 13.2716 4.27957 13.0067C4.27957 10.7551 4.27957 8.47693 4.27957 6.22526C4.27957 5.96035 4.35914 5.90737 4.59787 5.90737C5.79149 5.90737 7.01164 5.90737 8.20531 5.90737L7.67475 5.11267C6.7464 5.11267 5.81802 5.11267 4.88964 5.11267C3.98779 5.11267 3.53687 5.53651 3.53687 6.46366C3.53687 8.58286 3.53687 10.7021 3.53687 12.8478C3.53687 13.7749 3.98779 14.1988 4.88964 14.1988C8.6562 14.1988 12.4228 14.1988 16.1893 14.1988C16.2954 14.1988 16.4015 14.1988 16.5076 14.1988C17.0912 14.1458 17.5421 13.6955 17.5421 13.1127C17.6747 10.7815 17.6747 8.47693 17.6482 6.17227Z"
        fill="#37A37D"
      />
      <path
        d="M12.9535 16.1325C12.5025 16.053 12.2903 15.8146 12.2903 15.3378C12.2903 15.1258 12.2903 14.9404 12.2903 14.7285C12.2903 14.5696 12.2373 14.5166 12.0781 14.5166C11.1232 14.5166 10.1683 14.5166 9.23994 14.5166C9.05429 14.5166 9.02774 14.596 9.02774 14.755C9.02774 14.9669 9.02774 15.1788 9.02774 15.3907C9.00118 15.8146 8.78898 16.053 8.39112 16.106C8.15243 16.1325 7.9667 16.2119 7.99325 16.4769C8.01981 16.7418 8.20546 16.7683 8.44422 16.7683C9.18691 16.7683 9.9296 16.7683 10.6723 16.7683C11.4415 16.7683 12.1842 16.7683 12.9535 16.7683C13.2452 16.7683 13.3779 16.6093 13.3513 16.3709C13.2983 16.212 13.1391 16.1854 12.9535 16.1325Z"
        fill="#37A37D"
      />
      <path
        d="M12.131 7.07284C11.7596 7.1258 11.2556 7.3907 10.8312 7.70863V7.52318C11.0434 7.44366 11.1761 7.25829 11.1761 7.04635C11.1761 6.75495 10.9374 6.51654 10.6456 6.51654C10.3538 6.51654 10.1151 6.75495 10.1151 7.04635C10.1151 7.25829 10.2477 7.47022 10.4599 7.52318V7.70863C10.0355 7.3907 9.53151 7.1258 9.1602 7.07284C7.9931 6.91387 7.72779 7.44366 7.0647 7.60263C7.51562 8.07946 7.86048 8.00001 8.49703 7.70863C8.39096 7.92049 8.12572 8.07946 7.88696 8.15891C8.44399 8.4238 8.94799 8.07946 9.13365 7.89401C9.08061 8.07946 8.92144 8.26491 8.70923 8.39732C9.34586 8.47684 9.98248 8.39732 10.4864 8.15891L10.513 9.69532C10.4864 9.69532 10.4599 9.69532 10.4334 9.69532C9.98248 9.61587 9.55806 9.56291 9.50503 9.32449C9.47848 9.24504 9.50503 9.16553 9.55806 9.11256C9.58455 9.08608 9.6111 9.0596 9.66413 9.03311C9.77027 8.98015 9.87634 9.0596 9.98248 9.0596C10.1416 9.03311 10.1946 8.9536 10.1946 8.82118C10.1681 8.66222 10.009 8.63573 9.92937 8.63573C9.69068 8.63573 9.45193 8.74173 9.3193 8.90063C9.21324 9.03311 9.18668 9.19201 9.21324 9.37746C9.29282 9.72187 9.6111 9.85429 9.98248 9.93373C9.74372 10.0662 9.58455 10.2517 9.55806 10.543C9.53151 10.9669 9.77027 11.1788 10.0885 11.2848C9.90289 11.3642 9.74372 11.5232 9.71717 11.7616C9.69068 12.1059 9.87634 12.2914 10.1416 12.3973C9.98248 12.4768 9.84986 12.6093 9.84986 12.8212H10.1681C10.1681 12.6887 10.3008 12.6357 10.5394 12.5828V12.8212H10.8048V12.5828C11.0434 12.6357 11.1761 12.7153 11.1761 12.8212H11.4944C11.4944 12.6093 11.3883 12.4768 11.2026 12.3973C11.4679 12.2914 11.6801 12.1059 11.627 11.7616C11.6005 11.5232 11.4413 11.3907 11.2556 11.2848C11.5739 11.1788 11.8127 10.9669 11.7861 10.543C11.7596 10.2252 11.6005 10.0397 11.3617 9.93373C11.7331 9.85429 12.0514 9.72187 12.131 9.37746C12.184 9.19201 12.131 9.03311 12.0249 8.90063C11.8923 8.74173 11.6535 8.63573 11.4148 8.63573C11.3352 8.63573 11.1761 8.66222 11.1496 8.82118C11.123 8.9536 11.2026 9.03311 11.3617 9.0596C11.4944 9.0596 11.5739 8.98015 11.6801 9.03311C11.7331 9.0596 11.7596 9.08608 11.7861 9.11256C11.8392 9.16553 11.8392 9.24504 11.8392 9.32449C11.7861 9.56291 11.3617 9.64235 10.9108 9.69532C10.8843 9.69532 10.8578 9.69532 10.8312 9.69532L10.8578 8.15891C11.3617 8.39732 11.9983 8.50332 12.635 8.39732C12.4493 8.26491 12.2636 8.10594 12.2105 7.89401C12.4228 8.07946 12.9268 8.4238 13.4572 8.15891C13.192 8.07946 12.9532 7.92049 12.8472 7.70863C13.4572 8.00001 13.8285 8.07946 14.2795 7.60263C13.5633 7.44366 13.2981 6.91387 12.131 7.07284ZM9.92937 8.6887C9.95592 8.6887 9.98248 8.71525 9.98248 8.74173C9.98248 8.76822 9.95592 8.7947 9.92937 8.7947C9.90289 8.7947 9.87634 8.76822 9.87634 8.74173C9.87634 8.71525 9.90289 8.6887 9.92937 8.6887ZM9.84986 10.543C9.87634 10.2517 10.1151 10.1457 10.4864 10.0397V11.0464C10.0355 10.9669 9.8233 10.8609 9.84986 10.543ZM10.009 11.7616C10.0355 11.5761 10.2212 11.4967 10.513 11.4437V12.1589C10.1416 12.053 9.98248 11.9735 10.009 11.7616ZM11.3617 8.7947C11.3352 8.7947 11.3087 8.76822 11.3087 8.74173C11.3087 8.71525 11.3352 8.6887 11.3617 8.6887C11.3883 8.6887 11.4148 8.71525 11.4148 8.74173C11.4413 8.76822 11.4148 8.7947 11.3617 8.7947ZM11.3087 11.7616C11.3352 11.9735 11.1761 12.053 10.8048 12.1589V11.4437C11.0965 11.4967 11.2822 11.5761 11.3087 11.7616ZM11.4413 10.543C11.4679 10.8609 11.2556 10.9669 10.7782 11.0728V10.0662C11.2026 10.1192 11.4413 10.2517 11.4413 10.543Z"
        fill="#252F3A"
      />
      <path
        d="M8.55016 4.50333C9.84988 3.49671 11.4679 3.49671 12.7677 4.50333C12.9268 4.60929 13.0859 4.71525 13.2451 4.52982C13.4042 4.34439 13.2982 4.18545 13.1125 4.053C12.3963 3.49671 11.574 3.23181 10.6191 3.20532C9.74381 3.23181 8.92153 3.49671 8.17885 4.053C8.01967 4.18545 7.88705 4.34439 8.04622 4.52982C8.20533 4.71525 8.39105 4.60929 8.55016 4.50333Z"
        fill="#252F3A"
      />
      <path
        d="M8.78901 5.24501C8.92163 5.45694 9.08074 5.40396 9.26646 5.2715C9.5317 5.11256 9.77039 4.98011 10.0356 4.90065C10.407 4.79468 10.8049 4.76819 11.1763 4.87415C11.468 4.95363 11.7333 5.05958 12.025 5.24501C12.1842 5.35097 12.3698 5.43045 12.5025 5.21852C12.6086 5.05958 12.529 4.92714 12.3964 4.82117C12.3698 4.79468 12.3434 4.79468 12.3168 4.76819C11.8129 4.39733 11.2558 4.23839 10.6458 4.23839C9.9826 4.2119 9.42557 4.39733 8.92163 4.76819C8.86853 4.79468 8.8155 4.84766 8.78901 4.90065C8.73591 5.03309 8.70943 5.11256 8.78901 5.24501Z"
        fill="#252F3A"
      />
      <path
        d="M9.50524 5.96037C9.58483 6.09282 9.74393 6.11931 9.87655 6.01335C10.3806 5.69546 10.858 5.69546 11.362 5.98686C11.5477 6.09282 11.6803 6.09282 11.8129 5.90739C11.919 5.74844 11.8129 5.616 11.6537 5.51004C11.4946 5.40407 11.2559 5.3246 11.1232 5.29811C10.8315 5.24513 10.5662 5.21864 10.2745 5.24513C10.0092 5.29811 9.77049 5.37758 9.55828 5.53653C9.42566 5.66897 9.42566 5.82791 9.50524 5.96037Z"
        fill="#252F3A"
      />
    </svg>
  );
};

export const MessageIcon = (props) => {
  return (
    <svg
      width={props?.size || '24'}
      height={props?.size || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 14.5H15.5M8.5 9.5H12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1706 20.8905C18.3536 20.6125 21.6856 17.2332 21.9598 12.9909C22.0134 12.1607 22.0134 11.3009 21.9598 10.4707C21.6856 6.22838 18.3536 2.84913 14.1706 2.57107C12.7435 2.47621 11.2536 2.47641 9.8294 2.57107C5.64639 2.84913 2.31441 6.22838 2.04024 10.4707C1.98659 11.3009 1.98659 12.1607 2.04024 12.9909C2.1401 14.536 2.82343 15.9666 3.62791 17.1746C4.09501 18.0203 3.78674 19.0758 3.30021 19.9978C2.94941 20.6626 2.77401 20.995 2.91484 21.2351C3.05568 21.4752 3.37026 21.4829 3.99943 21.4982C5.24367 21.5285 6.08268 21.1757 6.74868 20.6846C7.1264 20.4061 7.31527 20.2668 7.44544 20.2508C7.5756 20.2348 7.83177 20.3403 8.34401 20.5513C8.8044 20.7409 9.33896 20.8579 9.8294 20.8905C11.2536 20.9852 12.7435 20.9854 14.1706 20.8905Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EmailIcon = (props) => {
  return (
    <svg
      width={props?.size || '24'}
      height={props?.size || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 8.5L9.94202 10.2394C11.6572 11.2535 12.3428 11.2535 14.058 10.2394L17 8.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.01577 13.4756C2.08114 16.5411 2.11383 18.0739 3.24496 19.2093C4.37609 20.3448 5.95034 20.3843 9.09884 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.755 19.2093C21.8862 18.0739 21.9189 16.5411 21.9842 13.4756C22.0053 12.4899 22.0053 11.51 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.755 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95034 3.61566 4.37609 3.65521 3.24496 4.79065C2.11383 5.92608 2.08114 7.45885 2.01577 10.5243C1.99474 11.51 1.99474 12.4899 2.01577 13.4756Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const JobIcon = (props) => {
  return (
    <svg
      width={props?.width || '24'}
      height={props?.height || '32'}
      viewBox="0 0 24 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.0809 17.152L8 11L13.4196 15.2796C14.1901 15.888 14.1941 17.0472 13.4277 17.6607C12.6614 18.2743 11.5189 18.0266 11.0809 17.152Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 8.81986C3.14864 10.6389 2 13.1737 2 15.9775C2 21.5128 6.47715 26 12 26C17.5228 26 22 21.5128 22 15.9775C22 11.1241 18.5581 7.07642 13.9872 6.15274C13.1512 5.9838 12.7332 5.89933 12.3666 6.20008C12 6.50083 12 6.987 12 7.95935V8.96161"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RecycleIcon = (props) => {
  return (
    <svg
      width={props?.size || '16'}
      height={props?.size || '16'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.3178 13C12.9345 11.9251 14 10.087 14 8C14 4.68629 11.3137 2 8 2C7.54173 2 7.09547 2.05137 6.66667 2.14868M11.3178 13V10.6667M11.3178 13H13.6667M4.66667 3.01037C3.05869 4.08671 2 5.91972 2 8C2 11.3137 4.68629 14 8 14C8.45827 14 8.90453 13.9486 9.33333 13.8513M4.66667 3.01037V5.33333M4.66667 3.01037H2.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PersonalCalenderIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.3333 1.66699V5.00033M6.66663 1.66699V5.00033"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 10.833V9.99967C17.5 6.85697 17.5 5.28563 16.5237 4.30932C15.5474 3.33301 13.976 3.33301 10.8333 3.33301H9.16667C6.02397 3.33301 4.45262 3.33301 3.47631 4.30932C2.5 5.28563 2.5 6.85697 2.5 9.99967V11.6663C2.5 14.809 2.5 16.3804 3.47631 17.3567C4.45262 18.333 6.02397 18.333 9.16667 18.333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 8.33301H17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5833 15.4163C13.6628 15.4163 12.9166 14.6702 12.9166 13.7497C12.9166 12.8292 13.6628 12.083 14.5833 12.083C15.5038 12.083 16.25 12.8292 16.25 13.7497C16.25 14.6702 15.5038 15.4163 14.5833 15.4163ZM14.5833 15.4163C16.1941 15.4163 17.5 16.7222 17.5 18.333M14.5833 15.4163C12.9725 15.4163 11.6666 16.7222 11.6666 18.333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CouponIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.05344 7.78648C1.84632 7.78648 1.65732 7.6186 1.66685 7.39915C1.72261 6.11408 1.87884 5.2775 2.31657 4.61572C2.5684 4.23499 2.88121 3.90385 3.24086 3.63725C4.21296 2.91669 5.58432 2.91669 8.32705 2.91669H11.6726C14.4154 2.91669 15.7867 2.91669 16.7589 3.63725C17.1185 3.90385 17.4313 4.23499 17.6831 4.61572C18.1208 5.27743 18.277 6.1139 18.3328 7.39871C18.3424 7.61842 18.1531 7.78648 17.9458 7.78648C16.7909 7.78648 15.8548 8.77752 15.8548 10C15.8548 11.2225 16.7909 12.2135 17.9458 12.2135C18.1531 12.2135 18.3424 12.3816 18.3328 12.6014C18.277 13.8862 18.1208 14.7226 17.6831 15.3844C17.4313 15.765 17.1185 16.0962 16.7589 16.3628C15.7867 17.0834 14.4154 17.0834 11.6726 17.0834H8.32705C5.58432 17.0834 4.21296 17.0834 3.24086 16.3628C2.88121 16.0962 2.5684 15.765 2.31657 15.3844C1.87884 14.7225 1.72261 13.8859 1.66685 12.6009C1.65732 12.3814 1.84632 12.2135 2.05344 12.2135C3.20827 12.2135 4.14443 11.2225 4.14443 10C4.14443 8.77752 3.20827 7.78648 2.05344 7.78648Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M7.9165 12.0834L12.0832 7.91669"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9165 7.91669H7.92586M12.0738 12.0834H12.0832"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CrmIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.0833 13.7503V7.08366C17.0833 5.11948 17.0833 4.13738 16.4731 3.52718C15.8629 2.91699 14.8808 2.91699 12.9166 2.91699H7.08329C5.11911 2.91699 4.13701 2.91699 3.52682 3.52718C2.91663 4.13738 2.91663 5.11948 2.91663 7.08366V13.7503"
        stroke="#077882"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3201 17.0833H1.6797C1.36059 17.0833 1.15304 16.7573 1.29575 16.4803L2.91655 13.75H17.0832L18.704 16.4803C18.8467 16.7573 18.6391 17.0833 18.3201 17.0833Z"
        stroke="#077882"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99989 10.0003V11.2503M9.99989 10.0003C10.6141 10.0003 11.1506 9.66808 11.4397 9.17358M9.99989 10.0003C9.38573 10.0003 8.84914 9.66808 8.55998 9.17358M11.4397 9.17358L12.4999 9.79199M11.4397 9.17358C11.5839 8.92691 11.6666 8.63999 11.6666 8.33366C11.6666 8.02736 11.5839 7.74037 11.4397 7.49373M8.55998 9.17358L7.49988 9.79199M8.55998 9.17358C8.41581 8.92699 8.33321 8.63999 8.33321 8.33366C8.33321 8.02736 8.41581 7.74036 8.55998 7.49373M9.99989 6.66699V5.41699M9.99989 6.66699C10.6141 6.66699 11.1506 6.99921 11.4397 7.49373M9.99989 6.66699C9.38573 6.66699 8.84914 6.9992 8.55998 7.49373M11.4397 7.49373L12.4999 6.87533M8.55998 7.49373L7.49988 6.87533"
        stroke="#077882"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HighLevelIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4945_21131)">
        <path
          d="M10.0942 6.43164L5.8219 10.8917H8.77965V19.8589H11.4088V10.8917H14.3665L10.0942 6.43164Z"
          fill="#2896FB"
        />
        <path d="M11.4087 10.8916H8.96741L11.4087 13.1921V10.8916Z" fill="#1F81DB" />
        <path d="M11.3969 10.8916V19.8353H8.76782" stroke="#356C9F" strokeWidth="0.0469484" />
        <path
          d="M4.27218 0.140625L-0.00012207 4.60072H2.95762V19.8589H5.58673V4.60072H8.54448L4.27218 0.140625Z"
          fill="#FDC400"
        />
        <path d="M5.5867 4.60059H3.14539L5.5867 6.90106V4.60059Z" fill="#DAA900" />
        <path d="M5.56328 4.60059V19.8353H2.95764" stroke="#B49011" strokeWidth="0.0469484" />
        <path
          d="M15.728 0.140625L11.4557 4.60072H14.4134V19.8589H17.0425V4.60072H20.0003L15.728 0.140625Z"
          fill="#4ACF27"
        />
        <path d="M17.0425 4.60059H14.6012L17.0425 6.90106V4.60059Z" fill="#51B346" />
        <path d="M17.019 4.60059V19.8353H14.4133" stroke="#48AC2E" strokeWidth="0.0469484" />
      </g>
      <defs>
        <clipPath id="clip0_4945_21131">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CallIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.63212 4.76019L7.29658 4.00521C7.07718 3.51157 6.96748 3.26473 6.80342 3.07584C6.59781 2.83912 6.3298 2.66495 6.02998 2.57321C5.79073 2.5 5.52063 2.5 4.98042 2.5C4.19017 2.5 3.79504 2.5 3.46335 2.65191C3.07263 2.83085 2.71978 3.2194 2.57918 3.6255C2.45983 3.97024 2.49403 4.32453 2.56239 5.03308C3.29017 12.5752 7.42509 16.7101 14.9671 17.4378C15.6757 17.5062 16.03 17.5404 16.3747 17.4211C16.7809 17.2805 17.1694 16.9276 17.3484 16.5369C17.5002 16.2052 17.5002 15.8101 17.5002 15.0198C17.5002 14.4796 17.5002 14.2095 17.427 13.9702C17.3353 13.6704 17.1611 13.4024 16.9244 13.1968C16.7355 13.0327 16.4887 12.9231 15.995 12.7037L15.24 12.3681C14.7055 12.1305 14.4381 12.0117 14.1665 11.9859C13.9065 11.9612 13.6445 11.9977 13.4011 12.0924C13.1469 12.1914 12.9222 12.3787 12.4727 12.7532C12.0254 13.126 11.8017 13.3124 11.5284 13.4122C11.286 13.5007 10.9657 13.5336 10.7105 13.4959C10.4226 13.4535 10.2022 13.3358 9.76129 13.1001C8.38962 12.3671 7.63318 11.6107 6.90013 10.2389C6.66453 9.79808 6.54673 9.57758 6.5043 9.28975C6.46669 9.0345 6.49948 8.71417 6.58799 8.47192C6.68784 8.19857 6.87425 7.97488 7.24707 7.5275C7.62159 7.07807 7.80886 6.85335 7.90787 6.59909C8.00262 6.35578 8.03909 6.09367 8.01437 5.83373C7.98853 5.5621 7.86972 5.2948 7.63212 4.76019Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const TagsIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.048 7.11369L14.2147 6.60236C13.3791 6.08966 12.9613 5.83331 12.4997 5.83331C12.038 5.83331 11.6203 6.08966 10.7847 6.60236L9.95134 7.11369C9.16092 7.59871 8.76567 7.84122 8.54934 8.23196C8.33301 8.62273 8.33301 9.09406 8.33301 10.0368V14.9245C8.33301 16.5314 8.33301 17.3349 8.82117 17.8341C9.30934 18.3333 10.095 18.3333 11.6663 18.3333H13.333C14.9043 18.3333 15.69 18.3333 16.1782 17.8341C16.6663 17.3349 16.6663 16.5314 16.6663 14.9245V10.0368C16.6663 9.09406 16.6663 8.62273 16.45 8.23196C16.2337 7.84122 15.8384 7.59871 15.048 7.11369Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6663 5.92341C11.134 5.41258 10.8156 5.14404 10.4142 5.04315C9.94751 4.92585 9.45726 5.0574 8.47676 5.3205L7.49891 5.58289C6.57136 5.83178 6.10758 5.95623 5.7854 6.26358C5.46321 6.57094 5.33836 7.00801 5.08867 7.88214L3.79407 12.4142C3.36843 13.9043 3.15561 14.6493 3.51687 15.2363C3.82748 15.741 5.06926 16.3616 6.24968 16.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0786 8.33335C12.7797 7.86717 13.402 7.11911 13.7887 6.18879C14.587 4.26804 14.0783 2.29772 12.6527 1.78797C11.2269 1.27821 9.42392 2.42205 8.62567 4.34281C8.49217 4.66391 8.39526 4.9864 8.33301 5.30321"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ClinicianIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.6663 18.3335V15.8335C16.6663 13.4765 16.6663 12.298 15.9341 11.5657C15.2018 10.8335 14.0233 10.8335 11.6663 10.8335L9.99967 12.5002L8.33301 10.8335C5.97598 10.8335 4.79747 10.8335 4.06524 11.5657C3.33301 12.298 3.33301 13.4765 3.33301 15.8335V18.3335"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9163 5.41675V4.58341C12.9163 2.97259 11.6105 1.66675 9.99967 1.66675C8.38884 1.66675 7.08301 2.97259 7.08301 4.58341V5.41675C7.08301 7.02758 8.38884 8.3334 9.99967 8.3334C11.6105 8.3334 12.9163 7.02758 12.9163 5.41675Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.333 13.3334V15.8334M14.583 14.5834H12.083"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChargeTickIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.16699 16.6666H8.75033C5.61818 16.6666 4.0521 16.6666 3.00654 15.8409C2.83931 15.7088 2.68465 15.5633 2.54433 15.4059C1.66699 14.4218 1.66699 12.9479 1.66699 9.99998C1.66699 7.05208 1.66699 5.57812 2.54433 4.59406C2.68465 4.43667 2.83931 4.2911 3.00654 4.15904C4.0521 3.33331 5.61818 3.33331 8.75033 3.33331H11.2503C14.3825 3.33331 15.9486 3.33331 16.9941 4.15904C17.1613 4.2911 17.316 4.43667 17.4563 4.59406C18.2467 5.48068 18.3251 6.76497 18.3328 9.16665"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.66699 7.5H18.3337" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path
        d="M11.667 15C11.667 15 12.5003 15 13.3337 16.6667C13.3337 16.6667 15.9807 12.5 18.3337 11.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProfileCardIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.5 8.33301C12.5 6.9523 11.3807 5.83301 10 5.83301C8.61925 5.83301 7.5 6.9523 7.5 8.33301C7.5 9.71376 8.61925 10.833 10 10.833C11.3807 10.833 12.5 9.71376 12.5 8.33301Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1663 14.9997C14.1663 12.6985 12.3008 10.833 9.99967 10.833C7.69849 10.833 5.83301 12.6985 5.83301 14.9997"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 10.8333V9.16667C17.5 6.02397 17.5 4.45262 16.5237 3.47631C15.5474 2.5 13.976 2.5 10.8333 2.5H9.16667C6.02397 2.5 4.45262 2.5 3.47631 3.47631C2.5 4.45262 2.5 6.02397 2.5 9.16667V10.8333C2.5 13.976 2.5 15.5474 3.47631 16.5237C4.45262 17.5 6.02397 17.5 9.16667 17.5H10.8333C13.976 17.5 15.5474 17.5 16.5237 16.5237C17.5 15.5474 17.5 13.976 17.5 10.8333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SelectArrowIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.8327 12.5L9.99935 6.66667L4.16602 12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PharmacyIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.6663 1.66669V3.7486M11.6663 3.7486V5.83335M11.6663 3.7486H8.33301M8.33301 3.7486V1.66669M8.33301 3.7486V5.83335"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83301 4.16669H4.99967C4.0792 4.16669 3.33301 4.91288 3.33301 5.83335V18.3334M14.1663 4.16669H14.9997C15.9202 4.16669 16.6663 4.91288 16.6663 5.83335V18.3334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 9.16669H13.3337M11.667 11.6667H13.3337M6.66699 11.6667H8.33366M6.66699 9.16669H8.33366"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.08301 18.3333H7.91634V15.8333C7.91634 15.3731 8.28944 15 8.74968 15H11.2497C11.7099 15 12.083 15.3731 12.083 15.8333V18.3333H17.9163"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AppointmentsIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16 2V6M8 2V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M21 13V12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3 10H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M17.5 18.5C16.3954 18.5 15.5 17.6046 15.5 16.5C15.5 15.3954 16.3954 14.5 17.5 14.5C18.6046 14.5 19.5 15.3954 19.5 16.5C19.5 17.6046 18.6046 18.5 17.5 18.5ZM17.5 18.5C19.433 18.5 21 20.067 21 22M17.5 18.5C15.567 18.5 14 20.067 14 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TimeRemainIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.6665 2H13.3332"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.6665 2V3.35359C3.6665 4.18151 4.05105 4.96247 4.70728 5.46726L7.99984 8L11.2924 5.46726C11.9486 4.96247 12.3332 4.18151 12.3332 3.35359V2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.6665 14V12.6464C3.6665 11.8185 4.05105 11.0375 4.70728 10.5327L7.99984 8L11.2924 10.5327C11.9486 11.0375 12.3332 11.8185 12.3332 12.6464V14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.6665 14H13.3332"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FollowUpIcon = (props) => {
  return (
    <svg
      width={props?.size || '24'}
      height={props?.size || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.5 13V9.36842C19.5 5.89491 19.5 4.15816 18.4749 3.07908C17.4497 2 15.7998 2 12.5 2H9.5C6.20017 2 4.55025 2 3.52513 3.07908C2.5 4.15816 2.5 5.89491 2.5 9.36842V14.6316C2.5 18.1051 2.5 19.8418 3.52513 20.9209C4.55025 22 6.20017 22 9.5 22H11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 2L7.0822 2.4932C7.28174 3.69044 7.38151 4.28906 7.80113 4.64453C8.22075 5 8.82762 5 10.0414 5H11.9586C13.1724 5 13.7793 5 14.1989 4.64453C14.6185 4.28906 14.7183 3.69044 14.9178 2.4932L15 2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M7 16H11M7 11H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M17 23C19.2091 23 21 21.2091 21 19C21 16.7909 19.2091 15 17 15C14.7909 15 13 16.7909 13 19C13 21.2091 14.7909 23 17 23Z"
        stroke="currentColor"
        strokeWidth="1.3"
      />
      <path
        d="M17 17.3999V18.9999L17.8 19.7999"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TickPersonIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.6693 7.08317C11.6693 4.78199 9.80377 2.9165 7.5026 2.9165C5.20142 2.9165 3.33594 4.78199 3.33594 7.08317C3.33594 9.38434 5.20142 11.2498 7.5026 11.2498C9.80377 11.2498 11.6693 9.38434 11.6693 7.08317Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3307 17.0833C13.3307 13.8617 10.7191 11.25 7.4974 11.25C4.27574 11.25 1.66406 13.8617 1.66406 17.0833"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3359 10.3274C13.3359 10.3274 14.3359 10.8706 14.8359 11.6667C14.8359 11.6667 16.3359 8.54167 18.3359 7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalenderDueIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.3307 1.6665V4.99984M6.66406 1.6665V4.99984"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8333 3.3335H9.16667C6.02397 3.3335 4.45262 3.3335 3.47631 4.3098C2.5 5.28612 2.5 6.85746 2.5 10.0002V11.6668C2.5 14.8095 2.5 16.3809 3.47631 17.3572C4.45262 18.3335 6.02397 18.3335 9.16667 18.3335H10.8333C13.976 18.3335 15.5474 18.3335 16.5237 17.3572C17.5 16.3809 17.5 14.8095 17.5 11.6668V10.0002C17.5 6.85746 17.5 5.28612 16.5237 4.3098C15.5474 3.3335 13.976 3.3335 10.8333 3.3335Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2.5 8.3335H17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.5 13.3335H7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ViewIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.3653 7.36331C14.5679 7.64751 14.6693 7.78965 14.6693 7.99998C14.6693 8.21031 14.5679 8.35245 14.3653 8.63665C13.4545 9.91371 11.1287 12.6666 8.0026 12.6666C4.87646 12.6666 2.55067 9.91371 1.63996 8.63665C1.43728 8.35245 1.33594 8.21031 1.33594 7.99998C1.33594 7.78965 1.43728 7.64751 1.63996 7.36331C2.55067 6.08627 4.87646 3.33331 8.0026 3.33331C11.1287 3.33331 13.4545 6.08627 14.3653 7.36331Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M10 8C10 6.8954 9.1046 6 8 6C6.8954 6 6 6.8954 6 8C6 9.1046 6.8954 10 8 10C9.1046 10 10 9.1046 10 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const ChevronDownCollapse = (props) => (
  <svg
    width={props?.width ?? '28'}
    height={props?.height ?? '28'}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={props?.width ?? '28'} height={props?.height ?? '28'} rx="14" fill="#E7F2F3" />
    <path
      d="M18.6654 16L13.9987 11.3333L9.33203 16"
      stroke="#077882"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RolesIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.6654 7.08317C11.6654 8.00361 10.9192 8.74984 9.9987 8.74984C9.0782 8.74984 8.33203 8.00361 8.33203 7.08317C8.33203 6.1627 9.0782 5.4165 9.9987 5.4165C10.9192 5.4165 11.6654 6.1627 11.6654 7.08317Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99299 11.3737C7.46901 11.6808 6.09514 12.3079 6.93192 13.0927C7.34067 13.476 7.79592 13.7502 8.3683 13.7502H11.6343C12.2066 13.7502 12.662 13.476 13.0707 13.0927C13.9075 12.3079 12.5336 11.6808 12.0096 11.3737C10.7809 10.6534 9.22172 10.6534 7.99299 11.3737Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 9.31925V6.90008C17.5 5.53341 17.5 4.85007 17.1632 4.40425C16.8265 3.95841 16.0651 3.74197 14.5423 3.30909C13.5018 3.01334 12.5847 2.65703 11.8519 2.33175C10.8528 1.88825 10.3533 1.6665 10 1.6665C9.64667 1.6665 9.14717 1.88825 8.14809 2.33175C7.41532 2.65703 6.4982 3.01333 5.45778 3.30909C3.93494 3.74197 3.17352 3.95841 2.83676 4.40425C2.5 4.85007 2.5 5.53341 2.5 6.90008V9.31925C2.5 14.0069 6.71897 16.8194 8.82833 17.9327C9.33425 18.1997 9.58717 18.3332 10 18.3332C10.4128 18.3332 10.6657 18.1997 11.1717 17.9327C13.281 16.8194 17.5 14.0069 17.5 9.31925Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LightThemeIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 2V5.33333M12 22V18.6667M22 12H18.6667M2 12H5.33333M19.0713 19.0713L16.714 16.714M4.92916 4.92916L7.28596 7.28596M4.92871 19.0713L7.28596 16.714M19.0709 4.92916L16.714 7.28596"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </svg>
  );
};

export const DarkThemeIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22 12.9009C21.8249 14.7962 21.1135 16.6025 19.9492 18.1084C18.785 19.6142 17.216 20.7574 15.4257 21.404C13.6355 22.0506 11.6981 22.174 9.84031 21.7597C7.9825 21.3455 6.28109 20.4107 4.93516 19.0649C3.58923 17.7189 2.65445 16.0175 2.2402 14.1596C1.82595 12.3019 1.94938 10.3645 2.59601 8.57427C3.24266 6.78405 4.38578 5.215 5.89163 4.05074C7.39746 2.88647 9.20374 2.17515 11.0991 2C9.98942 3.50126 9.45544 5.35094 9.59428 7.21262C9.7331 9.07431 10.5355 10.8243 11.8556 12.1444C13.1756 13.4645 14.9256 14.2669 16.7874 14.4057C18.649 14.5445 20.4987 14.0106 22 12.9009Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AttachmentIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.21895 6.78105C8.17755 5.73965 6.48911 5.73965 5.44772 6.78105L2.78105 9.44772C1.73965 10.4891 1.73965 12.1776 2.78105 13.219C3.82245 14.2603 5.51089 14.2603 6.55228 13.219L7.28666 12.4846M6.78105 9.21895C7.82245 10.2603 9.51089 10.2604 10.5523 9.21895L13.219 6.55228C14.2603 5.51089 14.2603 3.82245 13.219 2.78105C12.1776 1.73965 10.4891 1.73965 9.44772 2.78105L8.71464 3.51412"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AddAttachmentIcon = (props) => (
  <svg width={36} height={36} viewBox={`0 0 36 36`} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6 18.0005V21.8166C6 26.6841 6 29.118 7.3291 30.7664C7.59762 31.0994 7.90096 31.4028 8.23399 31.6713C9.88246 33.0005 12.3162 33.0005 17.1837 33.0005C18.2421 33.0005 18.7712 33.0005 19.2558 32.8295C19.3566 32.7938 19.4553 32.753 19.5518 32.7068C20.0154 32.4851 20.3895 32.111 21.1378 31.3626L28.2426 24.2577C29.1097 23.3907 29.5432 22.9571 29.7717 22.4058C30 21.8546 30 21.2414 30 20.0151V15.0005C30 9.34353 30 6.51512 28.2426 4.75775C26.6539 3.16901 24.1898 3.01658 19.5518 3.00195M19.5 32.2505V31.5005C19.5 27.2577 19.5 25.1364 20.8181 23.8184C22.1361 22.5005 24.2574 22.5005 28.5 22.5005H29.25"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M18 9H6M12 3V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const LabWorkIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.5834 17.5C12.9726 17.5 11.6667 16.1942 11.6667 14.5833V2.5H17.5001V14.5833C17.5001 16.1942 16.1942 17.5 14.5834 17.5Z"
        stroke="currentColor"
        strokeWidth={props?.strokeWidth ?? '1.5'}
      />
      <path
        d="M18.3333 2.5H10.8333"
        stroke="currentColor"
        strokeWidth={props?.strokeWidth ?? '1.5'}
        strokeLinecap="round"
      />
      <path
        d="M14.1667 5.83398H11.6667"
        stroke="currentColor"
        strokeWidth={props?.strokeWidth ?? '1.5'}
        strokeLinecap="round"
      />
      <path
        d="M8.33341 14.0632C8.33341 16.5945 6.66675 17.5007 5.00008 17.5007C3.33341 17.5007 1.66675 16.5945 1.66675 14.0632C1.66675 11.5318 5.00008 8.33398 5.00008 8.33398C5.00008 8.33398 8.33341 11.5318 8.33341 14.0632Z"
        stroke="currentColor"
        strokeWidth={props?.strokeWidth ?? '1.5'}
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 10.0007C12.5692 9.27865 13.5812 8.23268 14.8092 8.96948C15.8346 9.58473 16.6952 8.93765 17.5001 8.33398"
        stroke="currentColor"
        strokeWidth={props?.strokeWidth ?? '1.5'}
        strokeLinecap="round"
      />
    </svg>
  );
};

export const MicroscopeIcon = (props) => {
  return (
    <svg
      width={props?.width ?? '32'}
      height={props?.height ?? '32'}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.33398 28.667H26.6673"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.666 12.667C16.666 13.7715 15.7705 14.667 14.666 14.667C13.5615 14.667 12.666 13.7715 12.666 12.667C12.666 11.5624 13.5615 10.667 14.666 10.667C15.7705 10.667 16.666 11.5624 16.666 12.667Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9993 24.667H16.666M12.666 12.667C9.35231 12.667 6.66602 15.3533 6.66602 18.667C6.66602 21.9807 9.35231 24.667 12.666 24.667H13.3327"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 28.667L16.3039 23.5787C16.1224 23.0342 15.6129 22.667 15.0389 22.667H14.9611C14.3871 22.667 13.8776 23.0342 13.6961 23.5787L12 28.667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0697 20.6663L24 18.9706M13.8479 10.8411L12.4539 8.42096C11.5195 6.79879 12.074 4.72453 13.6924 3.78796C15.3107 2.8514 17.38 3.4072 18.3144 5.02937L22.3745 12.0787C23.0071 13.1767 23.3233 13.7258 23.3233 14.271C23.3233 14.6282 23.2295 14.9791 23.0513 15.2885C22.7793 15.7607 22.2316 16.0777 21.1361 16.7117C20.0407 17.3457 19.4929 17.6626 18.9489 17.6626C18.5927 17.6626 18.2425 17.5686 17.9339 17.3899C17.4628 17.1174 17.1465 16.5683 16.5141 15.4702L15.8344 14.2902"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BeakerIcon = (props) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.9633 2.33301V5.2336C16.9633 7.27287 16.9633 8.29251 17.2129 9.27135C17.4626 10.2502 17.9519 11.149 18.9305 12.9465L20.2565 15.3824C22.7503 19.9631 23.9972 22.2535 22.9743 23.9513L22.9584 23.9772C21.9205 25.6663 19.2801 25.6663 13.9993 25.6663C8.71851 25.6663 6.0781 25.6663 5.04028 23.9772L5.02447 23.9513C4.00154 22.2535 5.24839 19.9631 7.74212 15.3824L9.0682 12.9465C10.0468 11.149 10.5361 10.2502 10.7857 9.27135C11.0354 8.29251 11.0354 7.27287 11.0354 5.2336V2.33301"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M10.5 18.6684L10.5087 18.666"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 21.0024L17.5087 21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33398 2.33301H18.6673"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 13.4819C9.91667 12.1363 11.7826 13.1063 14 14.3708C16.9167 16.0341 18.6667 14.7579 19.25 13.5507"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const DownloadFileIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.99935 12.0833V3.75M9.99935 12.0833C9.41585 12.0833 8.32562 10.4214 7.91602 10M9.99935 12.0833C10.5828 12.0833 11.6731 10.4214 12.0827 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6673 13.75C16.6673 15.8183 16.2356 16.25 14.1673 16.25H5.83398C3.76565 16.25 3.33398 15.8183 3.33398 13.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TimeFlaskIcon = (props) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14 14L9.72711 10.4393C9.09226 9.91022 8.77484 9.6457 8.54664 9.32144C8.34444 9.03413 8.19429 8.71354 8.10301 8.37428C8 7.99139 8 7.57819 8 6.7518V4M14 14L18.2729 10.4393C18.9077 9.91022 19.2252 9.6457 19.4534 9.32144C19.6556 9.03413 19.8057 8.71354 19.897 8.37428C20 7.99139 20 7.57819 20 6.7518V4M14 14L9.72711 17.5607C9.09226 18.0898 8.77484 18.3543 8.54664 18.6786C8.34444 18.9659 8.19429 19.2865 8.10301 19.6257C8 20.0086 8 20.4218 8 21.2482V24M14 14L18.2729 17.5607C18.9077 18.0898 19.2252 18.3543 19.4534 18.6786C19.6556 18.9659 19.8057 19.2865 19.897 19.6257C20 20.0086 20 20.4218 20 21.2482V24M6 4H22M6 24H22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalenderCheckIcon = (props) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.6663 2.33301V6.99967M9.33301 2.33301V6.99967"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1667 4.66699H12.8333C8.43355 4.66699 6.23367 4.66699 4.86683 6.03382C3.5 7.40067 3.5 9.60055 3.5 14.0003V16.3337C3.5 20.7334 3.5 22.9334 4.86683 24.3001C6.23367 25.667 8.43355 25.667 12.8333 25.667H15.1667C19.5664 25.667 21.7664 25.667 23.1331 24.3001C24.5 22.9334 24.5 20.7334 24.5 16.3337V14.0003C24.5 9.60055 24.5 7.40067 23.1331 6.03382C21.7664 4.66699 19.5664 4.66699 15.1667 4.66699Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3.5 11.667H24.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M10.5 19.25C10.5 19.25 12.25 19.8333 12.8333 21.5833C12.8333 21.5833 15.3726 16.9167 18.6667 15.75"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LocationIcon = (props) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.5837 7.50033C12.5837 8.65091 11.6509 9.58366 10.5003 9.58366C9.34974 9.58366 8.41699 8.65091 8.41699 7.50033C8.41699 6.34973 9.34974 5.41699 10.5003 5.41699C11.6509 5.41699 12.5837 6.34973 12.5837 7.50033Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M11.5482 14.5783C11.2671 14.849 10.8914 15.0003 10.5005 15.0003C10.1095 15.0003 9.73383 14.849 9.45274 14.5783C6.87891 12.0843 3.42965 9.29824 5.11175 5.25343C6.02124 3.06643 8.20444 1.66699 10.5005 1.66699C12.7965 1.66699 14.9797 3.06643 15.8892 5.25343C17.5692 9.29316 14.1283 12.0929 11.5482 14.5783Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M15.5 16.667C15.5 17.5875 13.2614 18.3337 10.5 18.3337C7.73857 18.3337 5.5 17.5875 5.5 16.667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const UserCalenderIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.3337 1.66699V5.00032M6.66699 1.66699V5.00032"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8333 3.33301H9.16667C6.02397 3.33301 4.45262 3.33301 3.47631 4.30932C2.5 5.28563 2.5 6.85697 2.5 9.99967V11.6663C2.5 14.809 2.5 16.3804 3.47631 17.3567C4.45262 18.333 6.02397 18.333 9.16667 18.333H10.8333C13.976 18.333 15.5474 18.333 16.5237 17.3567C17.5 16.3804 17.5 14.809 17.5 11.6663V9.99967C17.5 6.85697 17.5 5.28563 16.5237 4.30932C15.5474 3.33301 13.976 3.33301 10.8333 3.33301Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 8.33301H17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99657 11.667H10.0041M9.99657 15.0003H10.0041M13.3262 11.667H13.3337M6.66699 11.667H6.67447M6.66699 15.0003H6.67447"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClockFourIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_6884_25290)">
        <path
          d="M10.0003 18.3337C14.6027 18.3337 18.3337 14.6027 18.3337 10.0003C18.3337 5.39795 14.6027 1.66699 10.0003 1.66699C5.39795 1.66699 1.66699 5.39795 1.66699 10.0003C1.66699 14.6027 5.39795 18.3337 10.0003 18.3337Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M10 6.66699V10.0003L11.6667 11.667"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6884_25290">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LocationEditIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.3481 17.8057C10.9867 18.144 10.5037 18.3332 10.0009 18.3332C9.49817 18.3332 9.01517 18.144 8.65375 17.8057C5.34418 14.6882 0.908967 11.2056 3.07189 6.14955C4.24136 3.4158 7.04862 1.6665 10.0009 1.6665C12.9532 1.6665 15.7605 3.4158 16.93 6.14955C19.0902 11.1993 14.6658 14.6989 11.3481 17.8057Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M7 11.1201V12H7.88005C8.18702 12 8.34055 12 8.47863 11.9428C8.61663 11.8856 8.72522 11.7771 8.94227 11.5601L12.56 7.94205C12.7648 7.7373 12.8672 7.63492 12.9219 7.52452C13.026 7.31437 13.026 7.0677 12.9219 6.85755C12.8672 6.74707 12.7648 6.6447 12.56 6.43995C12.3552 6.2352 12.2529 6.13282 12.1424 6.07807C11.9322 5.97398 11.6855 5.97398 11.4753 6.07807C11.3648 6.13282 11.2625 6.2352 11.0577 6.43995L7.44003 10.058C7.2229 10.275 7.11437 10.3835 7.05715 10.5215C7 10.6596 7 10.813 7 11.1201Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalenderTimerIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.3346 1.66675V5.00008M6.66797 1.66675V5.00008"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 11.6666V9.99992C17.5 6.85722 17.5 5.28588 16.5237 4.30956C15.5474 3.33325 13.976 3.33325 10.8333 3.33325H9.16667C6.02397 3.33325 4.45262 3.33325 3.47631 4.30956C2.5 5.28588 2.5 6.85722 2.5 9.99992V11.6666C2.5 14.8093 2.5 16.3807 3.47631 17.3569C4.45262 18.3333 6.02397 18.3333 9.16667 18.3333H10"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 8.33325H17.5"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5846 18.3333C16.1955 18.3333 17.5013 17.0275 17.5013 15.4167C17.5013 13.8058 16.1955 12.5 14.5846 12.5C12.9738 12.5 11.668 13.8058 11.668 15.4167C11.668 17.0275 12.9738 18.3333 14.5846 18.3333Z"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '1.3'}
      />
      <path
        d="M14.5859 14.25V15.4167L15.1693 16"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '1.3'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChargeCrossIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.5 20H10.5C6.74142 20 4.86213 20 3.60746 19.0091C3.40678 18.8506 3.22119 18.676 3.0528 18.4871C2 17.3062 2 15.5375 2 12C2 8.46252 2 6.69377 3.0528 5.5129C3.22119 5.32403 3.40678 5.14935 3.60746 4.99087C4.86213 4 6.74142 4 10.5 4H13.5C17.2586 4 19.1379 4 20.3925 4.99087C20.5932 5.14935 20.7788 5.32403 20.9472 5.5129C21.8394 6.51358 21.9755 7.93642 21.9963 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0251 18.9744L20.9749 14.0247M16.0251 14.0247L20.9749 18.9744"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M2 9H22" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
};

export const AddressIcon = (props) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M27.2354 42.734C26.3682 43.546 25.2088 44 24.0022 44C22.7956 44 21.6364 43.546 20.769 42.734C12.826 35.252 2.18152 26.8938 7.37254 14.7593C10.1793 8.19832 16.9167 4 24.0022 4C31.0878 4 37.8252 8.19832 40.632 14.7593C45.8164 26.8786 35.198 35.2778 27.2354 42.734Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M31 22C31 25.866 27.866 29 24 29C20.134 29 17 25.866 17 22C17 18.134 20.134 15 24 15C27.866 15 31 18.134 31 22Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export const UserCardIcon = (props) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M28 18H36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M28 25H34" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M34 6H14C8.47715 6 4 10.4772 4 16V32C4 37.5228 8.47715 42 14 42H34C39.5228 42 44 37.5228 44 32V16C44 10.4772 39.5228 6 34 6Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M10 32C12.4166 26.8378 21.4244 26.4982 24 32"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 17.9995C21 20.2086 19.2091 21.9996 17 21.9996C14.7909 21.9996 13 20.2086 13 17.9995C13 15.7904 14.7909 13.9995 17 13.9995C19.2091 13.9995 21 15.7904 21 17.9995Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export const WeightIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.94476 17.3636H16.0552C16.1514 17.3636 16.234 17.3235 16.3028 17.2431C16.3716 17.1625 16.3992 17.0734 16.3854 16.9755L14.9494 6.73791C14.9357 6.65391 14.8978 6.58564 14.836 6.53309C14.7741 6.48073 14.7019 6.45455 14.6193 6.45455H5.38073C5.29812 6.45455 5.22588 6.48073 5.16402 6.53309C5.10215 6.58564 5.06433 6.65391 5.05057 6.73791L3.6146 16.9755C3.60084 17.0734 3.62837 17.1625 3.69721 17.2431C3.76605 17.3235 3.84857 17.3636 3.94476 17.3636ZM10 4.81818C10.304 4.81818 10.5588 4.71364 10.7644 4.50455C10.97 4.29545 11.0728 4.03636 11.0728 3.72727C11.0728 3.41818 10.97 3.15909 10.7644 2.95C10.5588 2.74091 10.304 2.63636 10 2.63636C9.69604 2.63636 9.44124 2.74091 9.23562 2.95C9.03 3.15909 8.92719 3.41818 8.92719 3.72727C8.92719 4.03636 9.03 4.29545 9.23562 4.50455C9.44124 4.71364 9.69604 4.81818 10 4.81818ZM12.4323 4.81818H14.6295C15.1178 4.81818 15.5398 4.98082 15.8954 5.30609C16.2508 5.63118 16.4664 6.03636 16.542 6.52164L17.978 16.7595C18.0606 17.351 17.9107 17.8723 17.5282 18.3234C17.1459 18.7745 16.6549 19 16.0552 19H3.94476C3.34506 19 2.85407 18.7745 2.47179 18.3234C2.08933 17.8723 1.9394 17.351 2.02201 16.7595L3.45797 6.52164C3.53361 6.03636 3.74915 5.63118 4.10461 5.30609C4.46025 4.98082 4.88222 4.81818 5.37053 4.81818H7.56766C7.49346 4.65036 7.43329 4.47664 7.38716 4.297C7.34103 4.11718 7.31796 3.92727 7.31796 3.72727C7.31796 2.96509 7.57758 2.32 8.09683 1.792C8.61607 1.264 9.25046 1 10 1C10.7495 1 11.3839 1.264 11.9032 1.792C12.4224 2.32 12.682 2.96509 12.682 3.72727C12.682 3.92727 12.659 4.11718 12.6128 4.297C12.5667 4.47664 12.5065 4.65036 12.4323 4.81818Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const HeightIcon = (props) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_8251_25144" maskUnits="userSpaceOnUse" x="2" y="1" width="17" height="18">
        <path d="M18.167 17.834V2.16699H2.5V17.834H18.167Z" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_8251_25144)">
        <path
          d="M17.4922 17.8457H13.5859V2.1556H17.4922V17.8457Z"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M13.5859 4.14062H14.5625"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5859 6.09375H15.2135"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5859 8.04688H14.5625"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5859 10H15.2135"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5859 11.9531H14.5625"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5859 13.9062H15.2135"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5859 15.8594H14.5625"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask id="mask1_8251_25144" maskUnits="userSpaceOnUse" x="2" y="1" width="17" height="18">
        <path d="M18.167 17.834V2.16699H2.5V17.834H18.167Z" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask1_8251_25144)">
        <path
          d="M5.45312 3.78255C5.45312 2.88366 6.18184 2.15495 7.08073 2.15495C7.97962 2.15495 8.70833 2.88366 8.70833 3.78255C8.70833 4.68145 7.97962 5.41016 7.08073 5.41016C6.18184 5.41016 5.45312 4.68145 5.45312 3.78255Z"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.07813 16.8691C7.07813 17.4085 6.64089 17.8457 6.10156 17.8457C5.56224 17.8457 5.125 17.4085 5.125 16.8691V8.08008V10.6842C5.125 11.2236 4.68776 11.6608 4.14844 11.6608C3.60911 11.6608 3.17188 11.2236 3.17188 10.6842V7.36393C3.17188 6.28526 4.04632 5.41081 5.125 5.41081H9.03125C10.1099 5.41081 10.9844 6.28526 10.9844 7.36393V10.6842C10.9844 11.2236 10.5471 11.6608 10.0078 11.6608C9.46849 11.6608 9.03125 11.2236 9.03125 10.6842V8.08008V16.8691C9.03125 17.4085 8.59401 17.8457 8.05469 17.8457C7.51536 17.8457 7.07813 17.4085 7.07813 16.8691ZM7.07813 16.8691V12.9629"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9844 2.15625H13.5885"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const IdealWeightIcon = (props) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.1988 1H4.12928C2.75971 1 1.66406 2.09565 1.66406 3.46522V16.5739C1.66406 17.9043 2.75971 19 4.12928 19H17.238C18.6075 19 19.7032 17.9043 19.7032 16.5348V3.46522C19.6641 2.09565 18.5684 1 17.1988 1ZM18.8815 16.5348C18.8815 17.4348 18.138 18.2174 17.1988 18.2174H4.12928C3.19015 18.2174 2.44667 17.4739 2.44667 16.5348V3.46522C2.44667 2.52609 3.19015 1.78261 4.12928 1.78261H17.238C18.138 1.78261 18.8815 2.52609 18.8815 3.46522V16.5348Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        d="M16.1036 5.44241C12.6992 3.17284 8.62967 3.17284 5.22532 5.44241C5.0688 5.5598 5.02967 5.75545 5.0688 5.91197L6.90793 10.2946C6.94706 10.412 7.02532 10.4902 7.14271 10.5294H7.26011C7.33837 10.5294 7.41663 10.4902 7.49489 10.4511C9.49054 9.12067 11.8775 9.12067 13.8731 10.4511C13.9514 10.5294 14.1079 10.5294 14.1862 10.4902C14.3036 10.4511 14.3818 10.3728 14.421 10.2555L16.2601 5.91197C16.3384 5.75545 16.2601 5.5598 16.1036 5.44241ZM13.8731 9.5511C12.9731 9.04241 11.9949 8.72937 11.0558 8.69024V5.71632C11.0558 5.48154 10.8992 5.32502 10.6645 5.32502C10.4297 5.32502 10.2731 5.48154 10.2731 5.71632V8.69024C9.29489 8.7685 8.35576 9.04241 7.45576 9.5511L5.92967 5.91197C8.90358 4.03371 12.4253 4.03371 15.3992 5.91197L13.8731 9.5511Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export const CouponsIcon = (props) => {
  return (
    <svg
      width={props?.size ?? '24'}
      height={props?.size ?? '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.46432 9.34375C2.21578 9.34375 1.98898 9.14229 2.00041 8.87895C2.06732 7.33687 2.2548 6.33298 2.78007 5.53884C3.08227 5.08196 3.45764 4.68459 3.88922 4.36468C5.05574 3.5 6.70138 3.5 9.99265 3.5H14.0073C17.2986 3.5 18.9442 3.5 20.1108 4.36468C20.5423 4.68459 20.9177 5.08196 21.2199 5.53884C21.7451 6.33289 21.9326 7.33665 21.9995 8.87843C22.011 9.14208 21.7839 9.34375 21.5351 9.34375C20.1493 9.34375 19.0259 10.533 19.0259 12C19.0259 13.467 20.1493 14.6562 21.5351 14.6562C21.7839 14.6562 22.011 14.8579 21.9995 15.1216C21.9326 16.6634 21.7451 17.6671 21.2199 18.4612C20.9177 18.918 20.5423 19.3154 20.1108 19.6353C18.9442 20.5 17.2986 20.5 14.0073 20.5H9.99265C6.70138 20.5 5.05574 20.5 3.88922 19.6353C3.45764 19.3154 3.08227 18.918 2.78007 18.4612C2.2548 17.667 2.06732 16.6631 2.00041 15.1211C1.98898 14.8577 2.21578 14.6562 2.46432 14.6562C3.85011 14.6562 4.97351 13.467 4.97351 12C4.97351 10.533 3.85011 9.34375 2.46432 9.34375Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 14.5L14.5 9.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 9.5H9.51123M14.4887 14.5H14.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PatientRecordIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M15.833 10V6.667c0-2.357 0-3.536-.732-4.268-.732-.732-1.91-.732-4.268-.732H7.5c-2.357 0-3.536 0-4.268.732C2.5 3.131 2.5 4.31 2.5 6.667v6.667c0 2.357 0 3.535.732 4.268.732.732 1.911.732 4.268.732h1.667"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12.083 1.667H6.25c0 1.178 0 1.768.366 2.134.366.366.955.366 2.134.366h.833c1.179 0 1.768 0 2.134-.366.366-.366.366-.956.366-2.134ZM5.836 12.5h3.333M5.836 9.167h6.667M15.39 15.918l-1.057-.585V13.89m3.334 1.444a3.334 3.334 0 1 1-6.667 0 3.334 3.334 0 0 1 6.667 0Z"
      />
    </svg>
  );
};

export const ProductIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.size ?? 21}
    height={props?.size ?? 20}
    viewBox="0 0 21 20"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#096DD9'}
      d="M10.503 10.209c-.367 0-.734-.092-1.067-.267L4.01 7.017a1.553 1.553 0 0 1-.8-1.375c0-.583.308-1.108.8-1.375l5.425-2.925a2.235 2.235 0 0 1 2.125 0l5.425 2.925c.492.267.8.792.8 1.375s-.308 1.108-.8 1.375L11.56 9.942a2.148 2.148 0 0 1-1.058.267Zm0-7.892a.988.988 0 0 0-.475.125L4.61 5.359c-.142.075-.15.233-.15.283 0 .05.008.208.15.275l5.425 2.925c.3.158.642.158.942 0l5.425-2.925c.133-.075.15-.233.15-.275 0-.05-.009-.208-.15-.275l-5.425-2.925a.988.988 0 0 0-.475-.125ZM8.647 18.934c-.233 0-.475-.059-.691-.167l-5.05-2.517a2.474 2.474 0 0 1-1.367-2.216V9.267a1.545 1.545 0 0 1 2.242-1.383L8.83 10.4a2.465 2.465 0 0 1 1.366 2.217v4.767c0 .541-.275 1.033-.733 1.317a1.52 1.52 0 0 1-.817.233ZM3.09 8.967a.362.362 0 0 0-.158.042.298.298 0 0 0-.142.258v4.767c0 .466.258.891.675 1.1l5.042 2.525a.308.308 0 0 0 .291-.008.298.298 0 0 0 .142-.259v-4.766c0-.467-.258-.892-.675-1.1L3.222 9a.286.286 0 0 0-.133-.033ZM12.347 18.933a1.52 1.52 0 0 1-.817-.233 1.538 1.538 0 0 1-.733-1.317v-4.766c0-.942.525-1.792 1.367-2.217l5.041-2.525a1.544 1.544 0 0 1 1.509.067c.458.283.733.775.733 1.316v4.767c0 .942-.525 1.792-1.367 2.217l-5.041 2.525a1.46 1.46 0 0 1-.692.166Zm5.558-9.966a.286.286 0 0 0-.133.033l-5.042 2.525a1.215 1.215 0 0 0-.675 1.1v4.767c0 .15.092.225.142.258.05.033.158.075.292.008l5.041-2.525c.417-.208.675-.633.675-1.1V9.267a.298.298 0 0 0-.141-.259.362.362 0 0 0-.159-.041Z"
    />
  </svg>
);

export const FillTickIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke="#24A147"
      strokeWidth={1.5}
      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10Z"
    />
    <path stroke="#24A147" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m8 12.5 2.5 2.5L16 9" />
  </svg>
);

export const TimePendingIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke="#434343"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2c4.478 0 8.226 2.943 9.5 7H19"
    />
    <path
      stroke="#434343"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 8v4l2 2M21.955 13c.03-.33.045-.663.045-1m-7 10a9.654 9.654 0 0 0 1-.392M20.79 17c.194-.372.366-.757.515-1.154m-3.113 4.383c.345-.285.671-.593.977-.922"
    />
  </svg>
);

export const NeutralIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke="#096DD9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10ZM16 12H8"
    />
  </svg>
);

export const CrossCancelIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke="#F5222D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10ZM15 15 9 9m0 6 6-6"
    />
  </svg>
);

export const QuizAttemptsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.91602 7.5013V11.668C2.91602 14.8106 2.91602 16.3821 3.89232 17.3583C4.86864 18.3346 6.43998 18.3346 9.58268 18.3346H10.416C13.5587 18.3346 15.1301 18.3346 16.1063 17.3583C17.0827 16.3821 17.0827 14.8106 17.0827 11.668V8.33464C17.0827 5.19194 17.0827 3.62059 16.1063 2.64428C15.1301 1.66797 13.5587 1.66797 10.416 1.66797H9.99935"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.25 14.168H14.5833"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.25 5.83203H14.5833"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11.25 10H14.5833" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5.41602 13.7513C5.41602 13.7513 6.22233 13.974 6.66602 15.0013C6.66602 15.0013 7.49935 12.5013 9.16602 11.668"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33268 4.16797H2.91602M8.33268 4.16797C8.33268 3.46774 6.39378 2.1595 5.90212 1.66797M8.33268 4.16797C8.33268 4.86819 6.39377 6.17644 5.90212 6.66797"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProductVariantIcon = (props) => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.75 15.3979V9H29.25V15.3979C29.25 20.1601 29.25 22.5413 27.7856 24.0206C26.3211 25.5 23.964 25.5 19.2499 25.5H16.7501C12.036 25.5 9.67893 25.5 8.21446 24.0206C6.75 22.5413 6.75 20.1601 6.75 15.3979Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 9L7.83172 6.69231C8.67067 4.90257 9.09014 4.0077 9.94038 3.50385C10.7906 3 11.8813 3 14.0625 3H21.9375C24.1188 3 25.2093 3 26.0597 3.50385C26.9099 4.0077 27.3294 4.90257 28.1682 6.69231L29.25 9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M15.75 13.5H20.25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M18 29.25V33M18 29.25H10.5M18 29.25H25.5M10.5 29.25H6.75C4.67893 29.25 3 30.929 3 33M10.5 29.25V33M25.5 29.25H29.25C31.321 29.25 33 30.929 33 33M25.5 29.25V33"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NoteIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.33594 15.538V6.71172C3.33594 4.33338 3.33594 3.14421 4.06817 2.40536C4.8004 1.6665 5.97891 1.6665 8.33594 1.6665H11.6693C14.0263 1.6665 15.2048 1.6665 15.937 2.40536C16.6693 3.14421 16.6693 4.33338 16.6693 6.71172V15.538C16.6693 16.7978 16.6693 17.4276 16.2843 17.6755C15.6552 18.0808 14.6827 17.231 14.1935 16.9226C13.7894 16.6677 13.5874 16.5403 13.363 16.5329C13.1207 16.5249 12.915 16.6472 12.4784 16.9226L10.8859 17.9268C10.4564 18.1977 10.2416 18.3332 10.0026 18.3332C9.7636 18.3332 9.54885 18.1977 9.11927 17.9268L7.52688 16.9226C7.12273 16.6677 6.92065 16.5403 6.69638 16.5329C6.45404 16.5249 6.24838 16.6472 5.81166 16.9226C5.32256 17.231 4.35 18.0808 3.7209 17.6755C3.33594 17.4276 3.33594 16.7978 3.33594 15.538Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16406 9.1665H6.66406"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6641 5.8335H6.66406"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CancelOrderIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.4141 16.6666H8.7474C5.61525 16.6666 4.04917 16.6666 3.00361 15.8408C2.83638 15.7088 2.68172 15.5633 2.5414 15.4058C1.66406 14.4218 1.66406 12.9478 1.66406 9.99992C1.66406 7.05202 1.66406 5.57806 2.5414 4.594C2.68172 4.43661 2.83638 4.29104 3.00361 4.15898C4.04917 3.33325 5.61525 3.33325 8.7474 3.33325H11.2474C14.3796 3.33325 15.9456 3.33325 16.9911 4.15898C17.1584 4.29104 17.3131 4.43661 17.4534 4.594C18.2438 5.48062 18.3221 6.76491 18.3299 9.16659"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66406 7.5H18.3307"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3359 11.6667L13.3359 16.6667M18.3359 16.6667L13.3359 11.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ResumeOrderIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.3307 7.91675C18.3003 6.03984 18.1551 4.95555 17.4611 4.1775C17.3206 4.02011 17.1659 3.87454 16.9986 3.74247C15.9525 2.91675 14.3856 2.91675 11.2521 2.91675H8.75081C5.61715 2.91675 4.05033 2.91675 3.00425 3.74247C2.83695 3.87454 2.68221 4.02011 2.54182 4.1775C1.66406 5.16156 1.66406 6.63551 1.66406 9.58341C1.66406 12.5313 1.66406 14.0052 2.54182 14.9893C2.68221 15.1467 2.83695 15.2922 3.00425 15.4243C4.05033 16.2501 5.61715 16.2501 8.75081 16.2501H9.16406"
      stroke="#096DD9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66406 7.08325H18.3307"
      stroke="#096DD9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1085 10.4167L16.7945 11.0483C16.9438 11.1951 17.0185 11.2685 16.9922 11.3308C16.9659 11.3932 16.8603 11.3932 16.6491 11.3932H14.0621C12.7377 11.3932 11.6641 12.4484 11.6641 13.7501C11.6641 14.0435 11.7186 14.3243 11.8182 14.5834M13.8863 17.0834L13.2003 16.4518C13.051 16.3051 12.9763 16.2317 13.0026 16.1693C13.0289 16.107 13.1345 16.107 13.3456 16.107H15.9326C17.2571 16.107 18.3307 15.0517 18.3307 13.7501C18.3307 13.4567 18.2761 13.1758 18.1766 12.9167"
      stroke="#096DD9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckoutCouponIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.9961 10H11.0111M10.9998 16H11.0148"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7 13H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17.5 5C18.3284 5 19 5.67157 19 6.5C19 7.32843 18.3284 8 17.5 8C16.6716 8 16 7.32843 16 6.5C16 5.67157 16.6716 5 17.5 5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.77423 11.1439C1.77108 12.2643 1.7495 13.9546 2.67016 15.1437C4.49711 17.5033 6.49674 19.5029 8.85633 21.3298C10.0454 22.2505 11.7357 22.2289 12.8561 21.2258C15.8979 18.5022 18.6835 15.6559 21.3719 12.5279C21.6377 12.2187 21.8039 11.8397 21.8412 11.4336C22.0062 9.63798 22.3452 4.46467 20.9403 3.05974C19.5353 1.65481 14.362 1.99377 12.5664 2.15876C12.1603 2.19608 11.7813 2.36233 11.472 2.62811C8.34412 5.31646 5.49781 8.10211 2.77423 11.1439Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const AffirmIcon = () => (
  <svg width="49" height="30" viewBox="0 0 49 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="49" height="30" rx="8" fill="#4A4AF4" fillOpacity="0.2" />
    <g clipPath="url(#clip0_15475_9461)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0417 15.6355C13.369 15.6355 12.5893 15.9588 12.1667 16.2942L12.5536 17.1085C12.8929 16.7972 13.4405 16.5337 13.9345 16.5337C14.4048 16.5337 14.6607 16.6894 14.6607 17.0068C14.6607 17.2223 14.4881 17.3301 14.1667 17.372C12.9524 17.5277 12 17.863 12 18.8032C12 19.5457 12.5298 20.0008 13.3512 20.0008C13.9405 20.0008 14.4643 19.6714 14.7143 19.2403V19.881H15.8095V17.1924C15.8095 16.0846 15.0417 15.6355 14.0417 15.6355ZM13.631 19.1385C13.3214 19.1385 13.1667 18.9888 13.1667 18.7373C13.1667 18.2702 13.6845 18.1145 14.631 18.0127C14.6369 18.6355 14.2143 19.1385 13.631 19.1385ZM26.1369 16.4499V15.7553H25.0417V19.881H26.2143V17.893C26.2143 16.9469 26.7798 16.6714 27.1786 16.6714C27.3333 16.6714 27.5417 16.7193 27.6786 16.8211L27.8929 15.7313C27.7143 15.6535 27.5238 15.6355 27.369 15.6355C26.7679 15.6355 26.3869 15.905 26.1369 16.4499ZM33.3333 15.6355C32.7143 15.6355 32.25 16.0068 32.006 16.36C31.7798 15.899 31.3095 15.6355 30.7381 15.6355C30.119 15.6355 29.6905 15.9828 29.4881 16.378V15.7553H28.3571V19.881H29.5298V17.7553C29.5298 16.9948 29.9286 16.6295 30.2976 16.6295C30.631 16.6295 30.9405 16.8451 30.9405 17.4079V19.881H32.119V17.7553C32.119 16.9828 32.506 16.6295 32.8929 16.6295C33.2024 16.6295 33.5298 16.8571 33.5298 17.402V19.881H34.7024V17.0307C34.7024 16.1026 34.0833 15.6355 33.3333 15.6355ZM19.9524 15.4499V15.7553H18.1726V15.3361C18.1726 14.7912 18.4821 14.6355 18.75 14.6355C18.9048 14.6355 19.1071 14.6714 19.2738 14.7672L19.6369 13.9349C19.4226 13.8091 19.0714 13.6954 18.6012 13.6954C17.8512 13.6954 17 14.1205 17 15.4559V15.7612H16.3214V16.6714H17V19.881H18.1726V16.6654H19.9524V19.881H21.125V16.6654H22.1905V15.7553H21.125V15.3361C21.125 14.7912 21.4345 14.6355 21.7024 14.6355C22 14.6355 22.2262 14.7672 22.2262 14.7672L22.5893 13.9349C22.5893 13.9349 22.2202 13.6954 21.5536 13.6954C20.8095 13.6894 19.9524 14.1145 19.9524 15.4499ZM22.8869 15.7553H24.0595V19.881H22.8869V15.7553Z"
        fill="#101820"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.7203 10C26.5536 10 23.7322 12.2096 22.9346 15.0539H24.0834C24.75 12.9341 27.0179 11.0778 29.7203 11.0778C33.006 11.0778 35.8393 13.5928 35.8393 17.509C35.8393 18.3892 35.7262 19.1796 35.512 19.8802H36.625L36.637 19.8443C36.8215 19.1198 36.9108 18.3353 36.9108 17.509C36.9108 13.1437 33.75 10 29.7203 10Z"
        fill="#4A4AF4"
      />
    </g>
    <defs>
      <clipPath id="clip0_15475_9461">
        <rect width="25" height="10" fill="white" transform="translate(12 10)" />
      </clipPath>
    </defs>
  </svg>
);

export const AfterPayIcon = () => (
  <svg width="78" height="30" viewBox="0 0 78 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="77.6166" height="30" rx="8" fill="#00D633" fillOpacity="0.2" />
    <path
      d="M16.4158 14.8887C16.4158 13.9878 15.7373 13.3538 14.9031 13.3538C14.0689 13.3538 13.3904 13.9989 13.3904 14.8887C13.3904 15.7674 14.0689 16.4237 14.9031 16.4237C15.7373 16.4237 16.4158 15.7897 16.4158 14.8887ZM16.4269 17.5693V16.8686C16.0153 17.3469 15.4036 17.6472 14.6695 17.6472C13.1457 17.6472 12 16.4682 12 14.8887C12 13.3093 13.2013 12.1191 14.7029 12.1191C15.4147 12.1191 16.0153 12.4195 16.4269 12.8866V12.2081H17.7839V17.5693H16.4269Z"
      fill="black"
    />
    <path
      d="M24.4148 16.384C23.9365 16.384 23.803 16.2171 23.803 15.7611V13.3919H24.6817V12.224H23.803V10.9226H22.4015V12.224H20.5996V11.9014C20.5996 11.4565 20.7776 11.2786 21.267 11.2786H21.5784V10.2441H20.9111C19.7543 10.2441 19.2093 10.6112 19.2093 11.7235V12.2351H18.4307V13.3919H19.2093V17.5852H20.6107V13.3919H22.4126V16.0169C22.4126 17.107 22.8464 17.5852 23.981 17.5852H24.704V16.3951H24.4148V16.384Z"
      fill="black"
    />
    <path
      d="M29.4288 14.413C29.3287 13.7123 28.7392 13.3007 28.0496 13.3007C27.36 13.3007 26.7927 13.7123 26.6481 14.413H29.4288ZM26.637 15.2472C26.7371 16.0369 27.3266 16.493 28.0718 16.493C28.6614 16.493 29.1174 16.226 29.3843 15.7922H30.8192C30.4855 16.9268 29.4288 17.6609 28.0496 17.6609C26.37 17.6609 25.2021 16.5263 25.2021 14.9135C25.2021 13.3007 26.4479 12.1328 28.083 12.1328C29.7403 12.1328 30.9304 13.3118 30.9304 14.9135C30.9304 15.0359 30.9193 15.1471 30.897 15.2583H26.637V15.2472Z"
      fill="black"
    />
    <path
      d="M39.8066 14.8913C39.8066 14.0237 39.1281 13.3563 38.2939 13.3563C37.4597 13.3563 36.7812 14.0015 36.7812 14.8913C36.7812 15.77 37.4597 16.4262 38.2939 16.4262C39.1392 16.4262 39.8066 15.7589 39.8066 14.8913ZM35.4131 12.2218H36.7812V12.9225C37.1927 12.4331 37.8045 12.1328 38.5386 12.1328C40.0402 12.1328 41.2081 13.323 41.2081 14.8913C41.2081 16.4707 40.0068 17.6609 38.5052 17.6609C37.8045 17.6609 37.2261 17.3939 36.8257 16.9379V19.7742H35.4131V12.2218Z"
      fill="black"
    />
    <path
      d="M46.1257 14.8887C46.1257 13.9878 45.4472 13.3538 44.613 13.3538C43.7788 13.3538 43.1003 13.9989 43.1003 14.8887C43.1003 15.7674 43.7788 16.4237 44.613 16.4237C45.4472 16.4237 46.1257 15.7897 46.1257 14.8887ZM46.1369 17.5693V16.8686C45.7253 17.3469 45.1136 17.6472 44.3794 17.6472C42.8556 17.6472 41.71 16.4682 41.71 14.8887C41.71 13.3093 42.9112 12.1191 44.4128 12.1191C45.1247 12.1191 45.7253 12.4195 46.1369 12.8866V12.2081H47.505V17.5693H46.1369Z"
      fill="black"
    />
    <path
      d="M32.9537 12.742C32.9537 12.742 33.2985 12.1191 34.1549 12.1191C34.522 12.1191 34.7556 12.2415 34.7556 12.2415V13.6096C34.7556 13.6096 34.2439 13.2982 33.7768 13.3649C33.3096 13.4316 33.0093 13.8432 33.0093 14.3993V17.5693H31.5967V12.2081H32.9648V12.742H32.9537Z"
      fill="black"
    />
    <path
      d="M53.8665 12.2168L50.4184 19.7581H48.9613L50.3183 16.8439L48.0381 12.2168H49.6843L51.019 15.309L52.3871 12.2168H53.8665Z"
      fill="black"
    />
    <path
      d="M64.8561 12.0969L61.4414 10.1949C60.4403 9.63878 59.1834 10.3395 59.1834 11.4518V11.652C59.1834 11.83 59.2835 11.9968 59.4393 12.0747L60.0844 12.4306C60.2735 12.5418 60.507 12.4084 60.507 12.197V11.7076C60.507 11.4629 60.774 11.3183 60.9965 11.4296L63.9551 13.0757C64.1776 13.1981 64.1776 13.4984 63.9551 13.6208L61.0076 15.2781C60.7851 15.4004 60.5182 15.2447 60.5182 15V14.7442C60.5182 13.6208 59.2613 12.9311 58.2602 13.4873L54.8455 15.3893C53.8445 15.9454 53.8445 17.3469 54.8455 17.9031L58.2602 19.8051C59.2613 20.3612 60.5182 19.6605 60.5182 18.5482V18.348C60.5182 18.17 60.4181 18.0143 60.2623 17.9253L59.6172 17.5694C59.4281 17.4582 59.1946 17.5916 59.1946 17.803V18.2924C59.1946 18.5371 58.9276 18.6817 58.7051 18.5704L55.7465 16.9243C55.524 16.8019 55.524 16.5016 55.7465 16.3792L58.7051 14.7331C58.9276 14.6107 59.1946 14.7664 59.1946 15.0111V15.2669C59.1946 16.3904 60.4514 17.08 61.4525 16.5238L64.8672 14.6218C65.8683 14.0546 65.8683 12.6531 64.8561 12.0969Z"
      fill="black"
    />
  </svg>
);

export const KlarnaIcon = () => (
  <svg width="69" height="30" viewBox="0 0 69 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="69" height="30" rx="8" fill="#FFB3C7" />
    <path
      d="M55.719 17.4049C55.5499 17.4055 55.3826 17.439 55.2267 17.5035C55.0708 17.5679 54.9293 17.6621 54.8103 17.7806C54.6913 17.8991 54.5972 18.0395 54.5333 18.194C54.4694 18.3484 54.437 18.5137 54.438 18.6805C54.437 18.8473 54.4694 19.0126 54.5333 19.167C54.5972 19.3214 54.6913 19.4619 54.8103 19.5804C54.9293 19.6989 55.0708 19.7931 55.2267 19.8575C55.3826 19.922 55.5499 19.9555 55.719 19.9561C56.4256 19.9561 57 19.3847 57 18.6805C57.0009 18.5137 56.9685 18.3484 56.9046 18.194C56.8407 18.0395 56.7466 17.8991 56.6276 17.7806C56.5086 17.6621 56.3671 17.5679 56.2112 17.5035C56.0553 17.439 55.888 17.4055 55.719 17.4049ZM51.5034 16.4197C51.5034 15.4547 50.6754 14.6734 49.654 14.6734C48.6326 14.6734 47.8046 15.4558 47.8046 16.4197C47.8046 17.3835 48.6338 18.1648 49.6552 18.1648C50.6766 18.1648 51.5034 17.3835 51.5034 16.4197ZM51.5106 13.0255H53.5511V19.8127H51.5106V19.3788C50.9157 19.7839 50.2098 20.0006 49.487 20C47.5006 20 45.8903 18.3972 45.8903 16.4197C45.8903 14.4422 47.5006 12.8394 49.487 12.8394C50.238 12.8394 50.9338 13.0682 51.5106 13.4606V13.0255ZM35.1771 13.9099V13.0267H33.0874V19.8127H35.182V16.6437C35.182 15.5744 36.3452 15.0006 37.1527 15.0006H37.1768V13.0267C36.3476 13.0267 35.5869 13.38 35.1771 13.9099ZM29.9714 16.4197C29.9714 15.4547 29.1434 14.6734 28.122 14.6734C27.1005 14.6734 26.2726 15.4558 26.2726 16.4197C26.2726 17.3835 27.1017 18.1648 28.1232 18.1648C29.1446 18.1648 29.9714 17.3835 29.9714 16.4197ZM29.9786 13.0255H32.0203V19.8127H29.9786V19.3788C29.4018 19.77 28.706 20 27.9549 20C25.9685 20 24.3583 18.3972 24.3583 16.4197C24.3583 14.4422 25.9685 12.8394 27.9549 12.8394C28.706 12.8394 29.4018 13.0682 29.9786 13.4606V13.0255ZM42.2636 12.8441C41.4488 12.8441 40.6773 13.0954 40.1606 13.7902V13.0267H38.1285V19.8127H40.1858V16.2466C40.1858 15.2152 40.8804 14.709 41.718 14.709C42.6145 14.709 43.1312 15.2424 43.1312 16.2324V19.8127H45.1693V15.4973C45.1693 13.9182 43.9075 12.8441 42.2636 12.8441ZM21.3853 19.8127H23.5219V10.0024H21.3853V19.8127ZM12 19.8151H14.2628V10H12.0012L12 19.8151ZM19.9144 10C19.9144 12.1245 19.0828 14.102 17.5999 15.5708L20.7267 19.8151H17.9328L14.5356 15.2033L15.4128 14.5489C16.127 14.019 16.7056 13.3317 17.1024 12.5419C17.4993 11.752 17.7034 10.8815 17.6985 10H19.912H19.9144Z"
      fill="#0A0B09"
    />
  </svg>
);

export const ShieldIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.7088 3.49534C16.8165 2.55382 14.5009 2 12 2C9.4991 2 7.1835 2.55382 5.29116 3.49534C4.36318 3.95706 3.89919 4.18792 3.4496 4.91378C3 5.63965 3 6.34248 3 7.74814V11.2371C3 16.9205 7.54236 20.0804 10.173 21.4338C10.9067 21.8113 11.2735 22 12 22C12.7265 22 13.0933 21.8113 13.8269 21.4338C16.4576 20.0804 21 16.9205 21 11.2371V7.74814C21 6.34249 21 5.63966 20.5504 4.91378C20.1008 4.18791 19.6368 3.95706 18.7088 3.49534Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11.5C9 11.5 10.4079 11.7519 11 13.5C11 13.5 12.5 10.5 15 9.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrustPilotStarIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M24 9.23077H14.7541L12 0L9.04918 9.23077H0L7.27869 14.7692L4.52459 24L12 18.2564L19.2787 24L16.5246 14.7692L24 9.23077Z"
      fill="#00B67A"
    />
    <path d="M17.1148 16.8189L16.5246 14.7676L12 18.2548L17.1148 16.8189Z" fill="#005128" />
  </svg>
);

export const BadgeIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.5 9.5C4.5 13.6421 7.85786 17 12 17C16.1421 17 19.5 13.6421 19.5 9.5C19.5 5.35786 16.1421 2 12 2C7.85786 2 4.5 5.35786 4.5 9.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 10.1667C9 10.1667 9.75 10.1667 10.5 11.5C10.5 11.5 12.8824 8.16667 15 7.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8825 15L17.5527 18.2099C17.9833 20.2723 18.1986 21.3035 17.7563 21.7923C17.3141 22.281 16.546 21.8606 15.0099 21.0198L12.7364 19.7753C12.3734 19.5766 12.1919 19.4773 12 19.4773C11.8081 19.4773 11.6266 19.5766 11.2636 19.7753L8.99008 21.0198C7.45397 21.8606 6.68592 22.281 6.24365 21.7923C5.80139 21.3035 6.01669 20.2723 6.44731 18.2099L7.11752 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const InfoIcon2 = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 16V11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 8.01V8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SecureIcon = (props) => (
  <svg
    width={props?.size || '20'}
    height={props?.size || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.55618 15.7039C3.74358 17.0958 4.89645 18.1862 6.29939 18.2507C7.4799 18.305 8.67909 18.3333 9.99967 18.3333C11.3203 18.3333 12.5194 18.305 13.6999 18.2507C15.1029 18.1862 16.2558 17.0958 16.4432 15.7039C16.5655 14.7956 16.6663 13.8647 16.6663 12.9167C16.6663 11.9687 16.5655 11.0377 16.4432 10.1294C16.2558 8.7375 15.1029 7.64707 13.6999 7.58257C12.5194 7.52831 11.3203 7.5 9.99967 7.5C8.67909 7.5 7.4799 7.52831 6.29939 7.58257C4.89645 7.64707 3.74358 8.7375 3.55618 10.1294C3.43387 11.0377 3.33301 11.9687 3.33301 12.9167C3.33301 13.8647 3.43387 14.7956 3.55618 15.7039Z"
      fill="currentColor"
    />
    <path
      d="M6.25 7.50001V5.41667C6.25 3.34561 7.92893 1.66667 10 1.66667C12.0711 1.66667 13.75 3.34561 13.75 5.41667V7.50001"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.99707 12.9167H10.0061" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const GiftTickIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4 11V15C4 18.2998 4 19.9497 5.02513 20.9749C6.05025 22 7.70017 22 11 22H12M20 13.5V11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 9C3 8.25231 3 7.87846 3.20096 7.6C3.33261 7.41758 3.52197 7.26609 3.75 7.16077C4.09808 7 4.56538 7 5.5 7H18.5C19.4346 7 19.9019 7 20.25 7.16077C20.478 7.26609 20.6674 7.41758 20.799 7.6C21 7.87846 21 8.25231 21 9C21 9.74769 21 10.1215 20.799 10.4C20.6674 10.5824 20.478 10.7339 20.25 10.8392C19.9019 11 19.4346 11 18.5 11H5.5C4.56538 11 4.09808 11 3.75 10.8392C3.52197 10.7339 3.33261 10.5824 3.20096 10.4C3 10.1215 3 9.74769 3 9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 3.78571C6 2.79949 6.79949 2 7.78571 2H8.14286C10.2731 2 12 3.7269 12 5.85714V7H9.21429C7.43908 7 6 5.56091 6 3.78571Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 3.78571C18 2.79949 17.2005 2 16.2143 2H15.8571C13.7269 2 12 3.7269 12 5.85714V7H14.7857C16.5609 7 18 5.56091 18 3.78571Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 11V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M14 19.5C14 19.5 15.3485 20.0067 16 22C16 22 19.1765 17 22 16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PaymentSecureIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.26781 18.8447C4.49269 20.515 5.87613 21.8235 7.55966 21.9009C8.97627 21.966 10.4153 22 12 22C13.5847 22 15.0237 21.966 16.4403 21.9009C18.1239 21.8235 19.5073 20.515 19.7322 18.8447C19.879 17.7547 20 16.6376 20 15.5C20 14.3624 19.879 13.2453 19.7322 12.1553C19.5073 10.485 18.1239 9.17649 16.4403 9.09909C15.0237 9.03397 13.5847 9 12 9C10.4153 9 8.97627 9.03397 7.55966 9.09909C5.87613 9.17649 4.49269 10.485 4.26781 12.1553C4.12104 13.2453 4 14.3624 4 15.5C4 16.6376 4.12104 17.7547 4.26781 18.8447Z"
      fill="#24A147"
    />
    <path
      d="M7.5 9V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V9"
      stroke="#24A147"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11.9961 15.5H12.0069" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CorruptedIcon = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.9987 25.6693C20.442 25.6693 25.6654 20.4459 25.6654 14.0026C25.6654 7.55928 20.442 2.33594 13.9987 2.33594C7.55537 2.33594 2.33203 7.55928 2.33203 14.0026C2.33203 20.4459 7.55537 25.6693 13.9987 25.6693Z"
      stroke="#F5222D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M14 9.33594V14.5859" stroke="#F5222D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 18.6562V18.6712" stroke="#F5222D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const PlusIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.9974 2.66602V13.3327M13.3307 7.99935L2.66406 7.99935"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CircleTickIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_16275_33048)">
      <path
        d="M18.3346 9.9974C18.3346 5.39502 14.6036 1.66406 10.0013 1.66406C5.39893 1.66406 1.66797 5.39502 1.66797 9.9974C1.66797 14.5997 5.39893 18.3307 10.0013 18.3307C14.6036 18.3307 18.3346 14.5997 18.3346 9.9974Z"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '1.5'}
      />
      <path
        d="M6.66797 10.4167L8.01278 11.7615C8.41536 12.1641 9.07233 12.1498 9.45704 11.7301L13.3346 7.5"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '1.5'}
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_16275_33048">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FolderAttachmentIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.8346 17.5H10.0013C6.07293 17.5 4.10874 17.5 2.88836 16.2796C1.66797 15.0592 1.66797 13.095 1.66797 9.16667V6.62023C1.66797 5.1065 1.66797 4.34963 1.9849 3.78172C2.21082 3.37689 2.54486 3.04285 2.94969 2.81693C3.5176 2.5 4.27447 2.5 5.78819 2.5C6.75799 2.5 7.24289 2.5 7.66735 2.65917C8.63647 3.0226 9.03614 3.90298 9.47347 4.77761L10.0013 5.83333M6.66797 5.83333H13.9596C15.7152 5.83333 16.593 5.83333 17.2236 6.25466C17.4966 6.43706 17.7309 6.67143 17.9133 6.94441C18.3176 7.54952 18.334 8.38233 18.3346 10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M17.5 12.8872V14.9385C17.5 16.3546 16.3807 17.5026 15 17.5026C13.6192 17.5026 12.5 16.3546 12.5 14.9385V12.118C12.5 11.4099 13.0597 10.8359 13.75 10.8359C14.4403 10.8359 15 11.4099 15 12.118V14.9385"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const DeleteIcon2 = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M9.5 16.5V10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M14.5 16.5V10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const LabReviewsIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.64298 3.14559L6.93816 3.93362C4.31272 5.14719 3 5.75397 3 6.75C3 7.74603 4.31272 8.35281 6.93817 9.56638L8.64298 10.3544C10.2952 11.1181 11.1214 11.5 12 11.5C12.8786 11.5 13.7048 11.1181 15.357 10.3544L17.0618 9.56638C19.6873 8.35281 21 7.74603 21 6.75C21 5.75397 19.6873 5.14719 17.0618 3.93362L15.357 3.14559C13.7048 2.38186 12.8786 2 12 2C11.1214 2 10.2952 2.38186 8.64298 3.14559Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.788 11.0938C20.9293 11.2924 21 11.4996 21 11.7274C21 12.7092 19.6873 13.3074 17.0618 14.5037L15.357 15.2806C13.7048 16.0333 12.8786 16.4098 12 16.4098C11.1214 16.4098 10.2952 16.0333 8.64298 15.2806L6.93817 14.5037C4.31272 13.3074 3 12.7092 3 11.7274C3 11.4996 3.07067 11.2924 3.212 11.0938"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.3767 16.2656C20.7922 16.5966 21 16.9265 21 17.3171C21 18.299 19.6873 18.8971 17.0618 20.0934L15.357 20.8702C13.7048 21.6231 12.8786 21.9995 12 21.9995C11.1214 21.9995 10.2952 21.6231 8.64298 20.8702L6.93817 20.0934C4.31272 18.8971 3 18.299 3 17.3171C3 16.9265 3.20778 16.5966 3.62334 16.2656"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BellNotificationIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.5 18C15.5 19.933 13.933 21.5 12 21.5C10.067 21.5 8.5 19.933 8.5 18"
      stroke="#077882"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2311 18H4.76887C3.79195 18 3 17.208 3 16.2311C3 15.762 3.18636 15.3121 3.51809 14.9803L4.12132 14.3771C4.68393 13.8145 5 13.0514 5 12.2558V9.5C5 5.63401 8.13401 2.5 12 2.5C15.866 2.5 19 5.634 19 9.5V12.2558C19 13.0514 19.3161 13.8145 19.8787 14.3771L20.4819 14.9803C20.8136 15.3121 21 15.762 21 16.2311C21 17.208 20.208 18 19.2311 18Z"
      stroke="#077882"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MuteBellICon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.5 18C15.5 19.933 13.933 21.5 12 21.5C10.067 21.5 8.5 19.933 8.5 18"
      stroke="#8C8C8C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2 2L22 22" stroke="#8C8C8C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M21 16.2311C21 15.762 20.8136 15.3121 20.4819 14.9803L19.8787 14.3771C19.3161 13.8145 19 13.0514 19 12.2558V9.5C19 5.634 15.866 2.5 12 2.5C10.4497 2.5 9.01706 3.00399 7.85707 3.85707M4.76887 18C3.79195 18 3 17.208 3 16.2311C3 15.762 3.18636 15.3121 3.51809 14.9803L4.12132 14.3771C4.68393 13.8145 5 13.0514 5 12.2558V9.5C5 8.20839 5.34981 6.99849 5.95987 5.95987L18 18H4.76887Z"
      stroke="#8C8C8C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TestIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.6654 1.33594V12.0026C10.6654 13.4753 9.47143 14.6693 7.9987 14.6693C6.52594 14.6693 5.33203 13.4753 5.33203 12.0026V1.33594"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M5.33203 5.70674C5.92462 4.93784 6.87243 5.49211 7.9987 6.21468C9.48016 7.16516 10.3691 6.43592 10.6654 5.74603"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M4.66797 1.33594H11.3346" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M7.32812 12.0014L7.33309 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.67188 9.34512L8.67684 9.34375"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AnthropometryIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.9998 14.0034V12.3621M11.9998 14.0034C10.3336 14.0034 8.66743 13.821 7.00125 13.4565M11.9998 14.0034C13.6664 14.0034 15.3331 13.8212 16.9998 13.4565M7.00125 13.4565C5.72636 13.1776 4.45148 12.7918 3.17659 12.2995C2.66703 12.1026 2.41225 12.0042 2.23743 11.7788C1.94737 11.4049 1.99979 10.8841 1.99979 10.4387C1.99979 9.20572 1.99979 7.58804 2.30059 7.26609C2.87005 6.65661 3.95714 7.21761 4.58942 7.42272C9.52967 9.02529 14.4699 9.02529 19.4102 7.42272C20.0424 7.21761 21.1295 6.65661 21.699 7.26609C21.9998 7.58804 21.9998 9.20572 21.9998 10.4387C21.9998 11.0571 21.9998 11.3663 21.8638 11.6217C21.6548 12.0141 21.2134 12.1487 20.823 12.2995C19.5486 12.7916 18.2742 13.1776 16.9998 13.4565M7.00125 13.4565L6.99979 11.8149M16.9998 13.4565V11.8149"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0001 19.0098C14.3334 20.346 9.66667 20.346 5 19.0098"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.191 2.99805C18.6141 4.30938 18.0839 6.55739 18.0839 7.58772M4.81544 2.99805C5.39237 4.30938 5.92253 6.55739 5.92253 7.58772M5.39913 15.5107C4.96029 16.8915 3.80051 19.6218 4.00426 21.0026M18.6142 15.5107C19.0531 16.8915 20.2129 19.6218 20.0091 21.0026"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowUpIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5686 7.00971L17.5 5L15.7748 12.0076L13.6225 9.9415L10.1509 13.5578C10.033 13.6806 9.87018 13.75 9.7 13.75C9.52982 13.75 9.36699 13.6806 9.24913 13.5578L6.7 10.9025L2.95087 14.8078C2.71182 15.0568 2.31618 15.0649 2.06717 14.8259C1.81816 14.5868 1.81009 14.1912 2.04913 13.9422L6.24913 9.56717C6.36699 9.4444 6.52982 9.375 6.7 9.375C6.87018 9.375 7.03301 9.4444 7.15087 9.56717L9.7 12.2225L12.7208 9.07584L10.5686 7.00971Z"
      fill="currentColor"
    />
  </svg>
);

export const DoubleTickIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m1.664 9.223 2.333 2.444.683-.715m6.317-6.618L6.955 8.568M5 9.223l2.333 2.444 7-7.333"
    />
  </svg>
);

export const QuizAnalyticsIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 2C7.85786 2 4.5 5.35786 4.5 9.5C4.5 11.816 5.54973 13.8867 7.19934 15.2625C8.19018 16.0889 9 17.2098 9 18.5H15C15 17.2098 15.8098 16.0889 16.8007 15.2625C18.4503 13.8867 19.5 11.816 19.5 9.5C19.5 5.35786 16.1421 2 12 2Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M15 18.5H9V20.5C9 21.3284 9.67157 22 10.5 22H13.5C14.3284 22 15 21.3284 15 20.5V18.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10 8C10 6.98748 10.8954 6 12 6C13.1046 6 14 6.82081 14 7.83333C14 8.19831 13.8837 8.53837 13.6831 8.82406C13.0854 9.67553 12 10.4875 12 11.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M11.9922 14H12.0012" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const ArrowIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18.5 12H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M13 18C13 18 19 13.5811 19 12C19 10.4188 13 6 13 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowBottomRightIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5686 12.9903L17.5 15L15.7748 7.99237L13.6225 10.0585L10.1509 6.44217C10.033 6.3194 9.87018 6.25 9.7 6.25C9.52982 6.25 9.36699 6.3194 9.24913 6.44217L6.7 9.09751L2.95087 5.19217C2.71182 4.94316 2.31618 4.93509 2.06717 5.17413C1.81816 5.41318 1.81009 5.80883 2.04913 6.05783L6.24913 10.4328C6.36699 10.5556 6.52982 10.625 6.7 10.625C6.87018 10.625 7.03301 10.5556 7.15087 10.4328L9.7 7.77749L12.7208 10.9242L10.5686 12.9903Z"
      fill="currentColor"
    />
  </svg>
);

export const GraphIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.83594 14.1693V10.8359" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M10 14.1693V5.83594" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M14.1641 14.1641V9.16406" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M2.08594 10.0026C2.08594 6.27065 2.08594 4.40468 3.2453 3.2453C4.40468 2.08594 6.27065 2.08594 10.0026 2.08594C13.7345 2.08594 15.6005 2.08594 16.7599 3.2453C17.9193 4.40468 17.9193 6.27065 17.9193 10.0026C17.9193 13.7345 17.9193 15.6005 16.7599 16.7599C15.6005 17.9193 13.7345 17.9193 10.0026 17.9193C6.27065 17.9193 4.40468 17.9193 3.2453 16.7599C2.08594 15.6005 2.08594 13.7345 2.08594 10.0026Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const MultiPeopleIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.5 11C15.5 9.067 13.933 7.5 12 7.5C10.067 7.5 8.5 9.067 8.5 11C8.5 12.933 10.067 14.5 12 14.5C13.933 14.5 15.5 12.933 15.5 11Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.481 11.3499C15.803 11.4475 16.1445 11.5 16.4983 11.5C18.4313 11.5 19.9983 9.933 19.9983 8C19.9983 6.067 18.4313 4.5 16.4983 4.5C14.6834 4.5 13.1911 5.8814 13.0156 7.65013"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9827 7.65013C10.8072 5.8814 9.31492 4.5 7.5 4.5C5.567 4.5 4 6.067 4 8C4 9.933 5.567 11.5 7.5 11.5C7.85381 11.5 8.19535 11.4475 8.51727 11.3499"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 16.5C22 13.7386 19.5376 11.5 16.5 11.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 19.5C17.5 16.7386 15.0376 14.5 12 14.5C8.96243 14.5 6.5 16.7386 6.5 19.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 11.5C4.46243 11.5 2 13.7386 2 16.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PersonDotIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_17452_37784)">
      <path
        d="M12.9154 8.7526C12.9154 7.14177 11.6095 5.83594 9.9987 5.83594C8.38786 5.83594 7.08203 7.14177 7.08203 8.7526C7.08203 10.3634 8.38786 11.6693 9.9987 11.6693C11.6095 11.6693 12.9154 10.3634 12.9154 8.7526Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3346 3.7474C18.3346 2.5968 17.4019 1.66406 16.2513 1.66406C15.1007 1.66406 14.168 2.5968 14.168 3.7474C14.168 4.89799 15.1007 5.83073 16.2513 5.83073C17.4019 5.83073 18.3346 4.89799 18.3346 3.7474Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.668 1.83076C11.1295 1.72145 10.5721 1.66406 10.0013 1.66406C5.39893 1.66406 1.66797 5.39502 1.66797 9.9974C1.66797 14.5997 5.39893 18.3307 10.0013 18.3307C14.6036 18.3307 18.3346 14.5997 18.3346 9.9974C18.3346 9.42665 18.2772 8.86923 18.168 8.33073"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 16.6641C15 13.9026 12.7614 11.6641 10 11.6641C7.23857 11.6641 5 13.9026 5 16.6641"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_17452_37784">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PackageIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_17450_29584)">
      <path
        d="M9.16797 18.3359C8.48614 18.3359 7.83479 18.0608 6.53208 17.5105C3.28934 16.1407 1.66797 15.4558 1.66797 14.3037C1.66797 13.9811 1.66797 8.38969 1.66797 5.83594M9.16797 18.3359V9.46494M9.16797 18.3359C9.77197 18.3359 10.2455 18.12 11.2513 17.6881M16.668 5.83594V9.16927"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 14.5807H18.3333M15.4167 17.4974V11.6641"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.10624 8.07355L3.6719 6.8956C2.33594 6.24915 1.66797 5.92592 1.66797 5.41406C1.66797 4.9022 2.33594 4.57898 3.6719 3.93252L6.10624 2.75458C7.60866 2.02757 8.35989 1.66406 9.16797 1.66406C9.97605 1.66406 10.7273 2.02756 12.2297 2.75458L14.6641 3.93252C16 4.57898 16.668 4.9022 16.668 5.41406C16.668 5.92592 16 6.24915 14.6641 6.8956L12.2297 8.07355C10.7273 8.80056 9.97605 9.16406 9.16797 9.16406C8.35989 9.16406 7.60866 8.80056 6.10624 8.07355Z"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16797 10L5.83464 10.8333"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 3.33594L5 7.5026"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_17450_29584">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CardPlusIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.418 16.6693H8.7513C5.61915 16.6693 4.05308 16.6693 3.00752 15.8435C2.84029 15.7114 2.68563 15.5659 2.5453 15.4085C1.66797 14.4244 1.66797 12.9505 1.66797 10.0026C1.66797 7.0547 1.66797 5.58075 2.5453 4.59669C2.68563 4.4393 2.84029 4.29373 3.00752 4.16166C4.05308 3.33594 5.61915 3.33594 8.7513 3.33594H11.2513C14.3835 3.33594 15.9496 3.33594 16.9951 4.16166C17.1623 4.29373 17.317 4.4393 17.4573 4.59669C18.2008 5.43059 18.3142 6.61629 18.3316 8.7526"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4167 16.6693V10.8359M12.5 13.7526H18.3333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66797 7.5H18.3346"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CardTickIcon = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M30 15C30 15 31 15 32 17C32 17 35.1764 12 38 11"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44 14C44 19.5228 39.5228 24 34 24C28.4772 24 24 19.5228 24 14C24 8.47716 28.4772 4 34 4C39.5228 4 44 8.47716 44 14Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.5 26.491C45.4986 25.6624 44.8258 24.992 43.9974 24.9936C43.169 24.995 42.4986 25.6678 42.5 26.4962L45.5 26.491ZM18.1316 13.5078C18.9601 13.5031 19.6278 12.8277 19.6231 11.9993C19.6184 11.1709 18.9431 10.5032 18.1147 10.5078L18.1316 13.5078ZM27 42.5028H21V45.5028H27V42.5028ZM21 42.5028C17.2062 42.5028 14.4871 42.5006 12.3979 42.2646C10.3363 42.0316 9.08718 41.5882 8.14458 40.8438L6.28526 43.1982C7.852 44.4356 9.73684 44.983 12.0612 45.2456C14.3579 45.505 17.2766 45.5028 21 45.5028V42.5028ZM2.5 28.0028C2.5 31.5006 2.49714 34.2662 2.77524 36.4472C3.05864 38.6694 3.65362 40.4808 4.98596 41.9752L7.22524 39.9788C6.45198 39.1114 5.99416 37.9732 5.75116 36.0676C5.50286 34.1206 5.5 31.58 5.5 28.0028H2.5ZM8.14458 40.8438C7.8109 40.5804 7.5034 40.2908 7.22524 39.9788L4.98596 41.9752C5.38136 42.4188 5.81622 42.8278 6.28526 43.1982L8.14458 40.8438ZM42.5 28.0028C42.5 31.58 42.4972 34.1206 42.2488 36.0676C42.0058 37.9732 41.548 39.1114 40.7748 39.9788L43.014 41.9752C44.3464 40.4808 44.9414 38.6694 45.2248 36.4472C45.5028 34.2662 45.5 31.5006 45.5 28.0028H42.5ZM27 45.5028C30.7234 45.5028 33.642 45.505 35.9388 45.2456C38.2632 44.983 40.148 44.4356 41.7148 43.1982L39.8554 40.8438C38.9128 41.5882 37.6636 42.0316 35.602 42.2646C33.513 42.5006 30.7938 42.5028 27 42.5028V45.5028ZM40.7748 39.9788C40.4966 40.2908 40.1892 40.5804 39.8554 40.8438L41.7148 43.1982C42.1838 42.8278 42.6186 42.4188 43.014 41.9752L40.7748 39.9788ZM5.5 28.0028C5.5 24.4256 5.50286 21.885 5.75116 19.9379C5.99416 18.0323 6.45198 16.8941 7.22524 16.0268L4.98596 14.0304C3.65362 15.5248 3.05864 17.3361 2.77524 19.5585C2.49714 21.7394 2.5 24.505 2.5 28.0028H5.5ZM6.28526 12.8073C5.81622 13.1777 5.38136 13.5869 4.98596 14.0304L7.22524 16.0268C7.5034 15.7148 7.8109 15.4252 8.14458 15.1617L6.28526 12.8073ZM45.5 28.0028C45.5 27.4844 45.5008 26.977 45.5 26.491L42.5 26.4962C42.5008 26.979 42.5 27.4772 42.5 28.0028H45.5ZM18.1147 10.5078C15.2996 10.5238 13.0082 10.5886 11.1312 10.8848C9.22602 11.1855 7.63724 11.7396 6.28526 12.8073L8.14458 15.1617C8.95912 14.5184 10.0025 14.1001 11.5988 13.8482C13.2233 13.5918 15.3028 13.5238 18.1316 13.5078L18.1147 10.5078Z"
      fill="currentColor"
    />
    <path
      d="M20 36H23"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29 36H36"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5 22H20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CardInvertIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_17465_28887)">
      <path
        d="M2.78906 13.4955L13.4799 2.80469M15.5273 9.21047L13.6944 11.0434M12.1301 12.5891L11.3145 13.4046"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.64686 13.4483C1.34167 12.1431 1.34167 10.027 2.64686 8.72182L8.72572 2.64296C10.0309 1.33776 12.1471 1.33776 13.4522 2.64296L17.3557 6.54649C18.661 7.85168 18.661 9.96782 17.3557 11.273L11.2769 17.3518C9.97172 18.6571 7.85559 18.6571 6.5504 17.3518L2.64686 13.4483Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M3.33203 18.3359H16.6654" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_17465_28887">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DeliveryProofIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.08203 6.25V11.25C2.08203 14.3927 2.08203 15.9641 3.05834 16.9403C4.03466 17.9167 5.606 17.9167 8.7487 17.9167H9.9987M17.9154 10.4167V6.25"
      stroke="#077882"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22294 4.43145L2.08203 6.2526H17.9154L16.8719 4.51346C16.1604 3.32778 15.8048 2.73494 15.2316 2.41044C14.6585 2.08594 13.9671 2.08594 12.5844 2.08594H7.46012C6.10701 2.08594 5.43046 2.08594 4.86547 2.39869C4.30049 2.71144 3.94131 3.28478 3.22294 4.43145Z"
      stroke="#077882"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 6.2526V2.08594" stroke="#077882" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.33203 8.75H11.6654" stroke="#077882" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12.082 16.2474C12.082 16.2474 12.9154 16.2474 13.7487 17.9141C13.7487 17.9141 15.5624 13.7474 17.9154 12.9141"
      stroke="#077882"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProductVariantsIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.8369 3.39185L11.3412 2.04946C10.6789 1.79514 10.3477 1.66797 10 1.66797C9.65225 1.66797 9.32108 1.79514 8.65883 2.04946L5.1631 3.39185C3.3877 4.07362 2.5 4.41451 2.5 5.0013C2.5 5.58809 3.3877 5.92899 5.16311 6.61075L8.65883 7.95314C9.32108 8.20747 9.65225 8.33464 10 8.33464C10.3477 8.33464 10.6789 8.20747 11.3412 7.95314L14.8369 6.61075C16.6123 5.92899 17.5 5.58809 17.5 5.0013C17.5 4.41451 16.6123 4.07362 14.8369 3.39185Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 5V15C17.5 15.5868 16.6123 15.9277 14.8369 16.6094L11.3412 17.9518C10.6789 18.2062 10.3477 18.3333 10 18.3333C9.65225 18.3333 9.32108 18.2062 8.65883 17.9518L5.16311 16.6094C3.3877 15.9277 2.5 15.5868 2.5 15V5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 8.33203V18.332" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M13.7507 3.33203L5.83398 6.66536V8.7487"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.58398 13.4113V12.7142C4.58398 12.1348 4.58398 11.8451 4.77128 11.7197C4.95858 11.5943 5.22091 11.7085 5.74558 11.9367L6.99558 12.4805C7.24054 12.5871 7.36302 12.6403 7.43183 12.7463C7.50065 12.8522 7.50065 12.9875 7.50065 13.258V13.9551C7.50065 14.5345 7.50065 14.8242 7.31336 14.9496C7.12606 15.075 6.86372 14.9608 6.33905 14.7326L5.08905 14.1888C4.84409 14.0822 4.72162 14.029 4.6528 13.923C4.58398 13.8171 4.58398 13.6818 4.58398 13.4113Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HospitalIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 4.5V6M12 6V7.5M12 6H13.5M12 6H10.5" stroke="#077882" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M8.58579 2.58579C8 3.17157 8 4.11438 8 6C8 7.88562 8 8.82843 8.58579 9.41421C9.17157 10 10.1144 10 12 10C13.8856 10 14.8284 10 15.4142 9.41421C16 8.82843 16 7.88562 16 6C16 4.11438 16 3.17157 15.4142 2.58579C14.8284 2 13.8856 2 12 2C10.1144 2 9.17157 2 8.58579 2.58579Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4 22V11.9707C4 8.66123 4 7.00649 5.02513 5.97836C5.67665 5.32493 6.58055 5.08679 8 5M20 22V11.9707C20 8.66123 20 7.00649 18.9749 5.97836C18.3233 5.32493 17.4194 5.08679 16 5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M3 22H21" stroke="#077882" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M9.5 22V19.5C9.5 18.5654 9.5 18.0981 9.70096 17.75C9.83261 17.522 10.022 17.3326 10.25 17.201C10.5981 17 11.0654 17 12 17C12.9346 17 13.4019 17 13.75 17.201C13.978 17.3326 14.1674 17.522 14.299 17.75C14.5 18.0981 14.5 18.5654 14.5 19.5V22"
      stroke="#077882"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M8.00896 13H8M12 13H11.991M16.0011 13H15.9922" stroke="#077882" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const SpikeLoader = (props) => (
  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M50 12.5V25" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    <path d="M50 75V87.5" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    <path d="M87.5 50H75" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    <path d="M25 50H12.5" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    <path d="M76.5184 23.4883L67.6797 32.3271" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    <path d="M32.3232 67.6758L23.4844 76.5145" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    <path d="M76.5184 76.5145L67.6797 67.6758" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    <path d="M32.3232 32.3271L23.4844 23.4883" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

export const ForwardIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.00005 6C9.00005 6 15 10.4189 15 12C15 13.5812 9 18 9 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IntakeIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_18101_36053)">
      <path
        d="M9.98438 4.677C9.98438 4.677 10.3177 5.01034 10.651 5.677C10.651 5.677 11.7098 4.01034 12.651 3.677"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66584 1.3476C5.00019 1.27708 3.71335 1.46896 3.71335 1.46896C2.90078 1.52706 1.34358 1.98261 1.34359 4.64307C1.3436 7.28091 1.32636 10.5329 1.34359 11.8293C1.34359 12.6214 1.834 14.4689 3.53144 14.5679C5.59467 14.6883 9.3111 14.7139 11.0162 14.5679C11.4727 14.5422 12.9924 14.1838 13.1847 12.5304C13.384 10.8176 13.3443 9.62718 13.3443 9.34384"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6653 4.67708C14.6653 6.51803 13.1715 8.01044 11.3287 8.01044C9.48599 8.01044 7.99219 6.51803 7.99219 4.67708C7.99219 2.83614 9.48599 1.34375 11.3287 1.34375C13.1715 1.34375 14.6653 2.83614 14.6653 4.67708Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.65625 8.677H7.3229"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.65625 11.3438H9.98956"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_18101_36053">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GethealthieIcon = (props) => {
  const uniqueId = generateUUID();
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id={uniqueId} maskUnits="userSpaceOnUse" x="0" y="2" width="20" height="16">
        <path
          d="M14.592 13.8509C14.6083 13.7765 14.6247 13.7032 14.6411 13.631C14.898 12.4907 15.1507 10.8991 15.1537 10.8833L15.1725 10.7613L15.2992 10.7736C17.3018 10.9676 18.3332 10.8921 19.1051 10.4946C19.8832 10.0947 20.0674 9.55361 19.9801 9.18075C19.8711 8.71233 19.4929 8.62263 18.4834 8.60563C17.4788 8.58862 16.3274 8.50537 15.324 8.3764C14.5635 8.2785 14.006 8.43678 13.5716 8.87531C13.208 9.24172 12.9486 9.79925 12.7032 10.7402C12.4621 11.6653 12.1664 12.9018 12.1633 12.9141L12.0112 13.549L11.9004 12.9059C11.8464 12.5957 11.787 12.0423 11.7246 11.456C11.6834 11.0749 11.6416 10.6816 11.598 10.3322C11.5404 9.86257 11.4828 9.16668 11.4168 8.36175C11.3574 7.64533 11.2908 6.83395 11.2114 6.03488C11.0757 4.67182 10.9775 4.10315 10.4836 3.52158C9.9819 2.93239 9.12018 2.62636 8.28825 2.7442C7.35144 2.87611 6.72428 3.36388 6.37283 4.23564C6.15529 4.77442 6.06075 5.29326 5.95229 5.89476C5.87412 6.32507 5.79353 6.76887 5.65841 7.28009C5.32271 8.54583 5.10032 9.17957 4.51982 9.52077C3.96112 9.84908 3.27094 9.8227 2.21295 9.43343C1.65425 9.22765 1.26766 9.20948 0.878638 9.36952C0.441135 9.54892 0 10.0203 0 10.6675C0 11.126 0.136946 11.7802 1.32522 12.176C2.11418 12.4386 3.52181 12.6227 4.89611 12.2791C6.46857 11.8858 7.09936 10.8158 7.50838 9.82212C7.86226 8.96325 8.25132 7.1517 8.25493 7.13353L8.42943 6.31628L8.52037 7.14642C8.52217 7.16108 8.67787 8.59683 8.76939 9.65504C8.89119 11.0644 9.02145 12.2164 9.18084 13.2816C9.20267 13.4305 9.22385 13.573 9.24322 13.7108C9.38562 14.7033 9.48863 15.4203 9.95769 16.2622C10.2255 16.7435 10.6927 17.0835 11.2726 17.2189C11.9045 17.3661 12.5905 17.2477 13.108 16.9018C14.0594 16.2663 14.3569 14.9278 14.5956 13.8521H14.5938L14.592 13.8509Z"
          fill="white"
        />
      </mask>
      <g mask={`url(#${uniqueId})`}>
        <path d="M21.0258 0.152832H-0.914062V19.8986H21.0258V0.152832Z" fill="#3C18ED" />
      </g>
    </svg>
  );
};

export const AwaitingLabIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 21.5H20" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12.5 9.5C12.5 10.3284 11.8284 11 11 11C10.1716 11 9.5 10.3284 9.5 9.5C9.5 8.67157 10.1716 8 11 8C11.8284 8 12.5 8.67157 12.5 9.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 18.5H12.5M9.5 9.5C7.01472 9.5 5 11.5147 5 14C5 16.4853 7.01472 18.5 9.5 18.5H10"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5 21.5L12.2279 17.6838C12.0918 17.2754 11.7097 17 11.2792 17H11.2208C10.7903 17 10.4082 17.2754 10.2721 17.6838L9 21.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8023 15.5L18 14.2282M10.3859 8.13107L9.34041 6.31596C8.63965 5.09933 9.05551 3.54364 10.2693 2.84121C11.483 2.13879 13.035 2.55564 13.7358 3.77227L16.7809 9.05924C17.2553 9.88279 17.4925 10.2946 17.4925 10.7035C17.4925 10.9714 17.4221 11.2346 17.2885 11.4666C17.0845 11.8208 16.6737 12.0585 15.8521 12.534C15.0305 13.0095 14.6197 13.2472 14.2117 13.2472C13.9445 13.2472 13.6819 13.1767 13.4504 13.0427C13.0971 12.8383 12.8599 12.4265 12.3856 11.6029L11.8758 10.7179"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const JunctionIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.1643 2H6.95655V3.81062H13.1643V2Z" fill="var(--user-junction-icon, #3D1836)" />
    <path
      d="M13.1944 13.1476C13.1944 14.8254 11.8297 16.1894 10.151 16.1894H9.84299C7.94686 16.1894 6.81764 15.0608 6.81764 13.1656H5C5 16.0566 6.94445 18 9.83696 18H10.1449C12.8261 18 15 15.8212 15 13.1476V3.81079H13.1884V13.1476H13.1944Z"
      fill="var(--user-junction-icon, #3D1836)"
    />
  </svg>
);

export const SupportChatIcon = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.75 8.10338C12.75 7.8441 12.75 7.7145 12.789 7.599C12.9024 7.26333 13.2014 7.13307 13.5008 6.99666C13.8375 6.84332 14.0058 6.76664 14.1726 6.75315C14.362 6.73784 14.5517 6.77864 14.7135 6.86947C14.9281 6.98988 15.0777 7.2187 15.2309 7.40477C15.9385 8.2641 16.2922 8.69385 16.4216 9.1677C16.5261 9.55005 16.5261 9.94995 16.4216 10.3323C16.2329 11.0234 15.6364 11.6028 15.1948 12.1391C14.969 12.4133 14.8561 12.5505 14.7135 12.6305C14.5517 12.7214 14.362 12.7622 14.1726 12.7469C14.0058 12.7334 13.8375 12.6567 13.5008 12.5033C13.2014 12.3669 12.9024 12.2367 12.789 11.901C12.75 11.7855 12.75 11.6559 12.75 11.3966V8.10338Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M5.25 8.10345C5.25 7.77705 5.24083 7.48366 4.97693 7.25415C4.88095 7.17068 4.75369 7.11271 4.49918 6.99679C4.16251 6.84344 3.99417 6.76677 3.82737 6.75327C3.32693 6.7128 3.05769 7.05436 2.7691 7.40489C2.06156 8.26425 1.70779 8.69393 1.57834 9.16778C1.47389 9.5502 1.47389 9.9501 1.57834 10.3325C1.76715 11.0236 2.36364 11.6029 2.80516 12.1392C3.08347 12.4772 3.34933 12.7856 3.82737 12.747C3.99417 12.7335 4.16251 12.6568 4.49918 12.5035C4.75369 12.3875 4.88095 12.3296 4.97693 12.2461C5.24083 12.0166 5.25 11.7233 5.25 11.3968V8.10345Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M3.75 6.75C3.75 4.26472 6.10051 2.25 9 2.25C11.8995 2.25 14.25 4.26472 14.25 6.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 12.75V13.35C14.25 14.6755 12.9068 15.75 11.25 15.75H9.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NoFileIcon = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8 23.9898V29.0808C8 35.5742 8 38.8208 9.77214 41.0198C10.1302 41.464 10.5346 41.8688 10.9787 42.227C13.1766 44 16.4216 44 22.9116 44C24.3228 44 25.0282 44 25.6744 43.7718C25.8088 43.7244 25.9404 43.6698 26.069 43.6084C26.6872 43.3126 27.186 42.8134 28.1838 41.8152L37.6568 32.3372C38.813 31.1806 39.391 30.6022 39.6956 29.8668C40 29.1312 40 28.3134 40 26.6776V19.9879C40 12.4416 40 8.66846 37.6568 6.32412C35.7942 4.46044 33.0288 4.07834 28.1838 4M26 42.9994V41.999C26 36.3392 26 33.5094 27.7574 31.7512C29.5148 29.993 32.3432 29.993 38 29.993H39"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M22 18L8 4M22 4L8 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CalenderDollarIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.3337 1.6665V4.99984M6.66699 1.6665V4.99984"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 10.0002C17.5 6.85746 17.5 5.28612 16.5237 4.3098C15.5474 3.3335 13.976 3.3335 10.8333 3.3335H9.16667C6.02397 3.3335 4.45262 3.3335 3.47631 4.3098C2.5 5.28612 2.5 6.85746 2.5 10.0002V11.6668C2.5 14.8095 2.5 16.3809 3.47631 17.3572C4.45262 18.3335 6.02397 18.3335 9.16667 18.3335H10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.5 8.3335H17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M16.0439 13.1761C16.1313 12.1223 14.5191 11.2619 13.2869 11.8392C11.7478 12.5603 11.882 14.383 13.7829 14.4793C14.6288 14.5222 15.3688 14.4309 15.8716 14.9758C16.3744 15.5208 16.5923 16.9086 15.1102 17.3795C13.6279 17.8505 12.083 17.0106 12.083 15.9861M14.1423 10.8335V11.6482M14.1423 17.6838V18.3335"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserFaceCardIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 18C17 15.2386 14.7614 13 12 13C9.23858 13 7 15.2386 7 18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 13V11C21 7.22876 21 5.34315 19.8284 4.17157C18.6569 3 16.7712 3 13 3H11C7.22876 3 5.34315 3 4.17157 4.17157C3 5.34315 3 7.22876 3 11V13C3 16.7712 3 18.6569 4.17157 19.8284C5.34315 21 7.22876 21 11 21H13C16.7712 21 18.6569 21 19.8284 19.8284C21 18.6569 21 16.7712 21 13Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export const NotificationDotIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.5 18.5C15.5 20.433 13.933 22 12 22C10.067 22 8.5 20.433 8.5 18.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 11.5V12.7558C19 13.5514 19.3161 14.3145 19.8787 14.8771L20.4819 15.4803C20.8136 15.8121 21 16.262 21 16.7311C21 17.708 20.208 18.5 19.2311 18.5H4.76887C3.79195 18.5 3 17.708 3 16.7311C3 16.262 3.18636 15.8121 3.51809 15.4803L4.12132 14.8771C4.68393 14.3145 5 13.5514 5 12.7558V10C5 6.13401 8.13401 3 12 3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 2C19.433 2 21 3.567 21 5.5C21 7.433 19.433 9 17.5 9C15.567 9 14 7.433 14 5.5C14 3.567 15.567 2 17.5 2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DisableNotificationIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_19772_39582)">
      <path
        d="M12.9193 15C12.9193 16.6108 11.6134 17.9167 10.0026 17.9167C8.39177 17.9167 7.08594 16.6108 7.08594 15"
        stroke="#F5222D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66406 1.66602L18.3307 18.3327"
        stroke="#F5222D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 13.5266C17.5 13.1357 17.3447 12.7607 17.0682 12.4842L16.5656 11.9816C16.0967 11.5127 15.8333 10.8768 15.8333 10.2138V7.91732C15.8333 4.69565 13.2217 2.08398 10 2.08398C8.70808 2.08398 7.51422 2.50398 6.54756 3.21488M3.97406 15.0007C3.15996 15.0007 2.5 14.3407 2.5 13.5266C2.5 13.1357 2.6553 12.7607 2.93174 12.4842L3.43443 11.9816C3.90327 11.5127 4.16667 10.8768 4.16667 10.2138V7.91732C4.16667 6.84098 4.45817 5.83273 4.96656 4.96721L15 15.0007H3.97406Z"
        stroke="#F5222D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_19772_39582">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const OrderTickIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.5 9.99935V8.63468C17.5 7.26234 17.5 6.57616 17.1805 6.00555C16.861 5.43494 16.2764 5.07713 15.1072 4.36152L12.6072 2.83132C11.338 2.05445 10.7034 1.66602 10 1.66602C9.29658 1.66602 8.662 2.05445 7.39275 2.83132L4.89275 4.36152C3.7236 5.07713 3.13902 5.43494 2.81951 6.00555C2.5 6.57616 2.5 7.26234 2.5 8.63468V11.364C2.5 12.7363 2.5 13.4225 2.81951 13.9932C3.13902 14.5638 3.7236 14.9216 4.89275 15.6372L7.39275 17.1673C8.662 17.9443 9.29658 18.3327 10 18.3327"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.91406 5.83398L9.9974 10.0007L17.0807 5.83398"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 10V18.3333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12.5 15.8333C12.5 15.8333 13.2292 15.8333 13.9583 17.5C13.9583 17.5 16.2745 13.3333 18.3333 12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const OrderCrossIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.5 9.9974V8.63273C17.5 7.26039 17.5 6.5742 17.1805 6.0036C16.861 5.43299 16.2764 5.07518 15.1072 4.35956L12.6072 2.82936C11.338 2.0525 10.7034 1.66406 10 1.66406C9.29658 1.66406 8.662 2.0525 7.39275 2.82936L4.89275 4.35956C3.7236 5.07518 3.13902 5.43299 2.81951 6.0036C2.5 6.5742 2.5 7.26039 2.5 8.63273V11.3621C2.5 12.7344 2.5 13.4206 2.81951 13.9912C3.13902 14.5618 3.7236 14.9196 4.89275 15.6352L7.39275 17.1654C8.662 17.9423 9.29658 18.3307 10 18.3307"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.91602 5.83594L9.99935 10.0026L17.0827 5.83594"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 10V18.3333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M13 12.5L15.5 15M15.5 15L18 17.5M15.5 15L13 17.5M15.5 15L18 12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CalenderClockIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.9167 1.66602V4.99935M6.25 1.66602V4.99935"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0014 6.66732C16.8948 5.58389 16.6539 4.85461 16.1096 4.31029C15.1334 3.33398 13.5619 3.33398 10.4193 3.33398H8.7526C5.6099 3.33398 4.03856 3.33398 3.06225 4.31029C2.08594 5.28661 2.08594 6.85795 2.08594 10.0007V11.6673C2.08594 14.81 2.08594 16.3814 3.06225 17.3577C3.73573 18.0312 4.69235 18.2401 6.2526 18.3048"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.08594 8.33398H6.2526"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9141 18.334C15.6755 18.334 17.9141 16.0954 17.9141 13.334C17.9141 10.5726 15.6755 8.33398 12.9141 8.33398C10.1526 8.33398 7.91406 10.5726 7.91406 13.334C7.91406 16.0954 10.1526 18.334 12.9141 18.334Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9141 10.834V13.334L14.5807 14.1673"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MapIcon = (props) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.66406 29.2891C8.8732 29.2891 10.6641 27.4982 10.6641 25.2891C10.6641 23.0799 8.8732 21.2891 6.66406 21.2891C4.45492 21.2891 2.66406 23.0799 2.66406 25.2891C2.66406 27.4982 4.45492 29.2891 6.66406 29.2891Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3333 9.28906H12.6667C10.0893 9.28906 8 11.0799 8 13.2891C8 15.4983 10.0893 17.2891 12.6667 17.2891H16.6667C19.244 17.2891 21.3333 19.0799 21.3333 21.2891C21.3333 23.4983 19.244 25.2891 16.6667 25.2891H14.6667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.3359 2.71094C21.5745 2.71094 19.3359 4.88166 19.3359 7.55936C19.3359 9.09048 19.961 10.281 21.2109 11.3444C22.0921 12.0939 23.6951 13.7017 24.3359 14.7109C25.0093 13.7219 26.5798 12.0939 27.461 11.3444C28.7109 10.281 29.3359 9.09048 29.3359 7.55936C29.3359 4.88166 27.0974 2.71094 24.3359 2.71094Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.5156 7.37728H24.349M24.6823 7.37728C24.6823 7.56137 24.533 7.71061 24.349 7.71061C24.1648 7.71061 24.0156 7.56137 24.0156 7.37728C24.0156 7.19319 24.1648 7.04395 24.349 7.04395C24.533 7.04395 24.6823 7.19319 24.6823 7.37728Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EyeHideIcon = (props) => {
  return (
    <svg
      width={props?.size || '20'}
      height={props?.size || '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.3307 6.66602C16.496 9.18477 13.4476 10.8327 9.9974 10.8327C6.54713 10.8327 3.49881 9.18477 1.66406 6.66602"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 10.834L13.75 13.334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6641 9.16602L18.3307 11.2493"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66406 11.2493L3.33073 9.16602"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10.834L6.25 13.334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CardRecycleIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.3307 7.91699C18.3003 6.04008 18.1551 4.95579 17.4611 4.17774C17.3206 4.02035 17.1659 3.87478 16.9986 3.74272C15.9525 2.91699 14.3856 2.91699 11.2521 2.91699H8.75081C5.61715 2.91699 4.05033 2.91699 3.00425 3.74272C2.83695 3.87478 2.68221 4.02035 2.54182 4.17774C1.66406 5.1618 1.66406 6.63576 1.66406 9.58366C1.66406 12.5316 1.66406 14.0055 2.54182 14.9896C2.68221 15.147 2.83695 15.2925 3.00425 15.4246C4.05033 16.2503 5.61715 16.2503 8.75081 16.2503H9.16406"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1.66406 7.08301H18.3307" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <path
      d="M16.1085 10.417L16.7945 11.0486C16.9438 11.1953 17.0185 11.2687 16.9922 11.3311C16.9659 11.3934 16.8603 11.3934 16.6491 11.3934H14.0621C12.7377 11.3934 11.6641 12.4487 11.6641 13.7503C11.6641 14.0437 11.7186 14.3246 11.8182 14.5837M13.8863 17.0837L13.2003 16.4521C13.051 16.3053 12.9763 16.2319 13.0026 16.1696C13.0289 16.1072 13.1345 16.1072 13.3456 16.1072H15.9326C17.2571 16.1072 18.3307 15.052 18.3307 13.7503C18.3307 13.4569 18.2761 13.1761 18.1766 12.917"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronDownIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.8307 7.5L9.9974 13.3333L4.16406 7.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RecurringIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.3884 3L17.3913 3.97574C17.8393 4.41165 18.0633 4.62961 17.9844 4.81481C17.9056 5 17.5888 5 16.9552 5H9.19422C5.22096 5 2 8.13401 2 12C2 13.4872 2.47668 14.8662 3.2895 16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.61156 21L6.60875 20.0243C6.16074 19.5883 5.93673 19.3704 6.01557 19.1852C6.09441 19 6.4112 19 7.04478 19H14.8058C18.779 19 22 15.866 22 12C22 10.5128 21.5233 9.13383 20.7105 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalenderCrossIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16 2V6M8 2V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M21 13V12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 10H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M21 16L18 19M18 19L15 22M18 19L21 22M18 19L15 16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DetachLinkIcon = (props) => (
  <svg
    width={props?.width ?? '20'}
    height={props?.height ?? '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.33594 11.0238C8.45394 11.2171 8.59402 11.4 8.7561 11.5687C9.76235 12.6159 11.2961 12.7797 12.4673 12.0598C12.6843 11.9264 12.8888 11.7628 13.0753 11.5687L15.7748 8.75918C16.9674 7.51788 16.9674 5.50531 15.7748 4.26399C14.582 3.02268 12.6483 3.02268 11.4555 4.26399L10.8609 4.88283"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M9.14452 15.1167L8.54969 15.7357C7.35699 16.977 5.4232 16.977 4.23048 15.7357C3.03776 14.4943 3.03776 12.4818 4.23048 11.2405L6.93 8.431C8.12271 7.18967 10.0565 7.18966 11.2492 8.431C11.4113 8.59958 11.5513 8.7825 11.6693 8.97566"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M17.5026 13.333H15.7702M13.3359 17.4997V15.7673"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 6.66667H4.23241M6.66667 2.5V4.23241"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DispositionIcon = (props) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16 10.6667C18.2091 10.6667 20 8.87589 20 6.66675C20 4.45761 18.2091 2.66675 16 2.66675C13.7909 2.66675 12 4.45761 12 6.66675C12 8.87589 13.7909 10.6667 16 10.6667Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M16.0026 29.3333C17.4754 29.3333 18.6693 28.1394 18.6693 26.6667C18.6693 25.1939 17.4754 24 16.0026 24C14.5298 24 13.3359 25.1939 13.3359 26.6667C13.3359 28.1394 14.5298 29.3333 16.0026 29.3333Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M26.6667 29.3333C28.1394 29.3333 29.3333 28.1394 29.3333 26.6667C29.3333 25.1939 28.1394 24 26.6667 24C25.1939 24 24 25.1939 24 26.6667C24 28.1394 25.1939 29.3333 26.6667 29.3333Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M5.33073 29.3333C6.80349 29.3333 7.9974 28.1394 7.9974 26.6667C7.9974 25.1939 6.80349 24 5.33073 24C3.85797 24 2.66406 25.1939 2.66406 26.6667C2.66406 28.1394 3.85797 29.3333 5.33073 29.3333Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M26.6693 19.9999C26.6693 18.5271 25.1769 17.3333 23.3359 17.3333H8.66927C6.82832 17.3333 5.33594 18.5271 5.33594 19.9999"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M16 14.6667V20.0001" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const ListTickIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10.8281 5H17.4948" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M10.8281 10H17.4948" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M10.8281 15H17.4948" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M3.52887 16.1232C3.83515 16.25 4.22343 16.25 5 16.25C5.77657 16.25 6.16486 16.25 6.47114 16.1232C6.87952 15.954 7.20398 15.6295 7.37313 15.2212C7.5 14.9148 7.5 14.5266 7.5 13.75C7.5 12.9734 7.5 12.5852 7.37313 12.2788C7.20398 11.8705 6.87952 11.546 6.47114 11.3768C6.16486 11.25 5.77657 11.25 5 11.25C4.22343 11.25 3.83515 11.25 3.52887 11.3768C3.12048 11.546 2.79603 11.8705 2.62687 12.2788C2.5 12.5852 2.5 12.9734 2.5 13.75C2.5 14.5266 2.5 14.9148 2.62687 15.2212C2.79603 15.6295 3.12048 15.954 3.52887 16.1232Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 5.97222C2.5 5.97222 3.125 5.97223 3.75 7.08333C3.75 7.08333 5.7353 4.30556 7.5 3.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DocumentIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_22630_21749)">
      <path
        d="M8.66406 1.66683V2.00016C8.66406 3.88578 8.66406 4.82859 9.24986 5.41438C9.83566 6.00016 10.7785 6.00016 12.6641 6.00016H12.9974M13.3307 7.10476V9.3335C13.3307 11.8476 13.3307 13.1048 12.5497 13.8858C11.7687 14.6668 10.5115 14.6668 7.9974 14.6668C5.48324 14.6668 4.22616 14.6668 3.44511 13.8858C2.66406 13.1048 2.66406 11.8476 2.66406 9.3335V6.30406C2.66406 4.14071 2.66406 3.05904 3.25478 2.32638C3.37412 2.17837 3.50894 2.04355 3.65695 1.92421C4.3896 1.3335 5.47128 1.3335 7.6346 1.3335C8.105 1.3335 8.34013 1.3335 8.55553 1.4095C8.60033 1.42531 8.6442 1.4435 8.68706 1.464C8.89313 1.56253 9.0594 1.72883 9.392 2.06142L12.5497 5.21912C12.9351 5.60449 13.1277 5.79718 13.2293 6.0422C13.3307 6.28723 13.3307 6.55973 13.3307 7.10476Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_22630_21749">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RecordIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_22630_40309)">
      <path d="M7.33594 5.3335H8.66927" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M1.33594 7.33317C1.33594 5.13328 1.33594 4.03334 2.01936 3.34992C2.70277 2.6665 3.80272 2.6665 6.0026 2.6665H6.66927C8.86914 2.6665 9.96907 2.6665 10.6525 3.34992C11.3359 4.03334 11.3359 5.13328 11.3359 7.33317V8.6665C11.3359 10.8664 11.3359 11.9663 10.6525 12.6498C9.96907 13.3332 8.86914 13.3332 6.66927 13.3332H6.0026C3.80272 13.3332 2.70277 13.3332 2.01936 12.6498C1.33594 11.9663 1.33594 10.8664 1.33594 8.6665V7.33317Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M11.3359 5.9374L11.4199 5.86814C12.8304 4.70432 13.5357 4.1224 14.1025 4.40338C14.6693 4.68435 14.6693 5.61586 14.6693 7.4789V8.52143C14.6693 10.3845 14.6693 11.316 14.1025 11.597C13.5357 11.8779 12.8304 11.296 11.4199 10.1322L11.3359 10.0629"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_22630_40309">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FileAttachIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.66406 8.00043V9.69657C2.66406 11.8599 2.66406 12.9416 3.25478 13.6742C3.37412 13.8222 3.50894 13.9571 3.65695 14.0764C4.3896 14.6671 5.47128 14.6671 7.6346 14.6671C8.105 14.6671 8.34013 14.6671 8.55553 14.5911C8.60033 14.5753 8.6442 14.5571 8.68706 14.5366C8.89313 14.4381 9.0594 14.2718 9.392 13.9392L12.5497 10.7815C12.9351 10.3961 13.1277 10.2034 13.2293 9.95843C13.3307 9.71337 13.3307 9.4409 13.3307 8.8959V6.6671C13.3307 4.15296 13.3307 2.89589 12.5497 2.11483C11.8436 1.40873 10.7484 1.34098 8.68706 1.33447M8.66406 14.3338V14.0004C8.66406 12.1148 8.66406 11.172 9.24986 10.5862C9.83566 10.0004 10.7785 10.0004 12.6641 10.0004H12.9974"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66406 5.48685V3.6407C2.66406 2.36619 3.70873 1.33301 4.9974 1.33301C6.28606 1.33301 7.33073 2.36619 7.33073 3.6407V6.17916C7.33073 6.8164 6.8084 7.333 6.16406 7.333C5.51973 7.333 4.9974 6.8164 4.9974 6.17916V3.6407"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ManualIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.9193 6.66667C12.9193 4.36548 11.0538 2.5 8.7526 2.5C6.45142 2.5 4.58594 4.36548 4.58594 6.66667C4.58594 8.96783 6.45142 10.8333 8.7526 10.8333C11.0538 10.8333 12.9193 8.96783 12.9193 6.66667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.91406 16.6668C2.91406 13.4452 5.52574 10.8335 8.7474 10.8335C9.8099 10.8335 10.8061 11.1176 11.6641 11.6139"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8239 12.445L16.3051 11.9262C15.9592 11.5803 15.3983 11.5803 15.0524 11.9262L12.2617 14.7169C11.8908 15.0878 11.638 15.5603 11.5351 16.0747L11.25 17.5001L12.6754 17.215C13.1898 17.1121 13.6623 16.8593 14.0332 16.4884L16.8239 13.6977C17.1698 13.3518 17.1698 12.7909 16.8239 12.445Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DocumentAttachIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.66667 14.6663H6C4.11438 14.6663 3.17157 14.6663 2.58579 14.0805C2 13.4947 2 12.5519 2 10.6663V5.33301C2 3.44739 2 2.50458 2.58579 1.91879C3.17157 1.33301 4.11438 1.33301 6 1.33301H8.66667C10.5523 1.33301 11.4951 1.33301 12.0809 1.91879C12.6667 2.50458 12.6667 3.44739 12.6667 5.33301V7.33301"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66406 4.66699H9.9974"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66406 7.33301H9.9974"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66406 10H7.33073"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0783 14.2521L13.5832 11.7472C13.8484 11.482 13.9974 11.1223 13.9974 10.7472C13.9974 9.96614 13.3643 9.33301 12.5832 9.33301C12.2081 9.33301 11.8484 9.48201 11.5832 9.74721L9.07826 12.2521C8.81306 12.5173 8.66406 12.8771 8.66406 13.2521C8.66406 14.0332 9.2972 14.6663 10.0783 14.6663C10.4533 14.6663 10.8131 14.5173 11.0783 14.2521Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3359 11L12.3359 13"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TwoPointsIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 5.33301C13.1046 5.33301 14 4.43758 14 3.33301C14 2.22844 13.1046 1.33301 12 1.33301C10.8954 1.33301 10 2.22844 10 3.33301C10 4.43758 10.8954 5.33301 12 5.33301Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 14.667C5.10457 14.667 6 13.7716 6 12.667C6 11.5624 5.10457 10.667 4 10.667C2.89543 10.667 2 11.5624 2 12.667C2 13.7716 2.89543 14.667 4 14.667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.9987 3.33301H5.66536C4.3767 3.33301 3.33203 4.37767 3.33203 5.66634C3.33203 6.95501 4.3767 7.99967 5.66536 7.99967H10.332C11.6207 7.99967 12.6654 9.04434 12.6654 10.333C12.6654 11.6217 11.6207 12.6663 10.332 12.6663H7.9987"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilesIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.8809 7.01656L17.6538 8.28825M11.8578 10.8134L14.2442 11.4492M11.9765 17.9664L12.9311 18.2208C15.631 18.9401 16.981 19.2998 18.0445 18.6893C19.108 18.0787 19.4698 16.7363 20.1932 14.0516L21.2163 10.2548C21.9398 7.57005 22.3015 6.22768 21.6875 5.17016C21.0735 4.11264 19.7235 3.75295 17.0235 3.03358L16.0689 2.77924C13.369 2.05986 12.019 1.70018 10.9555 2.31074C9.89196 2.9213 9.53023 4.26367 8.80678 6.94841L7.78366 10.7452C7.0602 13.4299 6.69848 14.7723 7.3125 15.8298C7.92652 16.8874 9.27651 17.2471 11.9765 17.9664Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12 20.9463L11.0477 21.2056C8.35403 21.9391 7.00722 22.3058 5.94619 21.6833C4.88517 21.0608 4.52429 19.6921 3.80253 16.9547L2.78182 13.0834C2.06006 10.346 1.69918 8.97728 2.31177 7.89902C2.84167 6.96629 4 7.00025 5.5 7.00013"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const SearchFileIcon = (props) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M31.6667 15.834V13.834C31.6533 9.16254 31.5085 6.68598 29.945 5.09135C28.222 3.33398 25.449 3.33398 19.9027 3.33398H16.7653C11.2191 3.33398 8.446 3.33398 6.723 5.09135C5 6.8487 5 9.67713 5 15.334V23.0007C5 28.6575 5 31.486 6.723 33.2433C8.25258 34.8033 10.6098 34.9785 15 34.9982"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M31.1281 32.8143L35.0026 36.6667M33.3359 27.5C33.3359 23.3578 29.9781 20 25.8359 20C21.6938 20 18.3359 23.3578 18.3359 27.5C18.3359 31.6422 21.6938 35 25.8359 35C29.9781 35 33.3359 31.6422 33.3359 27.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11.6641 11.666H24.9974" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M11.6641 18.334H16.6641" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const CrossFileIcon = (props) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M31.6667 15.834V13.834C31.6533 9.16254 31.5085 6.68598 29.945 5.09135C28.222 3.33398 25.449 3.33398 19.9027 3.33398H16.7653C11.2191 3.33398 8.446 3.33398 6.723 5.09135C5 6.8487 5 9.67713 5 15.334V23.0007C5 28.6575 5 31.486 6.723 33.2433C8.25258 34.8033 10.6098 34.9785 15 34.9982"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M11.6641 11.666H24.9974" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M11.6641 18.334H16.6641" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M20 22L26 28M26 28L32 34M26 28L20 34M26 28L32 22"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const PersonPlusIcon = (props) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.6693 11.3327C18.6693 7.65079 15.6845 4.66602 12.0026 4.66602C8.32071 4.66602 5.33594 7.65079 5.33594 11.3327C5.33594 15.0145 8.32071 17.9993 12.0026 17.9993C15.6845 17.9993 18.6693 15.0145 18.6693 11.3327Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.3307 27.3333C21.3307 22.1787 17.1521 18 11.9974 18C6.84274 18 2.66406 22.1787 2.66406 27.3333"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.3359 12V20M29.3359 16H21.3359"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TicketTypeIcon = (props) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M29.3302 11.8379C29.241 9.78184 28.991 8.44332 28.2906 7.38447C27.8876 6.7753 27.3872 6.24547 26.8118 5.81892C25.2564 4.66602 23.0622 4.66602 18.6739 4.66602H13.3209C8.93255 4.66602 6.73836 4.66602 5.183 5.81892C4.60758 6.24547 4.10707 6.7753 3.70414 7.38447C3.00386 8.4432 2.75386 9.78155 2.66462 11.8373C2.64935 12.1888 2.95215 12.4577 3.28392 12.4577C5.13163 12.4577 6.6295 14.0433 6.6295 15.9993C6.6295 17.9553 5.13163 19.5409 3.28392 19.5409C2.95215 19.5409 2.64935 19.8099 2.66462 20.1615C2.75386 22.2172 3.00386 23.5555 3.70414 24.6143C4.10707 25.2233 4.60758 25.7532 5.183 26.1797C6.73836 27.3327 8.93255 27.3327 13.3209 27.3327H18.6739C23.0622 27.3327 25.2564 27.3327 26.8118 26.1797C27.3872 25.7532 27.8876 25.2233 28.2906 24.6143C28.991 23.5553 29.241 22.2168 29.3302 20.1608V11.8379Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M17.3359 16H22.6693" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 21.334H22.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const FirstAidIcon = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.33301 14.6562C2.33301 11.0471 2.33301 9.24246 3.52899 8.12124C4.72497 7 6.64987 7 10.4997 7H17.4997C21.3494 7 23.2743 7 24.4704 8.12124C25.6663 9.24246 25.6663 11.0471 25.6663 14.6562V16.8437C25.6663 20.4529 25.6663 22.2575 24.4704 23.3787C23.2743 24.5 21.3494 24.5 17.4997 24.5H10.4997C6.64987 24.5 4.72497 24.5 3.52899 23.3787C2.33301 22.2575 2.33301 20.4529 2.33301 16.8437V14.6562Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 15.75H17.5M14 12.25V19.25"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.8337 7C19.8337 4.10433 19.2293 3.5 16.3337 3.5H11.667C8.77133 3.5 8.16699 4.10433 8.16699 7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalenderDashIcon = (props) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M26.6693 3.33398V10.0007M13.3359 3.33398V10.0007"
      stroke="currentColor"
      strokeWidth={props?.strokeWidth ?? '2'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35 24.9993V19.9993C35 13.7139 35 10.5713 33.0473 8.61863C31.0948 6.66602 27.952 6.66602 21.6667 6.66602H18.3333C12.0479 6.66602 8.90525 6.66602 6.95262 8.61863C5 10.5713 5 13.7139 5 19.9993V23.3327C5 29.618 5 32.7608 6.95262 34.7133C8.90525 36.666 12.0479 36.666 18.3333 36.666H21.6667"
      stroke="currentColor"
      strokeWidth={props?.strokeWidth ?? '2'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 16.666H35"
      stroke="currentColor"
      strokeWidth={props?.strokeWidth ?? '2'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.0026 30.834H23.3359"
      stroke="currentColor"
      strokeWidth={props?.strokeWidth ?? '2'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalenderBlankIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.3307 1.66602V4.99935M6.66406 1.66602V4.99935"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8333 3.33398H9.16667C6.02397 3.33398 4.45262 3.33398 3.47631 4.31029C2.5 5.28661 2.5 6.85795 2.5 10.0007V11.6673C2.5 14.81 2.5 16.3814 3.47631 17.3577C4.45262 18.334 6.02397 18.334 9.16667 18.334H10.8333C13.976 18.334 15.5474 18.334 16.5237 17.3577C17.5 16.3814 17.5 14.81 17.5 11.6673V10.0007C17.5 6.85795 17.5 5.28661 16.5237 4.31029C15.5474 3.33398 13.976 3.33398 10.8333 3.33398Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.5 8.33398H17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const RoundedCircleVertical = (props) => (
  <svg width="50" height="115" viewBox="0 0 50 115" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M29.6187 79H33.5C42.3366 79 49.5 86.1634 49.5 95L49.5 19.5C49.5 28.3366 42.3366 35.5 33.5 35.5H31.4922C25.1336 35.5 19.0755 38.2064 14.8327 42.9426L13.9503 43.9276C6.23192 52.5434 6.9181 65.7746 15.4863 73.5457C19.3563 77.0557 24.394 79 29.6187 79Z"
      fill={props?.fill ?? '#077882'}
      fillOpacity="0.1"
    />
    <rect x="17" y="43" width="28" height="28" rx="14" fill={props?.fill ?? '#077882'} />
  </svg>
);

export const RoundedCircle = (props) => (
  <svg width="120" height="66" viewBox="0 0 120 66" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M33.361 34.2517V49.9925C33.361 58.829 26.1976 65.9925 17.361 65.9925H102.141C93.3045 65.9925 86.1411 58.829 86.1411 49.9925V34.5216C86.1411 27.6273 83.1762 21.0659 78.0019 16.5096L75.4164 14.2329C66.2207 6.13543 52.4019 6.26504 43.3597 14.5336L41.1651 16.5403C36.193 21.087 33.361 27.5142 33.361 34.2517Z"
      fill={props?.fill ?? '#077882'}
      fillOpacity="0.1"
    />
    <rect x="46" y="19" width="28" height="28" rx="14" fill={props?.fill ?? '#077882'} />
  </svg>
);

export const PrescriptionPillIcon = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.6667 25.6693H10.5C7.20016 25.6693 5.55025 25.6693 4.52513 24.6441C3.5 23.619 3.5 21.9691 3.5 18.6693V9.33594C3.5 6.0361 3.5 4.38619 4.52513 3.36106C5.55025 2.33594 7.20016 2.33594 10.5 2.33594H15.1667C18.4665 2.33594 20.1164 2.33594 21.1415 3.36106C22.1667 4.38619 22.1667 6.0361 22.1667 9.33594V12.8359"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.16406 8.16406H17.4974"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.16406 12.8359H17.4974"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.16406 17.5H12.8307"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.3889 24.9444L23.7725 20.5608C24.2366 20.0967 24.4974 19.4672 24.4974 18.8108C24.4974 17.4439 23.3894 16.3359 22.0225 16.3359C21.3662 16.3359 20.7366 16.5967 20.2725 17.0608L15.8889 21.4444C15.4248 21.9085 15.1641 22.5381 15.1641 23.1944C15.1641 24.5613 16.272 25.6693 17.6389 25.6693C18.2953 25.6693 18.9248 25.4085 19.3889 24.9444Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0859 19.25L21.5859 22.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PackageTickIcon = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M23.9063 8.16406V13.9974M2.90625 8.16406C2.90625 11.7393 2.90625 19.5673 2.90625 20.0189C2.90625 21.6318 5.17616 22.5907 9.71599 24.5085C11.5398 25.2788 12.4517 25.6641 13.4063 25.6641V13.2447"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.11982 11.3092L5.71174 9.6601C3.84142 8.75505 2.90625 8.30254 2.90625 7.58594C2.90625 6.86934 3.84142 6.41682 5.71174 5.51178L9.11982 3.86266C11.2232 2.84485 12.2749 2.33594 13.4063 2.33594C14.5376 2.33594 15.5893 2.84484 17.6927 3.86266L21.1008 5.51178C22.9711 6.41682 23.9063 6.86934 23.9063 7.58594C23.9063 8.30254 22.9711 8.75505 21.1008 9.6601L17.6927 11.3092C15.5893 12.327 14.5376 12.8359 13.4063 12.8359C12.2749 12.8359 11.2232 12.327 9.11982 11.3092Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.40625 14L8.73958 15.1667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2448 4.66406L7.57812 10.4974"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9062 22.1667C16.9062 22.1667 17.9271 22.1667 18.9479 24.5C18.9479 24.5 22.1906 18.6667 25.0729 17.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShopIcon = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.08594 11.6641V17.4974C4.08594 20.7972 4.08594 22.4471 5.11105 23.4722C6.13618 24.4974 7.7861 24.4974 11.0859 24.4974H16.9192C20.219 24.4974 21.8691 24.4974 22.8941 23.4722C23.9192 22.4471 23.9192 20.7972 23.9192 17.4974V11.6641"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.8359 8.75171C19.8359 10.3625 18.5301 11.6662 16.9193 11.6662C15.3084 11.6662 14.0026 10.3604 14.0026 8.74953C14.0026 10.3604 12.6967 11.6662 11.0859 11.6662C9.4751 11.6662 8.16928 10.3604 8.16928 8.74953C8.16928 10.3604 6.80023 11.6662 5.11143 11.6662C4.2024 11.6662 3.38601 11.2878 2.82592 10.6872C1.86298 9.65467 2.48246 8.13594 3.28615 6.98606L3.73828 6.36783C4.76709 4.96105 5.2815 4.25767 6.02834 3.87866C6.77518 3.49966 7.6466 3.49978 9.38943 3.50001L18.6169 3.50124C20.3592 3.50147 21.2303 3.50159 21.9769 3.88058C22.7234 4.25957 23.2377 4.96273 24.2662 6.36907L24.719 6.98824C25.5227 8.13811 26.1422 9.65684 25.1793 10.6894C24.6191 11.29 23.8028 11.6683 22.8938 11.6683C21.2049 11.6683 19.8359 10.3625 19.8359 8.75171Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4966 19.8359C16.6988 20.5443 15.4288 21.0026 13.9982 21.0026C12.5677 21.0026 11.2977 20.5443 10.5 19.8359"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReviewStarIcon = (props) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_26340_76661)">
      <path
        d="M6.99626 0.726562C7.60835 0.726562 8.09048 1.18887 8.39824 1.81268L9.42613 3.88541C9.45728 3.94955 9.53119 4.03988 9.64226 4.12252C9.75321 4.20507 9.86188 4.2506 9.93334 4.26261L11.7939 4.5743C12.4661 4.68724 13.0294 5.01668 13.2123 5.59034C13.395 6.16352 13.1273 6.75916 12.6439 7.24333L12.6435 7.24385L11.198 8.70125C11.1407 8.759 11.0766 8.86779 11.0363 9.00954C10.9964 9.15036 10.9928 9.27864 11.0109 9.36147L11.0112 9.36264L11.4247 11.1655C11.5963 11.9159 11.5394 12.66 11.0102 13.049C10.4791 13.4393 9.75344 13.2663 9.09416 12.8737L7.35005 11.8326C7.27678 11.7889 7.15102 11.7534 6.99918 11.7534C6.84844 11.7534 6.72005 11.7884 6.642 11.8338L6.64089 11.8345L4.90021 12.8734C4.24173 13.2675 3.51693 13.4374 2.98585 13.0467C2.45699 12.6576 2.39728 11.9149 2.56935 11.1651L2.98281 9.36264L2.98306 9.36147C3.00119 9.27864 2.99764 9.15036 2.95767 9.00954C2.91742 8.86779 2.85324 8.759 2.79596 8.70125L1.34945 7.24274C0.869246 6.75858 0.602406 6.16346 0.783671 5.59112C0.965461 5.01712 1.5277 4.68728 2.20023 4.57426L4.0593 4.26284L4.05989 4.26274C4.12805 4.25092 4.23511 4.20589 4.34581 4.12313C4.45672 4.04021 4.53079 3.94968 4.56202 3.88541L4.5636 3.8822L5.59015 1.81213L5.59055 1.81131C5.90128 1.18803 6.38487 0.726562 6.99626 0.726562Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_26340_76661">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FaxIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_26602_96479)">
      <path
        d="M14.1641 14.1693H15.553C16.5914 14.1693 17.1106 14.1693 17.4974 13.946C17.7507 13.7997 17.9611 13.5893 18.1074 13.3359C18.3307 12.9492 18.3307 12.4299 18.3307 11.3915C18.3307 9.3146 18.3307 8.2761 17.8841 7.5026C17.5916 6.99587 17.1708 6.57508 16.6641 6.28252C15.8906 5.83594 14.8521 5.83594 12.7751 5.83594H7.21962C5.1427 5.83594 4.10423 5.83594 3.33073 6.28252C2.824 6.57508 2.4032 6.99587 2.11065 7.5026C1.66406 8.2761 1.66406 9.3146 1.66406 11.3915C1.66406 12.4299 1.66406 12.9492 1.88735 13.3359C2.03364 13.5893 2.24403 13.7997 2.4974 13.946C2.88415 14.1693 3.40338 14.1693 4.44184 14.1693H5.83073"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1693 5.83073V4.16406C14.1693 2.98555 14.1693 2.3963 13.8032 2.03018C13.437 1.66406 12.8478 1.66406 11.6693 1.66406H8.33594C7.15743 1.66406 6.56817 1.66406 6.20205 2.03018C5.83594 2.3963 5.83594 2.98555 5.83594 4.16406V5.83073"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1693 11.6641V15.8307C14.1693 17.0092 14.1693 17.5985 13.8032 17.9646C13.437 18.3307 12.8478 18.3307 11.6693 18.3307H8.33594C7.15743 18.3307 6.56817 18.3307 6.20205 17.9646C5.83594 17.5985 5.83594 17.0092 5.83594 15.8307V11.6641H14.1693Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7266 8.54427H15.6224M15.8307 8.54427C15.8307 8.65935 15.7375 8.7526 15.6224 8.7526C15.5073 8.7526 15.4141 8.65935 15.4141 8.54427C15.4141 8.42919 15.5073 8.33594 15.6224 8.33594C15.7375 8.33594 15.8307 8.42919 15.8307 8.54427Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_26602_96479">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Map2Icon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.3481 17.8032C10.9867 18.1416 10.5037 18.3307 10.0009 18.3307C9.49817 18.3307 9.01517 18.1416 8.65375 17.8032C5.34418 14.6857 0.908967 11.2031 3.07189 6.14711C4.24136 3.41336 7.04862 1.66406 10.0009 1.66406C12.9532 1.66406 15.7605 3.41336 16.93 6.14711C19.0902 11.1968 14.6658 14.6965 11.3481 17.8032Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12.9193 9.16667C12.9193 10.7775 11.6134 12.0833 10.0026 12.0833C8.39177 12.0833 7.08594 10.7775 7.08594 9.16667C7.08594 7.55583 8.39177 6.25 10.0026 6.25C11.6134 6.25 12.9193 7.55583 12.9193 9.16667Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const PrescriptionCrossIcon = (props) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.6667 36.6693H15C10.2859 36.6693 7.92893 36.6693 6.46447 35.2048C5 33.7403 5 31.3833 5 26.6693V13.3359C5 8.62189 5 6.26487 6.46447 4.8004C7.92893 3.33594 10.2859 3.33594 15 3.33594H21.6667C26.3807 3.33594 28.7377 3.33594 30.2022 4.8004C31.6667 6.26487 31.6667 8.62189 31.6667 13.3359V19.3359"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
    <path
      d="M11.6641 11.6641H24.9974"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
    <path
      d="M11.6641 18.3359H24.9974"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
    <path d="M11.6641 25H18.3307" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" />
    <path
      d="M35 26L30 31M30 31L25 36M30 31L35 36M30 31L25 26"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
  </svg>
);
